export const contourData = [
    {
        "type": "MultiPolygon",
        "value": 15,
        "coordinates": [
            [
                [
                    [
                        177.58333333333334,
                        12.5
                    ],
                    [
                        177.6,
                        11.5
                    ],
                    [
                        177.5,
                        11.166666666666666
                    ],
                    [
                        177.16666666666666,
                        11.5
                    ],
                    [
                        177.25,
                        12.5
                    ],
                    [
                        177.5,
                        12.75
                    ],
                    [
                        177.58333333333334,
                        12.5
                    ]
                ]
            ],
            [
                [
                    [
                        174.7,
                        40.5
                    ],
                    [
                        175.16666666666666,
                        39.5
                    ],
                    [
                        174.5,
                        38.92857142857143
                    ],
                    [
                        173.5,
                        39.5
                    ],
                    [
                        173.5,
                        39.5
                    ],
                    [
                        172.5,
                        40.07142857142857
                    ],
                    [
                        172.07142857142858,
                        40.5
                    ],
                    [
                        172.5,
                        40.92857142857143
                    ],
                    [
                        173.5,
                        40.95454545454545
                    ],
                    [
                        174.5,
                        40.611111111111114
                    ],
                    [
                        174.7,
                        40.5
                    ]
                ]
            ],
            [
                [
                    [
                        162.5,
                        49.5
                    ],
                    [
                        163,
                        48.5
                    ],
                    [
                        162.5,
                        48
                    ],
                    [
                        162,
                        48.5
                    ],
                    [
                        162.5,
                        49.5
                    ],
                    [
                        162.5,
                        49.5
                    ],
                    [
                        162.5,
                        49.5
                    ]
                ]
            ],
            [
                [
                    [
                        190.5,
                        67.5
                    ],
                    [
                        190.5,
                        66.5
                    ],
                    [
                        190.875,
                        65.5
                    ],
                    [
                        190.5,
                        64.9
                    ],
                    [
                        189.5,
                        65
                    ],
                    [
                        189,
                        65.5
                    ],
                    [
                        189.5,
                        66.5
                    ],
                    [
                        188.5,
                        66.83333333333333
                    ],
                    [
                        188,
                        67.5
                    ],
                    [
                        188.5,
                        67.9
                    ],
                    [
                        189.5,
                        67.75
                    ],
                    [
                        190.5,
                        67.5
                    ],
                    [
                        190.5,
                        67.5
                    ]
                ]
            ],
            [
                [
                    [
                        163.7,
                        69.5
                    ],
                    [
                        163.5,
                        69.25
                    ],
                    [
                        162.5,
                        69.5
                    ],
                    [
                        162.5,
                        69.5
                    ],
                    [
                        162.5,
                        69.5
                    ],
                    [
                        163.5,
                        70
                    ],
                    [
                        163.7,
                        69.5
                    ]
                ]
            ],
            [
                [
                    [
                        206,
                        80.5
                    ],
                    [
                        205.5,
                        80.1
                    ],
                    [
                        205.12962962962962,
                        80.5
                    ],
                    [
                        205.5,
                        80.9
                    ],
                    [
                        206,
                        80.5
                    ]
                ]
            ],
            [
                [
                    [
                        167.71428571428572,
                        91.5
                    ],
                    [
                        167.5,
                        91
                    ],
                    [
                        166.9,
                        90.5
                    ],
                    [
                        167.5,
                        90.34210526315789
                    ],
                    [
                        168.38888888888889,
                        89.5
                    ],
                    [
                        168.5,
                        89.27777777777777
                    ],
                    [
                        168.9375,
                        88.5
                    ],
                    [
                        169.5,
                        87.75
                    ],
                    [
                        169.8,
                        87.5
                    ],
                    [
                        170.35714285714286,
                        86.5
                    ],
                    [
                        170.5,
                        86.31818181818181
                    ],
                    [
                        170.97368421052633,
                        85.5
                    ],
                    [
                        171.26923076923077,
                        84.5
                    ],
                    [
                        171.5,
                        83.9
                    ],
                    [
                        171.66666666666666,
                        83.5
                    ],
                    [
                        172,
                        82.5
                    ],
                    [
                        172.22727272727272,
                        81.5
                    ],
                    [
                        171.96153846153845,
                        80.5
                    ],
                    [
                        171.5,
                        80.03846153846153
                    ],
                    [
                        170.5,
                        80.22727272727273
                    ],
                    [
                        169.9,
                        80.5
                    ],
                    [
                        169.5,
                        80.58695652173913
                    ],
                    [
                        168.5,
                        80.64285714285714
                    ],
                    [
                        167.5,
                        81.05555555555556
                    ],
                    [
                        166.5,
                        81.5
                    ],
                    [
                        166.5,
                        81.5
                    ],
                    [
                        165.5,
                        81.72222222222223
                    ],
                    [
                        164.5,
                        82.25
                    ],
                    [
                        163.5,
                        81.7
                    ],
                    [
                        162.5,
                        81.68181818181819
                    ],
                    [
                        162,
                        81.5
                    ],
                    [
                        161.5,
                        80.83333333333333
                    ],
                    [
                        160.5,
                        80.5
                    ],
                    [
                        161.5,
                        80
                    ],
                    [
                        161.7,
                        79.5
                    ],
                    [
                        162.5,
                        78.92857142857143
                    ],
                    [
                        163.5,
                        78.5
                    ],
                    [
                        164.5,
                        79
                    ],
                    [
                        165.5,
                        78.92857142857143
                    ],
                    [
                        166.5,
                        78.7
                    ],
                    [
                        166.75,
                        78.5
                    ],
                    [
                        166.5,
                        78
                    ],
                    [
                        166.25,
                        77.5
                    ],
                    [
                        165.5,
                        76.5
                    ],
                    [
                        166.5,
                        75.5
                    ],
                    [
                        167.5,
                        75.5
                    ],
                    [
                        168,
                        76.5
                    ],
                    [
                        168.5,
                        77
                    ],
                    [
                        169,
                        76.5
                    ],
                    [
                        169.5,
                        76
                    ],
                    [
                        170.5,
                        75.5
                    ],
                    [
                        171.5,
                        76
                    ],
                    [
                        172,
                        76.5
                    ],
                    [
                        172.5,
                        76.64285714285714
                    ],
                    [
                        173.5,
                        76.92857142857143
                    ],
                    [
                        174.5,
                        77.4
                    ],
                    [
                        174.66666666666666,
                        77.5
                    ],
                    [
                        175.5,
                        77.95454545454545
                    ],
                    [
                        176.5,
                        78.3
                    ],
                    [
                        177.5,
                        78.26470588235294
                    ],
                    [
                        178.5,
                        78.03333333333333
                    ],
                    [
                        179.5,
                        77.86363636363636
                    ],
                    [
                        180.5,
                        77.5
                    ],
                    [
                        180.5,
                        77.5
                    ],
                    [
                        181.5,
                        77.26923076923077
                    ],
                    [
                        182.5,
                        76.83333333333333
                    ],
                    [
                        182.875,
                        76.5
                    ],
                    [
                        183.5,
                        76.3
                    ],
                    [
                        184.5,
                        76.07894736842105
                    ],
                    [
                        185.5,
                        75.92857142857143
                    ],
                    [
                        186.5,
                        75.5
                    ],
                    [
                        186.5,
                        75.5
                    ],
                    [
                        186.78571428571428,
                        74.5
                    ],
                    [
                        186.5,
                        74
                    ],
                    [
                        185.5,
                        73.5
                    ],
                    [
                        185.5,
                        72.5
                    ],
                    [
                        185.5,
                        72.5
                    ],
                    [
                        185.07142857142858,
                        71.5
                    ],
                    [
                        184.5,
                        70.83333333333333
                    ],
                    [
                        184.39473684210526,
                        70.5
                    ],
                    [
                        184.33333333333334,
                        69.5
                    ],
                    [
                        184.5,
                        69.35714285714286
                    ],
                    [
                        185.5,
                        69.13636363636364
                    ],
                    [
                        186.375,
                        68.5
                    ],
                    [
                        186.5,
                        68.3
                    ],
                    [
                        187.16666666666666,
                        67.5
                    ],
                    [
                        187.5,
                        66.5
                    ],
                    [
                        187.5,
                        66.5
                    ],
                    [
                        187.5,
                        66.5
                    ],
                    [
                        187.375,
                        65.5
                    ],
                    [
                        187.34615384615384,
                        64.5
                    ],
                    [
                        187.22727272727272,
                        63.5
                    ],
                    [
                        187.21428571428572,
                        62.5
                    ],
                    [
                        186.5,
                        61.875
                    ],
                    [
                        185.5,
                        61.833333333333336
                    ],
                    [
                        184.5,
                        61.5
                    ],
                    [
                        184.5,
                        61.5
                    ],
                    [
                        183.5,
                        61.27777777777778
                    ],
                    [
                        182.5,
                        61.357142857142854
                    ],
                    [
                        181.5,
                        61.357142857142854
                    ],
                    [
                        180.5,
                        61.25
                    ],
                    [
                        180.21428571428572,
                        61.5
                    ],
                    [
                        179.5,
                        62.5
                    ],
                    [
                        179.5,
                        62.5
                    ],
                    [
                        178.5,
                        63.5
                    ],
                    [
                        178.5,
                        63.5
                    ],
                    [
                        177.5,
                        64.16666666666667
                    ],
                    [
                        176.83333333333334,
                        63.5
                    ],
                    [
                        176.5,
                        62.5
                    ],
                    [
                        176.5,
                        62.5
                    ],
                    [
                        175.5,
                        62.166666666666664
                    ],
                    [
                        174.83333333333334,
                        61.5
                    ],
                    [
                        174.5,
                        60.5
                    ],
                    [
                        174.5,
                        60.5
                    ],
                    [
                        174.5,
                        60.5
                    ],
                    [
                        173.5,
                        60.9
                    ],
                    [
                        172.5,
                        60.7
                    ],
                    [
                        172,
                        60.5
                    ],
                    [
                        171.5,
                        60.214285714285715
                    ],
                    [
                        170.5,
                        59.68181818181818
                    ],
                    [
                        169.5,
                        59.625
                    ],
                    [
                        169.16666666666666,
                        59.5
                    ],
                    [
                        168.75,
                        58.5
                    ],
                    [
                        168.5,
                        58
                    ],
                    [
                        168.25,
                        57.5
                    ],
                    [
                        167.5,
                        56.75
                    ],
                    [
                        166.5,
                        56.9
                    ],
                    [
                        165.5,
                        57.125
                    ],
                    [
                        164.5,
                        56.75
                    ],
                    [
                        163.75,
                        57.5
                    ],
                    [
                        163.9,
                        58.5
                    ],
                    [
                        163.5,
                        59.5
                    ],
                    [
                        163.5,
                        59.5
                    ],
                    [
                        163.35714285714286,
                        60.5
                    ],
                    [
                        163.5,
                        61
                    ],
                    [
                        163.75,
                        61.5
                    ],
                    [
                        164.5,
                        62.5
                    ],
                    [
                        164.5,
                        62.5
                    ],
                    [
                        164.66666666666666,
                        63.5
                    ],
                    [
                        165.5,
                        64.33333333333333
                    ],
                    [
                        166.5,
                        64.5
                    ],
                    [
                        166.5,
                        64.5
                    ],
                    [
                        167,
                        65.5
                    ],
                    [
                        166.9,
                        66.5
                    ],
                    [
                        167.25,
                        67.5
                    ],
                    [
                        167.5,
                        68
                    ],
                    [
                        167.625,
                        68.5
                    ],
                    [
                        167.5,
                        68.83333333333333
                    ],
                    [
                        166.5,
                        69.33333333333333
                    ],
                    [
                        166.25,
                        69.5
                    ],
                    [
                        166.5,
                        69.83333333333333
                    ],
                    [
                        167.5,
                        70.16666666666667
                    ],
                    [
                        168,
                        70.5
                    ],
                    [
                        168.5,
                        71.5
                    ],
                    [
                        167.5,
                        72.16666666666667
                    ],
                    [
                        166.5,
                        72.5
                    ],
                    [
                        165.5,
                        72.25
                    ],
                    [
                        165.16666666666666,
                        72.5
                    ],
                    [
                        165.5,
                        73.5
                    ],
                    [
                        164.5,
                        74
                    ],
                    [
                        163.83333333333334,
                        73.5
                    ],
                    [
                        163.5,
                        72.5
                    ],
                    [
                        163.5,
                        72.5
                    ],
                    [
                        163.5,
                        72.5
                    ],
                    [
                        162.5,
                        73.16666666666667
                    ],
                    [
                        161.5,
                        73.5
                    ],
                    [
                        161.16666666666666,
                        72.5
                    ],
                    [
                        161.5,
                        71.5
                    ],
                    [
                        161.5,
                        71.5
                    ],
                    [
                        161.5,
                        71.5
                    ],
                    [
                        161.16666666666666,
                        70.5
                    ],
                    [
                        160.5,
                        69.83333333333333
                    ],
                    [
                        159.5,
                        69.9
                    ],
                    [
                        158.83333333333334,
                        69.5
                    ],
                    [
                        159,
                        68.5
                    ],
                    [
                        158.5,
                        68.3
                    ],
                    [
                        157.5,
                        67.5
                    ],
                    [
                        157.64285714285714,
                        66.5
                    ],
                    [
                        157.5,
                        66.16666666666667
                    ],
                    [
                        156.5,
                        65.5
                    ],
                    [
                        156.5,
                        65.5
                    ],
                    [
                        155.5,
                        65.5
                    ],
                    [
                        155.5,
                        65.5
                    ],
                    [
                        155.5,
                        65.5
                    ],
                    [
                        155.7,
                        66.5
                    ],
                    [
                        155.5,
                        67
                    ],
                    [
                        154.5,
                        67.16666666666667
                    ],
                    [
                        153.5,
                        67
                    ],
                    [
                        153,
                        66.5
                    ],
                    [
                        152.5,
                        66
                    ],
                    [
                        151.5,
                        66.5
                    ],
                    [
                        151.25,
                        65.5
                    ],
                    [
                        150.75,
                        64.5
                    ],
                    [
                        150.5,
                        64
                    ],
                    [
                        150.25,
                        63.5
                    ],
                    [
                        150.5,
                        63
                    ],
                    [
                        151,
                        62.5
                    ],
                    [
                        151.5,
                        62.166666666666664
                    ],
                    [
                        152,
                        61.5
                    ],
                    [
                        152.5,
                        60.5
                    ],
                    [
                        152.5,
                        60.5
                    ],
                    [
                        152.5,
                        59.5
                    ],
                    [
                        152.5,
                        59.5
                    ],
                    [
                        151.5,
                        59.5
                    ],
                    [
                        150.5,
                        59
                    ],
                    [
                        149.5,
                        59.5
                    ],
                    [
                        149.16666666666666,
                        58.5
                    ],
                    [
                        149.25,
                        57.5
                    ],
                    [
                        149.5,
                        57
                    ],
                    [
                        150,
                        56.5
                    ],
                    [
                        150.5,
                        56.166666666666664
                    ],
                    [
                        151.16666666666666,
                        55.5
                    ],
                    [
                        150.75,
                        54.5
                    ],
                    [
                        151.5,
                        54
                    ],
                    [
                        152.5,
                        54.333333333333336
                    ],
                    [
                        153.5,
                        53.7
                    ],
                    [
                        154,
                        53.5
                    ],
                    [
                        154.375,
                        52.5
                    ],
                    [
                        154,
                        51.5
                    ],
                    [
                        154.5,
                        50.5
                    ],
                    [
                        154.5,
                        50.5
                    ],
                    [
                        155.5,
                        50.166666666666664
                    ],
                    [
                        156.5,
                        50.5
                    ],
                    [
                        155.5,
                        51.5
                    ],
                    [
                        155.5,
                        51.5
                    ],
                    [
                        155.5,
                        51.5
                    ],
                    [
                        156.5,
                        51.5
                    ],
                    [
                        156.5,
                        51.5
                    ],
                    [
                        156.5,
                        50.5
                    ],
                    [
                        157.5,
                        50.166666666666664
                    ],
                    [
                        158.5,
                        49.833333333333336
                    ],
                    [
                        159.5,
                        50.3
                    ],
                    [
                        160.5,
                        50.166666666666664
                    ],
                    [
                        161.16666666666666,
                        49.5
                    ],
                    [
                        161.16666666666666,
                        48.5
                    ],
                    [
                        161.5,
                        48
                    ],
                    [
                        162,
                        47.5
                    ],
                    [
                        162,
                        46.5
                    ],
                    [
                        162.5,
                        45.5
                    ],
                    [
                        162.5,
                        45.5
                    ],
                    [
                        162.5,
                        45.5
                    ],
                    [
                        162.125,
                        44.5
                    ],
                    [
                        162.5,
                        44
                    ],
                    [
                        163.1,
                        43.5
                    ],
                    [
                        163.5,
                        43.166666666666664
                    ],
                    [
                        164.5,
                        43.3
                    ],
                    [
                        165.07142857142858,
                        42.5
                    ],
                    [
                        165.5,
                        41.75
                    ],
                    [
                        166.5,
                        41.5
                    ],
                    [
                        167.5,
                        41.5
                    ],
                    [
                        167.5,
                        41.5
                    ],
                    [
                        168.5,
                        40.5
                    ],
                    [
                        168.5,
                        40.5
                    ],
                    [
                        169.5,
                        40
                    ],
                    [
                        170.5,
                        40.333333333333336
                    ],
                    [
                        171.5,
                        39.833333333333336
                    ],
                    [
                        171.83333333333334,
                        39.5
                    ],
                    [
                        171.5,
                        39
                    ],
                    [
                        171,
                        38.5
                    ],
                    [
                        171.5,
                        38.31818181818182
                    ],
                    [
                        172.5,
                        38.04545454545455
                    ],
                    [
                        173.25,
                        37.5
                    ],
                    [
                        173.5,
                        36.833333333333336
                    ],
                    [
                        173.75,
                        36.5
                    ],
                    [
                        174.38888888888889,
                        35.5
                    ],
                    [
                        174.5,
                        35
                    ],
                    [
                        174.61111111111111,
                        34.5
                    ],
                    [
                        175.5,
                        33.92857142857143
                    ],
                    [
                        176.07142857142858,
                        34.5
                    ],
                    [
                        176.04545454545453,
                        35.5
                    ],
                    [
                        176.5,
                        36.5
                    ],
                    [
                        176.5,
                        36.5
                    ],
                    [
                        177.25,
                        37.5
                    ],
                    [
                        176.5,
                        38.5
                    ],
                    [
                        176.5,
                        38.5
                    ],
                    [
                        176.5,
                        38.5
                    ],
                    [
                        177.5,
                        39
                    ],
                    [
                        178.5,
                        39.166666666666664
                    ],
                    [
                        179.5,
                        38.5
                    ],
                    [
                        180.5,
                        39.04545454545455
                    ],
                    [
                        181.5,
                        39
                    ],
                    [
                        182.5,
                        39.166666666666664
                    ],
                    [
                        183.5,
                        39.333333333333336
                    ],
                    [
                        184,
                        39.5
                    ],
                    [
                        184.5,
                        39.75
                    ],
                    [
                        185.5,
                        40.5
                    ],
                    [
                        185.5,
                        40.5
                    ],
                    [
                        186.5,
                        40.666666666666664
                    ],
                    [
                        187.5,
                        41.1
                    ],
                    [
                        188.5,
                        41.1
                    ],
                    [
                        188.9,
                        41.5
                    ],
                    [
                        189.16666666666666,
                        42.5
                    ],
                    [
                        189.5,
                        42.72222222222222
                    ],
                    [
                        189.78571428571428,
                        42.5
                    ],
                    [
                        189.875,
                        41.5
                    ],
                    [
                        189.83333333333334,
                        40.5
                    ],
                    [
                        189.5,
                        40.1
                    ],
                    [
                        188.75,
                        39.5
                    ],
                    [
                        188.5,
                        39.4
                    ],
                    [
                        187.5,
                        38.57692307692308
                    ],
                    [
                        187.41666666666666,
                        38.5
                    ],
                    [
                        187.5,
                        38.333333333333336
                    ],
                    [
                        188.05555555555554,
                        37.5
                    ],
                    [
                        188.23333333333332,
                        36.5
                    ],
                    [
                        188.5,
                        36.13636363636363
                    ],
                    [
                        189.13636363636363,
                        35.5
                    ],
                    [
                        188.94444444444446,
                        34.5
                    ],
                    [
                        189.33333333333334,
                        33.5
                    ],
                    [
                        189.5,
                        33
                    ],
                    [
                        189.75,
                        32.5
                    ],
                    [
                        190.5,
                        31.5
                    ],
                    [
                        190.5,
                        31.5
                    ],
                    [
                        190.5,
                        31.5
                    ],
                    [
                        189.5,
                        30.75
                    ],
                    [
                        188.75,
                        31.5
                    ],
                    [
                        188.5,
                        31.75
                    ],
                    [
                        187.75,
                        32.5
                    ],
                    [
                        187.5,
                        32.611111111111114
                    ],
                    [
                        186.5,
                        32.95454545454545
                    ],
                    [
                        185.5,
                        33.04545454545455
                    ],
                    [
                        184.5,
                        33.3
                    ],
                    [
                        184.25,
                        33.5
                    ],
                    [
                        183.66666666666666,
                        34.5
                    ],
                    [
                        183.5,
                        34.6
                    ],
                    [
                        182.5,
                        35.5
                    ],
                    [
                        182.5,
                        35.5
                    ],
                    [
                        181.5,
                        35.833333333333336
                    ],
                    [
                        181.07142857142858,
                        35.5
                    ],
                    [
                        180.5,
                        34.92857142857143
                    ],
                    [
                        179.5,
                        35.1
                    ],
                    [
                        178.5,
                        35.3
                    ],
                    [
                        178.27777777777777,
                        34.5
                    ],
                    [
                        178.5,
                        34.31818181818182
                    ],
                    [
                        179.3181818181818,
                        33.5
                    ],
                    [
                        179.5,
                        33
                    ],
                    [
                        180.5,
                        32.5
                    ],
                    [
                        180.5,
                        32.5
                    ],
                    [
                        181.15217391304347,
                        31.5
                    ],
                    [
                        180.5,
                        30.61764705882353
                    ],
                    [
                        180.25,
                        30.5
                    ],
                    [
                        179.5,
                        30.23913043478261
                    ],
                    [
                        178.5,
                        29.5
                    ],
                    [
                        179.19230769230768,
                        28.5
                    ],
                    [
                        179.5,
                        28.144444444444446
                    ],
                    [
                        180.5,
                        28.289473684210527
                    ],
                    [
                        180.7,
                        28.5
                    ],
                    [
                        181.5,
                        29.195652173913043
                    ],
                    [
                        182.2,
                        29.5
                    ],
                    [
                        182.5,
                        30.1
                    ],
                    [
                        183.5,
                        30.5
                    ],
                    [
                        182.91666666666666,
                        31.5
                    ],
                    [
                        183.5,
                        32
                    ],
                    [
                        184.5,
                        31.700000000000003
                    ],
                    [
                        184.61111111111111,
                        31.5
                    ],
                    [
                        184.5,
                        31.38888888888889
                    ],
                    [
                        183.5,
                        30.5
                    ],
                    [
                        184.5,
                        30.283783783783782
                    ],
                    [
                        185.07142857142858,
                        30.5
                    ],
                    [
                        185.5,
                        30.928571428571427
                    ],
                    [
                        186.5,
                        30.6
                    ],
                    [
                        187.5,
                        30.96153846153846
                    ],
                    [
                        188.5,
                        31.40909090909091
                    ],
                    [
                        189.4090909090909,
                        30.5
                    ],
                    [
                        188.5,
                        29.73076923076923
                    ],
                    [
                        188.3235294117647,
                        29.5
                    ],
                    [
                        187.5,
                        28.863636363636363
                    ],
                    [
                        187.19230769230768,
                        28.5
                    ],
                    [
                        187,
                        27.5
                    ],
                    [
                        186.5,
                        26.944444444444443
                    ],
                    [
                        185.5,
                        27.5
                    ],
                    [
                        185.21428571428572,
                        26.5
                    ],
                    [
                        184.5,
                        25.59090909090909
                    ],
                    [
                        184.3,
                        25.5
                    ],
                    [
                        183.5,
                        25.136363636363637
                    ],
                    [
                        182.72222222222223,
                        24.5
                    ],
                    [
                        182.5,
                        24.318181818181817
                    ],
                    [
                        182.1,
                        24.5
                    ],
                    [
                        181.5,
                        24.6
                    ],
                    [
                        180.5,
                        24.65
                    ],
                    [
                        179.5,
                        24.794117647058822
                    ],
                    [
                        179.27272727272728,
                        24.5
                    ],
                    [
                        179.1,
                        23.5
                    ],
                    [
                        179.5,
                        23.318181818181817
                    ],
                    [
                        180.5,
                        23.25
                    ],
                    [
                        181.04545454545453,
                        22.5
                    ],
                    [
                        180.5,
                        21.75
                    ],
                    [
                        179.5,
                        21.681818181818183
                    ],
                    [
                        178.5,
                        22.5
                    ],
                    [
                        177.5,
                        21.863636363636363
                    ],
                    [
                        176.5,
                        21.785714285714285
                    ],
                    [
                        175.5,
                        22.1
                    ],
                    [
                        175.1,
                        22.5
                    ],
                    [
                        174.5,
                        23.5
                    ],
                    [
                        173.5,
                        23
                    ],
                    [
                        173.16666666666666,
                        23.5
                    ],
                    [
                        172.5,
                        23.56451612903226
                    ],
                    [
                        172,
                        23.5
                    ],
                    [
                        172.5,
                        22.5
                    ],
                    [
                        172.5,
                        22.5
                    ],
                    [
                        173.5,
                        22.375
                    ],
                    [
                        174.5,
                        21.9
                    ],
                    [
                        174.9,
                        21.5
                    ],
                    [
                        175.5,
                        20.75
                    ],
                    [
                        176.5,
                        20.928571428571427
                    ],
                    [
                        176.92857142857142,
                        20.5
                    ],
                    [
                        176.5,
                        19.75
                    ],
                    [
                        176.35714285714286,
                        19.5
                    ],
                    [
                        176.16666666666666,
                        18.5
                    ],
                    [
                        175.5,
                        17.5
                    ],
                    [
                        175.5,
                        17.5
                    ],
                    [
                        175.07142857142858,
                        16.5
                    ],
                    [
                        174.5,
                        15.833333333333332
                    ],
                    [
                        174.21428571428572,
                        15.5
                    ],
                    [
                        173.5,
                        14.666666666666666
                    ],
                    [
                        173.4090909090909,
                        14.5
                    ],
                    [
                        172.5,
                        13.590909090909092
                    ],
                    [
                        172.3,
                        13.5
                    ],
                    [
                        171.5,
                        12.928571428571429
                    ],
                    [
                        170.5,
                        12.676470588235293
                    ],
                    [
                        169.5,
                        12.585714285714285
                    ],
                    [
                        169.22727272727272,
                        12.5
                    ],
                    [
                        168.5,
                        12.029411764705882
                    ],
                    [
                        167.5,
                        11.710526315789474
                    ],
                    [
                        166.5,
                        11.75
                    ],
                    [
                        165.5,
                        12.1
                    ],
                    [
                        165.16666666666666,
                        12.5
                    ],
                    [
                        164.5,
                        13.5
                    ],
                    [
                        164.5,
                        13.5
                    ],
                    [
                        163.625,
                        14.5
                    ],
                    [
                        163.75,
                        15.5
                    ],
                    [
                        163.5,
                        15.833333333333332
                    ],
                    [
                        162.5,
                        15.75
                    ],
                    [
                        161.5,
                        15.600000000000001
                    ],
                    [
                        161.16666666666666,
                        15.5
                    ],
                    [
                        160.5,
                        15
                    ],
                    [
                        159.5,
                        15
                    ],
                    [
                        159.33333333333334,
                        14.5
                    ],
                    [
                        158.5,
                        13.875
                    ],
                    [
                        158.16666666666666,
                        13.5
                    ],
                    [
                        157.5,
                        12.9
                    ],
                    [
                        156.92857142857142,
                        12.5
                    ],
                    [
                        156.5,
                        12.125
                    ],
                    [
                        155.5,
                        11.633333333333333
                    ],
                    [
                        155.1,
                        11.5
                    ],
                    [
                        154.5,
                        11.071428571428571
                    ],
                    [
                        153.5,
                        10.6
                    ],
                    [
                        152.5,
                        10.61111111111111
                    ],
                    [
                        151.5,
                        11
                    ],
                    [
                        150.5,
                        10.884615384615385
                    ],
                    [
                        149.5,
                        11.038461538461538
                    ],
                    [
                        148.5,
                        11.115384615384615
                    ],
                    [
                        147.5,
                        11.045454545454545
                    ],
                    [
                        146.5,
                        10.571428571428571
                    ],
                    [
                        146.4090909090909,
                        10.5
                    ],
                    [
                        145.5,
                        9.944444444444445
                    ],
                    [
                        144.83333333333334,
                        9.5
                    ],
                    [
                        144.5,
                        9.289473684210526
                    ],
                    [
                        143.5,
                        9.181818181818182
                    ],
                    [
                        142.5,
                        9.18421052631579
                    ],
                    [
                        142.1,
                        9.5
                    ],
                    [
                        141.5,
                        10.4
                    ],
                    [
                        141.4,
                        10.5
                    ],
                    [
                        140.92857142857142,
                        11.5
                    ],
                    [
                        140.78571428571428,
                        12.5
                    ],
                    [
                        140.78571428571428,
                        13.5
                    ],
                    [
                        140.5,
                        14
                    ],
                    [
                        139.83333333333334,
                        14.5
                    ],
                    [
                        139.5,
                        15
                    ],
                    [
                        138.5,
                        15.5
                    ],
                    [
                        138.5,
                        15.5
                    ],
                    [
                        138.5,
                        15.5
                    ],
                    [
                        139.5,
                        16.5
                    ],
                    [
                        139,
                        17.5
                    ],
                    [
                        138.5,
                        18.5
                    ],
                    [
                        137.5,
                        17.5
                    ],
                    [
                        137.5,
                        17.5
                    ],
                    [
                        136.5,
                        17.5
                    ],
                    [
                        136.5,
                        17.5
                    ],
                    [
                        135.5,
                        18
                    ],
                    [
                        135,
                        18.5
                    ],
                    [
                        134.5,
                        19
                    ],
                    [
                        133.5,
                        19.5
                    ],
                    [
                        133.5,
                        19.5
                    ],
                    [
                        132.5,
                        20.5
                    ],
                    [
                        131.5,
                        20.5
                    ],
                    [
                        130.5,
                        19.833333333333332
                    ],
                    [
                        129.5,
                        20
                    ],
                    [
                        128.5,
                        20
                    ],
                    [
                        127.5,
                        19.928571428571427
                    ],
                    [
                        126.5,
                        20
                    ],
                    [
                        125.5,
                        20.166666666666668
                    ],
                    [
                        124.5,
                        20.071428571428573
                    ],
                    [
                        123.5,
                        20
                    ],
                    [
                        122.5,
                        20
                    ],
                    [
                        122.16666666666667,
                        19.5
                    ],
                    [
                        121.5,
                        19.214285714285715
                    ],
                    [
                        120.5,
                        18.833333333333332
                    ],
                    [
                        119.5,
                        18.7
                    ],
                    [
                        119.3,
                        18.5
                    ],
                    [
                        118.5,
                        18.136363636363637
                    ],
                    [
                        117.5,
                        18.357142857142858
                    ],
                    [
                        117,
                        18.5
                    ],
                    [
                        116.5,
                        18.642857142857142
                    ],
                    [
                        116,
                        18.5
                    ],
                    [
                        115.5,
                        18.3
                    ],
                    [
                        114.5,
                        18
                    ],
                    [
                        113.5,
                        18.166666666666668
                    ],
                    [
                        112.5,
                        18.5
                    ],
                    [
                        111.5,
                        17.5
                    ],
                    [
                        111.5,
                        17.5
                    ],
                    [
                        110.5,
                        16.5
                    ],
                    [
                        110.5,
                        16.5
                    ],
                    [
                        109.5,
                        16.5
                    ],
                    [
                        109.5,
                        16.5
                    ],
                    [
                        108.5,
                        17.166666666666668
                    ],
                    [
                        108,
                        16.5
                    ],
                    [
                        107.5,
                        16.3
                    ],
                    [
                        106.5,
                        16.166666666666668
                    ],
                    [
                        105.5,
                        16.1875
                    ],
                    [
                        104.5,
                        16.026315789473685
                    ],
                    [
                        103.5,
                        15.785714285714285
                    ],
                    [
                        102.7,
                        15.5
                    ],
                    [
                        102.5,
                        15.433333333333334
                    ],
                    [
                        101.5,
                        15.236842105263158
                    ],
                    [
                        100.5,
                        15.038461538461538
                    ],
                    [
                        99.5,
                        15.205882352941176
                    ],
                    [
                        99.04545454545455,
                        15.5
                    ],
                    [
                        98.5,
                        15.899999999999999
                    ],
                    [
                        97.5,
                        16.25
                    ],
                    [
                        97.125,
                        15.5
                    ],
                    [
                        96.5,
                        14.785714285714286
                    ],
                    [
                        96.1,
                        14.5
                    ],
                    [
                        95.5,
                        14.125
                    ],
                    [
                        94.78571428571429,
                        13.5
                    ],
                    [
                        94.5,
                        13.214285714285714
                    ],
                    [
                        94.1875,
                        12.5
                    ],
                    [
                        94.07142857142857,
                        11.5
                    ],
                    [
                        93.57692307692308,
                        10.5
                    ],
                    [
                        93.5,
                        10.409090909090908
                    ],
                    [
                        92.97368421052632,
                        9.5
                    ],
                    [
                        92.5,
                        8.970588235294118
                    ],
                    [
                        91.61111111111111,
                        8.5
                    ],
                    [
                        91.5,
                        8.433333333333334
                    ],
                    [
                        90.5,
                        7.98
                    ],
                    [
                        89.5,
                        7.892857142857142
                    ],
                    [
                        88.5,
                        7.790322580645162
                    ],
                    [
                        87.5,
                        7.6
                    ],
                    [
                        86.5,
                        7.530303030303031
                    ],
                    [
                        85.5,
                        7.5606060606060606
                    ],
                    [
                        85.31818181818181,
                        7.5
                    ],
                    [
                        84.63333333333334,
                        6.5
                    ],
                    [
                        84.5,
                        6.3
                    ],
                    [
                        84.1923076923077,
                        5.5
                    ],
                    [
                        84.26470588235294,
                        4.5
                    ],
                    [
                        83.5,
                        4.035714285714286
                    ],
                    [
                        83.03571428571429,
                        4.5
                    ],
                    [
                        82.95454545454545,
                        5.5
                    ],
                    [
                        82.94117647058823,
                        6.5
                    ],
                    [
                        83.38235294117646,
                        7.5
                    ],
                    [
                        83.5,
                        7.666666666666666
                    ],
                    [
                        83.95454545454545,
                        8.5
                    ],
                    [
                        83.82,
                        9.5
                    ],
                    [
                        83.61111111111111,
                        10.5
                    ],
                    [
                        83.5,
                        11.5
                    ],
                    [
                        83.5,
                        11.5
                    ],
                    [
                        83.23684210526316,
                        12.5
                    ],
                    [
                        82.97826086956522,
                        13.5
                    ],
                    [
                        82.5,
                        14.416666666666666
                    ],
                    [
                        82.4375,
                        14.5
                    ],
                    [
                        82.06,
                        15.5
                    ],
                    [
                        81.94,
                        16.5
                    ],
                    [
                        81.66,
                        17.5
                    ],
                    [
                        81.5,
                        18
                    ],
                    [
                        81.25,
                        18.5
                    ],
                    [
                        80.5,
                        19.5
                    ],
                    [
                        80.5,
                        19.5
                    ],
                    [
                        79.95454545454545,
                        20.5
                    ],
                    [
                        79.80434782608695,
                        21.5
                    ],
                    [
                        79.5,
                        22.5
                    ],
                    [
                        79.5,
                        22.5
                    ],
                    [
                        78.96666666666667,
                        23.5
                    ],
                    [
                        78.78571428571429,
                        24.5
                    ],
                    [
                        78.76666666666667,
                        25.5
                    ],
                    [
                        78.5,
                        26.166666666666668
                    ],
                    [
                        78.27777777777777,
                        26.5
                    ],
                    [
                        78.22727272727273,
                        27.5
                    ],
                    [
                        77.7,
                        28.5
                    ],
                    [
                        77.83333333333333,
                        29.5
                    ],
                    [
                        77.5,
                        29.833333333333332
                    ],
                    [
                        76.83333333333333,
                        30.5
                    ],
                    [
                        76.5,
                        30.8
                    ],
                    [
                        75.5,
                        30.954545454545453
                    ],
                    [
                        74.5,
                        30.625
                    ],
                    [
                        73.5,
                        31.166666666666668
                    ],
                    [
                        72.5,
                        31.4375
                    ],
                    [
                        71.5,
                        31.333333333333332
                    ],
                    [
                        70.75,
                        31.5
                    ],
                    [
                        70.5,
                        31.55263157894737
                    ],
                    [
                        69.5,
                        32.125
                    ],
                    [
                        69.125,
                        32.5
                    ],
                    [
                        68.5,
                        33.26923076923077
                    ],
                    [
                        67.5,
                        33.42857142857143
                    ],
                    [
                        66.5,
                        33.333333333333336
                    ],
                    [
                        65.5,
                        33.4375
                    ],
                    [
                        64.5,
                        33.38235294117647
                    ],
                    [
                        63.5,
                        33.4375
                    ],
                    [
                        63.40909090909091,
                        33.5
                    ],
                    [
                        62.5,
                        33.704081632653065
                    ],
                    [
                        61.5,
                        33.73529411764706
                    ],
                    [
                        60.5,
                        33.51754385964912
                    ],
                    [
                        60.464285714285715,
                        33.5
                    ],
                    [
                        59.5,
                        32.78947368421053
                    ],
                    [
                        58.5,
                        32.554545454545455
                    ],
                    [
                        57.5,
                        32.5
                    ],
                    [
                        57.5,
                        32.5
                    ],
                    [
                        57.5,
                        32.5
                    ],
                    [
                        56.5,
                        32.6764705882353
                    ],
                    [
                        55.5,
                        32.70967741935484
                    ],
                    [
                        54.5,
                        32.780701754385966
                    ],
                    [
                        53.5,
                        32.91025641025641
                    ],
                    [
                        52.5,
                        33.15384615384615
                    ],
                    [
                        51.5,
                        33.208333333333336
                    ],
                    [
                        50.8,
                        33.5
                    ],
                    [
                        50.5,
                        33.6764705882353
                    ],
                    [
                        49.76315789473684,
                        34.5
                    ],
                    [
                        49.5,
                        34.857142857142854
                    ],
                    [
                        48.5,
                        35.357142857142854
                    ],
                    [
                        48.3,
                        35.5
                    ],
                    [
                        47.5,
                        35.766666666666666
                    ],
                    [
                        46.54347826086956,
                        36.5
                    ],
                    [
                        46.5,
                        36.52564102564103
                    ],
                    [
                        45.5,
                        36.854838709677416
                    ],
                    [
                        44.5,
                        37.2
                    ],
                    [
                        44.07142857142857,
                        37.5
                    ],
                    [
                        43.5,
                        37.72857142857143
                    ],
                    [
                        42.6,
                        38.5
                    ],
                    [
                        42.5,
                        38.6578947368421
                    ],
                    [
                        41.86,
                        39.5
                    ],
                    [
                        41.5,
                        40.31818181818182
                    ],
                    [
                        41.34615384615385,
                        40.5
                    ],
                    [
                        41.083333333333336,
                        41.5
                    ],
                    [
                        41.5,
                        41.95454545454545
                    ],
                    [
                        41.833333333333336,
                        42.5
                    ],
                    [
                        41.5,
                        42.96153846153846
                    ],
                    [
                        41.0625,
                        43.5
                    ],
                    [
                        40.875,
                        44.5
                    ],
                    [
                        41.5,
                        45.026315789473685
                    ],
                    [
                        41.95,
                        45.5
                    ],
                    [
                        42.5,
                        46.078947368421055
                    ],
                    [
                        43.388888888888886,
                        46.5
                    ],
                    [
                        43.5,
                        46.6
                    ],
                    [
                        44.5,
                        47.5
                    ],
                    [
                        44.5,
                        47.5
                    ],
                    [
                        45.5,
                        48.36666666666667
                    ],
                    [
                        45.785714285714285,
                        48.5
                    ],
                    [
                        46.5,
                        49.125
                    ],
                    [
                        47,
                        49.5
                    ],
                    [
                        47.5,
                        50.1
                    ],
                    [
                        48.166666666666664,
                        50.5
                    ],
                    [
                        48.5,
                        51
                    ],
                    [
                        48.75,
                        51.5
                    ],
                    [
                        48.75,
                        52.5
                    ],
                    [
                        48.5,
                        53.5
                    ],
                    [
                        47.5,
                        53
                    ],
                    [
                        46.5,
                        53.5
                    ],
                    [
                        46.5,
                        53.5
                    ],
                    [
                        46.3,
                        54.5
                    ],
                    [
                        46.5,
                        54.833333333333336
                    ],
                    [
                        47,
                        55.5
                    ],
                    [
                        47.5,
                        56.5
                    ],
                    [
                        47.5,
                        56.5
                    ],
                    [
                        48.125,
                        57.5
                    ],
                    [
                        48.4,
                        58.5
                    ],
                    [
                        48.5,
                        58.75
                    ],
                    [
                        48.875,
                        59.5
                    ],
                    [
                        48.642857142857146,
                        60.5
                    ],
                    [
                        49.5,
                        61.5
                    ],
                    [
                        49.5,
                        61.5
                    ],
                    [
                        49.833333333333336,
                        62.5
                    ],
                    [
                        50.166666666666664,
                        63.5
                    ],
                    [
                        50.5,
                        64.5
                    ],
                    [
                        50.166666666666664,
                        65.5
                    ],
                    [
                        49.833333333333336,
                        66.5
                    ],
                    [
                        50.1,
                        67.5
                    ],
                    [
                        50.5,
                        68.5
                    ],
                    [
                        50.5,
                        68.5
                    ],
                    [
                        50.7,
                        69.5
                    ],
                    [
                        51.166666666666664,
                        70.5
                    ],
                    [
                        51,
                        71.5
                    ],
                    [
                        51.25,
                        72.5
                    ],
                    [
                        51.5,
                        73
                    ],
                    [
                        51.7,
                        73.5
                    ],
                    [
                        51.9,
                        74.5
                    ],
                    [
                        52.166666666666664,
                        75.5
                    ],
                    [
                        52.5,
                        76.5
                    ],
                    [
                        52.5,
                        76.5
                    ],
                    [
                        53,
                        77.5
                    ],
                    [
                        53.5,
                        78.5
                    ],
                    [
                        53.166666666666664,
                        79.5
                    ],
                    [
                        53.166666666666664,
                        80.5
                    ],
                    [
                        53.5,
                        81.5
                    ],
                    [
                        53,
                        82.5
                    ],
                    [
                        52.5,
                        83.5
                    ],
                    [
                        52.5,
                        83.5
                    ],
                    [
                        52.5,
                        84.5
                    ],
                    [
                        52.5,
                        84.5
                    ],
                    [
                        52.7,
                        85.5
                    ],
                    [
                        52.5,
                        86
                    ],
                    [
                        52.166666666666664,
                        86.5
                    ],
                    [
                        52.5,
                        87.5
                    ],
                    [
                        52.5,
                        88.5
                    ],
                    [
                        52.5,
                        88.5
                    ],
                    [
                        52.833333333333336,
                        89.5
                    ],
                    [
                        53.5,
                        90.5
                    ],
                    [
                        53.5,
                        91.5
                    ],
                    [
                        53.5,
                        92
                    ],
                    [
                        54.5,
                        92
                    ],
                    [
                        55.5,
                        92
                    ],
                    [
                        56.5,
                        92
                    ],
                    [
                        57.5,
                        92
                    ],
                    [
                        58.5,
                        92
                    ],
                    [
                        59.5,
                        92
                    ],
                    [
                        60.5,
                        92
                    ],
                    [
                        61.5,
                        92
                    ],
                    [
                        62.5,
                        92
                    ],
                    [
                        63.5,
                        92
                    ],
                    [
                        64.5,
                        92
                    ],
                    [
                        65.5,
                        92
                    ],
                    [
                        66.5,
                        92
                    ],
                    [
                        67.5,
                        92
                    ],
                    [
                        68.5,
                        92
                    ],
                    [
                        69.5,
                        92
                    ],
                    [
                        70.5,
                        92
                    ],
                    [
                        71.5,
                        92
                    ],
                    [
                        72.5,
                        92
                    ],
                    [
                        73.5,
                        92
                    ],
                    [
                        74.5,
                        92
                    ],
                    [
                        75.5,
                        92
                    ],
                    [
                        76.5,
                        92
                    ],
                    [
                        77.5,
                        92
                    ],
                    [
                        78.5,
                        92
                    ],
                    [
                        79.5,
                        92
                    ],
                    [
                        80.5,
                        92
                    ],
                    [
                        81.5,
                        92
                    ],
                    [
                        82.5,
                        92
                    ],
                    [
                        83.5,
                        92
                    ],
                    [
                        84.5,
                        92
                    ],
                    [
                        85.5,
                        92
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        144.5,
                        92
                    ],
                    [
                        145.5,
                        92
                    ],
                    [
                        146.5,
                        92
                    ],
                    [
                        147.5,
                        92
                    ],
                    [
                        148.5,
                        92
                    ],
                    [
                        149.5,
                        92
                    ],
                    [
                        150.5,
                        92
                    ],
                    [
                        151.5,
                        92
                    ],
                    [
                        152.5,
                        92
                    ],
                    [
                        153.5,
                        92
                    ],
                    [
                        154.5,
                        92
                    ],
                    [
                        155.5,
                        92
                    ],
                    [
                        156.5,
                        92
                    ],
                    [
                        157.5,
                        92
                    ],
                    [
                        158.5,
                        92
                    ],
                    [
                        159.5,
                        92
                    ],
                    [
                        160.5,
                        92
                    ],
                    [
                        161.5,
                        92
                    ],
                    [
                        162.5,
                        92
                    ],
                    [
                        163.5,
                        92
                    ],
                    [
                        164.5,
                        92
                    ],
                    [
                        165.5,
                        92
                    ],
                    [
                        166.5,
                        92
                    ],
                    [
                        167.5,
                        92
                    ],
                    [
                        167.71428571428572,
                        91.5
                    ]
                ],
                [
                    [
                        183.5,
                        28
                    ],
                    [
                        183.4090909090909,
                        27.5
                    ],
                    [
                        183.5,
                        27.4375
                    ],
                    [
                        183.66666666666666,
                        27.5
                    ],
                    [
                        183.5,
                        28
                    ]
                ],
                [
                    [
                        177.5,
                        30.923076923076923
                    ],
                    [
                        176.8125,
                        30.5
                    ],
                    [
                        177.5,
                        29.5
                    ],
                    [
                        178.5,
                        30.5
                    ],
                    [
                        177.5,
                        30.923076923076923
                    ]
                ],
                [
                    [
                        153.5,
                        65.5
                    ],
                    [
                        153.5,
                        65.5
                    ],
                    [
                        153.5,
                        65.5
                    ],
                    [
                        153.5,
                        65.5
                    ],
                    [
                        153.5,
                        65.5
                    ]
                ],
                [
                    [
                        161.5,
                        68.5
                    ],
                    [
                        161.5,
                        68.5
                    ],
                    [
                        160.5,
                        68.5
                    ],
                    [
                        160.5,
                        68.5
                    ],
                    [
                        160.5,
                        68.5
                    ],
                    [
                        161.5,
                        68.5
                    ],
                    [
                        161.5,
                        68.5
                    ]
                ],
                [
                    [
                        191.5,
                        68.5
                    ],
                    [
                        191.5,
                        68.5
                    ],
                    [
                        191.5,
                        68.5
                    ],
                    [
                        191.5,
                        68.5
                    ],
                    [
                        191.5,
                        68.5
                    ]
                ],
                [
                    [
                        166.5,
                        75.5
                    ],
                    [
                        165.5,
                        74.5
                    ],
                    [
                        166.5,
                        74.16666666666667
                    ],
                    [
                        166.83333333333334,
                        74.5
                    ],
                    [
                        166.5,
                        75.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 30,
        "coordinates": [
            [
                [
                    [
                        83.73529411764706,
                        6.5
                    ],
                    [
                        83.61538461538461,
                        5.5
                    ],
                    [
                        83.5,
                        4.9
                    ],
                    [
                        83.4090909090909,
                        5.5
                    ],
                    [
                        83.38235294117646,
                        6.5
                    ],
                    [
                        83.5,
                        6.735294117647059
                    ],
                    [
                        83.73529411764706,
                        6.5
                    ]
                ]
            ],
            [
                [
                    [
                        146.16666666666666,
                        11.5
                    ],
                    [
                        145.5,
                        11.055555555555555
                    ],
                    [
                        144.94444444444446,
                        10.5
                    ],
                    [
                        144.5,
                        10.233333333333333
                    ],
                    [
                        143.5,
                        10.115384615384615
                    ],
                    [
                        142.5,
                        10.192307692307692
                    ],
                    [
                        142.27777777777777,
                        10.5
                    ],
                    [
                        142.5,
                        11.5
                    ],
                    [
                        142.5,
                        11.5
                    ],
                    [
                        142.5,
                        11.5
                    ],
                    [
                        143.5,
                        11.333333333333334
                    ],
                    [
                        143.83333333333334,
                        11.5
                    ],
                    [
                        144.5,
                        12
                    ],
                    [
                        145.5,
                        12.3
                    ],
                    [
                        146.16666666666666,
                        11.5
                    ]
                ]
            ],
            [
                [
                    [
                        186.6153846153846,
                        28.5
                    ],
                    [
                        186.5,
                        28.26923076923077
                    ],
                    [
                        186.2,
                        28.5
                    ],
                    [
                        186.5,
                        28.676470588235293
                    ],
                    [
                        186.6153846153846,
                        28.5
                    ]
                ]
            ],
            [
                [
                    [
                        185.3235294117647,
                        29.5
                    ],
                    [
                        184.5,
                        28.5
                    ],
                    [
                        184.5,
                        28.5
                    ],
                    [
                        184.5,
                        28.5
                    ],
                    [
                        183.76315789473685,
                        29.5
                    ],
                    [
                        184.5,
                        29.87837837837838
                    ],
                    [
                        185.3235294117647,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        180.5,
                        31.5
                    ],
                    [
                        180.5,
                        31.5
                    ],
                    [
                        179.5,
                        31.25
                    ],
                    [
                        179.25,
                        31.5
                    ],
                    [
                        179.5,
                        31.714285714285715
                    ],
                    [
                        180.5,
                        31.5
                    ],
                    [
                        180.5,
                        31.5
                    ]
                ]
            ],
            [
                [
                    [
                        178.63636363636363,
                        33.5
                    ],
                    [
                        178.5,
                        33.2
                    ],
                    [
                        178.125,
                        33.5
                    ],
                    [
                        178.5,
                        33.63636363636363
                    ],
                    [
                        178.63636363636363,
                        33.5
                    ]
                ]
            ],
            [
                [
                    [
                        171.9,
                        36.5
                    ],
                    [
                        171.5,
                        35.5
                    ],
                    [
                        171.5,
                        35.5
                    ],
                    [
                        171.5,
                        35.5
                    ],
                    [
                        170.83333333333334,
                        36.5
                    ],
                    [
                        171.5,
                        36.9
                    ],
                    [
                        171.9,
                        36.5
                    ]
                ]
            ],
            [
                [
                    [
                        187,
                        36.5
                    ],
                    [
                        187.5,
                        35.5
                    ],
                    [
                        187.5,
                        35.5
                    ],
                    [
                        187.5,
                        35.5
                    ],
                    [
                        186.5,
                        35.05555555555556
                    ],
                    [
                        185.5,
                        35.3
                    ],
                    [
                        185.25,
                        35.5
                    ],
                    [
                        185.5,
                        36
                    ],
                    [
                        185.7,
                        36.5
                    ],
                    [
                        186.5,
                        37.3
                    ],
                    [
                        187,
                        36.5
                    ]
                ]
            ],
            [
                [
                    [
                        169.86363636363637,
                        37.5
                    ],
                    [
                        169.5,
                        37.13636363636363
                    ],
                    [
                        168.5,
                        37.357142857142854
                    ],
                    [
                        168.4090909090909,
                        37.5
                    ],
                    [
                        168.5,
                        38
                    ],
                    [
                        169.5,
                        37.80769230769231
                    ],
                    [
                        169.86363636363637,
                        37.5
                    ]
                ]
            ],
            [
                [
                    [
                        160.85294117647058,
                        41.5
                    ],
                    [
                        160.5,
                        40.5
                    ],
                    [
                        160.5,
                        40.5
                    ],
                    [
                        159.5,
                        40
                    ],
                    [
                        159.16666666666666,
                        40.5
                    ],
                    [
                        159.5,
                        41.5
                    ],
                    [
                        159.5,
                        41.5
                    ],
                    [
                        160.5,
                        42.04545454545455
                    ],
                    [
                        160.85294117647058,
                        41.5
                    ]
                ]
            ],
            [
                [
                    [
                        154.6818181818182,
                        43.5
                    ],
                    [
                        154.5,
                        43
                    ],
                    [
                        153.83333333333334,
                        43.5
                    ],
                    [
                        154.5,
                        43.68181818181818
                    ],
                    [
                        154.6818181818182,
                        43.5
                    ]
                ]
            ],
            [
                [
                    [
                        161.8684210526316,
                        43.5
                    ],
                    [
                        161.5,
                        43.03333333333333
                    ],
                    [
                        160.91666666666666,
                        43.5
                    ],
                    [
                        161.5,
                        43.911764705882355
                    ],
                    [
                        161.8684210526316,
                        43.5
                    ]
                ]
            ],
            [
                [
                    [
                        158.75,
                        46.5
                    ],
                    [
                        159.21428571428572,
                        45.5
                    ],
                    [
                        158.5,
                        45.04545454545455
                    ],
                    [
                        157.64285714285714,
                        44.5
                    ],
                    [
                        157.5,
                        44.375
                    ],
                    [
                        157,
                        44.5
                    ],
                    [
                        157.22727272727272,
                        45.5
                    ],
                    [
                        156.61111111111111,
                        46.5
                    ],
                    [
                        157.5,
                        47.22727272727273
                    ],
                    [
                        158.5,
                        46.73529411764706
                    ],
                    [
                        158.75,
                        46.5
                    ]
                ]
            ],
            [
                [
                    [
                        156.85294117647058,
                        48.5
                    ],
                    [
                        157,
                        47.5
                    ],
                    [
                        156.5,
                        46.75
                    ],
                    [
                        156.35714285714286,
                        46.5
                    ],
                    [
                        155.5,
                        45.5
                    ],
                    [
                        155.5,
                        45.5
                    ],
                    [
                        155.5,
                        45.5
                    ],
                    [
                        154.9,
                        46.5
                    ],
                    [
                        154.83333333333334,
                        47.5
                    ],
                    [
                        154.63333333333333,
                        48.5
                    ],
                    [
                        155.5,
                        49
                    ],
                    [
                        156.5,
                        48.833333333333336
                    ],
                    [
                        156.85294117647058,
                        48.5
                    ]
                ]
            ],
            [
                [
                    [
                        180.4,
                        76.5
                    ],
                    [
                        180.5,
                        76.4090909090909
                    ],
                    [
                        181.5,
                        75.78571428571429
                    ],
                    [
                        182.5,
                        75.79411764705883
                    ],
                    [
                        183.5,
                        75.7
                    ],
                    [
                        184.05555555555554,
                        75.5
                    ],
                    [
                        184.5,
                        75.1923076923077
                    ],
                    [
                        185.25,
                        74.5
                    ],
                    [
                        184.5,
                        73.75
                    ],
                    [
                        184.375,
                        73.5
                    ],
                    [
                        184.42,
                        72.5
                    ],
                    [
                        184.02173913043478,
                        71.5
                    ],
                    [
                        183.60526315789474,
                        70.5
                    ],
                    [
                        183.5,
                        70.33333333333333
                    ],
                    [
                        183.02380952380952,
                        69.5
                    ],
                    [
                        182.625,
                        68.5
                    ],
                    [
                        183.5,
                        67.86363636363636
                    ],
                    [
                        184.5,
                        67.8076923076923
                    ],
                    [
                        185.5,
                        67.61111111111111
                    ],
                    [
                        185.58333333333334,
                        67.5
                    ],
                    [
                        186.25,
                        66.5
                    ],
                    [
                        186.13636363636363,
                        65.5
                    ],
                    [
                        186.19230769230768,
                        64.5
                    ],
                    [
                        185.625,
                        63.5
                    ],
                    [
                        185.5,
                        63.416666666666664
                    ],
                    [
                        184.5,
                        63.166666666666664
                    ],
                    [
                        183.5,
                        63.04545454545455
                    ],
                    [
                        182.5,
                        63
                    ],
                    [
                        181.5,
                        62.875
                    ],
                    [
                        180.5,
                        63.333333333333336
                    ],
                    [
                        180.4,
                        63.5
                    ],
                    [
                        179.625,
                        64.5
                    ],
                    [
                        179.5,
                        64.58333333333333
                    ],
                    [
                        178.5,
                        65.14285714285714
                    ],
                    [
                        177.5,
                        65.3125
                    ],
                    [
                        176.5,
                        64.5
                    ],
                    [
                        176.5,
                        64.5
                    ],
                    [
                        175.5,
                        63.5
                    ],
                    [
                        175.5,
                        63.5
                    ],
                    [
                        174.5,
                        62.970588235294116
                    ],
                    [
                        173.5,
                        62.63636363636363
                    ],
                    [
                        172.5,
                        62.5
                    ],
                    [
                        172.5,
                        62.5
                    ],
                    [
                        171.5,
                        62.5
                    ],
                    [
                        170.5,
                        61.75
                    ],
                    [
                        169.9,
                        62.5
                    ],
                    [
                        169.94444444444446,
                        63.5
                    ],
                    [
                        169.57692307692307,
                        64.5
                    ],
                    [
                        169.5,
                        64.66666666666667
                    ],
                    [
                        169.08333333333334,
                        65.5
                    ],
                    [
                        169.2,
                        66.5
                    ],
                    [
                        169.5,
                        67
                    ],
                    [
                        169.73076923076923,
                        67.5
                    ],
                    [
                        170.33333333333334,
                        68.5
                    ],
                    [
                        170.5,
                        68.66666666666667
                    ],
                    [
                        171.5,
                        69.41666666666667
                    ],
                    [
                        171.61111111111111,
                        69.5
                    ],
                    [
                        171.5,
                        69.75
                    ],
                    [
                        171.07142857142858,
                        70.5
                    ],
                    [
                        171.5,
                        71.1
                    ],
                    [
                        171.83333333333334,
                        71.5
                    ],
                    [
                        172,
                        72.5
                    ],
                    [
                        172.5,
                        72.83333333333333
                    ],
                    [
                        173.5,
                        73.16666666666667
                    ],
                    [
                        174.5,
                        73.5
                    ],
                    [
                        174.5,
                        73.5
                    ],
                    [
                        174.61111111111111,
                        74.5
                    ],
                    [
                        174.95454545454547,
                        75.5
                    ],
                    [
                        175.35714285714286,
                        76.5
                    ],
                    [
                        175.5,
                        76.5909090909091
                    ],
                    [
                        176.5,
                        77.3
                    ],
                    [
                        177.5,
                        77.4
                    ],
                    [
                        178.5,
                        77.20833333333333
                    ],
                    [
                        179.5,
                        76.95
                    ],
                    [
                        180.4,
                        76.5
                    ]
                ]
            ],
            [
                [
                    [
                        152.5,
                        82.5
                    ],
                    [
                        152.75,
                        81.5
                    ],
                    [
                        152.5,
                        81.21428571428571
                    ],
                    [
                        152.1,
                        81.5
                    ],
                    [
                        151.5,
                        82.5
                    ],
                    [
                        151.5,
                        82.5
                    ],
                    [
                        151.5,
                        82.5
                    ],
                    [
                        152.5,
                        82.5
                    ],
                    [
                        152.5,
                        82.5
                    ]
                ]
            ],
            [
                [
                    [
                        165.35714285714286,
                        91.5
                    ],
                    [
                        164.94444444444446,
                        90.5
                    ],
                    [
                        165.5,
                        90.22222222222223
                    ],
                    [
                        166.5,
                        89.88095238095238
                    ],
                    [
                        167.5,
                        89.55263157894737
                    ],
                    [
                        167.55555555555554,
                        89.5
                    ],
                    [
                        168.18,
                        88.5
                    ],
                    [
                        168.5,
                        87.61111111111111
                    ],
                    [
                        168.57692307692307,
                        87.5
                    ],
                    [
                        169.28571428571428,
                        86.5
                    ],
                    [
                        169.5,
                        86.125
                    ],
                    [
                        169.95454545454547,
                        85.5
                    ],
                    [
                        170.22222222222223,
                        84.5
                    ],
                    [
                        170.5,
                        84
                    ],
                    [
                        170.77777777777777,
                        83.5
                    ],
                    [
                        171.08823529411765,
                        82.5
                    ],
                    [
                        171.5,
                        81.625
                    ],
                    [
                        171.54545454545453,
                        81.5
                    ],
                    [
                        171.5,
                        81.4
                    ],
                    [
                        170.5,
                        81.07142857142857
                    ],
                    [
                        169.5,
                        81.23913043478261
                    ],
                    [
                        168.83333333333334,
                        81.5
                    ],
                    [
                        168.5,
                        81.71428571428571
                    ],
                    [
                        167.5,
                        82.1470588235294
                    ],
                    [
                        166.5,
                        82.4375
                    ],
                    [
                        166.38888888888889,
                        82.5
                    ],
                    [
                        165.5,
                        83.5
                    ],
                    [
                        165.5,
                        83.5
                    ],
                    [
                        164.5,
                        84.125
                    ],
                    [
                        163.5,
                        83.5
                    ],
                    [
                        163.5,
                        83.5
                    ],
                    [
                        162.5,
                        83.35714285714286
                    ],
                    [
                        161.5,
                        82.95454545454545
                    ],
                    [
                        160.5,
                        82.5
                    ],
                    [
                        160.5,
                        82.5
                    ],
                    [
                        159.5,
                        82.08823529411765
                    ],
                    [
                        158.5,
                        81.94444444444444
                    ],
                    [
                        157.5,
                        82.07142857142857
                    ],
                    [
                        156.64285714285714,
                        82.5
                    ],
                    [
                        156.5,
                        82.57692307692308
                    ],
                    [
                        155.5,
                        82.83333333333333
                    ],
                    [
                        154.75,
                        83.5
                    ],
                    [
                        154.5,
                        83.72222222222223
                    ],
                    [
                        153.5,
                        84.375
                    ],
                    [
                        153.25,
                        84.5
                    ],
                    [
                        152.5,
                        85.25
                    ],
                    [
                        152.16666666666666,
                        85.5
                    ],
                    [
                        151.5,
                        85.9
                    ],
                    [
                        150.5,
                        85.5
                    ],
                    [
                        150.5,
                        85.5
                    ],
                    [
                        149.83333333333334,
                        84.5
                    ],
                    [
                        149.9,
                        83.5
                    ],
                    [
                        149.5,
                        82.5
                    ],
                    [
                        150,
                        81.5
                    ],
                    [
                        150.5,
                        80.5
                    ],
                    [
                        150.5,
                        80.5
                    ],
                    [
                        151,
                        79.5
                    ],
                    [
                        151.5,
                        78.75
                    ],
                    [
                        152.5,
                        78.5
                    ],
                    [
                        152.5,
                        78.5
                    ],
                    [
                        152.5,
                        78.5
                    ],
                    [
                        152.16666666666666,
                        77.5
                    ],
                    [
                        152.5,
                        77
                    ],
                    [
                        152.75,
                        76.5
                    ],
                    [
                        152.5,
                        76
                    ],
                    [
                        151.5,
                        75.5
                    ],
                    [
                        151.5,
                        74.5
                    ],
                    [
                        151.5,
                        74.5
                    ],
                    [
                        150.5,
                        73.75
                    ],
                    [
                        150,
                        73.5
                    ],
                    [
                        150.5,
                        73
                    ],
                    [
                        150.7,
                        72.5
                    ],
                    [
                        151.07142857142858,
                        71.5
                    ],
                    [
                        151.21428571428572,
                        70.5
                    ],
                    [
                        151,
                        69.5
                    ],
                    [
                        150.5,
                        69.21428571428571
                    ],
                    [
                        149.5,
                        68.875
                    ],
                    [
                        149,
                        68.5
                    ],
                    [
                        148.5,
                        68.125
                    ],
                    [
                        147.5,
                        67.86363636363636
                    ],
                    [
                        146.5,
                        67.7
                    ],
                    [
                        145.83333333333334,
                        67.5
                    ],
                    [
                        145.5,
                        67.3
                    ],
                    [
                        144.5,
                        66.6
                    ],
                    [
                        144.33333333333334,
                        66.5
                    ],
                    [
                        143.5,
                        65.94444444444444
                    ],
                    [
                        142.83333333333334,
                        65.5
                    ],
                    [
                        142.5,
                        65.21428571428571
                    ],
                    [
                        141.5,
                        64.875
                    ],
                    [
                        140.5,
                        64.5
                    ],
                    [
                        141.5,
                        63.75
                    ],
                    [
                        141.83333333333334,
                        63.5
                    ],
                    [
                        142.5,
                        62.5
                    ],
                    [
                        142.5,
                        62.5
                    ],
                    [
                        143.5,
                        61.5
                    ],
                    [
                        143.5,
                        61.5
                    ],
                    [
                        144,
                        60.5
                    ],
                    [
                        143.5,
                        59.5
                    ],
                    [
                        144.5,
                        58.75
                    ],
                    [
                        144.75,
                        58.5
                    ],
                    [
                        145.5,
                        57.9
                    ],
                    [
                        145.9,
                        57.5
                    ],
                    [
                        146.5,
                        56.75
                    ],
                    [
                        146.64285714285714,
                        56.5
                    ],
                    [
                        147.5,
                        55.75
                    ],
                    [
                        147.9,
                        55.5
                    ],
                    [
                        148.5,
                        54.5
                    ],
                    [
                        148.5,
                        54.5
                    ],
                    [
                        148.64285714285714,
                        53.5
                    ],
                    [
                        148.5,
                        53.375
                    ],
                    [
                        147.72222222222223,
                        52.5
                    ],
                    [
                        148.27777777777777,
                        51.5
                    ],
                    [
                        148.16666666666666,
                        50.5
                    ],
                    [
                        147.7,
                        49.5
                    ],
                    [
                        147.5,
                        49.357142857142854
                    ],
                    [
                        146.75,
                        48.5
                    ],
                    [
                        146.5,
                        48.25
                    ],
                    [
                        145.5,
                        47.5
                    ],
                    [
                        145.5,
                        47.5
                    ],
                    [
                        144.5,
                        46.642857142857146
                    ],
                    [
                        144.33333333333334,
                        46.5
                    ],
                    [
                        143.9,
                        45.5
                    ],
                    [
                        143.5,
                        44.833333333333336
                    ],
                    [
                        142.5,
                        44.5
                    ],
                    [
                        143.5,
                        43.5
                    ],
                    [
                        143.5,
                        43.5
                    ],
                    [
                        144.16666666666666,
                        42.5
                    ],
                    [
                        144.5,
                        42.333333333333336
                    ],
                    [
                        145,
                        42.5
                    ],
                    [
                        145.5,
                        42.75
                    ],
                    [
                        146,
                        42.5
                    ],
                    [
                        146.5,
                        42.333333333333336
                    ],
                    [
                        147.5,
                        41.9
                    ],
                    [
                        148.5,
                        41.9
                    ],
                    [
                        149.5,
                        41.7
                    ],
                    [
                        149.83333333333334,
                        41.5
                    ],
                    [
                        150.5,
                        41.27777777777778
                    ],
                    [
                        151.5,
                        41.5
                    ],
                    [
                        151.5,
                        41.5
                    ],
                    [
                        151.5,
                        41.5
                    ],
                    [
                        152.5,
                        41.333333333333336
                    ],
                    [
                        153,
                        41.5
                    ],
                    [
                        152.5,
                        42.5
                    ],
                    [
                        152.5,
                        42.5
                    ],
                    [
                        152.5,
                        42.5
                    ],
                    [
                        153.5,
                        42.5
                    ],
                    [
                        153.5,
                        42.5
                    ],
                    [
                        154.5,
                        42.34615384615385
                    ],
                    [
                        155.5,
                        42.30952380952381
                    ],
                    [
                        156.5,
                        42.09090909090909
                    ],
                    [
                        157.26470588235293,
                        41.5
                    ],
                    [
                        156.5,
                        40.57142857142857
                    ],
                    [
                        156.375,
                        40.5
                    ],
                    [
                        156.5,
                        40.3
                    ],
                    [
                        157.5,
                        40.357142857142854
                    ],
                    [
                        158.5,
                        39.833333333333336
                    ],
                    [
                        159,
                        39.5
                    ],
                    [
                        158.5,
                        39
                    ],
                    [
                        158.33333333333334,
                        38.5
                    ],
                    [
                        158.5,
                        38.166666666666664
                    ],
                    [
                        159.16666666666666,
                        37.5
                    ],
                    [
                        159.5,
                        37.3
                    ],
                    [
                        160.5,
                        37
                    ],
                    [
                        161.5,
                        37.25
                    ],
                    [
                        162.5,
                        36.5
                    ],
                    [
                        163.5,
                        37.26190476190476
                    ],
                    [
                        164.5,
                        36.666666666666664
                    ],
                    [
                        165.5,
                        36.6875
                    ],
                    [
                        166.5,
                        36.785714285714285
                    ],
                    [
                        167,
                        36.5
                    ],
                    [
                        166.5,
                        36.1
                    ],
                    [
                        166.3235294117647,
                        35.5
                    ],
                    [
                        166.5,
                        35.26923076923077
                    ],
                    [
                        167.5,
                        35.13636363636363
                    ],
                    [
                        168.5,
                        35.4
                    ],
                    [
                        169.5,
                        35.125
                    ],
                    [
                        170.5,
                        35.31818181818182
                    ],
                    [
                        171.4,
                        34.5
                    ],
                    [
                        171.5,
                        34.166666666666664
                    ],
                    [
                        172.5,
                        34.166666666666664
                    ],
                    [
                        173.5,
                        33.7
                    ],
                    [
                        173.64285714285714,
                        33.5
                    ],
                    [
                        174.5,
                        33.22727272727273
                    ],
                    [
                        175.5,
                        33.25675675675676
                    ],
                    [
                        176.5,
                        32.75
                    ],
                    [
                        177.3,
                        32.5
                    ],
                    [
                        177.5,
                        31.5
                    ],
                    [
                        177.5,
                        31.5
                    ],
                    [
                        177.5,
                        31.5
                    ],
                    [
                        176.5,
                        31.08823529411765
                    ],
                    [
                        176.34126984126985,
                        30.5
                    ],
                    [
                        176.47297297297297,
                        29.5
                    ],
                    [
                        176.5,
                        29.483050847457626
                    ],
                    [
                        177.5,
                        29.071428571428573
                    ],
                    [
                        178.5,
                        29.083333333333332
                    ],
                    [
                        178.90384615384616,
                        28.5
                    ],
                    [
                        179.5,
                        27.81111111111111
                    ],
                    [
                        180.5,
                        27.5
                    ],
                    [
                        181.45,
                        28.5
                    ],
                    [
                        181.5,
                        28.543478260869566
                    ],
                    [
                        181.7,
                        28.5
                    ],
                    [
                        181.78571428571428,
                        27.5
                    ],
                    [
                        181.5,
                        27.166666666666668
                    ],
                    [
                        181.3181818181818,
                        26.5
                    ],
                    [
                        181.5,
                        26.25
                    ],
                    [
                        181.76666666666668,
                        26.5
                    ],
                    [
                        182.5,
                        27.1875
                    ],
                    [
                        183.5,
                        26.5
                    ],
                    [
                        183.5,
                        26.5
                    ],
                    [
                        183.5,
                        26.5
                    ],
                    [
                        182.88888888888889,
                        25.5
                    ],
                    [
                        182.5,
                        25.15
                    ],
                    [
                        181.5,
                        25.1
                    ],
                    [
                        180.5,
                        25.4
                    ],
                    [
                        180.1,
                        25.5
                    ],
                    [
                        179.5,
                        25.575
                    ],
                    [
                        178.5,
                        25.571428571428573
                    ],
                    [
                        178.45652173913044,
                        25.5
                    ],
                    [
                        178.5,
                        25.166666666666668
                    ],
                    [
                        178.5909090909091,
                        24.5
                    ],
                    [
                        178.5,
                        24.357142857142858
                    ],
                    [
                        177.8684210526316,
                        23.5
                    ],
                    [
                        177.5,
                        23.033333333333335
                    ],
                    [
                        176.5,
                        23.333333333333332
                    ],
                    [
                        176.16666666666666,
                        23.5
                    ],
                    [
                        176.5,
                        23.625
                    ],
                    [
                        176.83333333333334,
                        24.5
                    ],
                    [
                        176.5,
                        24.75925925925926
                    ],
                    [
                        175.5,
                        24.8
                    ],
                    [
                        175.22727272727272,
                        24.5
                    ],
                    [
                        174.5,
                        24.152173913043477
                    ],
                    [
                        173.5,
                        24.06
                    ],
                    [
                        172.5,
                        24.048387096774192
                    ],
                    [
                        171.5,
                        24.428571428571427
                    ],
                    [
                        171.16666666666666,
                        24.5
                    ],
                    [
                        171.5,
                        24.6
                    ],
                    [
                        171.8913043478261,
                        25.5
                    ],
                    [
                        171.5,
                        26.5
                    ],
                    [
                        170.5,
                        25.5
                    ],
                    [
                        170.5,
                        25.5
                    ],
                    [
                        170.21428571428572,
                        24.5
                    ],
                    [
                        169.5,
                        23.785714285714285
                    ],
                    [
                        169,
                        23.5
                    ],
                    [
                        168.625,
                        22.5
                    ],
                    [
                        168.5,
                        21.5
                    ],
                    [
                        168.5,
                        21.5
                    ],
                    [
                        167.75,
                        20.5
                    ],
                    [
                        168.5,
                        19.75
                    ],
                    [
                        169.5,
                        20.433333333333334
                    ],
                    [
                        169.66666666666666,
                        20.5
                    ],
                    [
                        170.5,
                        20.884615384615383
                    ],
                    [
                        171.5,
                        20.916666666666668
                    ],
                    [
                        172.125,
                        20.5
                    ],
                    [
                        172.5,
                        20.323529411764707
                    ],
                    [
                        173.375,
                        19.5
                    ],
                    [
                        173.5,
                        19.214285714285715
                    ],
                    [
                        173.7941176470588,
                        18.5
                    ],
                    [
                        174.19565217391303,
                        17.5
                    ],
                    [
                        173.97619047619048,
                        16.5
                    ],
                    [
                        173.5,
                        16
                    ],
                    [
                        173.08333333333334,
                        15.5
                    ],
                    [
                        172.5,
                        14.763157894736842
                    ],
                    [
                        171.875,
                        14.5
                    ],
                    [
                        171.5,
                        14.285714285714286
                    ],
                    [
                        170.5,
                        13.53448275862069
                    ],
                    [
                        170.44444444444446,
                        13.5
                    ],
                    [
                        169.5,
                        13.014285714285714
                    ],
                    [
                        168.5,
                        12.78
                    ],
                    [
                        167.5,
                        12.5
                    ],
                    [
                        167.5,
                        12.5
                    ],
                    [
                        167.5,
                        12.5
                    ],
                    [
                        166.5,
                        12.961538461538462
                    ],
                    [
                        165.8,
                        13.5
                    ],
                    [
                        165.5,
                        14.25
                    ],
                    [
                        165.38888888888889,
                        14.5
                    ],
                    [
                        165.25,
                        15.5
                    ],
                    [
                        165.38888888888889,
                        16.5
                    ],
                    [
                        165.5,
                        16.666666666666668
                    ],
                    [
                        166.33333333333334,
                        17.5
                    ],
                    [
                        166.5,
                        18.5
                    ],
                    [
                        165.5,
                        18.9
                    ],
                    [
                        164.83333333333334,
                        18.5
                    ],
                    [
                        164.5,
                        18.375
                    ],
                    [
                        163.5,
                        18.071428571428573
                    ],
                    [
                        162.5,
                        17.5
                    ],
                    [
                        162.5,
                        17.5
                    ],
                    [
                        161.5,
                        17.357142857142858
                    ],
                    [
                        160.5,
                        16.9
                    ],
                    [
                        159.5,
                        16.75
                    ],
                    [
                        159.125,
                        16.5
                    ],
                    [
                        158.5,
                        16
                    ],
                    [
                        158.04545454545453,
                        15.5
                    ],
                    [
                        157.5909090909091,
                        14.5
                    ],
                    [
                        157.5,
                        14.4
                    ],
                    [
                        156.5,
                        13.5
                    ],
                    [
                        156.5,
                        13.5
                    ],
                    [
                        155.5,
                        12.653846153846153
                    ],
                    [
                        154.5,
                        12.5
                    ],
                    [
                        154.5,
                        12.5
                    ],
                    [
                        153.5,
                        12.166666666666666
                    ],
                    [
                        152.5,
                        12.5
                    ],
                    [
                        152.5,
                        12.5
                    ],
                    [
                        151.5,
                        12.576923076923077
                    ],
                    [
                        150.5,
                        12.5
                    ],
                    [
                        150.5,
                        12.5
                    ],
                    [
                        150.5,
                        12.5
                    ],
                    [
                        149.5,
                        12.642857142857142
                    ],
                    [
                        148.5,
                        12.5
                    ],
                    [
                        148.5,
                        12.5
                    ],
                    [
                        147.5,
                        11.916666666666666
                    ],
                    [
                        146.5,
                        11.785714285714286
                    ],
                    [
                        145.66666666666666,
                        12.5
                    ],
                    [
                        146.3,
                        13.5
                    ],
                    [
                        146.5,
                        14.5
                    ],
                    [
                        146.5,
                        15.5
                    ],
                    [
                        146.5,
                        15.5
                    ],
                    [
                        146.66666666666666,
                        16.5
                    ],
                    [
                        146.72222222222223,
                        17.5
                    ],
                    [
                        146.75,
                        18.5
                    ],
                    [
                        146.5,
                        19.5
                    ],
                    [
                        146.5,
                        19.5
                    ],
                    [
                        146.5,
                        19.5
                    ],
                    [
                        146.83333333333334,
                        20.5
                    ],
                    [
                        146.5,
                        20.75
                    ],
                    [
                        145.5,
                        20.7
                    ],
                    [
                        145.16666666666666,
                        20.5
                    ],
                    [
                        144.5,
                        20.25
                    ],
                    [
                        143.5,
                        20.375
                    ],
                    [
                        143.25,
                        20.5
                    ],
                    [
                        142.5,
                        20.875
                    ],
                    [
                        141.5,
                        21.071428571428573
                    ],
                    [
                        141,
                        21.5
                    ],
                    [
                        140.5,
                        21.75
                    ],
                    [
                        139.5,
                        21.766666666666666
                    ],
                    [
                        138.5,
                        21.766666666666666
                    ],
                    [
                        137.5,
                        21.807692307692307
                    ],
                    [
                        136.5,
                        21.852941176470587
                    ],
                    [
                        135.5,
                        22.166666666666668
                    ],
                    [
                        134.5,
                        22.166666666666668
                    ],
                    [
                        133.83333333333334,
                        22.5
                    ],
                    [
                        133.5,
                        22.75
                    ],
                    [
                        132.5,
                        23.166666666666668
                    ],
                    [
                        131.5,
                        22.642857142857142
                    ],
                    [
                        131.35714285714286,
                        22.5
                    ],
                    [
                        130.5,
                        21.75
                    ],
                    [
                        129.83333333333334,
                        21.5
                    ],
                    [
                        129.5,
                        21.423076923076923
                    ],
                    [
                        128.5,
                        21.346153846153847
                    ],
                    [
                        127.5,
                        21.1875
                    ],
                    [
                        126.5,
                        21.26923076923077
                    ],
                    [
                        125.5,
                        21.423076923076923
                    ],
                    [
                        124.5,
                        21.5
                    ],
                    [
                        124.5,
                        21.5
                    ],
                    [
                        123.5,
                        22.25
                    ],
                    [
                        123,
                        22.5
                    ],
                    [
                        122.5,
                        22.681818181818183
                    ],
                    [
                        122.16666666666667,
                        22.5
                    ],
                    [
                        121.5,
                        22.1
                    ],
                    [
                        120.5,
                        22.1
                    ],
                    [
                        119.5,
                        21.625
                    ],
                    [
                        119.25,
                        21.5
                    ],
                    [
                        118.5,
                        21.166666666666668
                    ],
                    [
                        117.5,
                        20.666666666666668
                    ],
                    [
                        116.5,
                        20.5
                    ],
                    [
                        116.5,
                        20.5
                    ],
                    [
                        116.5,
                        20.5
                    ],
                    [
                        115.5,
                        20.954545454545453
                    ],
                    [
                        114.5,
                        20.625
                    ],
                    [
                        113.625,
                        21.5
                    ],
                    [
                        113.61764705882354,
                        22.5
                    ],
                    [
                        113.79411764705883,
                        23.5
                    ],
                    [
                        113.5,
                        24.5
                    ],
                    [
                        112.5,
                        23.875
                    ],
                    [
                        111.5,
                        24.3
                    ],
                    [
                        111.25,
                        24.5
                    ],
                    [
                        110.5,
                        25.1
                    ],
                    [
                        110.125,
                        24.5
                    ],
                    [
                        109.625,
                        23.5
                    ],
                    [
                        109.94444444444444,
                        22.5
                    ],
                    [
                        110.5,
                        22
                    ],
                    [
                        111,
                        21.5
                    ],
                    [
                        111.5,
                        20.875
                    ],
                    [
                        112.1,
                        20.5
                    ],
                    [
                        111.5,
                        20
                    ],
                    [
                        110.5,
                        20.1
                    ],
                    [
                        110,
                        20.5
                    ],
                    [
                        109.5,
                        20.72222222222222
                    ],
                    [
                        108.5,
                        21.1
                    ],
                    [
                        107.5,
                        21
                    ],
                    [
                        106.75,
                        20.5
                    ],
                    [
                        106.5,
                        20.333333333333332
                    ],
                    [
                        105.5,
                        19.833333333333332
                    ],
                    [
                        105.35714285714286,
                        19.5
                    ],
                    [
                        104.7,
                        18.5
                    ],
                    [
                        104.5,
                        18.166666666666668
                    ],
                    [
                        104.21428571428571,
                        17.5
                    ],
                    [
                        103.5,
                        17
                    ],
                    [
                        102.5,
                        16.6
                    ],
                    [
                        102.16666666666667,
                        16.5
                    ],
                    [
                        101.5,
                        16.333333333333332
                    ],
                    [
                        100.5,
                        15.666666666666668
                    ],
                    [
                        99.5,
                        16
                    ],
                    [
                        98.875,
                        16.5
                    ],
                    [
                        98.5,
                        16.928571428571427
                    ],
                    [
                        97.77272727272727,
                        17.5
                    ],
                    [
                        97.5,
                        17.65
                    ],
                    [
                        96.5,
                        17.5
                    ],
                    [
                        96.5,
                        17.5
                    ],
                    [
                        96.07894736842105,
                        16.5
                    ],
                    [
                        96.20588235294117,
                        15.5
                    ],
                    [
                        95.5,
                        14.928571428571429
                    ],
                    [
                        94.85714285714286,
                        14.5
                    ],
                    [
                        94.5,
                        14.1875
                    ],
                    [
                        94.07692307692308,
                        13.5
                    ],
                    [
                        93.71875,
                        12.5
                    ],
                    [
                        93.53571428571429,
                        11.5
                    ],
                    [
                        93.5,
                        11.433333333333334
                    ],
                    [
                        92.86363636363636,
                        10.5
                    ],
                    [
                        92.5,
                        9.928571428571429
                    ],
                    [
                        92.07142857142857,
                        9.5
                    ],
                    [
                        91.5,
                        9.136363636363637
                    ],
                    [
                        90.5,
                        8.681818181818182
                    ],
                    [
                        90,
                        8.5
                    ],
                    [
                        89.5,
                        8.428571428571429
                    ],
                    [
                        88.5,
                        8.274193548387096
                    ],
                    [
                        87.5,
                        8.1
                    ],
                    [
                        86.5,
                        7.984848484848484
                    ],
                    [
                        85.5,
                        8.015151515151516
                    ],
                    [
                        84.65789473684211,
                        8.5
                    ],
                    [
                        84.5,
                        9.1
                    ],
                    [
                        84.42,
                        9.5
                    ],
                    [
                        84.16666666666667,
                        10.5
                    ],
                    [
                        83.98387096774194,
                        11.5
                    ],
                    [
                        83.84482758620689,
                        12.5
                    ],
                    [
                        83.58108108108108,
                        13.5
                    ],
                    [
                        83.5,
                        13.65
                    ],
                    [
                        82.95161290322581,
                        14.5
                    ],
                    [
                        82.61764705882354,
                        15.5
                    ],
                    [
                        82.54,
                        16.5
                    ],
                    [
                        82.5,
                        16.642857142857142
                    ],
                    [
                        82.26,
                        17.5
                    ],
                    [
                        81.95833333333333,
                        18.5
                    ],
                    [
                        81.5,
                        19.1875
                    ],
                    [
                        81.25,
                        19.5
                    ],
                    [
                        80.5,
                        20.333333333333332
                    ],
                    [
                        80.4090909090909,
                        20.5
                    ],
                    [
                        80.45652173913044,
                        21.5
                    ],
                    [
                        80.38235294117646,
                        22.5
                    ],
                    [
                        80.08333333333333,
                        23.5
                    ],
                    [
                        79.91666666666667,
                        24.5
                    ],
                    [
                        79.94444444444444,
                        25.5
                    ],
                    [
                        79.5,
                        26.3
                    ],
                    [
                        79.42857142857143,
                        26.5
                    ],
                    [
                        79.5,
                        26.75
                    ],
                    [
                        79.83333333333333,
                        27.5
                    ],
                    [
                        79.5,
                        28
                    ],
                    [
                        79.2,
                        28.5
                    ],
                    [
                        79.4,
                        29.5
                    ],
                    [
                        79.5,
                        30
                    ],
                    [
                        79.625,
                        30.5
                    ],
                    [
                        80.16666666666667,
                        31.5
                    ],
                    [
                        80.5,
                        31.611111111111114
                    ],
                    [
                        81.5,
                        32.03333333333333
                    ],
                    [
                        82.5,
                        32.375
                    ],
                    [
                        82.7,
                        32.5
                    ],
                    [
                        83.5,
                        33.3
                    ],
                    [
                        84.5,
                        33.26470588235294
                    ],
                    [
                        85.16666666666667,
                        33.5
                    ],
                    [
                        84.5,
                        33.9
                    ],
                    [
                        83.5,
                        33.75
                    ],
                    [
                        82.5,
                        33.916666666666664
                    ],
                    [
                        81.5,
                        33.92857142857143
                    ],
                    [
                        80.5,
                        34
                    ],
                    [
                        79.5,
                        33.92857142857143
                    ],
                    [
                        78.5,
                        34.03333333333333
                    ],
                    [
                        77.5,
                        34.07142857142857
                    ],
                    [
                        76.5,
                        33.5
                    ],
                    [
                        76.5,
                        33.5
                    ],
                    [
                        75.5,
                        32.7
                    ],
                    [
                        75,
                        32.5
                    ],
                    [
                        74.5,
                        32.388888888888886
                    ],
                    [
                        73.5,
                        32.40909090909091
                    ],
                    [
                        72.5,
                        32.43333333333333
                    ],
                    [
                        71.5,
                        32.3
                    ],
                    [
                        70.5,
                        32.3421052631579
                    ],
                    [
                        70.25,
                        32.5
                    ],
                    [
                        69.5,
                        33.25
                    ],
                    [
                        69.3,
                        33.5
                    ],
                    [
                        68.5,
                        34.02173913043478
                    ],
                    [
                        67.5,
                        34
                    ],
                    [
                        66.5,
                        33.81578947368421
                    ],
                    [
                        65.5,
                        33.81111111111111
                    ],
                    [
                        64.5,
                        33.825
                    ],
                    [
                        63.5,
                        33.833333333333336
                    ],
                    [
                        62.5,
                        34.01020408163265
                    ],
                    [
                        61.5,
                        34.029411764705884
                    ],
                    [
                        60.5,
                        33.780701754385966
                    ],
                    [
                        59.92857142857143,
                        33.5
                    ],
                    [
                        59.5,
                        33.18421052631579
                    ],
                    [
                        58.5,
                        32.82727272727273
                    ],
                    [
                        57.5,
                        32.82608695652174
                    ],
                    [
                        56.5,
                        32.970588235294116
                    ],
                    [
                        55.5,
                        32.95161290322581
                    ],
                    [
                        54.5,
                        33.04385964912281
                    ],
                    [
                        53.5,
                        33.294871794871796
                    ],
                    [
                        52.92857142857143,
                        33.5
                    ],
                    [
                        52.5,
                        33.625
                    ],
                    [
                        51.5,
                        33.75806451612903
                    ],
                    [
                        50.541666666666664,
                        34.5
                    ],
                    [
                        50.5,
                        34.57692307692308
                    ],
                    [
                        49.833333333333336,
                        35.5
                    ],
                    [
                        49.5,
                        35.75
                    ],
                    [
                        48.5,
                        35.88235294117647
                    ],
                    [
                        47.5,
                        36.266666666666666
                    ],
                    [
                        47.19565217391305,
                        36.5
                    ],
                    [
                        46.5,
                        36.91025641025641
                    ],
                    [
                        45.5,
                        37.33870967741935
                    ],
                    [
                        45.142857142857146,
                        37.5
                    ],
                    [
                        44.5,
                        37.725
                    ],
                    [
                        43.5,
                        38.15714285714286
                    ],
                    [
                        43.1,
                        38.5
                    ],
                    [
                        42.5,
                        39.44736842105263
                    ],
                    [
                        42.46,
                        39.5
                    ],
                    [
                        41.964285714285715,
                        40.5
                    ],
                    [
                        41.95454545454545,
                        41.5
                    ],
                    [
                        42.5,
                        42.3
                    ],
                    [
                        42.714285714285715,
                        42.5
                    ],
                    [
                        42.5,
                        43
                    ],
                    [
                        42.22727272727273,
                        43.5
                    ],
                    [
                        41.76315789473684,
                        44.5
                    ],
                    [
                        42.5,
                        45.27777777777778
                    ],
                    [
                        42.69047619047619,
                        45.5
                    ],
                    [
                        43.5,
                        46.04838709677419
                    ],
                    [
                        44.5,
                        46.5
                    ],
                    [
                        44.5,
                        46.5
                    ],
                    [
                        45.5,
                        47.388888888888886
                    ],
                    [
                        45.7,
                        47.5
                    ],
                    [
                        46.5,
                        47.94444444444444
                    ],
                    [
                        47.5,
                        48.205882352941174
                    ],
                    [
                        48.5,
                        48.5
                    ],
                    [
                        48.5,
                        48.5
                    ],
                    [
                        49.5,
                        48.611111111111114
                    ],
                    [
                        50.5,
                        48.5
                    ],
                    [
                        51.5,
                        48.875
                    ],
                    [
                        52.5,
                        49.5
                    ],
                    [
                        52.5,
                        49.5
                    ],
                    [
                        53.5,
                        49.5
                    ],
                    [
                        54.3,
                        50.5
                    ],
                    [
                        54.5,
                        50.833333333333336
                    ],
                    [
                        55.166666666666664,
                        51.5
                    ],
                    [
                        54.92857142857143,
                        52.5
                    ],
                    [
                        54.59090909090909,
                        53.5
                    ],
                    [
                        54.8,
                        54.5
                    ],
                    [
                        54.5,
                        55.1
                    ],
                    [
                        53.5,
                        54.7
                    ],
                    [
                        53.357142857142854,
                        54.5
                    ],
                    [
                        52.833333333333336,
                        53.5
                    ],
                    [
                        52.5,
                        53
                    ],
                    [
                        51.5,
                        53.125
                    ],
                    [
                        50.9,
                        53.5
                    ],
                    [
                        51.25,
                        54.5
                    ],
                    [
                        51.214285714285715,
                        55.5
                    ],
                    [
                        51.25,
                        56.5
                    ],
                    [
                        50.833333333333336,
                        57.5
                    ],
                    [
                        50.5,
                        58.5
                    ],
                    [
                        50.5,
                        58.5
                    ],
                    [
                        50.5,
                        58.5
                    ],
                    [
                        51.5,
                        59.25
                    ],
                    [
                        51.642857142857146,
                        59.5
                    ],
                    [
                        51.94444444444444,
                        60.5
                    ],
                    [
                        52.5,
                        61.214285714285715
                    ],
                    [
                        53.166666666666664,
                        61.5
                    ],
                    [
                        53.5,
                        61.666666666666664
                    ],
                    [
                        54.5,
                        61.833333333333336
                    ],
                    [
                        55.5,
                        62.5
                    ],
                    [
                        55.5,
                        62.5
                    ],
                    [
                        56.5,
                        63.5
                    ],
                    [
                        56.5,
                        64.5
                    ],
                    [
                        55.833333333333336,
                        65.5
                    ],
                    [
                        55.9,
                        66.5
                    ],
                    [
                        55.9,
                        67.5
                    ],
                    [
                        55.9,
                        68.5
                    ],
                    [
                        55.833333333333336,
                        69.5
                    ],
                    [
                        55.833333333333336,
                        70.5
                    ],
                    [
                        55.833333333333336,
                        71.5
                    ],
                    [
                        56.5,
                        72.5
                    ],
                    [
                        56.5,
                        73.5
                    ],
                    [
                        56.5,
                        73.5
                    ],
                    [
                        57,
                        74.5
                    ],
                    [
                        57.5,
                        75.5
                    ],
                    [
                        57.5,
                        75.5
                    ],
                    [
                        57.833333333333336,
                        76.5
                    ],
                    [
                        57.9,
                        77.5
                    ],
                    [
                        57.9,
                        78.5
                    ],
                    [
                        58.5,
                        79.25
                    ],
                    [
                        58.666666666666664,
                        79.5
                    ],
                    [
                        58.5,
                        80
                    ],
                    [
                        58,
                        80.5
                    ],
                    [
                        58,
                        81.5
                    ],
                    [
                        57.75,
                        82.5
                    ],
                    [
                        57.5,
                        83.5
                    ],
                    [
                        57.5,
                        83.5
                    ],
                    [
                        56.7,
                        84.5
                    ],
                    [
                        56.5,
                        85
                    ],
                    [
                        56.25,
                        85.5
                    ],
                    [
                        56.166666666666664,
                        86.5
                    ],
                    [
                        56.5,
                        87.5
                    ],
                    [
                        56.5,
                        87.5
                    ],
                    [
                        57,
                        88.5
                    ],
                    [
                        57,
                        89.5
                    ],
                    [
                        56.833333333333336,
                        90.5
                    ],
                    [
                        57.5,
                        91
                    ],
                    [
                        58.5,
                        91
                    ],
                    [
                        59.5,
                        91.25
                    ],
                    [
                        60,
                        91.5
                    ],
                    [
                        60.5,
                        92
                    ],
                    [
                        61.5,
                        92
                    ],
                    [
                        61.5,
                        91.5
                    ],
                    [
                        62.5,
                        91.16666666666667
                    ],
                    [
                        63.5,
                        91.5
                    ],
                    [
                        63.5,
                        92
                    ],
                    [
                        64.5,
                        92
                    ],
                    [
                        65.5,
                        92
                    ],
                    [
                        66.5,
                        92
                    ],
                    [
                        67.5,
                        92
                    ],
                    [
                        68.5,
                        92
                    ],
                    [
                        69.5,
                        92
                    ],
                    [
                        70.5,
                        92
                    ],
                    [
                        71.5,
                        92
                    ],
                    [
                        72.5,
                        92
                    ],
                    [
                        73.5,
                        92
                    ],
                    [
                        74.5,
                        92
                    ],
                    [
                        75.5,
                        92
                    ],
                    [
                        76.5,
                        92
                    ],
                    [
                        77.5,
                        92
                    ],
                    [
                        78.5,
                        92
                    ],
                    [
                        79.5,
                        92
                    ],
                    [
                        80.5,
                        92
                    ],
                    [
                        81.5,
                        92
                    ],
                    [
                        82.5,
                        92
                    ],
                    [
                        83.5,
                        92
                    ],
                    [
                        84.5,
                        92
                    ],
                    [
                        85.5,
                        92
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        144.5,
                        92
                    ],
                    [
                        145.5,
                        92
                    ],
                    [
                        146.5,
                        92
                    ],
                    [
                        147.5,
                        92
                    ],
                    [
                        148.5,
                        92
                    ],
                    [
                        149.5,
                        92
                    ],
                    [
                        150.5,
                        92
                    ],
                    [
                        151.5,
                        92
                    ],
                    [
                        152.5,
                        92
                    ],
                    [
                        153.5,
                        92
                    ],
                    [
                        154.5,
                        92
                    ],
                    [
                        155.5,
                        92
                    ],
                    [
                        156.5,
                        92
                    ],
                    [
                        157.5,
                        92
                    ],
                    [
                        158.5,
                        92
                    ],
                    [
                        159.5,
                        92
                    ],
                    [
                        160.5,
                        92
                    ],
                    [
                        161.5,
                        92
                    ],
                    [
                        162.5,
                        92
                    ],
                    [
                        163.5,
                        92
                    ],
                    [
                        164.5,
                        92
                    ],
                    [
                        165.35714285714286,
                        91.5
                    ]
                ],
                [
                    [
                        142.5,
                        58.166666666666664
                    ],
                    [
                        141.83333333333334,
                        57.5
                    ],
                    [
                        142.5,
                        56.5
                    ],
                    [
                        143.16666666666666,
                        57.5
                    ],
                    [
                        142.5,
                        58.166666666666664
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 45,
        "coordinates": [
            [
                [
                    [
                        172.41666666666666,
                        19.5
                    ],
                    [
                        172.5,
                        19.423076923076923
                    ],
                    [
                        173.04545454545453,
                        18.5
                    ],
                    [
                        173.5,
                        17.59090909090909
                    ],
                    [
                        173.54347826086956,
                        17.5
                    ],
                    [
                        173.5,
                        17.333333333333332
                    ],
                    [
                        173.29166666666666,
                        16.5
                    ],
                    [
                        172.5,
                        15.55
                    ],
                    [
                        172.45,
                        15.5
                    ],
                    [
                        171.5,
                        14.887096774193548
                    ],
                    [
                        171.02,
                        14.5
                    ],
                    [
                        170.5,
                        14.051724137931034
                    ],
                    [
                        169.61111111111111,
                        13.5
                    ],
                    [
                        169.5,
                        13.442857142857143
                    ],
                    [
                        168.5,
                        13.38
                    ],
                    [
                        167.5,
                        13.5
                    ],
                    [
                        167.5,
                        13.5
                    ],
                    [
                        166.83333333333334,
                        14.5
                    ],
                    [
                        166.8,
                        15.5
                    ],
                    [
                        167.5,
                        16.136363636363637
                    ],
                    [
                        168.07142857142858,
                        16.5
                    ],
                    [
                        168.5,
                        16.875
                    ],
                    [
                        169,
                        17.5
                    ],
                    [
                        169.5,
                        18.5
                    ],
                    [
                        169.5,
                        18.5
                    ],
                    [
                        169.5909090909091,
                        19.5
                    ],
                    [
                        170.5,
                        20
                    ],
                    [
                        171.5,
                        20.023809523809526
                    ],
                    [
                        172.41666666666666,
                        19.5
                    ]
                ]
            ],
            [
                [
                    [
                        180.63636363636363,
                        26.5
                    ],
                    [
                        180.5,
                        26.3125
                    ],
                    [
                        179.5,
                        25.95
                    ],
                    [
                        178.58333333333334,
                        26.5
                    ],
                    [
                        179.5,
                        27.456521739130434
                    ],
                    [
                        180.5,
                        26.666666666666668
                    ],
                    [
                        180.63636363636363,
                        26.5
                    ]
                ]
            ],
            [
                [
                    [
                        156,
                        41.5
                    ],
                    [
                        155.5,
                        41.3
                    ],
                    [
                        155.16666666666666,
                        41.5
                    ],
                    [
                        155.5,
                        41.595238095238095
                    ],
                    [
                        156,
                        41.5
                    ]
                ]
            ],
            [
                [
                    [
                        57.75,
                        53.5
                    ],
                    [
                        57.5,
                        53.1
                    ],
                    [
                        56.5,
                        53.214285714285715
                    ],
                    [
                        56.214285714285715,
                        53.5
                    ],
                    [
                        56.5,
                        54
                    ],
                    [
                        57.5,
                        53.7
                    ],
                    [
                        57.75,
                        53.5
                    ]
                ]
            ],
            [
                [
                    [
                        178.75,
                        76.5
                    ],
                    [
                        179.5,
                        76
                    ],
                    [
                        180.04545454545453,
                        75.5
                    ],
                    [
                        180.5,
                        74.875
                    ],
                    [
                        181.25,
                        74.5
                    ],
                    [
                        181.5,
                        74.45652173913044
                    ],
                    [
                        181.625,
                        74.5
                    ],
                    [
                        182.5,
                        74.91176470588235
                    ],
                    [
                        183.5,
                        74.83333333333333
                    ],
                    [
                        183.95454545454547,
                        74.5
                    ],
                    [
                        183.75,
                        73.5
                    ],
                    [
                        183.82,
                        72.5
                    ],
                    [
                        183.5,
                        71.77272727272727
                    ],
                    [
                        183.38888888888889,
                        71.5
                    ],
                    [
                        182.98,
                        70.5
                    ],
                    [
                        182.5,
                        69.75
                    ],
                    [
                        182.3,
                        69.5
                    ],
                    [
                        181.83333333333334,
                        68.5
                    ],
                    [
                        182.16666666666666,
                        67.5
                    ],
                    [
                        182.5,
                        67.04545454545455
                    ],
                    [
                        183.5,
                        66.71428571428571
                    ],
                    [
                        184.5,
                        66.71428571428571
                    ],
                    [
                        184.75,
                        66.5
                    ],
                    [
                        185.375,
                        65.5
                    ],
                    [
                        184.75,
                        64.5
                    ],
                    [
                        184.5,
                        64.34615384615384
                    ],
                    [
                        183.5,
                        64.125
                    ],
                    [
                        182.5,
                        64.25
                    ],
                    [
                        182,
                        64.5
                    ],
                    [
                        181.5,
                        64.75
                    ],
                    [
                        180.5,
                        65.38888888888889
                    ],
                    [
                        180.3,
                        65.5
                    ],
                    [
                        179.5,
                        65.8076923076923
                    ],
                    [
                        178.5,
                        65.97619047619048
                    ],
                    [
                        177.5,
                        66.16666666666667
                    ],
                    [
                        176.5,
                        65.8125
                    ],
                    [
                        175.875,
                        65.5
                    ],
                    [
                        175.5,
                        65.125
                    ],
                    [
                        175.1875,
                        64.5
                    ],
                    [
                        174.5,
                        63.852941176470594
                    ],
                    [
                        173.9,
                        63.5
                    ],
                    [
                        173.5,
                        63.31818181818182
                    ],
                    [
                        172.5,
                        63.5
                    ],
                    [
                        172.5,
                        63.5
                    ],
                    [
                        171.5,
                        64.25
                    ],
                    [
                        171.1,
                        64.5
                    ],
                    [
                        170.5,
                        65.25
                    ],
                    [
                        170.4090909090909,
                        65.5
                    ],
                    [
                        170.3,
                        66.5
                    ],
                    [
                        170.5,
                        66.875
                    ],
                    [
                        170.77777777777777,
                        67.5
                    ],
                    [
                        171.5,
                        68.26470588235294
                    ],
                    [
                        171.9,
                        68.5
                    ],
                    [
                        172.5,
                        68.96153846153847
                    ],
                    [
                        173.08333333333334,
                        69.5
                    ],
                    [
                        173.5,
                        69.95454545454545
                    ],
                    [
                        173.92857142857142,
                        70.5
                    ],
                    [
                        174.5,
                        71.3
                    ],
                    [
                        174.625,
                        71.5
                    ],
                    [
                        175.5,
                        72.32352941176471
                    ],
                    [
                        175.83333333333334,
                        72.5
                    ],
                    [
                        176.5,
                        73.5
                    ],
                    [
                        176.08333333333334,
                        74.5
                    ],
                    [
                        176.0625,
                        75.5
                    ],
                    [
                        176.5,
                        76.2
                    ],
                    [
                        177,
                        76.5
                    ],
                    [
                        177.5,
                        76.65
                    ],
                    [
                        178.5,
                        76.58333333333333
                    ],
                    [
                        178.75,
                        76.5
                    ]
                ]
            ],
            [
                [
                    [
                        163.85714285714286,
                        91.5
                    ],
                    [
                        163.5,
                        90.875
                    ],
                    [
                        163.22727272727272,
                        90.5
                    ],
                    [
                        163.5,
                        90.2
                    ],
                    [
                        164.5,
                        89.65384615384616
                    ],
                    [
                        165,
                        89.5
                    ],
                    [
                        165.5,
                        89.38888888888889
                    ],
                    [
                        166.5,
                        89.15
                    ],
                    [
                        167.5,
                        88.625
                    ],
                    [
                        167.58,
                        88.5
                    ],
                    [
                        167.72222222222223,
                        87.5
                    ],
                    [
                        168.27777777777777,
                        86.5
                    ],
                    [
                        168.5,
                        86.23333333333333
                    ],
                    [
                        169.02380952380952,
                        85.5
                    ],
                    [
                        169.38888888888889,
                        84.5
                    ],
                    [
                        169.5,
                        84.3
                    ],
                    [
                        169.94444444444446,
                        83.5
                    ],
                    [
                        169.5,
                        82.61111111111111
                    ],
                    [
                        168.5,
                        82.73529411764706
                    ],
                    [
                        167.5,
                        83.02941176470588
                    ],
                    [
                        166.92857142857142,
                        83.5
                    ],
                    [
                        166.5,
                        84
                    ],
                    [
                        166.07142857142858,
                        84.5
                    ],
                    [
                        165.5,
                        85
                    ],
                    [
                        164.5,
                        85.1
                    ],
                    [
                        163.5,
                        84.875
                    ],
                    [
                        162.5,
                        84.71739130434783
                    ],
                    [
                        161.66666666666666,
                        84.5
                    ],
                    [
                        161.5,
                        84.4
                    ],
                    [
                        160.5,
                        83.5
                    ],
                    [
                        160.5,
                        83.5
                    ],
                    [
                        159.5,
                        83
                    ],
                    [
                        158.5,
                        82.76315789473684
                    ],
                    [
                        157.5,
                        83.1
                    ],
                    [
                        156.83333333333334,
                        83.5
                    ],
                    [
                        156.5,
                        83.6875
                    ],
                    [
                        155.5,
                        84.1923076923077
                    ],
                    [
                        155.16666666666666,
                        84.5
                    ],
                    [
                        154.5,
                        85.07142857142857
                    ],
                    [
                        154.1,
                        85.5
                    ],
                    [
                        153.80769230769232,
                        86.5
                    ],
                    [
                        153.5,
                        87.16666666666667
                    ],
                    [
                        153.16666666666666,
                        87.5
                    ],
                    [
                        152.5,
                        87.86363636363636
                    ],
                    [
                        151.5,
                        88.35714285714286
                    ],
                    [
                        151.375,
                        88.5
                    ],
                    [
                        150.5,
                        89.5
                    ],
                    [
                        150.5,
                        89.5
                    ],
                    [
                        149.5,
                        89.61111111111111
                    ],
                    [
                        149,
                        89.5
                    ],
                    [
                        148.5,
                        89.3
                    ],
                    [
                        147.5,
                        88.5
                    ],
                    [
                        147.5,
                        88.5
                    ],
                    [
                        146.5,
                        88.33333333333333
                    ],
                    [
                        145.5,
                        88.5
                    ],
                    [
                        144.5,
                        88.3
                    ],
                    [
                        143.5,
                        87.625
                    ],
                    [
                        143.25,
                        87.5
                    ],
                    [
                        143.3,
                        86.5
                    ],
                    [
                        143.25,
                        85.5
                    ],
                    [
                        143.5,
                        84.83333333333333
                    ],
                    [
                        144.5,
                        84.5
                    ],
                    [
                        144.5,
                        84.5
                    ],
                    [
                        144.5,
                        84.5
                    ],
                    [
                        144,
                        83.5
                    ],
                    [
                        143.5,
                        82.5
                    ],
                    [
                        144.25,
                        81.5
                    ],
                    [
                        144.07142857142858,
                        80.5
                    ],
                    [
                        144,
                        79.5
                    ],
                    [
                        144.5,
                        78.5
                    ],
                    [
                        145.5,
                        79
                    ],
                    [
                        145.92857142857142,
                        79.5
                    ],
                    [
                        146.5,
                        80.3
                    ],
                    [
                        147.5,
                        80.3
                    ],
                    [
                        148.5,
                        79.9
                    ],
                    [
                        148.9,
                        79.5
                    ],
                    [
                        149.5,
                        78.83333333333333
                    ],
                    [
                        149.77272727272728,
                        78.5
                    ],
                    [
                        149.8,
                        77.5
                    ],
                    [
                        149.5,
                        76.5
                    ],
                    [
                        149.5,
                        76.5
                    ],
                    [
                        148.5,
                        75.875
                    ],
                    [
                        147.75,
                        75.5
                    ],
                    [
                        147.5,
                        75.4090909090909
                    ],
                    [
                        146.5,
                        75.07142857142857
                    ],
                    [
                        145.92857142857142,
                        74.5
                    ],
                    [
                        145.92857142857142,
                        73.5
                    ],
                    [
                        146.1,
                        72.5
                    ],
                    [
                        146.5,
                        72.16666666666667
                    ],
                    [
                        147.5,
                        71.95454545454545
                    ],
                    [
                        148.5,
                        71.61111111111111
                    ],
                    [
                        148.7,
                        71.5
                    ],
                    [
                        149.33333333333334,
                        70.5
                    ],
                    [
                        148.5,
                        69.875
                    ],
                    [
                        148.07142857142858,
                        69.5
                    ],
                    [
                        147.5,
                        69.16666666666667
                    ],
                    [
                        146.5,
                        69.03846153846153
                    ],
                    [
                        145.5,
                        68.9375
                    ],
                    [
                        144.625,
                        68.5
                    ],
                    [
                        144.5,
                        68.35714285714286
                    ],
                    [
                        143.9,
                        67.5
                    ],
                    [
                        143.5,
                        67.21428571428571
                    ],
                    [
                        142.73076923076923,
                        66.5
                    ],
                    [
                        142.5,
                        66.3125
                    ],
                    [
                        141.5,
                        66.02631578947368
                    ],
                    [
                        140.5,
                        66.20588235294117
                    ],
                    [
                        139.5,
                        66.28571428571429
                    ],
                    [
                        138.5,
                        66.42307692307692
                    ],
                    [
                        137.5,
                        66.4090909090909
                    ],
                    [
                        137.25,
                        66.5
                    ],
                    [
                        136.5,
                        66.92857142857143
                    ],
                    [
                        135.5,
                        67.35714285714286
                    ],
                    [
                        134.5,
                        67.1
                    ],
                    [
                        133.75,
                        66.5
                    ],
                    [
                        133.5,
                        66
                    ],
                    [
                        133.33333333333334,
                        65.5
                    ],
                    [
                        133.5,
                        65.3
                    ],
                    [
                        134.5,
                        64.7
                    ],
                    [
                        134.83333333333334,
                        64.5
                    ],
                    [
                        135.5,
                        64.1
                    ],
                    [
                        136.25,
                        63.5
                    ],
                    [
                        136.5,
                        63.166666666666664
                    ],
                    [
                        137,
                        62.5
                    ],
                    [
                        137.33333333333334,
                        61.5
                    ],
                    [
                        137.5,
                        60.5
                    ],
                    [
                        137.5,
                        60.5
                    ],
                    [
                        138.16666666666666,
                        59.5
                    ],
                    [
                        138.5,
                        58.5
                    ],
                    [
                        138.5,
                        58.5
                    ],
                    [
                        138.64285714285714,
                        57.5
                    ],
                    [
                        138.875,
                        56.5
                    ],
                    [
                        139,
                        55.5
                    ],
                    [
                        139.5,
                        54.5
                    ],
                    [
                        139.5,
                        54.5
                    ],
                    [
                        139.9,
                        53.5
                    ],
                    [
                        140.5,
                        53
                    ],
                    [
                        141.5,
                        52.785714285714285
                    ],
                    [
                        142.5,
                        52.7
                    ],
                    [
                        143.5,
                        53.5
                    ],
                    [
                        143.5,
                        53.5
                    ],
                    [
                        144.3,
                        54.5
                    ],
                    [
                        144.5,
                        54.59090909090909
                    ],
                    [
                        144.75,
                        54.5
                    ],
                    [
                        145.5,
                        53.75
                    ],
                    [
                        145.625,
                        53.5
                    ],
                    [
                        145.5,
                        53
                    ],
                    [
                        145.3,
                        52.5
                    ],
                    [
                        145.5,
                        52.40909090909091
                    ],
                    [
                        146.16666666666666,
                        51.5
                    ],
                    [
                        146.2,
                        50.5
                    ],
                    [
                        145.66666666666666,
                        49.5
                    ],
                    [
                        145.5,
                        49.388888888888886
                    ],
                    [
                        144.5,
                        48.92857142857143
                    ],
                    [
                        143.9,
                        48.5
                    ],
                    [
                        143.5,
                        48.1
                    ],
                    [
                        142.5,
                        47.7
                    ],
                    [
                        142.25,
                        47.5
                    ],
                    [
                        141.5,
                        47.07142857142857
                    ],
                    [
                        140.83333333333334,
                        46.5
                    ],
                    [
                        140.5,
                        46.25
                    ],
                    [
                        139.5,
                        45.5
                    ],
                    [
                        139.5,
                        45.5
                    ],
                    [
                        138.5,
                        44.5
                    ],
                    [
                        138.5,
                        44.5
                    ],
                    [
                        137.66666666666666,
                        43.5
                    ],
                    [
                        137.5,
                        43.357142857142854
                    ],
                    [
                        136.5,
                        42.94444444444444
                    ],
                    [
                        135.5,
                        42.75
                    ],
                    [
                        134.5,
                        42.625
                    ],
                    [
                        134,
                        42.5
                    ],
                    [
                        133.5,
                        42
                    ],
                    [
                        133,
                        41.5
                    ],
                    [
                        133.5,
                        40.5
                    ],
                    [
                        133.5,
                        40.5
                    ],
                    [
                        133.5,
                        40.5
                    ],
                    [
                        133,
                        39.5
                    ],
                    [
                        133,
                        38.5
                    ],
                    [
                        133.5,
                        38.166666666666664
                    ],
                    [
                        133.9,
                        37.5
                    ],
                    [
                        134.5,
                        36.5
                    ],
                    [
                        134.5,
                        36.5
                    ],
                    [
                        135.5,
                        36.3
                    ],
                    [
                        136.5,
                        36.166666666666664
                    ],
                    [
                        137.5,
                        35.5
                    ],
                    [
                        137.75,
                        36.5
                    ],
                    [
                        138,
                        37.5
                    ],
                    [
                        138.5,
                        38.5
                    ],
                    [
                        138.5,
                        38.5
                    ],
                    [
                        138.5,
                        38.5
                    ],
                    [
                        138.83333333333334,
                        37.5
                    ],
                    [
                        139.5,
                        36.5
                    ],
                    [
                        140.5,
                        36.5
                    ],
                    [
                        140.92857142857142,
                        37.5
                    ],
                    [
                        141.5,
                        38.3
                    ],
                    [
                        142.5,
                        38.357142857142854
                    ],
                    [
                        142.7,
                        38.5
                    ],
                    [
                        143.5,
                        39
                    ],
                    [
                        144.5,
                        39.333333333333336
                    ],
                    [
                        145.5,
                        39.5
                    ],
                    [
                        145.5,
                        39.5
                    ],
                    [
                        146.5,
                        40.166666666666664
                    ],
                    [
                        147.5,
                        40.166666666666664
                    ],
                    [
                        148.5,
                        39.88461538461539
                    ],
                    [
                        149.5,
                        39.68181818181818
                    ],
                    [
                        149.9,
                        39.5
                    ],
                    [
                        150.5,
                        39.22727272727273
                    ],
                    [
                        151.5,
                        38.875
                    ],
                    [
                        151.83333333333334,
                        38.5
                    ],
                    [
                        152.5,
                        37.833333333333336
                    ],
                    [
                        153.1,
                        37.5
                    ],
                    [
                        153.5,
                        37.36666666666667
                    ],
                    [
                        154.42857142857142,
                        36.5
                    ],
                    [
                        153.9,
                        35.5
                    ],
                    [
                        154.5,
                        34.5
                    ],
                    [
                        154.5,
                        34.5
                    ],
                    [
                        155.5,
                        34.214285714285715
                    ],
                    [
                        156.5,
                        34.5
                    ],
                    [
                        156.5,
                        34.5
                    ],
                    [
                        157.5,
                        35.5
                    ],
                    [
                        157.5,
                        35.5
                    ],
                    [
                        158.5,
                        35.5
                    ],
                    [
                        158.5,
                        35.5
                    ],
                    [
                        159.5,
                        35.375
                    ],
                    [
                        160.5,
                        35.3
                    ],
                    [
                        161.5,
                        34.642857142857146
                    ],
                    [
                        161.64285714285714,
                        34.5
                    ],
                    [
                        162.5,
                        33.642857142857146
                    ],
                    [
                        163.16666666666666,
                        34.5
                    ],
                    [
                        162.875,
                        35.5
                    ],
                    [
                        163.4375,
                        36.5
                    ],
                    [
                        163.5,
                        36.54761904761905
                    ],
                    [
                        163.57142857142858,
                        36.5
                    ],
                    [
                        164.33333333333334,
                        35.5
                    ],
                    [
                        164.1,
                        34.5
                    ],
                    [
                        164.5,
                        34
                    ],
                    [
                        165.5,
                        34.5
                    ],
                    [
                        165.5,
                        34.5
                    ],
                    [
                        165.5,
                        34.5
                    ],
                    [
                        166.5,
                        33.94444444444444
                    ],
                    [
                        166.76666666666668,
                        33.5
                    ],
                    [
                        167.5,
                        32.766666666666666
                    ],
                    [
                        167.86363636363637,
                        32.5
                    ],
                    [
                        168.44117647058823,
                        31.5
                    ],
                    [
                        168.5,
                        31
                    ],
                    [
                        169.5,
                        30.5
                    ],
                    [
                        169.5,
                        30.5
                    ],
                    [
                        170.5,
                        30
                    ],
                    [
                        171.5,
                        30.210526315789473
                    ],
                    [
                        172.5,
                        29.833333333333332
                    ],
                    [
                        172.57692307692307,
                        30.5
                    ],
                    [
                        173.5,
                        31.32758620689655
                    ],
                    [
                        173.75,
                        31.5
                    ],
                    [
                        174.33333333333334,
                        32.5
                    ],
                    [
                        174.5,
                        32.54545454545455
                    ],
                    [
                        175.5,
                        32.851351351351354
                    ],
                    [
                        176.04166666666666,
                        32.5
                    ],
                    [
                        176.05555555555554,
                        31.5
                    ],
                    [
                        176.1031746031746,
                        30.5
                    ],
                    [
                        176.06756756756758,
                        29.5
                    ],
                    [
                        176.5,
                        29.228813559322035
                    ],
                    [
                        177.5,
                        28.642857142857142
                    ],
                    [
                        178.5,
                        28.666666666666668
                    ],
                    [
                        178.6153846153846,
                        28.5
                    ],
                    [
                        179.45238095238096,
                        27.5
                    ],
                    [
                        178.5,
                        26.59090909090909
                    ],
                    [
                        177.8548387096774,
                        27.5
                    ],
                    [
                        177.5,
                        28.1875
                    ],
                    [
                        176.5,
                        27.565217391304348
                    ],
                    [
                        176.33333333333334,
                        27.5
                    ],
                    [
                        176.5,
                        27.2
                    ],
                    [
                        177.5,
                        26.714285714285715
                    ],
                    [
                        178.1,
                        26.5
                    ],
                    [
                        177.80434782608697,
                        25.5
                    ],
                    [
                        177.5,
                        24.625
                    ],
                    [
                        176.5,
                        25.314814814814813
                    ],
                    [
                        176.1153846153846,
                        25.5
                    ],
                    [
                        175.5,
                        26.071428571428573
                    ],
                    [
                        174.5,
                        25.75
                    ],
                    [
                        174.16666666666666,
                        25.5
                    ],
                    [
                        173.5,
                        24.785714285714285
                    ],
                    [
                        172.5909090909091,
                        25.5
                    ],
                    [
                        172.5,
                        26
                    ],
                    [
                        172.4375,
                        26.5
                    ],
                    [
                        171.8846153846154,
                        27.5
                    ],
                    [
                        171.5,
                        27.727272727272727
                    ],
                    [
                        170.5,
                        28.214285714285715
                    ],
                    [
                        170.04545454545453,
                        27.5
                    ],
                    [
                        169.5,
                        27.125
                    ],
                    [
                        168.5,
                        26.5625
                    ],
                    [
                        168.43333333333334,
                        26.5
                    ],
                    [
                        168.5,
                        25.5
                    ],
                    [
                        168.5,
                        25.5
                    ],
                    [
                        168.5,
                        25.5
                    ],
                    [
                        167.5,
                        24.5
                    ],
                    [
                        167.5,
                        24.5
                    ],
                    [
                        166.5,
                        23.5
                    ],
                    [
                        166.5,
                        23.5
                    ],
                    [
                        165.5,
                        23.071428571428573
                    ],
                    [
                        165.05555555555554,
                        22.5
                    ],
                    [
                        164.5,
                        21.666666666666668
                    ],
                    [
                        164.33333333333334,
                        21.5
                    ],
                    [
                        164.05555555555554,
                        20.5
                    ],
                    [
                        163.625,
                        19.5
                    ],
                    [
                        163.5,
                        19.423076923076923
                    ],
                    [
                        162.5,
                        18.833333333333332
                    ],
                    [
                        161.875,
                        18.5
                    ],
                    [
                        161.5,
                        18.323529411764707
                    ],
                    [
                        160.5,
                        18
                    ],
                    [
                        159.5,
                        17.8
                    ],
                    [
                        158.5,
                        17.605263157894736
                    ],
                    [
                        158.27777777777777,
                        17.5
                    ],
                    [
                        157.5,
                        16.625
                    ],
                    [
                        157.44117647058823,
                        16.5
                    ],
                    [
                        157.05,
                        15.5
                    ],
                    [
                        156.5,
                        14.653846153846153
                    ],
                    [
                        156.35714285714286,
                        14.5
                    ],
                    [
                        155.5,
                        13.75
                    ],
                    [
                        154.92857142857142,
                        13.5
                    ],
                    [
                        154.5,
                        13.333333333333334
                    ],
                    [
                        153.9,
                        13.5
                    ],
                    [
                        153.5,
                        13.58
                    ],
                    [
                        152.5,
                        13.785714285714286
                    ],
                    [
                        151.5,
                        13.657894736842104
                    ],
                    [
                        150.5,
                        14.166666666666666
                    ],
                    [
                        150.125,
                        14.5
                    ],
                    [
                        149.8,
                        15.5
                    ],
                    [
                        149.5,
                        16.1
                    ],
                    [
                        149.3,
                        16.5
                    ],
                    [
                        148.86363636363637,
                        17.5
                    ],
                    [
                        149.125,
                        18.5
                    ],
                    [
                        149.5,
                        19.1
                    ],
                    [
                        149.75,
                        19.5
                    ],
                    [
                        149.5,
                        20.5
                    ],
                    [
                        149.5,
                        20.5
                    ],
                    [
                        149.16666666666666,
                        21.5
                    ],
                    [
                        148.5,
                        22
                    ],
                    [
                        147.5,
                        22.5
                    ],
                    [
                        146.5,
                        22.3
                    ],
                    [
                        145.5,
                        22.5
                    ],
                    [
                        145.5,
                        22.5
                    ],
                    [
                        144.5,
                        22.583333333333332
                    ],
                    [
                        143.5,
                        22.5
                    ],
                    [
                        143.5,
                        22.5
                    ],
                    [
                        143.5,
                        22.5
                    ],
                    [
                        142.5,
                        22.714285714285715
                    ],
                    [
                        141.5,
                        22.630434782608695
                    ],
                    [
                        140.5,
                        22.81578947368421
                    ],
                    [
                        139.5,
                        22.807692307692307
                    ],
                    [
                        138.5,
                        22.863636363636363
                    ],
                    [
                        137.5,
                        22.9
                    ],
                    [
                        136.5,
                        22.833333333333332
                    ],
                    [
                        135.5,
                        23.233333333333334
                    ],
                    [
                        134.7,
                        23.5
                    ],
                    [
                        134.5,
                        23.59090909090909
                    ],
                    [
                        133.5,
                        24.25
                    ],
                    [
                        132.9,
                        24.5
                    ],
                    [
                        132.5,
                        24.642857142857142
                    ],
                    [
                        131.5,
                        24.625
                    ],
                    [
                        131.3,
                        24.5
                    ],
                    [
                        130.5,
                        23.5
                    ],
                    [
                        130.5,
                        23.5
                    ],
                    [
                        129.5,
                        22.666666666666668
                    ],
                    [
                        129.1,
                        22.5
                    ],
                    [
                        128.5,
                        22.3125
                    ],
                    [
                        127.5,
                        22.214285714285715
                    ],
                    [
                        126.5,
                        22.423076923076923
                    ],
                    [
                        126.25,
                        22.5
                    ],
                    [
                        125.5,
                        22.8
                    ],
                    [
                        124.5,
                        23.2
                    ],
                    [
                        124.16666666666667,
                        23.5
                    ],
                    [
                        123.5,
                        23.928571428571427
                    ],
                    [
                        122.5,
                        23.96153846153846
                    ],
                    [
                        121.5,
                        23.72222222222222
                    ],
                    [
                        121.1,
                        23.5
                    ],
                    [
                        120.5,
                        23.285714285714285
                    ],
                    [
                        119.5,
                        23.033333333333335
                    ],
                    [
                        118.5,
                        22.7
                    ],
                    [
                        118.1,
                        22.5
                    ],
                    [
                        117.5,
                        22.125
                    ],
                    [
                        116.5,
                        22.1
                    ],
                    [
                        115.5,
                        22.029411764705884
                    ],
                    [
                        114.5,
                        22.5
                    ],
                    [
                        114.5,
                        22.5
                    ],
                    [
                        114.5,
                        22.5
                    ],
                    [
                        114.67647058823529,
                        23.5
                    ],
                    [
                        115.1,
                        24.5
                    ],
                    [
                        115.33333333333333,
                        25.5
                    ],
                    [
                        114.7,
                        26.5
                    ],
                    [
                        114.5,
                        27
                    ],
                    [
                        114.33333333333333,
                        26.5
                    ],
                    [
                        113.5,
                        26.166666666666668
                    ],
                    [
                        112.78571428571429,
                        26.5
                    ],
                    [
                        112.5,
                        26.785714285714285
                    ],
                    [
                        111.5,
                        27
                    ],
                    [
                        110.64285714285714,
                        26.5
                    ],
                    [
                        110.5,
                        26.428571428571427
                    ],
                    [
                        109.5,
                        25.65
                    ],
                    [
                        109.16666666666667,
                        25.5
                    ],
                    [
                        108.5,
                        24.9
                    ],
                    [
                        107.5,
                        24.537037037037038
                    ],
                    [
                        107.4375,
                        24.5
                    ],
                    [
                        107.5,
                        24.333333333333332
                    ],
                    [
                        108,
                        23.5
                    ],
                    [
                        107.92857142857143,
                        22.5
                    ],
                    [
                        107.5,
                        22.3
                    ],
                    [
                        106.5,
                        22.026315789473685
                    ],
                    [
                        105.5,
                        21.944444444444443
                    ],
                    [
                        104.5,
                        22.071428571428573
                    ],
                    [
                        103.77272727272727,
                        21.5
                    ],
                    [
                        104.20370370370371,
                        20.5
                    ],
                    [
                        104.16666666666667,
                        19.5
                    ],
                    [
                        103.5,
                        18.681818181818183
                    ],
                    [
                        102.92857142857143,
                        18.5
                    ],
                    [
                        102.5,
                        18.166666666666668
                    ],
                    [
                        101.5,
                        17.875
                    ],
                    [
                        101.22727272727273,
                        17.5
                    ],
                    [
                        100.5,
                        16.5
                    ],
                    [
                        100.5,
                        16.5
                    ],
                    [
                        100.5,
                        16.5
                    ],
                    [
                        99.5,
                        16.916666666666668
                    ],
                    [
                        99,
                        17.5
                    ],
                    [
                        98.5,
                        17.833333333333332
                    ],
                    [
                        97.5,
                        18.4
                    ],
                    [
                        96.5,
                        18.38235294117647
                    ],
                    [
                        95.5,
                        17.785714285714285
                    ],
                    [
                        95.25,
                        17.5
                    ],
                    [
                        95,
                        16.5
                    ],
                    [
                        95,
                        15.5
                    ],
                    [
                        94.5,
                        15.26923076923077
                    ],
                    [
                        93.83333333333333,
                        14.5
                    ],
                    [
                        93.5,
                        13.5
                    ],
                    [
                        93.5,
                        13.5
                    ],
                    [
                        92.96666666666667,
                        12.5
                    ],
                    [
                        92.5,
                        11.8
                    ],
                    [
                        91.75,
                        11.5
                    ],
                    [
                        91.5,
                        11.25
                    ],
                    [
                        90.75,
                        10.5
                    ],
                    [
                        90.5,
                        10.357142857142858
                    ],
                    [
                        89.5,
                        10.25
                    ],
                    [
                        88.64285714285714,
                        9.5
                    ],
                    [
                        88.5,
                        9.38888888888889
                    ],
                    [
                        87.5,
                        8.875
                    ],
                    [
                        86.9,
                        8.5
                    ],
                    [
                        86.5,
                        8.43939393939394
                    ],
                    [
                        85.5,
                        8.469696969696969
                    ],
                    [
                        85.44736842105263,
                        8.5
                    ],
                    [
                        85.11904761904762,
                        9.5
                    ],
                    [
                        84.875,
                        10.5
                    ],
                    [
                        84.5,
                        11.357142857142858
                    ],
                    [
                        84.46774193548387,
                        11.5
                    ],
                    [
                        84.36206896551724,
                        12.5
                    ],
                    [
                        83.98648648648648,
                        13.5
                    ],
                    [
                        83.5,
                        14.4
                    ],
                    [
                        83.43548387096774,
                        14.5
                    ],
                    [
                        83.05882352941177,
                        15.5
                    ],
                    [
                        83.14,
                        16.5
                    ],
                    [
                        82.8,
                        17.5
                    ],
                    [
                        82.55263157894737,
                        18.5
                    ],
                    [
                        82.5,
                        18.61111111111111
                    ],
                    [
                        81.88461538461539,
                        19.5
                    ],
                    [
                        81.5,
                        20.055555555555557
                    ],
                    [
                        81.1,
                        20.5
                    ],
                    [
                        81.23684210526316,
                        21.5
                    ],
                    [
                        81.26470588235294,
                        22.5
                    ],
                    [
                        81.4090909090909,
                        23.5
                    ],
                    [
                        81.11538461538461,
                        24.5
                    ],
                    [
                        81.5,
                        25.214285714285715
                    ],
                    [
                        81.68181818181819,
                        25.5
                    ],
                    [
                        81.64285714285714,
                        26.5
                    ],
                    [
                        81.875,
                        27.5
                    ],
                    [
                        81.7,
                        28.5
                    ],
                    [
                        81.5,
                        29.166666666666668
                    ],
                    [
                        81.35714285714286,
                        29.5
                    ],
                    [
                        81.16666666666667,
                        30.5
                    ],
                    [
                        81.5,
                        30.863636363636363
                    ],
                    [
                        82.5,
                        31.452380952380953
                    ],
                    [
                        82.61111111111111,
                        31.5
                    ],
                    [
                        83.5,
                        32.03333333333333
                    ],
                    [
                        84.5,
                        32.4
                    ],
                    [
                        84.75,
                        32.5
                    ],
                    [
                        85.5,
                        32.81578947368421
                    ],
                    [
                        86.5,
                        33.23684210526316
                    ],
                    [
                        87.21428571428571,
                        33.5
                    ],
                    [
                        87.5,
                        34
                    ],
                    [
                        88.16666666666667,
                        34.5
                    ],
                    [
                        88.5,
                        35
                    ],
                    [
                        88.83333333333333,
                        35.5
                    ],
                    [
                        88.75,
                        36.5
                    ],
                    [
                        88.5,
                        37.5
                    ],
                    [
                        88.5,
                        37.5
                    ],
                    [
                        87.5,
                        37.75
                    ],
                    [
                        86.5,
                        38.166666666666664
                    ],
                    [
                        86,
                        38.5
                    ],
                    [
                        85.5,
                        38.833333333333336
                    ],
                    [
                        84.5,
                        38.5
                    ],
                    [
                        84.5,
                        38.5
                    ],
                    [
                        83.5,
                        38.25
                    ],
                    [
                        82.5,
                        38
                    ],
                    [
                        81.83333333333333,
                        38.5
                    ],
                    [
                        81.5,
                        39
                    ],
                    [
                        80.5,
                        39.5
                    ],
                    [
                        80.5,
                        39.5
                    ],
                    [
                        80.5,
                        40.5
                    ],
                    [
                        80,
                        41.5
                    ],
                    [
                        79.5,
                        42.5
                    ],
                    [
                        78.5,
                        42.5
                    ],
                    [
                        78,
                        41.5
                    ],
                    [
                        77.5,
                        41.166666666666664
                    ],
                    [
                        76.5,
                        41.166666666666664
                    ],
                    [
                        75.5,
                        41
                    ],
                    [
                        74.5,
                        40.5
                    ],
                    [
                        75.5,
                        39.5
                    ],
                    [
                        75.5,
                        39.5
                    ],
                    [
                        75.5,
                        38.5
                    ],
                    [
                        75.5,
                        38.5
                    ],
                    [
                        75.16666666666667,
                        37.5
                    ],
                    [
                        75,
                        36.5
                    ],
                    [
                        75.5,
                        35.833333333333336
                    ],
                    [
                        76,
                        35.5
                    ],
                    [
                        75.5,
                        35.25
                    ],
                    [
                        74.5,
                        35.1
                    ],
                    [
                        73.5,
                        34.5
                    ],
                    [
                        73.5,
                        34.5
                    ],
                    [
                        73.5,
                        34.5
                    ],
                    [
                        72.5,
                        34.75
                    ],
                    [
                        72.25,
                        34.5
                    ],
                    [
                        71.5,
                        34.125
                    ],
                    [
                        70.5,
                        33.9
                    ],
                    [
                        69.5,
                        34.5
                    ],
                    [
                        69.5,
                        34.5
                    ],
                    [
                        68.5,
                        34.94444444444444
                    ],
                    [
                        67.5,
                        34.625
                    ],
                    [
                        67.41666666666667,
                        34.5
                    ],
                    [
                        66.5,
                        34.21052631578947
                    ],
                    [
                        65.5,
                        34.144444444444446
                    ],
                    [
                        64.5,
                        34.2
                    ],
                    [
                        63.5,
                        34.19047619047619
                    ],
                    [
                        62.5,
                        34.316326530612244
                    ],
                    [
                        61.5,
                        34.3235294117647
                    ],
                    [
                        60.5,
                        34.04385964912281
                    ],
                    [
                        59.5,
                        33.55882352941177
                    ],
                    [
                        59.38,
                        33.5
                    ],
                    [
                        58.5,
                        33.1
                    ],
                    [
                        57.5,
                        33.15217391304348
                    ],
                    [
                        56.5,
                        33.26470588235294
                    ],
                    [
                        55.5,
                        33.193548387096776
                    ],
                    [
                        54.5,
                        33.30701754385965
                    ],
                    [
                        53.888888888888886,
                        33.5
                    ],
                    [
                        53.5,
                        33.666666666666664
                    ],
                    [
                        52.5,
                        33.9375
                    ],
                    [
                        51.5,
                        34.24193548387097
                    ],
                    [
                        51.166666666666664,
                        34.5
                    ],
                    [
                        50.642857142857146,
                        35.5
                    ],
                    [
                        50.5,
                        35.73076923076923
                    ],
                    [
                        49.5,
                        36.375
                    ],
                    [
                        48.5,
                        36.3235294117647
                    ],
                    [
                        48.07142857142857,
                        36.5
                    ],
                    [
                        47.5,
                        36.74242424242424
                    ],
                    [
                        46.5,
                        37.294871794871796
                    ],
                    [
                        46.05555555555556,
                        37.5
                    ],
                    [
                        45.5,
                        37.75
                    ],
                    [
                        44.5,
                        38.1
                    ],
                    [
                        43.6578947368421,
                        38.5
                    ],
                    [
                        43.5,
                        38.666666666666664
                    ],
                    [
                        42.98275862068966,
                        39.5
                    ],
                    [
                        42.5,
                        40.5
                    ],
                    [
                        42.5,
                        40.5
                    ],
                    [
                        42.5,
                        40.5
                    ],
                    [
                        42.92857142857143,
                        41.5
                    ],
                    [
                        43.5,
                        42
                    ],
                    [
                        43.9,
                        42.5
                    ],
                    [
                        43.714285714285715,
                        43.5
                    ],
                    [
                        43.5,
                        43.77272727272727
                    ],
                    [
                        42.611111111111114,
                        44.5
                    ],
                    [
                        43.404761904761905,
                        45.5
                    ],
                    [
                        43.5,
                        45.564516129032256
                    ],
                    [
                        44.5,
                        45.875
                    ],
                    [
                        45.4375,
                        46.5
                    ],
                    [
                        45.5,
                        46.55555555555556
                    ],
                    [
                        46.5,
                        47.0625
                    ],
                    [
                        47.5,
                        47.22727272727273
                    ],
                    [
                        48.5,
                        47.13636363636363
                    ],
                    [
                        49.5,
                        47.1
                    ],
                    [
                        50.5,
                        47.1875
                    ],
                    [
                        51.5,
                        47.25
                    ],
                    [
                        52.5,
                        47.5
                    ],
                    [
                        52.5,
                        47.5
                    ],
                    [
                        53.5,
                        47.666666666666664
                    ],
                    [
                        54.333333333333336,
                        48.5
                    ],
                    [
                        54.5,
                        48.611111111111114
                    ],
                    [
                        55.5,
                        49.07142857142857
                    ],
                    [
                        56.5,
                        49.5
                    ],
                    [
                        56.5,
                        49.5
                    ],
                    [
                        57.5,
                        49.642857142857146
                    ],
                    [
                        58.5,
                        49.666666666666664
                    ],
                    [
                        59.5,
                        50.07142857142857
                    ],
                    [
                        60.5,
                        50.1
                    ],
                    [
                        61.5,
                        50.3
                    ],
                    [
                        62.5,
                        50.333333333333336
                    ],
                    [
                        63.5,
                        50.357142857142854
                    ],
                    [
                        64.5,
                        50.357142857142854
                    ],
                    [
                        65.5,
                        50.375
                    ],
                    [
                        66,
                        50.5
                    ],
                    [
                        66.5,
                        50.7
                    ],
                    [
                        67.5,
                        51.166666666666664
                    ],
                    [
                        67.83333333333333,
                        51.5
                    ],
                    [
                        67.5,
                        51.583333333333336
                    ],
                    [
                        66.5,
                        52.07142857142857
                    ],
                    [
                        65.5,
                        52.214285714285715
                    ],
                    [
                        64.5,
                        52
                    ],
                    [
                        63.5,
                        52.3
                    ],
                    [
                        63.166666666666664,
                        52.5
                    ],
                    [
                        62.5,
                        52.9
                    ],
                    [
                        61.5,
                        52.68181818181818
                    ],
                    [
                        60.5,
                        53.25
                    ],
                    [
                        60.25,
                        53.5
                    ],
                    [
                        60.5,
                        53.57142857142857
                    ],
                    [
                        61.5,
                        54.142857142857146
                    ],
                    [
                        62.5,
                        54.5
                    ],
                    [
                        62.5,
                        54.5
                    ],
                    [
                        63.5,
                        54.5
                    ],
                    [
                        63.5,
                        54.5
                    ],
                    [
                        64.5,
                        53.833333333333336
                    ],
                    [
                        65.16666666666667,
                        54.5
                    ],
                    [
                        64.5,
                        55.5
                    ],
                    [
                        64.5,
                        55.5
                    ],
                    [
                        64.5,
                        55.5
                    ],
                    [
                        65.5,
                        55.7
                    ],
                    [
                        66.5,
                        55.666666666666664
                    ],
                    [
                        66.83333333333333,
                        55.5
                    ],
                    [
                        67.5,
                        54.833333333333336
                    ],
                    [
                        68.5,
                        55.5
                    ],
                    [
                        68.5,
                        55.5
                    ],
                    [
                        68.64285714285714,
                        56.5
                    ],
                    [
                        68.5,
                        56.59090909090909
                    ],
                    [
                        67.5,
                        57.1
                    ],
                    [
                        67.16666666666667,
                        57.5
                    ],
                    [
                        66.5,
                        57.86363636363637
                    ],
                    [
                        65.5,
                        58.05555555555556
                    ],
                    [
                        64.5,
                        58.22727272727273
                    ],
                    [
                        63.5,
                        58.2
                    ],
                    [
                        62.625,
                        57.5
                    ],
                    [
                        63,
                        56.5
                    ],
                    [
                        62.5,
                        55.833333333333336
                    ],
                    [
                        61.5,
                        56.5
                    ],
                    [
                        60.5,
                        56.42307692307692
                    ],
                    [
                        60,
                        56.5
                    ],
                    [
                        59.5,
                        56.833333333333336
                    ],
                    [
                        59.31818181818182,
                        57.5
                    ],
                    [
                        59.5,
                        57.75
                    ],
                    [
                        60.5,
                        58.3
                    ],
                    [
                        61.5,
                        58.5
                    ],
                    [
                        60.833333333333336,
                        59.5
                    ],
                    [
                        60.5,
                        60.5
                    ],
                    [
                        60.5,
                        60.5
                    ],
                    [
                        60.5,
                        60.5
                    ],
                    [
                        61.5,
                        60.5
                    ],
                    [
                        61.5,
                        60.5
                    ],
                    [
                        62.5,
                        60.166666666666664
                    ],
                    [
                        62.75,
                        60.5
                    ],
                    [
                        62.9,
                        61.5
                    ],
                    [
                        62.5,
                        62.166666666666664
                    ],
                    [
                        62.166666666666664,
                        62.5
                    ],
                    [
                        61.75,
                        63.5
                    ],
                    [
                        61.5,
                        63.75
                    ],
                    [
                        60.5,
                        64
                    ],
                    [
                        60.3,
                        64.5
                    ],
                    [
                        59.75,
                        65.5
                    ],
                    [
                        59.5,
                        66.5
                    ],
                    [
                        59.5,
                        66.5
                    ],
                    [
                        59.357142857142854,
                        67.5
                    ],
                    [
                        59,
                        68.5
                    ],
                    [
                        59,
                        69.5
                    ],
                    [
                        59.357142857142854,
                        70.5
                    ],
                    [
                        59.5,
                        70.83333333333333
                    ],
                    [
                        59.833333333333336,
                        71.5
                    ],
                    [
                        60.333333333333336,
                        72.5
                    ],
                    [
                        60.5,
                        73
                    ],
                    [
                        60.75,
                        73.5
                    ],
                    [
                        61,
                        74.5
                    ],
                    [
                        61.166666666666664,
                        75.5
                    ],
                    [
                        61.5,
                        76
                    ],
                    [
                        61.7,
                        76.5
                    ],
                    [
                        61.7,
                        77.5
                    ],
                    [
                        62,
                        78.5
                    ],
                    [
                        61.785714285714285,
                        79.5
                    ],
                    [
                        61.72222222222222,
                        80.5
                    ],
                    [
                        61.833333333333336,
                        81.5
                    ],
                    [
                        62.5,
                        82.3
                    ],
                    [
                        62.75,
                        82.5
                    ],
                    [
                        63.5,
                        83.25
                    ],
                    [
                        63.75,
                        83.5
                    ],
                    [
                        63.5,
                        84
                    ],
                    [
                        62.5,
                        84.5
                    ],
                    [
                        62.5,
                        84.5
                    ],
                    [
                        62.5,
                        85.5
                    ],
                    [
                        62.5,
                        85.5
                    ],
                    [
                        63,
                        86.5
                    ],
                    [
                        63.5,
                        87
                    ],
                    [
                        63.83333333333333,
                        87.5
                    ],
                    [
                        64.5,
                        88.5
                    ],
                    [
                        64.5,
                        88.5
                    ],
                    [
                        64.5,
                        88.5
                    ],
                    [
                        65.5,
                        88
                    ],
                    [
                        66.5,
                        88.5
                    ],
                    [
                        66.5,
                        88.5
                    ],
                    [
                        67.16666666666667,
                        89.5
                    ],
                    [
                        67.5,
                        90
                    ],
                    [
                        68.5,
                        90.5
                    ],
                    [
                        68.5,
                        90.5
                    ],
                    [
                        69.5,
                        90.72222222222223
                    ],
                    [
                        70.5,
                        90.9
                    ],
                    [
                        71.5,
                        91.31818181818181
                    ],
                    [
                        72.16666666666667,
                        91.5
                    ],
                    [
                        72.5,
                        92
                    ],
                    [
                        73.5,
                        92
                    ],
                    [
                        74.5,
                        92
                    ],
                    [
                        75.5,
                        92
                    ],
                    [
                        76.5,
                        92
                    ],
                    [
                        77.5,
                        92
                    ],
                    [
                        78.5,
                        92
                    ],
                    [
                        79.5,
                        92
                    ],
                    [
                        80.5,
                        92
                    ],
                    [
                        81.5,
                        92
                    ],
                    [
                        82.5,
                        92
                    ],
                    [
                        83.5,
                        92
                    ],
                    [
                        84.5,
                        92
                    ],
                    [
                        85.5,
                        92
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        144.5,
                        92
                    ],
                    [
                        145.5,
                        92
                    ],
                    [
                        146.5,
                        92
                    ],
                    [
                        147.5,
                        92
                    ],
                    [
                        148.5,
                        92
                    ],
                    [
                        149.5,
                        92
                    ],
                    [
                        150.5,
                        92
                    ],
                    [
                        151.5,
                        92
                    ],
                    [
                        152.5,
                        92
                    ],
                    [
                        153.5,
                        92
                    ],
                    [
                        154.5,
                        92
                    ],
                    [
                        155.5,
                        92
                    ],
                    [
                        156.5,
                        92
                    ],
                    [
                        157.5,
                        92
                    ],
                    [
                        158.5,
                        92
                    ],
                    [
                        159.5,
                        92
                    ],
                    [
                        160.5,
                        92
                    ],
                    [
                        161.5,
                        92
                    ],
                    [
                        162.5,
                        92
                    ],
                    [
                        163.5,
                        92
                    ],
                    [
                        163.85714285714286,
                        91.5
                    ]
                ],
                [
                    [
                        174.5,
                        29.236842105263158
                    ],
                    [
                        173.625,
                        28.5
                    ],
                    [
                        173.5,
                        28.1
                    ],
                    [
                        173.22727272727272,
                        27.5
                    ],
                    [
                        173.5,
                        27.392857142857142
                    ],
                    [
                        173.75,
                        27.5
                    ],
                    [
                        174.5,
                        27.891304347826086
                    ],
                    [
                        174.75925925925927,
                        28.5
                    ],
                    [
                        174.5,
                        29.236842105263158
                    ]
                ],
                [
                    [
                        82.5,
                        36.5
                    ],
                    [
                        82.5,
                        36.5
                    ],
                    [
                        81.5,
                        36.5
                    ],
                    [
                        81.5,
                        36.5
                    ],
                    [
                        81.5,
                        36.5
                    ],
                    [
                        82.5,
                        36.5
                    ],
                    [
                        82.5,
                        36.5
                    ]
                ],
                [
                    [
                        73.5,
                        40.7
                    ],
                    [
                        73,
                        40.5
                    ],
                    [
                        73.5,
                        40.166666666666664
                    ],
                    [
                        74.5,
                        40.5
                    ],
                    [
                        73.5,
                        40.7
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 60,
        "coordinates": [
            [
                [
                    [
                        171.9,
                        18.5
                    ],
                    [
                        172.5,
                        18.227272727272727
                    ],
                    [
                        172.86363636363637,
                        17.5
                    ],
                    [
                        172.66666666666666,
                        16.5
                    ],
                    [
                        172.5,
                        16.3
                    ],
                    [
                        171.7,
                        15.5
                    ],
                    [
                        171.5,
                        15.370967741935484
                    ],
                    [
                        170.5,
                        14.58695652173913
                    ],
                    [
                        170.33333333333334,
                        14.5
                    ],
                    [
                        169.5,
                        14.065217391304348
                    ],
                    [
                        168.5,
                        14.5
                    ],
                    [
                        168.5,
                        14.5
                    ],
                    [
                        168.5,
                        15.5
                    ],
                    [
                        168.5,
                        15.5
                    ],
                    [
                        169.5,
                        16.5
                    ],
                    [
                        169.5,
                        16.5
                    ],
                    [
                        170.5,
                        17.3125
                    ],
                    [
                        170.83333333333334,
                        17.5
                    ],
                    [
                        171.21428571428572,
                        18.5
                    ],
                    [
                        171.5,
                        18.833333333333332
                    ],
                    [
                        171.9,
                        18.5
                    ]
                ]
            ],
            [
                [
                    [
                        174.5,
                        26.5
                    ],
                    [
                        174.5,
                        26.5
                    ],
                    [
                        173.5,
                        25.833333333333332
                    ],
                    [
                        173.08333333333334,
                        26.5
                    ],
                    [
                        173.5,
                        26.857142857142858
                    ],
                    [
                        174.5,
                        26.5
                    ],
                    [
                        174.5,
                        26.5
                    ]
                ]
            ],
            [
                [
                    [
                        179.8684210526316,
                        26.5
                    ],
                    [
                        179.5,
                        26.325
                    ],
                    [
                        179.20833333333334,
                        26.5
                    ],
                    [
                        179.5,
                        26.804347826086957
                    ],
                    [
                        179.8684210526316,
                        26.5
                    ]
                ]
            ],
            [
                [
                    [
                        178.73809523809524,
                        27.5
                    ],
                    [
                        178.5,
                        27.272727272727273
                    ],
                    [
                        178.33870967741936,
                        27.5
                    ],
                    [
                        178.5,
                        27.857142857142858
                    ],
                    [
                        178.73809523809524,
                        27.5
                    ]
                ]
            ],
            [
                [
                    [
                        171.96153846153845,
                        29.5
                    ],
                    [
                        172.5,
                        29.12162162162162
                    ],
                    [
                        173.13888888888889,
                        28.5
                    ],
                    [
                        172.5,
                        27.733333333333334
                    ],
                    [
                        171.5,
                        28.40909090909091
                    ],
                    [
                        171.36666666666667,
                        28.5
                    ],
                    [
                        170.92857142857142,
                        29.5
                    ],
                    [
                        171.5,
                        29.81578947368421
                    ],
                    [
                        171.96153846153845,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        167.55882352941177,
                        31.5
                    ],
                    [
                        167.5,
                        31.357142857142858
                    ],
                    [
                        167.42857142857142,
                        31.5
                    ],
                    [
                        167.5,
                        31.583333333333336
                    ],
                    [
                        167.55882352941177,
                        31.5
                    ]
                ]
            ],
            [
                [
                    [
                        174.5,
                        31.5
                    ],
                    [
                        175.5,
                        31.321428571428573
                    ],
                    [
                        175.86507936507937,
                        30.5
                    ],
                    [
                        175.66216216216216,
                        29.5
                    ],
                    [
                        176.5,
                        28.97457627118644
                    ],
                    [
                        177.23684210526315,
                        28.5
                    ],
                    [
                        176.5,
                        27.891304347826086
                    ],
                    [
                        175.5,
                        27.5
                    ],
                    [
                        175.5,
                        27.5
                    ],
                    [
                        175.5,
                        27.5
                    ],
                    [
                        175.03703703703704,
                        28.5
                    ],
                    [
                        175.125,
                        29.5
                    ],
                    [
                        174.5,
                        29.844827586206897
                    ],
                    [
                        173.5,
                        29.857142857142858
                    ],
                    [
                        173.15384615384616,
                        30.5
                    ],
                    [
                        173.5,
                        30.810344827586206
                    ],
                    [
                        174.5,
                        31.5
                    ],
                    [
                        174.5,
                        31.5
                    ],
                    [
                        174.5,
                        31.5
                    ]
                ]
            ],
            [
                [
                    [
                        164.91666666666666,
                        32.5
                    ],
                    [
                        164.5,
                        31.785714285714285
                    ],
                    [
                        163.875,
                        32.5
                    ],
                    [
                        164.5,
                        32.77777777777778
                    ],
                    [
                        164.91666666666666,
                        32.5
                    ]
                ]
            ],
            [
                [
                    [
                        72.5,
                        48.5
                    ],
                    [
                        73.5,
                        48
                    ],
                    [
                        74.5,
                        47.92857142857143
                    ],
                    [
                        75.5,
                        47.5
                    ],
                    [
                        75.5,
                        47.5
                    ],
                    [
                        76,
                        46.5
                    ],
                    [
                        75.5,
                        46.357142857142854
                    ],
                    [
                        74.5,
                        46.333333333333336
                    ],
                    [
                        73.5,
                        45.833333333333336
                    ],
                    [
                        73.33333333333333,
                        45.5
                    ],
                    [
                        73.125,
                        44.5
                    ],
                    [
                        72.5,
                        43.785714285714285
                    ],
                    [
                        72,
                        43.5
                    ],
                    [
                        71.5,
                        43.1
                    ],
                    [
                        70.5,
                        42.625
                    ],
                    [
                        70,
                        42.5
                    ],
                    [
                        69.5,
                        42.333333333333336
                    ],
                    [
                        68.5,
                        41.5
                    ],
                    [
                        68.5,
                        41.5
                    ],
                    [
                        67.83333333333333,
                        40.5
                    ],
                    [
                        67.5,
                        39.5
                    ],
                    [
                        67.5,
                        38.5
                    ],
                    [
                        68,
                        37.5
                    ],
                    [
                        67.66666666666667,
                        36.5
                    ],
                    [
                        67.5,
                        36.388888888888886
                    ],
                    [
                        66.61111111111111,
                        35.5
                    ],
                    [
                        66.5,
                        35.3
                    ],
                    [
                        65.7,
                        34.5
                    ],
                    [
                        65.5,
                        34.477777777777774
                    ],
                    [
                        65.25,
                        34.5
                    ],
                    [
                        64.5,
                        34.6875
                    ],
                    [
                        63.5,
                        34.583333333333336
                    ],
                    [
                        62.5,
                        34.714285714285715
                    ],
                    [
                        61.5,
                        34.68181818181818
                    ],
                    [
                        61.14705882352941,
                        34.5
                    ],
                    [
                        60.5,
                        34.30701754385965
                    ],
                    [
                        59.5,
                        33.85294117647059
                    ],
                    [
                        58.78,
                        33.5
                    ],
                    [
                        58.5,
                        33.372727272727275
                    ],
                    [
                        57.5,
                        33.47826086956522
                    ],
                    [
                        57.25,
                        33.5
                    ],
                    [
                        56.5,
                        33.6
                    ],
                    [
                        56.07142857142857,
                        33.5
                    ],
                    [
                        55.5,
                        33.435483870967744
                    ],
                    [
                        55,
                        33.5
                    ],
                    [
                        54.5,
                        33.614285714285714
                    ],
                    [
                        53.5,
                        34.023809523809526
                    ],
                    [
                        52.5,
                        34.25
                    ],
                    [
                        51.86842105263158,
                        34.5
                    ],
                    [
                        51.5,
                        35.2
                    ],
                    [
                        51.357142857142854,
                        35.5
                    ],
                    [
                        50.916666666666664,
                        36.5
                    ],
                    [
                        50.5,
                        36.672413793103445
                    ],
                    [
                        49.5,
                        36.85294117647059
                    ],
                    [
                        48.5,
                        36.84615384615385
                    ],
                    [
                        47.5,
                        37.196969696969695
                    ],
                    [
                        46.911764705882355,
                        37.5
                    ],
                    [
                        46.5,
                        37.68421052631579
                    ],
                    [
                        45.5,
                        38.125
                    ],
                    [
                        44.5,
                        38.475
                    ],
                    [
                        44.44736842105263,
                        38.5
                    ],
                    [
                        43.5,
                        39.5
                    ],
                    [
                        43.5,
                        39.5
                    ],
                    [
                        43.5,
                        39.5
                    ],
                    [
                        43.9,
                        40.5
                    ],
                    [
                        44.5,
                        41.357142857142854
                    ],
                    [
                        44.625,
                        41.5
                    ],
                    [
                        45.5,
                        42.27777777777778
                    ],
                    [
                        45.785714285714285,
                        42.5
                    ],
                    [
                        45.5,
                        43
                    ],
                    [
                        45.166666666666664,
                        43.5
                    ],
                    [
                        45,
                        44.5
                    ],
                    [
                        45.5,
                        45
                    ],
                    [
                        46.5,
                        45.5
                    ],
                    [
                        46.5,
                        45.5
                    ],
                    [
                        47.5,
                        45.86363636363637
                    ],
                    [
                        48.5,
                        45.96666666666667
                    ],
                    [
                        49.5,
                        46
                    ],
                    [
                        50.5,
                        46.05555555555556
                    ],
                    [
                        51.5,
                        45.75
                    ],
                    [
                        52.5,
                        45.5
                    ],
                    [
                        53.5,
                        46
                    ],
                    [
                        54.333333333333336,
                        46.5
                    ],
                    [
                        54.5,
                        46.6
                    ],
                    [
                        55.5,
                        46.875
                    ],
                    [
                        56.5,
                        47
                    ],
                    [
                        57.5,
                        47.07142857142857
                    ],
                    [
                        58.5,
                        47.1
                    ],
                    [
                        59.5,
                        47
                    ],
                    [
                        60.5,
                        47
                    ],
                    [
                        61.5,
                        47.166666666666664
                    ],
                    [
                        62.5,
                        47.5
                    ],
                    [
                        62.5,
                        47.5
                    ],
                    [
                        63.5,
                        48.166666666666664
                    ],
                    [
                        64.5,
                        48.3
                    ],
                    [
                        65,
                        48.5
                    ],
                    [
                        65.5,
                        48.611111111111114
                    ],
                    [
                        66.5,
                        48.68181818181818
                    ],
                    [
                        67.5,
                        49.04545454545455
                    ],
                    [
                        68.5,
                        49.083333333333336
                    ],
                    [
                        69.5,
                        49.04545454545455
                    ],
                    [
                        70.5,
                        49
                    ],
                    [
                        71.5,
                        48.875
                    ],
                    [
                        72.5,
                        48.5
                    ],
                    [
                        72.5,
                        48.5
                    ]
                ]
            ],
            [
                [
                    [
                        178.85714285714286,
                        75.5
                    ],
                    [
                        179.5,
                        74.68181818181819
                    ],
                    [
                        179.64285714285714,
                        74.5
                    ],
                    [
                        180.5,
                        73.79411764705883
                    ],
                    [
                        181.5,
                        73.80434782608695
                    ],
                    [
                        182.5,
                        73.83333333333333
                    ],
                    [
                        182.80769230769232,
                        73.5
                    ],
                    [
                        183.08823529411765,
                        72.5
                    ],
                    [
                        182.83333333333334,
                        71.5
                    ],
                    [
                        182.5,
                        70.75
                    ],
                    [
                        182.3695652173913,
                        70.5
                    ],
                    [
                        181.55,
                        69.5
                    ],
                    [
                        181.5,
                        69.38888888888889
                    ],
                    [
                        180.83333333333334,
                        68.5
                    ],
                    [
                        180.94444444444446,
                        67.5
                    ],
                    [
                        180.5,
                        67.1
                    ],
                    [
                        179.5,
                        67.04545454545455
                    ],
                    [
                        178.5,
                        67.16666666666667
                    ],
                    [
                        177.5,
                        67.1923076923077
                    ],
                    [
                        176.5,
                        66.76666666666667
                    ],
                    [
                        176.23333333333332,
                        66.5
                    ],
                    [
                        175.5,
                        66.02173913043478
                    ],
                    [
                        174.57692307692307,
                        65.5
                    ],
                    [
                        174.5,
                        65.3
                    ],
                    [
                        173.5,
                        64.83333333333333
                    ],
                    [
                        172.5,
                        65.5
                    ],
                    [
                        172.5,
                        65.5
                    ],
                    [
                        171.5,
                        65.94444444444444
                    ],
                    [
                        171.2058823529412,
                        66.5
                    ],
                    [
                        171.5,
                        67.21428571428571
                    ],
                    [
                        171.64285714285714,
                        67.5
                    ],
                    [
                        172.5,
                        68.07142857142857
                    ],
                    [
                        173.02941176470588,
                        68.5
                    ],
                    [
                        173.5,
                        68.94444444444444
                    ],
                    [
                        174.26923076923077,
                        69.5
                    ],
                    [
                        174.5,
                        69.8
                    ],
                    [
                        175.03846153846155,
                        70.5
                    ],
                    [
                        175.5,
                        71.35714285714286
                    ],
                    [
                        175.64285714285714,
                        71.5
                    ],
                    [
                        176.5,
                        71.9
                    ],
                    [
                        177.25,
                        72.5
                    ],
                    [
                        177.5,
                        73
                    ],
                    [
                        177.77272727272728,
                        73.5
                    ],
                    [
                        177.5,
                        73.92857142857143
                    ],
                    [
                        177.21428571428572,
                        74.5
                    ],
                    [
                        177.1153846153846,
                        75.5
                    ],
                    [
                        177.5,
                        75.79411764705883
                    ],
                    [
                        178.5,
                        75.77777777777777
                    ],
                    [
                        178.85714285714286,
                        75.5
                    ]
                ]
            ],
            [
                [
                    [
                        147.66666666666666,
                        78.5
                    ],
                    [
                        148.1,
                        77.5
                    ],
                    [
                        147.5,
                        76.83333333333333
                    ],
                    [
                        146.5,
                        76.66666666666667
                    ],
                    [
                        145.94444444444446,
                        77.5
                    ],
                    [
                        146.5,
                        78.21428571428571
                    ],
                    [
                        147.16666666666666,
                        78.5
                    ],
                    [
                        147.5,
                        78.625
                    ],
                    [
                        147.66666666666666,
                        78.5
                    ]
                ]
            ],
            [
                [
                    [
                        147.9,
                        91.5
                    ],
                    [
                        147.5,
                        91.1
                    ],
                    [
                        146.75,
                        90.5
                    ],
                    [
                        146.5,
                        90.35714285714286
                    ],
                    [
                        145.5,
                        90.27777777777777
                    ],
                    [
                        144.5,
                        89.83333333333333
                    ],
                    [
                        143.83333333333334,
                        89.5
                    ],
                    [
                        143.5,
                        89.3
                    ],
                    [
                        142.5,
                        88.6
                    ],
                    [
                        142,
                        88.5
                    ],
                    [
                        141.5,
                        88.4
                    ],
                    [
                        140.5,
                        87.61111111111111
                    ],
                    [
                        140.33333333333334,
                        87.5
                    ],
                    [
                        140.38888888888889,
                        86.5
                    ],
                    [
                        140.5,
                        86.42857142857143
                    ],
                    [
                        141.5,
                        85.9
                    ],
                    [
                        141.80769230769232,
                        85.5
                    ],
                    [
                        141.91666666666666,
                        84.5
                    ],
                    [
                        141.86363636363637,
                        83.5
                    ],
                    [
                        141.96153846153845,
                        82.5
                    ],
                    [
                        141.61111111111111,
                        81.5
                    ],
                    [
                        141.5,
                        81.3
                    ],
                    [
                        140.5,
                        80.5909090909091
                    ],
                    [
                        140.35714285714286,
                        80.5
                    ],
                    [
                        139.5,
                        79.5
                    ],
                    [
                        139.5,
                        79.5
                    ],
                    [
                        138.5,
                        78.9
                    ],
                    [
                        137.5,
                        78.5
                    ],
                    [
                        137.5,
                        78.5
                    ],
                    [
                        137.1,
                        77.5
                    ],
                    [
                        137.5,
                        77.16666666666667
                    ],
                    [
                        138.5,
                        77
                    ],
                    [
                        139,
                        76.5
                    ],
                    [
                        139.5,
                        76.3
                    ],
                    [
                        140.5,
                        75.875
                    ],
                    [
                        141.5,
                        75.92857142857143
                    ],
                    [
                        142.5,
                        75.875
                    ],
                    [
                        143.5,
                        75.5
                    ],
                    [
                        143.5,
                        75.5
                    ],
                    [
                        144.07142857142858,
                        74.5
                    ],
                    [
                        144.33333333333334,
                        73.5
                    ],
                    [
                        144.25,
                        72.5
                    ],
                    [
                        144.45238095238096,
                        71.5
                    ],
                    [
                        144.5,
                        71.38888888888889
                    ],
                    [
                        145.5,
                        70.5
                    ],
                    [
                        145.5,
                        70.5
                    ],
                    [
                        145.5,
                        70.5
                    ],
                    [
                        144.5,
                        69.92857142857143
                    ],
                    [
                        143.75,
                        69.5
                    ],
                    [
                        143.5,
                        69.31818181818181
                    ],
                    [
                        142.75,
                        68.5
                    ],
                    [
                        142.5,
                        67.9
                    ],
                    [
                        142.3181818181818,
                        67.5
                    ],
                    [
                        141.5,
                        66.9
                    ],
                    [
                        140.5,
                        67
                    ],
                    [
                        139.5,
                        67.16666666666667
                    ],
                    [
                        138.5,
                        67.43333333333334
                    ],
                    [
                        138.35714285714286,
                        67.5
                    ],
                    [
                        137.5,
                        68.16666666666667
                    ],
                    [
                        137,
                        68.5
                    ],
                    [
                        136.5,
                        68.75
                    ],
                    [
                        135.5,
                        68.71428571428571
                    ],
                    [
                        134.5,
                        68.5
                    ],
                    [
                        134.5,
                        68.5
                    ],
                    [
                        133.5,
                        68.28571428571429
                    ],
                    [
                        132.5,
                        68.125
                    ],
                    [
                        132,
                        67.5
                    ],
                    [
                        131.5,
                        67.08333333333333
                    ],
                    [
                        130.5,
                        66.71428571428571
                    ],
                    [
                        130,
                        66.5
                    ],
                    [
                        129.83333333333334,
                        65.5
                    ],
                    [
                        130.5,
                        64.9
                    ],
                    [
                        131.3,
                        64.5
                    ],
                    [
                        131.5,
                        64.3
                    ],
                    [
                        132.5,
                        63.7
                    ],
                    [
                        133.16666666666666,
                        63.5
                    ],
                    [
                        133.5,
                        63.42307692307692
                    ],
                    [
                        134.42307692307693,
                        62.5
                    ],
                    [
                        134.5,
                        62.40909090909091
                    ],
                    [
                        135.33333333333334,
                        61.5
                    ],
                    [
                        135.5,
                        61
                    ],
                    [
                        135.7,
                        60.5
                    ],
                    [
                        135.72222222222223,
                        59.5
                    ],
                    [
                        136.125,
                        58.5
                    ],
                    [
                        136.41666666666666,
                        57.5
                    ],
                    [
                        136.5,
                        57.3
                    ],
                    [
                        136.9,
                        56.5
                    ],
                    [
                        136.5,
                        55.92857142857143
                    ],
                    [
                        136.16666666666666,
                        55.5
                    ],
                    [
                        135.5,
                        54.75
                    ],
                    [
                        135.25,
                        54.5
                    ],
                    [
                        134.5,
                        53.642857142857146
                    ],
                    [
                        134.375,
                        53.5
                    ],
                    [
                        133.5,
                        52.5
                    ],
                    [
                        133.5,
                        52.5
                    ],
                    [
                        133.1,
                        51.5
                    ],
                    [
                        132.5,
                        50.9
                    ],
                    [
                        132,
                        50.5
                    ],
                    [
                        131.5,
                        49.5
                    ],
                    [
                        132.5,
                        49.1
                    ],
                    [
                        133.16666666666666,
                        49.5
                    ],
                    [
                        133.5,
                        49.7
                    ],
                    [
                        134.5,
                        50.25
                    ],
                    [
                        135.5,
                        50.333333333333336
                    ],
                    [
                        136.5,
                        50.5
                    ],
                    [
                        136.5,
                        50.5
                    ],
                    [
                        137.5,
                        50.75
                    ],
                    [
                        138.5,
                        50.625
                    ],
                    [
                        139.5,
                        50.77272727272727
                    ],
                    [
                        140.5,
                        50.875
                    ],
                    [
                        141.5,
                        50.642857142857146
                    ],
                    [
                        141.83333333333334,
                        50.5
                    ],
                    [
                        141.9,
                        49.5
                    ],
                    [
                        141.5,
                        48.833333333333336
                    ],
                    [
                        141.375,
                        48.5
                    ],
                    [
                        140.5,
                        47.916666666666664
                    ],
                    [
                        139.78571428571428,
                        47.5
                    ],
                    [
                        139.5,
                        47.25
                    ],
                    [
                        138.5,
                        46.625
                    ],
                    [
                        138.33333333333334,
                        46.5
                    ],
                    [
                        137.5,
                        45.875
                    ],
                    [
                        136.9,
                        45.5
                    ],
                    [
                        136.5,
                        45.166666666666664
                    ],
                    [
                        135.5,
                        44.5
                    ],
                    [
                        135.5,
                        44.5
                    ],
                    [
                        134.5,
                        44.166666666666664
                    ],
                    [
                        133.5,
                        44.22727272727273
                    ],
                    [
                        132.5,
                        44.166666666666664
                    ],
                    [
                        131.83333333333334,
                        43.5
                    ],
                    [
                        131.5,
                        43
                    ],
                    [
                        131.1,
                        42.5
                    ],
                    [
                        130.5,
                        41.9
                    ],
                    [
                        130.25,
                        41.5
                    ],
                    [
                        129.64285714285714,
                        40.5
                    ],
                    [
                        129.5,
                        40.166666666666664
                    ],
                    [
                        129.25,
                        39.5
                    ],
                    [
                        128.77272727272728,
                        38.5
                    ],
                    [
                        128.5,
                        38.25
                    ],
                    [
                        127.5,
                        38.375
                    ],
                    [
                        126.5,
                        38.25
                    ],
                    [
                        125.5,
                        37.5
                    ],
                    [
                        125.5,
                        37.5
                    ],
                    [
                        125.33333333333333,
                        36.5
                    ],
                    [
                        125.16666666666667,
                        35.5
                    ],
                    [
                        125.5,
                        34.833333333333336
                    ],
                    [
                        125.75,
                        34.5
                    ],
                    [
                        126.5,
                        33.5
                    ],
                    [
                        126.5,
                        33.5
                    ],
                    [
                        127.5,
                        32.833333333333336
                    ],
                    [
                        127.83333333333334,
                        32.5
                    ],
                    [
                        128.5,
                        32.25
                    ],
                    [
                        129.5,
                        32.166666666666664
                    ],
                    [
                        130.5,
                        32.2
                    ],
                    [
                        131.5,
                        32.07142857142857
                    ],
                    [
                        132.5,
                        31.92857142857143
                    ],
                    [
                        133.25,
                        31.5
                    ],
                    [
                        133.5,
                        31.357142857142858
                    ],
                    [
                        134.5,
                        31
                    ],
                    [
                        135.5,
                        31.071428571428573
                    ],
                    [
                        136,
                        31.5
                    ],
                    [
                        136.5,
                        31.875
                    ],
                    [
                        137.5,
                        32.27777777777778
                    ],
                    [
                        137.72222222222223,
                        32.5
                    ],
                    [
                        138.5,
                        33.27777777777778
                    ],
                    [
                        139.16666666666666,
                        33.5
                    ],
                    [
                        139.5,
                        33.625
                    ],
                    [
                        140.5,
                        33.785714285714285
                    ],
                    [
                        141.5,
                        33.5
                    ],
                    [
                        142.5,
                        34.3
                    ],
                    [
                        142.75,
                        34.5
                    ],
                    [
                        143.5,
                        34.92857142857143
                    ],
                    [
                        143.76666666666668,
                        35.5
                    ],
                    [
                        143.9,
                        36.5
                    ],
                    [
                        143.94444444444446,
                        37.5
                    ],
                    [
                        144.5,
                        38
                    ],
                    [
                        145.5,
                        37.92857142857143
                    ],
                    [
                        146.5,
                        38.3
                    ],
                    [
                        147.5,
                        38.4
                    ],
                    [
                        148,
                        38.5
                    ],
                    [
                        148.5,
                        38.59090909090909
                    ],
                    [
                        149.5,
                        38.5
                    ],
                    [
                        149.5,
                        38.5
                    ],
                    [
                        150.1,
                        37.5
                    ],
                    [
                        150.5,
                        36.833333333333336
                    ],
                    [
                        150.75,
                        36.5
                    ],
                    [
                        151.22727272727272,
                        35.5
                    ],
                    [
                        151.5,
                        35
                    ],
                    [
                        151.8,
                        34.5
                    ],
                    [
                        151.5,
                        33.5
                    ],
                    [
                        151.5,
                        33.5
                    ],
                    [
                        151.26923076923077,
                        32.5
                    ],
                    [
                        151.5,
                        32
                    ],
                    [
                        151.92857142857142,
                        31.5
                    ],
                    [
                        151.66666666666666,
                        30.5
                    ],
                    [
                        151.5,
                        29.5
                    ],
                    [
                        152.5,
                        28.833333333333332
                    ],
                    [
                        153.5,
                        29.25
                    ],
                    [
                        154,
                        29.5
                    ],
                    [
                        154.5,
                        30
                    ],
                    [
                        154.75,
                        30.5
                    ],
                    [
                        155.5,
                        31.357142857142858
                    ],
                    [
                        155.6,
                        31.5
                    ],
                    [
                        156,
                        32.5
                    ],
                    [
                        156.5,
                        32.96153846153846
                    ],
                    [
                        157.5,
                        32.970588235294116
                    ],
                    [
                        158.5,
                        33.285714285714285
                    ],
                    [
                        159.25,
                        33.5
                    ],
                    [
                        159.5,
                        33.611111111111114
                    ],
                    [
                        160.5,
                        33.5
                    ],
                    [
                        160.5,
                        33.5
                    ],
                    [
                        160.78571428571428,
                        32.5
                    ],
                    [
                        161.5,
                        32
                    ],
                    [
                        162.5,
                        31.611111111111114
                    ],
                    [
                        162.75,
                        31.5
                    ],
                    [
                        163.5,
                        31.2
                    ],
                    [
                        164.5,
                        31.166666666666668
                    ],
                    [
                        165.3,
                        30.5
                    ],
                    [
                        165.5,
                        30.433333333333334
                    ],
                    [
                        166.5,
                        30.192307692307693
                    ],
                    [
                        167.5,
                        29.5
                    ],
                    [
                        167.5,
                        29.5
                    ],
                    [
                        168.5,
                        29.125
                    ],
                    [
                        169,
                        28.5
                    ],
                    [
                        168.5,
                        27.5
                    ],
                    [
                        168.5,
                        27.5
                    ],
                    [
                        167.5,
                        26.59090909090909
                    ],
                    [
                        167.44736842105263,
                        26.5
                    ],
                    [
                        166.5,
                        25.642857142857142
                    ],
                    [
                        166.2,
                        25.5
                    ],
                    [
                        165.5,
                        24.863636363636363
                    ],
                    [
                        164.7,
                        24.5
                    ],
                    [
                        164.5,
                        24.333333333333332
                    ],
                    [
                        163.66666666666666,
                        23.5
                    ],
                    [
                        163.5,
                        23.25
                    ],
                    [
                        163.16666666666666,
                        22.5
                    ],
                    [
                        162.5,
                        21.5
                    ],
                    [
                        162.73076923076923,
                        20.5
                    ],
                    [
                        162.5,
                        20.125
                    ],
                    [
                        162.26190476190476,
                        19.5
                    ],
                    [
                        161.5,
                        18.928571428571427
                    ],
                    [
                        160.5,
                        18.74
                    ],
                    [
                        159.5,
                        18.53448275862069
                    ],
                    [
                        159.16666666666666,
                        18.5
                    ],
                    [
                        158.5,
                        18.394736842105264
                    ],
                    [
                        157.5,
                        17.9
                    ],
                    [
                        156.96666666666667,
                        17.5
                    ],
                    [
                        156.55882352941177,
                        16.5
                    ],
                    [
                        156.5,
                        16.3
                    ],
                    [
                        156.1,
                        15.5
                    ],
                    [
                        155.5,
                        14.833333333333334
                    ],
                    [
                        155.2,
                        14.5
                    ],
                    [
                        154.5,
                        14.131578947368421
                    ],
                    [
                        153.5,
                        14.18
                    ],
                    [
                        152.5,
                        14.5
                    ],
                    [
                        151.5,
                        14.447368421052632
                    ],
                    [
                        151.42307692307693,
                        14.5
                    ],
                    [
                        150.83333333333334,
                        15.5
                    ],
                    [
                        150.56666666666666,
                        16.5
                    ],
                    [
                        150.5,
                        16.75
                    ],
                    [
                        150.22727272727272,
                        17.5
                    ],
                    [
                        150.5,
                        17.875
                    ],
                    [
                        150.95454545454547,
                        18.5
                    ],
                    [
                        151.3181818181818,
                        19.5
                    ],
                    [
                        151.5,
                        20
                    ],
                    [
                        151.75,
                        20.5
                    ],
                    [
                        152.125,
                        21.5
                    ],
                    [
                        152.5,
                        21.875
                    ],
                    [
                        153.5,
                        22.125
                    ],
                    [
                        153.83333333333334,
                        22.5
                    ],
                    [
                        153.875,
                        23.5
                    ],
                    [
                        153.5,
                        24
                    ],
                    [
                        152.5,
                        24.5
                    ],
                    [
                        152.5,
                        24.5
                    ],
                    [
                        151.5,
                        25
                    ],
                    [
                        150.5,
                        25.333333333333332
                    ],
                    [
                        149.5,
                        24.785714285714285
                    ],
                    [
                        149.1,
                        24.5
                    ],
                    [
                        148.5,
                        24.227272727272727
                    ],
                    [
                        147.5,
                        23.875
                    ],
                    [
                        146.5,
                        23.625
                    ],
                    [
                        145.5,
                        23.8
                    ],
                    [
                        144.5,
                        23.9
                    ],
                    [
                        143.5,
                        23.916666666666668
                    ],
                    [
                        142.5,
                        23.735294117647058
                    ],
                    [
                        142.05555555555554,
                        23.5
                    ],
                    [
                        141.5,
                        23.282608695652176
                    ],
                    [
                        140.78571428571428,
                        23.5
                    ],
                    [
                        140.5,
                        23.605263157894736
                    ],
                    [
                        139.5,
                        23.772727272727273
                    ],
                    [
                        138.5,
                        23.92105263157895
                    ],
                    [
                        137.5,
                        23.785714285714285
                    ],
                    [
                        136.5,
                        23.85
                    ],
                    [
                        135.5,
                        24.11111111111111
                    ],
                    [
                        134.91666666666666,
                        24.5
                    ],
                    [
                        134.5,
                        24.8125
                    ],
                    [
                        133.5,
                        25.423076923076923
                    ],
                    [
                        133.25,
                        25.5
                    ],
                    [
                        132.5,
                        25.7
                    ],
                    [
                        131.5,
                        25.583333333333332
                    ],
                    [
                        131.4,
                        25.5
                    ],
                    [
                        130.5,
                        24.9375
                    ],
                    [
                        129.86363636363637,
                        24.5
                    ],
                    [
                        129.5,
                        24.055555555555557
                    ],
                    [
                        128.5,
                        23.5
                    ],
                    [
                        128.5,
                        23.5
                    ],
                    [
                        127.5,
                        23.285714285714285
                    ],
                    [
                        126.5,
                        23.5
                    ],
                    [
                        126.5,
                        23.5
                    ],
                    [
                        125.5,
                        24.38888888888889
                    ],
                    [
                        125.3,
                        24.5
                    ],
                    [
                        124.5,
                        24.72222222222222
                    ],
                    [
                        123.5,
                        24.86842105263158
                    ],
                    [
                        122.5,
                        24.9
                    ],
                    [
                        121.5,
                        24.796296296296298
                    ],
                    [
                        120.83333333333333,
                        24.5
                    ],
                    [
                        120.5,
                        24.25
                    ],
                    [
                        119.5,
                        24
                    ],
                    [
                        118.5,
                        23.75
                    ],
                    [
                        117.625,
                        23.5
                    ],
                    [
                        117.5,
                        23.423076923076923
                    ],
                    [
                        116.5,
                        23.233333333333334
                    ],
                    [
                        115.7,
                        23.5
                    ],
                    [
                        116.11111111111111,
                        24.5
                    ],
                    [
                        116.5,
                        25
                    ],
                    [
                        116.85,
                        25.5
                    ],
                    [
                        116.8157894736842,
                        26.5
                    ],
                    [
                        116.5,
                        27.166666666666668
                    ],
                    [
                        116.125,
                        27.5
                    ],
                    [
                        115.66666666666667,
                        28.5
                    ],
                    [
                        115.5,
                        28.61111111111111
                    ],
                    [
                        114.5,
                        29.055555555555557
                    ],
                    [
                        113.5,
                        29.166666666666668
                    ],
                    [
                        112.5,
                        28.9
                    ],
                    [
                        111.5,
                        28.7
                    ],
                    [
                        111.39473684210526,
                        28.5
                    ],
                    [
                        110.5,
                        27.727272727272727
                    ],
                    [
                        109.5,
                        27.5
                    ],
                    [
                        109.625,
                        26.5
                    ],
                    [
                        109.5,
                        26.4
                    ],
                    [
                        108.5,
                        25.973684210526315
                    ],
                    [
                        108.05,
                        25.5
                    ],
                    [
                        107.5,
                        25.09259259259259
                    ],
                    [
                        106.5,
                        24.5
                    ],
                    [
                        106.66666666666667,
                        23.5
                    ],
                    [
                        106.5,
                        23.25
                    ],
                    [
                        105.5,
                        23.055555555555557
                    ],
                    [
                        104.5,
                        23.142857142857142
                    ],
                    [
                        103.5,
                        22.9
                    ],
                    [
                        102.95454545454545,
                        22.5
                    ],
                    [
                        103,
                        21.5
                    ],
                    [
                        103.5,
                        20.75
                    ],
                    [
                        103.64814814814815,
                        20.5
                    ],
                    [
                        103.61111111111111,
                        19.5
                    ],
                    [
                        103.5,
                        19.363636363636363
                    ],
                    [
                        102.5,
                        19.071428571428573
                    ],
                    [
                        101.5,
                        19.08823529411765
                    ],
                    [
                        100.5,
                        18.944444444444443
                    ],
                    [
                        99.5,
                        18.666666666666668
                    ],
                    [
                        98.5,
                        18.75
                    ],
                    [
                        97.5,
                        19.3125
                    ],
                    [
                        96.9,
                        19.5
                    ],
                    [
                        96.5,
                        19.666666666666668
                    ],
                    [
                        95.5,
                        20.071428571428573
                    ],
                    [
                        94.7,
                        19.5
                    ],
                    [
                        94.5,
                        19.25
                    ],
                    [
                        94.32352941176471,
                        18.5
                    ],
                    [
                        93.5,
                        17.916666666666668
                    ],
                    [
                        92.5,
                        17.55263157894737
                    ],
                    [
                        92.38888888888889,
                        17.5
                    ],
                    [
                        91.5,
                        16.5
                    ],
                    [
                        91.78571428571429,
                        15.5
                    ],
                    [
                        91.5,
                        14.833333333333334
                    ],
                    [
                        91.25,
                        14.5
                    ],
                    [
                        90.5,
                        13.75
                    ],
                    [
                        90.35714285714286,
                        13.5
                    ],
                    [
                        90,
                        12.5
                    ],
                    [
                        89.5,
                        12
                    ],
                    [
                        88.5,
                        11.7
                    ],
                    [
                        87.5,
                        11.61111111111111
                    ],
                    [
                        86.5,
                        11.5
                    ],
                    [
                        86.5,
                        11.5
                    ],
                    [
                        86.5,
                        11.5
                    ],
                    [
                        85.5,
                        11.75
                    ],
                    [
                        85.1470588235294,
                        12.5
                    ],
                    [
                        84.5,
                        13.233333333333333
                    ],
                    [
                        84.39189189189189,
                        13.5
                    ],
                    [
                        83.98148148148148,
                        14.5
                    ],
                    [
                        83.5,
                        15.5
                    ],
                    [
                        83.5,
                        15.5
                    ],
                    [
                        83.5,
                        15.5
                    ],
                    [
                        83.72222222222223,
                        16.5
                    ],
                    [
                        83.5,
                        17
                    ],
                    [
                        83.3,
                        17.5
                    ],
                    [
                        82.94736842105263,
                        18.5
                    ],
                    [
                        82.5,
                        19.444444444444443
                    ],
                    [
                        82.46153846153847,
                        19.5
                    ],
                    [
                        81.91176470588235,
                        20.5
                    ],
                    [
                        82.21428571428571,
                        21.5
                    ],
                    [
                        82.34615384615384,
                        22.5
                    ],
                    [
                        82.27777777777777,
                        23.5
                    ],
                    [
                        82.26923076923077,
                        24.5
                    ],
                    [
                        82.5,
                        24.833333333333332
                    ],
                    [
                        83,
                        25.5
                    ],
                    [
                        83.5,
                        26.5
                    ],
                    [
                        83.4090909090909,
                        27.5
                    ],
                    [
                        83.2,
                        28.5
                    ],
                    [
                        82.6,
                        29.5
                    ],
                    [
                        82.5,
                        29.666666666666668
                    ],
                    [
                        82.1875,
                        30.5
                    ],
                    [
                        82.5,
                        30.738095238095237
                    ],
                    [
                        83.5,
                        31.0625
                    ],
                    [
                        84.2,
                        31.5
                    ],
                    [
                        84.5,
                        31.65
                    ],
                    [
                        85.5,
                        32
                    ],
                    [
                        86.5,
                        32.416666666666664
                    ],
                    [
                        86.75,
                        32.5
                    ],
                    [
                        87.5,
                        32.6875
                    ],
                    [
                        88.5,
                        32.5
                    ],
                    [
                        88.5,
                        32.5
                    ],
                    [
                        89.5,
                        31.75
                    ],
                    [
                        90,
                        31.5
                    ],
                    [
                        90.5,
                        31.346153846153847
                    ],
                    [
                        91.5,
                        31.125
                    ],
                    [
                        91.88461538461539,
                        30.5
                    ],
                    [
                        92.5,
                        29.772727272727273
                    ],
                    [
                        93.5,
                        29.642857142857142
                    ],
                    [
                        94.16666666666667,
                        30.5
                    ],
                    [
                        94.5,
                        31.25
                    ],
                    [
                        95,
                        31.5
                    ],
                    [
                        95.5,
                        32
                    ],
                    [
                        95.61111111111111,
                        32.5
                    ],
                    [
                        96.5,
                        33.5
                    ],
                    [
                        96.5,
                        33.5
                    ],
                    [
                        97.5,
                        33.9
                    ],
                    [
                        98.5,
                        34
                    ],
                    [
                        99.5,
                        34.1
                    ],
                    [
                        100.5,
                        34.5
                    ],
                    [
                        100.5,
                        34.5
                    ],
                    [
                        101.5,
                        34.5
                    ],
                    [
                        102.5,
                        35.1
                    ],
                    [
                        103.5,
                        35.3
                    ],
                    [
                        104.5,
                        35.5
                    ],
                    [
                        104.5,
                        35.5
                    ],
                    [
                        104.75,
                        36.5
                    ],
                    [
                        105.16666666666667,
                        37.5
                    ],
                    [
                        104.83333333333333,
                        38.5
                    ],
                    [
                        104.5,
                        39.5
                    ],
                    [
                        104.5,
                        39.5
                    ],
                    [
                        104.5,
                        40.5
                    ],
                    [
                        104.5,
                        41.5
                    ],
                    [
                        104.5,
                        42.5
                    ],
                    [
                        103.5,
                        43.5
                    ],
                    [
                        103.5,
                        43.5
                    ],
                    [
                        103.5,
                        44.5
                    ],
                    [
                        102.5,
                        45.5
                    ],
                    [
                        101.5,
                        45
                    ],
                    [
                        100.5,
                        44.5
                    ],
                    [
                        100.5,
                        43.5
                    ],
                    [
                        101,
                        42.5
                    ],
                    [
                        100.5,
                        41.5
                    ],
                    [
                        100.5,
                        41.5
                    ],
                    [
                        100.5,
                        41.5
                    ],
                    [
                        100.16666666666667,
                        42.5
                    ],
                    [
                        100.5,
                        43.5
                    ],
                    [
                        100.5,
                        44.5
                    ],
                    [
                        99.5,
                        45
                    ],
                    [
                        98.5,
                        44.833333333333336
                    ],
                    [
                        97.5,
                        44.666666666666664
                    ],
                    [
                        97.16666666666667,
                        44.5
                    ],
                    [
                        96.5,
                        43.833333333333336
                    ],
                    [
                        96,
                        43.5
                    ],
                    [
                        95.5,
                        43.25
                    ],
                    [
                        94.5,
                        43.166666666666664
                    ],
                    [
                        94.16666666666667,
                        43.5
                    ],
                    [
                        93.5,
                        43.833333333333336
                    ],
                    [
                        92.5,
                        44.1
                    ],
                    [
                        91.5,
                        43.7
                    ],
                    [
                        91,
                        43.5
                    ],
                    [
                        90.5,
                        43.166666666666664
                    ],
                    [
                        90.25,
                        43.5
                    ],
                    [
                        89.5,
                        44.25
                    ],
                    [
                        88.5,
                        44.5
                    ],
                    [
                        88.5,
                        44.5
                    ],
                    [
                        87.5,
                        45.166666666666664
                    ],
                    [
                        87.25,
                        45.5
                    ],
                    [
                        86.7,
                        46.5
                    ],
                    [
                        86.83333333333333,
                        47.5
                    ],
                    [
                        86.5,
                        48.5
                    ],
                    [
                        85.5,
                        48.5
                    ],
                    [
                        84.5,
                        48.5
                    ],
                    [
                        84.5,
                        48.5
                    ],
                    [
                        83.5,
                        48.666666666666664
                    ],
                    [
                        82.5,
                        48.92857142857143
                    ],
                    [
                        81.5,
                        49.5
                    ],
                    [
                        81.5,
                        49.5
                    ],
                    [
                        80.5,
                        50.1
                    ],
                    [
                        79.92857142857143,
                        50.5
                    ],
                    [
                        79.5,
                        50.714285714285715
                    ],
                    [
                        78.5,
                        50.94444444444444
                    ],
                    [
                        77.5,
                        51.5
                    ],
                    [
                        77.5,
                        51.5
                    ],
                    [
                        76.5,
                        51.75
                    ],
                    [
                        75.5,
                        51.9
                    ],
                    [
                        74.5,
                        51.625
                    ],
                    [
                        73.5,
                        51.833333333333336
                    ],
                    [
                        72.5,
                        52.083333333333336
                    ],
                    [
                        71.5,
                        52.416666666666664
                    ],
                    [
                        71.25,
                        52.5
                    ],
                    [
                        71.5,
                        52.7
                    ],
                    [
                        72.5,
                        53.214285714285715
                    ],
                    [
                        72.75,
                        53.5
                    ],
                    [
                        72.5,
                        53.72222222222222
                    ],
                    [
                        71.5,
                        53.94444444444444
                    ],
                    [
                        70.5,
                        54.3
                    ],
                    [
                        70.16666666666667,
                        54.5
                    ],
                    [
                        70.07142857142857,
                        55.5
                    ],
                    [
                        70.5,
                        56
                    ],
                    [
                        71.5,
                        55.5
                    ],
                    [
                        71.5,
                        55.5
                    ],
                    [
                        72.5,
                        55.03846153846154
                    ],
                    [
                        73.5,
                        55.125
                    ],
                    [
                        74.5,
                        54.857142857142854
                    ],
                    [
                        75.5,
                        54.833333333333336
                    ],
                    [
                        76.5,
                        54.833333333333336
                    ],
                    [
                        77.16666666666667,
                        55.5
                    ],
                    [
                        76.5,
                        55.833333333333336
                    ],
                    [
                        75.5,
                        55.92857142857143
                    ],
                    [
                        74.5,
                        56.1
                    ],
                    [
                        73.5,
                        56
                    ],
                    [
                        72.5,
                        56.5
                    ],
                    [
                        72.5,
                        56.5
                    ],
                    [
                        71.5,
                        57.5
                    ],
                    [
                        70.5,
                        57.25
                    ],
                    [
                        69.5,
                        57.5
                    ],
                    [
                        69.5,
                        57.5
                    ],
                    [
                        69.5,
                        58.5
                    ],
                    [
                        69.5,
                        58.5
                    ],
                    [
                        70.5,
                        58.5
                    ],
                    [
                        71.21428571428571,
                        59.5
                    ],
                    [
                        70.5,
                        60.5
                    ],
                    [
                        70.5,
                        60.5
                    ],
                    [
                        70.5,
                        60.5
                    ],
                    [
                        71.16666666666667,
                        61.5
                    ],
                    [
                        71.16666666666667,
                        62.5
                    ],
                    [
                        70.5,
                        63.5
                    ],
                    [
                        70.5,
                        63.5
                    ],
                    [
                        69.5,
                        63.64285714285714
                    ],
                    [
                        68.5,
                        63.5
                    ],
                    [
                        68.5,
                        63.5
                    ],
                    [
                        68.5,
                        63.5
                    ],
                    [
                        67.5,
                        63.64285714285714
                    ],
                    [
                        66.5,
                        63.83333333333333
                    ],
                    [
                        65.5,
                        64.3
                    ],
                    [
                        65.25,
                        64.5
                    ],
                    [
                        64.5,
                        65.5
                    ],
                    [
                        64.5,
                        65.5
                    ],
                    [
                        64.5,
                        66.5
                    ],
                    [
                        63.5,
                        67
                    ],
                    [
                        63,
                        67.5
                    ],
                    [
                        62.833333333333336,
                        68.5
                    ],
                    [
                        62.75,
                        69.5
                    ],
                    [
                        63,
                        70.5
                    ],
                    [
                        63.5,
                        71.5
                    ],
                    [
                        63.5,
                        71.5
                    ],
                    [
                        63.75,
                        72.5
                    ],
                    [
                        64.5,
                        73.5
                    ],
                    [
                        64.5,
                        73.5
                    ],
                    [
                        64.75,
                        74.5
                    ],
                    [
                        64.5,
                        75.5
                    ],
                    [
                        64.5,
                        75.5
                    ],
                    [
                        64.5,
                        76.5
                    ],
                    [
                        64.5,
                        76.5
                    ],
                    [
                        65,
                        77.5
                    ],
                    [
                        65.16666666666667,
                        78.5
                    ],
                    [
                        65.5,
                        79.16666666666667
                    ],
                    [
                        65.75,
                        79.5
                    ],
                    [
                        66.5,
                        80.5
                    ],
                    [
                        66.5,
                        80.5
                    ],
                    [
                        66.75,
                        81.5
                    ],
                    [
                        66.83333333333333,
                        82.5
                    ],
                    [
                        67.5,
                        83.5
                    ],
                    [
                        67.5,
                        84.5
                    ],
                    [
                        67.5,
                        84.5
                    ],
                    [
                        68,
                        85.5
                    ],
                    [
                        68.5,
                        86
                    ],
                    [
                        69.5,
                        86.1
                    ],
                    [
                        70.5,
                        86.25
                    ],
                    [
                        70.75,
                        86.5
                    ],
                    [
                        71.5,
                        87.25
                    ],
                    [
                        71.75,
                        87.5
                    ],
                    [
                        71.7,
                        88.5
                    ],
                    [
                        72.5,
                        89.5
                    ],
                    [
                        72.5,
                        89.5
                    ],
                    [
                        73.5,
                        89.78571428571429
                    ],
                    [
                        74.5,
                        90.3
                    ],
                    [
                        75.5,
                        90.5
                    ],
                    [
                        75.5,
                        90.5
                    ],
                    [
                        76.5,
                        90.75
                    ],
                    [
                        77.5,
                        91.3
                    ],
                    [
                        77.83333333333333,
                        91.5
                    ],
                    [
                        78.5,
                        92
                    ],
                    [
                        79.5,
                        92
                    ],
                    [
                        80.5,
                        92
                    ],
                    [
                        81.5,
                        92
                    ],
                    [
                        82.5,
                        92
                    ],
                    [
                        83.5,
                        92
                    ],
                    [
                        84.5,
                        92
                    ],
                    [
                        85.5,
                        92
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        144.5,
                        92
                    ],
                    [
                        145.5,
                        92
                    ],
                    [
                        146.5,
                        92
                    ],
                    [
                        147.5,
                        92
                    ],
                    [
                        147.9,
                        91.5
                    ]
                ],
                [
                    [
                        90.5,
                        11.5
                    ],
                    [
                        90.5,
                        11.5
                    ],
                    [
                        90.5,
                        11.5
                    ],
                    [
                        90.5,
                        11.5
                    ],
                    [
                        90.5,
                        11.5
                    ]
                ],
                [
                    [
                        100.5,
                        39.5
                    ],
                    [
                        100.5,
                        38.5
                    ],
                    [
                        100.5,
                        38.5
                    ],
                    [
                        100.5,
                        38.5
                    ],
                    [
                        100.5,
                        39.5
                    ],
                    [
                        100.5,
                        39.5
                    ],
                    [
                        100.5,
                        39.5
                    ]
                ],
                [
                    [
                        72.5,
                        59.9
                    ],
                    [
                        72,
                        59.5
                    ],
                    [
                        72,
                        58.5
                    ],
                    [
                        72.5,
                        58.25
                    ],
                    [
                        73.5,
                        57.833333333333336
                    ],
                    [
                        74.5,
                        57.77272727272727
                    ],
                    [
                        75.5,
                        58.5
                    ],
                    [
                        74.5,
                        59
                    ],
                    [
                        73.5,
                        59.04545454545455
                    ],
                    [
                        72.78571428571429,
                        59.5
                    ],
                    [
                        72.5,
                        59.9
                    ]
                ],
                [
                    [
                        74.5,
                        61.75
                    ],
                    [
                        74.16666666666667,
                        61.5
                    ],
                    [
                        74.5,
                        61.333333333333336
                    ],
                    [
                        75,
                        61.5
                    ],
                    [
                        74.5,
                        61.75
                    ]
                ]
            ],
            [
                [
                    [
                        161.7,
                        91.5
                    ],
                    [
                        161.86363636363637,
                        90.5
                    ],
                    [
                        162.41666666666666,
                        89.5
                    ],
                    [
                        162.5,
                        89.44444444444444
                    ],
                    [
                        163.5,
                        89.13636363636364
                    ],
                    [
                        164.5,
                        88.88095238095238
                    ],
                    [
                        165.5,
                        88.55555555555556
                    ],
                    [
                        165.83333333333334,
                        88.5
                    ],
                    [
                        166.5,
                        88.31818181818181
                    ],
                    [
                        166.95,
                        87.5
                    ],
                    [
                        167.38888888888889,
                        86.5
                    ],
                    [
                        167.5,
                        86.16666666666667
                    ],
                    [
                        167.83333333333334,
                        85.5
                    ],
                    [
                        168.5,
                        84.7
                    ],
                    [
                        168.55555555555554,
                        84.5
                    ],
                    [
                        168.5,
                        84.16666666666667
                    ],
                    [
                        167.5,
                        84.375
                    ],
                    [
                        167.4,
                        84.5
                    ],
                    [
                        166.5,
                        85.25
                    ],
                    [
                        166.2,
                        85.5
                    ],
                    [
                        165.5,
                        86
                    ],
                    [
                        164.5,
                        85.80434782608695
                    ],
                    [
                        163.5,
                        85.5
                    ],
                    [
                        163.5,
                        85.5
                    ],
                    [
                        162.5,
                        85.3695652173913
                    ],
                    [
                        161.5,
                        85.2
                    ],
                    [
                        160.5,
                        84.5909090909091
                    ],
                    [
                        160.34615384615384,
                        84.5
                    ],
                    [
                        159.5,
                        83.88888888888889
                    ],
                    [
                        158.5,
                        83.57142857142857
                    ],
                    [
                        157.5,
                        84.1
                    ],
                    [
                        156.75,
                        84.5
                    ],
                    [
                        156.5,
                        84.61764705882354
                    ],
                    [
                        155.5,
                        85.1470588235294
                    ],
                    [
                        155.1,
                        85.5
                    ],
                    [
                        154.9,
                        86.5
                    ],
                    [
                        154.85294117647058,
                        87.5
                    ],
                    [
                        154.5,
                        88.35714285714286
                    ],
                    [
                        154.3,
                        88.5
                    ],
                    [
                        153.5,
                        88.83333333333333
                    ],
                    [
                        152.7,
                        89.5
                    ],
                    [
                        152.5,
                        90
                    ],
                    [
                        152,
                        90.5
                    ],
                    [
                        151.5,
                        90.5952380952381
                    ],
                    [
                        150.5,
                        90.7
                    ],
                    [
                        149.5,
                        91.375
                    ],
                    [
                        149.25,
                        91.5
                    ],
                    [
                        149.5,
                        92
                    ],
                    [
                        150.5,
                        92
                    ],
                    [
                        151.5,
                        92
                    ],
                    [
                        152.5,
                        92
                    ],
                    [
                        153.5,
                        92
                    ],
                    [
                        154.5,
                        92
                    ],
                    [
                        155.5,
                        92
                    ],
                    [
                        156.5,
                        92
                    ],
                    [
                        157.5,
                        92
                    ],
                    [
                        158.5,
                        92
                    ],
                    [
                        159.5,
                        92
                    ],
                    [
                        160.5,
                        92
                    ],
                    [
                        161.5,
                        92
                    ],
                    [
                        161.7,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 75,
        "coordinates": [
            [
                [
                    [
                        170.85294117647058,
                        15.5
                    ],
                    [
                        170.5,
                        15.23913043478261
                    ],
                    [
                        169.95454545454547,
                        15.5
                    ],
                    [
                        170.5,
                        16.25
                    ],
                    [
                        170.85294117647058,
                        15.5
                    ]
                ]
            ],
            [
                [
                    [
                        172.72222222222223,
                        28.5
                    ],
                    [
                        172.5,
                        28.233333333333334
                    ],
                    [
                        172.11904761904762,
                        28.5
                    ],
                    [
                        172.5,
                        28.716216216216218
                    ],
                    [
                        172.72222222222223,
                        28.5
                    ]
                ]
            ],
            [
                [
                    [
                        176.8421052631579,
                        28.5
                    ],
                    [
                        176.5,
                        28.217391304347824
                    ],
                    [
                        175.5,
                        28.1
                    ],
                    [
                        175.3148148148148,
                        28.5
                    ],
                    [
                        175.5,
                        29.026315789473685
                    ],
                    [
                        176.5,
                        28.720338983050848
                    ],
                    [
                        176.8421052631579,
                        28.5
                    ]
                ]
            ],
            [
                [
                    [
                        175.62698412698413,
                        30.5
                    ],
                    [
                        175.5,
                        30.029411764705884
                    ],
                    [
                        174.5,
                        30.362068965517242
                    ],
                    [
                        174.1,
                        30.5
                    ],
                    [
                        174.5,
                        30.710526315789473
                    ],
                    [
                        175.5,
                        30.785714285714285
                    ],
                    [
                        175.62698412698413,
                        30.5
                    ]
                ]
            ],
            [
                [
                    [
                        159.5,
                        31.5
                    ],
                    [
                        160.5,
                        30.916666666666668
                    ],
                    [
                        161.5,
                        30.5
                    ],
                    [
                        161.5,
                        30.5
                    ],
                    [
                        162.5,
                        30.27777777777778
                    ],
                    [
                        163.5,
                        29.833333333333332
                    ],
                    [
                        164.5,
                        29.95
                    ],
                    [
                        165.4,
                        29.5
                    ],
                    [
                        165.5,
                        29.4375
                    ],
                    [
                        166.5,
                        28.833333333333332
                    ],
                    [
                        167.1,
                        28.5
                    ],
                    [
                        167.26190476190476,
                        27.5
                    ],
                    [
                        166.6578947368421,
                        26.5
                    ],
                    [
                        166.5,
                        26.357142857142858
                    ],
                    [
                        165.5,
                        25.970588235294116
                    ],
                    [
                        164.5,
                        25.970588235294116
                    ],
                    [
                        163.5,
                        25.794117647058822
                    ],
                    [
                        162.875,
                        25.5
                    ],
                    [
                        162.5,
                        24.75
                    ],
                    [
                        162.4,
                        24.5
                    ],
                    [
                        162.1,
                        23.5
                    ],
                    [
                        161.75,
                        22.5
                    ],
                    [
                        161.75,
                        21.5
                    ],
                    [
                        162.2391304347826,
                        20.5
                    ],
                    [
                        161.54761904761904,
                        19.5
                    ],
                    [
                        161.5,
                        19.464285714285715
                    ],
                    [
                        160.5,
                        19.34
                    ],
                    [
                        159.5,
                        19.051724137931036
                    ],
                    [
                        158.5,
                        18.98148148148148
                    ],
                    [
                        157.5,
                        18.65
                    ],
                    [
                        157.22727272727272,
                        18.5
                    ],
                    [
                        156.5,
                        18
                    ],
                    [
                        156.07894736842104,
                        17.5
                    ],
                    [
                        155.5,
                        16.766666666666666
                    ],
                    [
                        155.3095238095238,
                        16.5
                    ],
                    [
                        154.9,
                        15.5
                    ],
                    [
                        154.5,
                        15.071428571428571
                    ],
                    [
                        153.5,
                        14.88888888888889
                    ],
                    [
                        152.5,
                        15.076923076923077
                    ],
                    [
                        151.5,
                        15.433333333333334
                    ],
                    [
                        151.45833333333334,
                        15.5
                    ],
                    [
                        151.5,
                        16
                    ],
                    [
                        151.57692307692307,
                        16.5
                    ],
                    [
                        151.5909090909091,
                        17.5
                    ],
                    [
                        152.1,
                        18.5
                    ],
                    [
                        152.42857142857142,
                        19.5
                    ],
                    [
                        152.5,
                        19.6
                    ],
                    [
                        153.5,
                        19.928571428571427
                    ],
                    [
                        154.07142857142858,
                        20.5
                    ],
                    [
                        154.5,
                        21
                    ],
                    [
                        154.875,
                        21.5
                    ],
                    [
                        155.5,
                        21.954545454545453
                    ],
                    [
                        156.5,
                        22.166666666666668
                    ],
                    [
                        157.04545454545453,
                        22.5
                    ],
                    [
                        156.5,
                        23.25
                    ],
                    [
                        156.1,
                        23.5
                    ],
                    [
                        155.5,
                        24.25
                    ],
                    [
                        155.35714285714286,
                        24.5
                    ],
                    [
                        154.875,
                        25.5
                    ],
                    [
                        154.5,
                        26.25
                    ],
                    [
                        154.38888888888889,
                        26.5
                    ],
                    [
                        154.16666666666666,
                        27.5
                    ],
                    [
                        154.5,
                        27.833333333333332
                    ],
                    [
                        155.5,
                        28.5
                    ],
                    [
                        155.5,
                        28.5
                    ],
                    [
                        156.5,
                        29
                    ],
                    [
                        157.33333333333334,
                        29.5
                    ],
                    [
                        157.21428571428572,
                        30.5
                    ],
                    [
                        157.25,
                        31.5
                    ],
                    [
                        157.5,
                        31.72222222222222
                    ],
                    [
                        158.5,
                        32.05555555555556
                    ],
                    [
                        159.5,
                        31.5
                    ],
                    [
                        159.5,
                        31.5
                    ]
                ]
            ],
            [
                [
                    [
                        70.25,
                        46.5
                    ],
                    [
                        70.5,
                        46.333333333333336
                    ],
                    [
                        71.21428571428571,
                        45.5
                    ],
                    [
                        70.7,
                        44.5
                    ],
                    [
                        70.5,
                        44.388888888888886
                    ],
                    [
                        69.5,
                        44
                    ],
                    [
                        68.5,
                        44.3
                    ],
                    [
                        67.5,
                        43.666666666666664
                    ],
                    [
                        67,
                        43.5
                    ],
                    [
                        66.5,
                        43.25
                    ],
                    [
                        65.5,
                        42.5
                    ],
                    [
                        65.5,
                        42.5
                    ],
                    [
                        64.625,
                        41.5
                    ],
                    [
                        64.5,
                        41.166666666666664
                    ],
                    [
                        63.83333333333333,
                        40.5
                    ],
                    [
                        64.5,
                        39.833333333333336
                    ],
                    [
                        64.6,
                        39.5
                    ],
                    [
                        64.77272727272727,
                        38.5
                    ],
                    [
                        64.72222222222223,
                        37.5
                    ],
                    [
                        64.77272727272727,
                        36.5
                    ],
                    [
                        64.5,
                        35.9
                    ],
                    [
                        64.27777777777777,
                        35.5
                    ],
                    [
                        63.5,
                        35.208333333333336
                    ],
                    [
                        62.5,
                        35.25
                    ],
                    [
                        61.5,
                        35.13636363636363
                    ],
                    [
                        60.5,
                        34.642857142857146
                    ],
                    [
                        60.31818181818182,
                        34.5
                    ],
                    [
                        59.5,
                        34.14705882352941
                    ],
                    [
                        58.5,
                        33.775862068965516
                    ],
                    [
                        57.5,
                        34.03846153846154
                    ],
                    [
                        56.5,
                        34.1
                    ],
                    [
                        55.5,
                        33.84375
                    ],
                    [
                        54.5,
                        34.042857142857144
                    ],
                    [
                        53.5,
                        34.38095238095238
                    ],
                    [
                        52.875,
                        34.5
                    ],
                    [
                        52.5,
                        34.73076923076923
                    ],
                    [
                        52.04545454545455,
                        35.5
                    ],
                    [
                        52.11538461538461,
                        36.5
                    ],
                    [
                        51.5,
                        37.166666666666664
                    ],
                    [
                        50.5,
                        37.189655172413794
                    ],
                    [
                        49.5,
                        37.294117647058826
                    ],
                    [
                        48.5,
                        37.42307692307692
                    ],
                    [
                        48.214285714285715,
                        37.5
                    ],
                    [
                        47.5,
                        37.672413793103445
                    ],
                    [
                        46.5,
                        38.078947368421055
                    ],
                    [
                        45.5,
                        38.5
                    ],
                    [
                        45.5,
                        38.5
                    ],
                    [
                        44.63333333333333,
                        39.5
                    ],
                    [
                        45.1,
                        40.5
                    ],
                    [
                        45.5,
                        40.92857142857143
                    ],
                    [
                        46.5,
                        41.4375
                    ],
                    [
                        46.642857142857146,
                        41.5
                    ],
                    [
                        47.5,
                        42.04545454545455
                    ],
                    [
                        48.214285714285715,
                        42.5
                    ],
                    [
                        48.357142857142854,
                        43.5
                    ],
                    [
                        48.5,
                        44.5
                    ],
                    [
                        48.5,
                        44.5
                    ],
                    [
                        49.5,
                        44.68181818181818
                    ],
                    [
                        50.5,
                        44.5
                    ],
                    [
                        50.5,
                        44.5
                    ],
                    [
                        51.5,
                        44.13636363636363
                    ],
                    [
                        52.5,
                        44.27777777777778
                    ],
                    [
                        53.166666666666664,
                        44.5
                    ],
                    [
                        53.5,
                        44.59090909090909
                    ],
                    [
                        54.5,
                        44.94444444444444
                    ],
                    [
                        55.5,
                        45.07142857142857
                    ],
                    [
                        56.5,
                        44.5
                    ],
                    [
                        57.5,
                        44.5
                    ],
                    [
                        58.5,
                        44.5
                    ],
                    [
                        58.5,
                        44.5
                    ],
                    [
                        59.5,
                        44.388888888888886
                    ],
                    [
                        60.5,
                        44.22727272727273
                    ],
                    [
                        61.5,
                        44.31818181818182
                    ],
                    [
                        62.5,
                        44.04545454545455
                    ],
                    [
                        63.5,
                        43.785714285714285
                    ],
                    [
                        64.5,
                        43.75
                    ],
                    [
                        65.25,
                        44.5
                    ],
                    [
                        65.5,
                        44.833333333333336
                    ],
                    [
                        66.16666666666667,
                        45.5
                    ],
                    [
                        66.5,
                        45.833333333333336
                    ],
                    [
                        67.16666666666667,
                        46.5
                    ],
                    [
                        67.5,
                        46.75
                    ],
                    [
                        68.5,
                        47
                    ],
                    [
                        69.5,
                        47
                    ],
                    [
                        70.25,
                        46.5
                    ]
                ]
            ],
            [
                [
                    [
                        138.3,
                        48.5
                    ],
                    [
                        137.5,
                        48
                    ],
                    [
                        136.92857142857142,
                        47.5
                    ],
                    [
                        136.5,
                        47.125
                    ],
                    [
                        135.5,
                        46.5
                    ],
                    [
                        135.5,
                        46.5
                    ],
                    [
                        135.5,
                        46.5
                    ],
                    [
                        134.8,
                        47.5
                    ],
                    [
                        135.25,
                        48.5
                    ],
                    [
                        135.5,
                        48.666666666666664
                    ],
                    [
                        136.5,
                        48.86363636363637
                    ],
                    [
                        137.5,
                        49.07142857142857
                    ],
                    [
                        138.3,
                        48.5
                    ]
                ]
            ],
            [
                [
                    [
                        80.3,
                        55.5
                    ],
                    [
                        79.5,
                        55.13636363636363
                    ],
                    [
                        78.83333333333333,
                        55.5
                    ],
                    [
                        79.5,
                        55.86363636363637
                    ],
                    [
                        80.3,
                        55.5
                    ]
                ]
            ],
            [
                [
                    [
                        182,
                        72.5
                    ],
                    [
                        182.14705882352942,
                        71.5
                    ],
                    [
                        181.7173913043478,
                        70.5
                    ],
                    [
                        181.5,
                        70.23684210526316
                    ],
                    [
                        180.5,
                        69.88888888888889
                    ],
                    [
                        179.86363636363637,
                        69.5
                    ],
                    [
                        179.5,
                        68.92857142857143
                    ],
                    [
                        179.125,
                        68.5
                    ],
                    [
                        178.5,
                        68.22222222222223
                    ],
                    [
                        177.5,
                        68.1875
                    ],
                    [
                        176.5,
                        67.78571428571429
                    ],
                    [
                        175.7,
                        67.5
                    ],
                    [
                        175.5,
                        67.3
                    ],
                    [
                        174.83333333333334,
                        66.5
                    ],
                    [
                        174.5,
                        66.375
                    ],
                    [
                        173.5,
                        66.4
                    ],
                    [
                        173.25,
                        66.5
                    ],
                    [
                        173.5,
                        67.5
                    ],
                    [
                        173.5,
                        67.5
                    ],
                    [
                        174.375,
                        68.5
                    ],
                    [
                        174.5,
                        68.57692307692308
                    ],
                    [
                        175.5,
                        69.5
                    ],
                    [
                        175.5,
                        69.5
                    ],
                    [
                        176.14285714285714,
                        70.5
                    ],
                    [
                        176.5,
                        70.85714285714286
                    ],
                    [
                        177.3181818181818,
                        71.5
                    ],
                    [
                        177.5,
                        71.64285714285714
                    ],
                    [
                        178.42307692307693,
                        72.5
                    ],
                    [
                        178.5,
                        72.625
                    ],
                    [
                        179.5,
                        73.03333333333333
                    ],
                    [
                        180.5,
                        72.875
                    ],
                    [
                        181.5,
                        72.88461538461539
                    ],
                    [
                        182,
                        72.5
                    ]
                ]
            ],
            [
                [
                    [
                        160.25,
                        90.5
                    ],
                    [
                        160.5,
                        90.35714285714286
                    ],
                    [
                        161.1,
                        89.5
                    ],
                    [
                        161.5,
                        89.13636363636364
                    ],
                    [
                        162.5,
                        88.61111111111111
                    ],
                    [
                        163.16666666666666,
                        88.5
                    ],
                    [
                        163.5,
                        88.45238095238095
                    ],
                    [
                        164.5,
                        88.15
                    ],
                    [
                        165.5,
                        87.5
                    ],
                    [
                        165.5,
                        87.5
                    ],
                    [
                        165.5,
                        87.5
                    ],
                    [
                        164.61111111111111,
                        86.5
                    ],
                    [
                        164.5,
                        86.45652173913044
                    ],
                    [
                        163.5,
                        86
                    ],
                    [
                        162.5,
                        85.94444444444444
                    ],
                    [
                        161.5,
                        85.8103448275862
                    ],
                    [
                        160.85714285714286,
                        85.5
                    ],
                    [
                        160.5,
                        85.27272727272727
                    ],
                    [
                        159.5,
                        84.67391304347827
                    ],
                    [
                        158.5,
                        84.6
                    ],
                    [
                        157.5,
                        85
                    ],
                    [
                        156.5,
                        85.5
                    ],
                    [
                        156.5,
                        85.5
                    ],
                    [
                        155.85294117647058,
                        86.5
                    ],
                    [
                        155.67391304347825,
                        87.5
                    ],
                    [
                        155.6578947368421,
                        88.5
                    ],
                    [
                        155.5,
                        89.25
                    ],
                    [
                        155.16666666666666,
                        89.5
                    ],
                    [
                        155.5,
                        89.75
                    ],
                    [
                        156.5,
                        90.5
                    ],
                    [
                        156.5,
                        90.5
                    ],
                    [
                        156.5,
                        90.5
                    ],
                    [
                        157.5,
                        90.41666666666667
                    ],
                    [
                        157.83333333333334,
                        90.5
                    ],
                    [
                        158.5,
                        90.66666666666667
                    ],
                    [
                        159.5,
                        90.75
                    ],
                    [
                        160.25,
                        90.5
                    ]
                ]
            ],
            [
                [
                    [
                        145.21428571428572,
                        91.5
                    ],
                    [
                        144.5,
                        91.08333333333333
                    ],
                    [
                        143.625,
                        90.5
                    ],
                    [
                        143.5,
                        90.42857142857143
                    ],
                    [
                        142.5,
                        89.9
                    ],
                    [
                        141.64285714285714,
                        89.5
                    ],
                    [
                        141.5,
                        89.43333333333334
                    ],
                    [
                        140.5,
                        88.96666666666667
                    ],
                    [
                        139.72222222222223,
                        88.5
                    ],
                    [
                        139.5,
                        88.33333333333333
                    ],
                    [
                        138.5,
                        87.63333333333334
                    ],
                    [
                        138.34615384615384,
                        87.5
                    ],
                    [
                        138.5,
                        87
                    ],
                    [
                        138.72222222222223,
                        86.5
                    ],
                    [
                        139.5,
                        86
                    ],
                    [
                        140.27777777777777,
                        85.5
                    ],
                    [
                        140.5,
                        85.1
                    ],
                    [
                        140.73076923076923,
                        84.5
                    ],
                    [
                        140.5,
                        83.75
                    ],
                    [
                        140.46153846153845,
                        83.5
                    ],
                    [
                        140.5,
                        83.16666666666667
                    ],
                    [
                        140.6818181818182,
                        82.5
                    ],
                    [
                        140.5,
                        82.21428571428571
                    ],
                    [
                        140,
                        81.5
                    ],
                    [
                        139.5,
                        81.14285714285714
                    ],
                    [
                        138.5,
                        80.72222222222223
                    ],
                    [
                        137.5,
                        80.7
                    ],
                    [
                        136.75,
                        80.5
                    ],
                    [
                        136.5,
                        80.38888888888889
                    ],
                    [
                        135.83333333333334,
                        79.5
                    ],
                    [
                        135.5,
                        78.92857142857143
                    ],
                    [
                        134.75,
                        78.5
                    ],
                    [
                        134.5,
                        78.25
                    ],
                    [
                        133.5,
                        77.5
                    ],
                    [
                        133.75,
                        76.5
                    ],
                    [
                        134.5,
                        76.125
                    ],
                    [
                        135.5,
                        76.04545454545455
                    ],
                    [
                        136.5,
                        75.91666666666667
                    ],
                    [
                        137.33333333333334,
                        75.5
                    ],
                    [
                        137.5,
                        75.42307692307692
                    ],
                    [
                        138.5,
                        74.83333333333333
                    ],
                    [
                        139.25,
                        74.5
                    ],
                    [
                        139.5,
                        74.38888888888889
                    ],
                    [
                        140.5,
                        74.25
                    ],
                    [
                        141.5,
                        74.25
                    ],
                    [
                        142.5,
                        73.92857142857143
                    ],
                    [
                        142.875,
                        73.5
                    ],
                    [
                        143.33333333333334,
                        72.5
                    ],
                    [
                        143.5,
                        72.125
                    ],
                    [
                        143.73809523809524,
                        71.5
                    ],
                    [
                        144.03333333333333,
                        70.5
                    ],
                    [
                        143.5,
                        70.11904761904762
                    ],
                    [
                        142.5,
                        69.6304347826087
                    ],
                    [
                        142.25,
                        69.5
                    ],
                    [
                        141.5,
                        68.6
                    ],
                    [
                        141.4090909090909,
                        68.5
                    ],
                    [
                        140.5,
                        67.83333333333333
                    ],
                    [
                        139.5,
                        67.9090909090909
                    ],
                    [
                        138.5,
                        68.5
                    ],
                    [
                        138.5,
                        68.5
                    ],
                    [
                        137.55882352941177,
                        69.5
                    ],
                    [
                        137.5,
                        69.57692307692308
                    ],
                    [
                        136.5,
                        69.875
                    ],
                    [
                        135.5,
                        69.73529411764706
                    ],
                    [
                        134.5,
                        69.5
                    ],
                    [
                        134.5,
                        69.5
                    ],
                    [
                        133.5,
                        69.3
                    ],
                    [
                        132.5,
                        69.5
                    ],
                    [
                        131.5,
                        68.75
                    ],
                    [
                        131.21428571428572,
                        68.5
                    ],
                    [
                        130.5,
                        67.78571428571429
                    ],
                    [
                        129.5,
                        67.73529411764706
                    ],
                    [
                        129.05555555555554,
                        67.5
                    ],
                    [
                        128.5,
                        67.14285714285714
                    ],
                    [
                        127.5,
                        66.71428571428571
                    ],
                    [
                        127,
                        66.5
                    ],
                    [
                        127.21428571428571,
                        65.5
                    ],
                    [
                        127.5,
                        65.27777777777777
                    ],
                    [
                        128.5,
                        64.7
                    ],
                    [
                        128.83333333333334,
                        64.5
                    ],
                    [
                        129.5,
                        63.83333333333333
                    ],
                    [
                        129.83333333333334,
                        63.5
                    ],
                    [
                        130.5,
                        63.233333333333334
                    ],
                    [
                        131.5,
                        62.888888888888886
                    ],
                    [
                        132.5,
                        62.77777777777778
                    ],
                    [
                        133.125,
                        62.5
                    ],
                    [
                        133.5,
                        62.22727272727273
                    ],
                    [
                        134.1153846153846,
                        61.5
                    ],
                    [
                        134.1153846153846,
                        60.5
                    ],
                    [
                        133.7,
                        59.5
                    ],
                    [
                        133.75,
                        58.5
                    ],
                    [
                        134.5,
                        58
                    ],
                    [
                        134.92857142857142,
                        57.5
                    ],
                    [
                        135.07142857142858,
                        56.5
                    ],
                    [
                        134.5,
                        55.833333333333336
                    ],
                    [
                        134.3181818181818,
                        55.5
                    ],
                    [
                        133.6818181818182,
                        54.5
                    ],
                    [
                        133.5,
                        54.3
                    ],
                    [
                        132.5,
                        53.75
                    ],
                    [
                        132.19230769230768,
                        53.5
                    ],
                    [
                        131.7,
                        52.5
                    ],
                    [
                        131.5,
                        52.214285714285715
                    ],
                    [
                        130.5,
                        52.07142857142857
                    ],
                    [
                        129.5,
                        51.875
                    ],
                    [
                        128.5,
                        51.77272727272727
                    ],
                    [
                        127.5,
                        51.642857142857146
                    ],
                    [
                        127.16666666666667,
                        51.5
                    ],
                    [
                        126.5,
                        50.833333333333336
                    ],
                    [
                        125.5,
                        50.92857142857143
                    ],
                    [
                        124.75,
                        50.5
                    ],
                    [
                        124.5,
                        50.25
                    ],
                    [
                        124.25,
                        50.5
                    ],
                    [
                        123.5,
                        50.833333333333336
                    ],
                    [
                        122.5,
                        50.7
                    ],
                    [
                        122.16666666666667,
                        50.5
                    ],
                    [
                        122,
                        49.5
                    ],
                    [
                        121.5,
                        49
                    ],
                    [
                        121.35714285714286,
                        48.5
                    ],
                    [
                        121.5,
                        48
                    ],
                    [
                        121.83333333333333,
                        47.5
                    ],
                    [
                        122.16666666666667,
                        46.5
                    ],
                    [
                        122.5,
                        46.214285714285715
                    ],
                    [
                        123.5,
                        45.833333333333336
                    ],
                    [
                        124.5,
                        45.666666666666664
                    ],
                    [
                        125,
                        45.5
                    ],
                    [
                        125.5,
                        45.4
                    ],
                    [
                        126.5,
                        45.3
                    ],
                    [
                        127,
                        45.5
                    ],
                    [
                        127.5,
                        45.75
                    ],
                    [
                        128.5,
                        45.72222222222222
                    ],
                    [
                        129.5,
                        45.666666666666664
                    ],
                    [
                        129.7,
                        45.5
                    ],
                    [
                        130.125,
                        44.5
                    ],
                    [
                        129.75,
                        43.5
                    ],
                    [
                        129.5,
                        42.833333333333336
                    ],
                    [
                        129.375,
                        42.5
                    ],
                    [
                        128.5,
                        41.5
                    ],
                    [
                        128.5,
                        41.5
                    ],
                    [
                        127.5,
                        40.611111111111114
                    ],
                    [
                        127.375,
                        40.5
                    ],
                    [
                        126.5,
                        39.8
                    ],
                    [
                        126.07142857142857,
                        39.5
                    ],
                    [
                        125.5,
                        39.214285714285715
                    ],
                    [
                        124.5,
                        39.166666666666664
                    ],
                    [
                        123.5,
                        38.7
                    ],
                    [
                        123.27777777777777,
                        38.5
                    ],
                    [
                        122.66666666666667,
                        37.5
                    ],
                    [
                        122.64285714285714,
                        36.5
                    ],
                    [
                        122.5,
                        36.166666666666664
                    ],
                    [
                        122.21428571428571,
                        35.5
                    ],
                    [
                        122.3,
                        34.5
                    ],
                    [
                        122.5,
                        34.3
                    ],
                    [
                        123,
                        33.5
                    ],
                    [
                        123.5,
                        32.833333333333336
                    ],
                    [
                        124,
                        32.5
                    ],
                    [
                        124.5,
                        32.1
                    ],
                    [
                        125.25,
                        31.5
                    ],
                    [
                        125.5,
                        31.357142857142858
                    ],
                    [
                        126.5,
                        30.8
                    ],
                    [
                        127.5,
                        30.61111111111111
                    ],
                    [
                        128.5,
                        30.5
                    ],
                    [
                        129.5,
                        30.5
                    ],
                    [
                        129.5,
                        30.5
                    ],
                    [
                        130.5,
                        30.166666666666668
                    ],
                    [
                        131.5,
                        30.166666666666668
                    ],
                    [
                        132.5,
                        30.033333333333335
                    ],
                    [
                        133.38888888888889,
                        29.5
                    ],
                    [
                        133.5,
                        29.4
                    ],
                    [
                        134.5,
                        28.666666666666668
                    ],
                    [
                        135.5,
                        28.833333333333332
                    ],
                    [
                        136.5,
                        28.5
                    ],
                    [
                        137.5,
                        29.5
                    ],
                    [
                        137.1875,
                        30.5
                    ],
                    [
                        137.5,
                        30.884615384615383
                    ],
                    [
                        138.5,
                        31.375
                    ],
                    [
                        138.7,
                        31.5
                    ],
                    [
                        139.5,
                        32.07142857142857
                    ],
                    [
                        140.5,
                        32.166666666666664
                    ],
                    [
                        141.5,
                        32.11538461538461
                    ],
                    [
                        142.5,
                        32.3
                    ],
                    [
                        143.5,
                        32.285714285714285
                    ],
                    [
                        144.25,
                        32.5
                    ],
                    [
                        144.5,
                        33
                    ],
                    [
                        145,
                        33.5
                    ],
                    [
                        145.5,
                        33.75
                    ],
                    [
                        146.5,
                        34.5
                    ],
                    [
                        145.5,
                        35.5
                    ],
                    [
                        145.5,
                        35.5
                    ],
                    [
                        145.5,
                        35.5
                    ],
                    [
                        146.5,
                        36
                    ],
                    [
                        146.7,
                        36.5
                    ],
                    [
                        147.5,
                        37.22727272727273
                    ],
                    [
                        148.16666666666666,
                        37.5
                    ],
                    [
                        148.5,
                        37.6764705882353
                    ],
                    [
                        148.7,
                        37.5
                    ],
                    [
                        149.04166666666666,
                        36.5
                    ],
                    [
                        148.5,
                        35.85
                    ],
                    [
                        147.8,
                        35.5
                    ],
                    [
                        148.5,
                        34.625
                    ],
                    [
                        148.64285714285714,
                        34.5
                    ],
                    [
                        148.5,
                        34.333333333333336
                    ],
                    [
                        147.5,
                        33.5
                    ],
                    [
                        147.5,
                        32.5
                    ],
                    [
                        148.5,
                        31.9
                    ],
                    [
                        149,
                        31.5
                    ],
                    [
                        149.5,
                        30.5
                    ],
                    [
                        149.5,
                        30.5
                    ],
                    [
                        149.58333333333334,
                        29.5
                    ],
                    [
                        149.75,
                        28.5
                    ],
                    [
                        149.5,
                        28
                    ],
                    [
                        148.75,
                        27.5
                    ],
                    [
                        148.65384615384616,
                        26.5
                    ],
                    [
                        148.5,
                        26.25
                    ],
                    [
                        147.64285714285714,
                        25.5
                    ],
                    [
                        147.5,
                        25.40909090909091
                    ],
                    [
                        146.5,
                        25.115384615384617
                    ],
                    [
                        145.5,
                        25.3
                    ],
                    [
                        144.5,
                        25.318181818181817
                    ],
                    [
                        143.5,
                        25.227272727272727
                    ],
                    [
                        142.5,
                        24.681818181818183
                    ],
                    [
                        142,
                        24.5
                    ],
                    [
                        141.5,
                        24.333333333333332
                    ],
                    [
                        140.5,
                        24.394736842105264
                    ],
                    [
                        139.5,
                        24.454545454545453
                    ],
                    [
                        139.3,
                        24.5
                    ],
                    [
                        138.5,
                        24.766666666666666
                    ],
                    [
                        137.5,
                        24.5
                    ],
                    [
                        137.5,
                        24.5
                    ],
                    [
                        137.5,
                        24.5
                    ],
                    [
                        136.5,
                        24.681818181818183
                    ],
                    [
                        135.5,
                        24.944444444444443
                    ],
                    [
                        134.78571428571428,
                        25.5
                    ],
                    [
                        134.5,
                        26.166666666666668
                    ],
                    [
                        134,
                        26.5
                    ],
                    [
                        133.5,
                        26.785714285714285
                    ],
                    [
                        132.5,
                        26.7
                    ],
                    [
                        131.5,
                        26.766666666666666
                    ],
                    [
                        131.1,
                        26.5
                    ],
                    [
                        130.5,
                        26
                    ],
                    [
                        129.75,
                        25.5
                    ],
                    [
                        129.5,
                        25.346153846153847
                    ],
                    [
                        128.5,
                        24.625
                    ],
                    [
                        128,
                        24.5
                    ],
                    [
                        127.5,
                        24.357142857142858
                    ],
                    [
                        127.21428571428571,
                        24.5
                    ],
                    [
                        126.5,
                        24.857142857142858
                    ],
                    [
                        125.5,
                        25.433333333333334
                    ],
                    [
                        125,
                        25.5
                    ],
                    [
                        124.5,
                        25.545454545454547
                    ],
                    [
                        123.5,
                        25.625
                    ],
                    [
                        122.5,
                        25.625
                    ],
                    [
                        122.07142857142857,
                        25.5
                    ],
                    [
                        121.5,
                        25.35185185185185
                    ],
                    [
                        120.5,
                        24.892857142857142
                    ],
                    [
                        119.5,
                        24.725806451612904
                    ],
                    [
                        118.96153846153847,
                        24.5
                    ],
                    [
                        118.5,
                        24.285714285714285
                    ],
                    [
                        117.5,
                        24.27777777777778
                    ],
                    [
                        117.16666666666667,
                        24.5
                    ],
                    [
                        117.5,
                        25.166666666666668
                    ],
                    [
                        117.5909090909091,
                        25.5
                    ],
                    [
                        117.5952380952381,
                        26.5
                    ],
                    [
                        117.5,
                        27.166666666666668
                    ],
                    [
                        117.42307692307692,
                        27.5
                    ],
                    [
                        117.5,
                        28
                    ],
                    [
                        117.5909090909091,
                        28.5
                    ],
                    [
                        117.5,
                        28.75
                    ],
                    [
                        117.07142857142857,
                        29.5
                    ],
                    [
                        116.5,
                        30
                    ],
                    [
                        115.5,
                        30.2
                    ],
                    [
                        114.5,
                        30.346153846153847
                    ],
                    [
                        113.5,
                        30.428571428571427
                    ],
                    [
                        112.5,
                        30.423076923076923
                    ],
                    [
                        111.5,
                        30.136363636363637
                    ],
                    [
                        110.86363636363636,
                        29.5
                    ],
                    [
                        110.60526315789474,
                        28.5
                    ],
                    [
                        110.5,
                        28.40909090909091
                    ],
                    [
                        109.5,
                        28.38235294117647
                    ],
                    [
                        108.5,
                        28.166666666666668
                    ],
                    [
                        108.21428571428571,
                        27.5
                    ],
                    [
                        107.78571428571429,
                        26.5
                    ],
                    [
                        107.5,
                        26.166666666666668
                    ],
                    [
                        107.1,
                        25.5
                    ],
                    [
                        106.5,
                        25.214285714285715
                    ],
                    [
                        105.5,
                        24.653846153846153
                    ],
                    [
                        104.5,
                        24.5
                    ],
                    [
                        104.5,
                        24.5
                    ],
                    [
                        103.5,
                        23.875
                    ],
                    [
                        102.5,
                        23.547619047619047
                    ],
                    [
                        102.4375,
                        23.5
                    ],
                    [
                        102.1875,
                        22.5
                    ],
                    [
                        102.4,
                        21.5
                    ],
                    [
                        102.5,
                        20.9
                    ],
                    [
                        102.65384615384616,
                        20.5
                    ],
                    [
                        102.5,
                        20.25
                    ],
                    [
                        101.5,
                        19.9
                    ],
                    [
                        100.5,
                        20
                    ],
                    [
                        99.5,
                        20.214285714285715
                    ],
                    [
                        98.5,
                        20.5
                    ],
                    [
                        97.5,
                        20.357142857142858
                    ],
                    [
                        97.21428571428571,
                        20.5
                    ],
                    [
                        96.5,
                        20.75
                    ],
                    [
                        95.5,
                        21
                    ],
                    [
                        94.5,
                        21.264705882352942
                    ],
                    [
                        93.5,
                        20.833333333333332
                    ],
                    [
                        92.5,
                        20.636363636363637
                    ],
                    [
                        92.07142857142857,
                        20.5
                    ],
                    [
                        92.5,
                        19.75
                    ],
                    [
                        93.5,
                        19.5
                    ],
                    [
                        93.5,
                        19.5
                    ],
                    [
                        93.5,
                        19.5
                    ],
                    [
                        93.25,
                        18.5
                    ],
                    [
                        92.5,
                        18.342105263157894
                    ],
                    [
                        91.5,
                        18.27777777777778
                    ],
                    [
                        90.5,
                        18.40909090909091
                    ],
                    [
                        89.5,
                        18.214285714285715
                    ],
                    [
                        88.5,
                        18
                    ],
                    [
                        87.5,
                        17.5
                    ],
                    [
                        87.5,
                        16.5
                    ],
                    [
                        87.5,
                        16.5
                    ],
                    [
                        87,
                        15.5
                    ],
                    [
                        87,
                        14.5
                    ],
                    [
                        86.5,
                        13.5
                    ],
                    [
                        86.5,
                        13.5
                    ],
                    [
                        85.5,
                        13.318181818181818
                    ],
                    [
                        85.34615384615384,
                        13.5
                    ],
                    [
                        84.64285714285714,
                        14.5
                    ],
                    [
                        84.5,
                        14.625
                    ],
                    [
                        84.18181818181819,
                        15.5
                    ],
                    [
                        84.27777777777777,
                        16.5
                    ],
                    [
                        83.875,
                        17.5
                    ],
                    [
                        83.5,
                        18.1
                    ],
                    [
                        83.34210526315789,
                        18.5
                    ],
                    [
                        83.16666666666667,
                        19.5
                    ],
                    [
                        82.83333333333333,
                        20.5
                    ],
                    [
                        83.11111111111111,
                        21.5
                    ],
                    [
                        83.22222222222223,
                        22.5
                    ],
                    [
                        83,
                        23.5
                    ],
                    [
                        83.07142857142857,
                        24.5
                    ],
                    [
                        83.5,
                        25
                    ],
                    [
                        84.1,
                        25.5
                    ],
                    [
                        84.5,
                        26.045454545454547
                    ],
                    [
                        84.77777777777777,
                        26.5
                    ],
                    [
                        84.73076923076923,
                        27.5
                    ],
                    [
                        84.95454545454545,
                        28.5
                    ],
                    [
                        85.5,
                        29.357142857142858
                    ],
                    [
                        85.66666666666667,
                        29.5
                    ],
                    [
                        86.3,
                        30.5
                    ],
                    [
                        86.5,
                        30.7
                    ],
                    [
                        87.5,
                        30.5
                    ],
                    [
                        87.5,
                        30.5
                    ],
                    [
                        88.1,
                        29.5
                    ],
                    [
                        88.5,
                        29.333333333333332
                    ],
                    [
                        89.5,
                        29.5
                    ],
                    [
                        89.5,
                        29.5
                    ],
                    [
                        90.5,
                        30.166666666666668
                    ],
                    [
                        91.22727272727273,
                        29.5
                    ],
                    [
                        91.5,
                        29.125
                    ],
                    [
                        92.33333333333333,
                        28.5
                    ],
                    [
                        92.5,
                        28.333333333333332
                    ],
                    [
                        93.5,
                        27.785714285714285
                    ],
                    [
                        94.5,
                        28.071428571428573
                    ],
                    [
                        95.1,
                        28.5
                    ],
                    [
                        95.34615384615384,
                        29.5
                    ],
                    [
                        95.5,
                        29.633333333333333
                    ],
                    [
                        96.5,
                        29.77777777777778
                    ],
                    [
                        97.5,
                        30.115384615384617
                    ],
                    [
                        98.125,
                        30.5
                    ],
                    [
                        98.5,
                        30.833333333333332
                    ],
                    [
                        99.5,
                        31.115384615384617
                    ],
                    [
                        100.5,
                        30.5
                    ],
                    [
                        101.5,
                        30.5
                    ],
                    [
                        101.66666666666667,
                        31.5
                    ],
                    [
                        102.5,
                        32.333333333333336
                    ],
                    [
                        103,
                        32.5
                    ],
                    [
                        103.5,
                        32.666666666666664
                    ],
                    [
                        104.5,
                        32.94444444444444
                    ],
                    [
                        105.5,
                        33.5
                    ],
                    [
                        105.5,
                        33.5
                    ],
                    [
                        106.5,
                        33.7
                    ],
                    [
                        107.5,
                        34.166666666666664
                    ],
                    [
                        107.7,
                        34.5
                    ],
                    [
                        108.21428571428571,
                        35.5
                    ],
                    [
                        108.5,
                        35.72222222222222
                    ],
                    [
                        109.5,
                        35.77272727272727
                    ],
                    [
                        110.5,
                        35.875
                    ],
                    [
                        111.5,
                        35.9
                    ],
                    [
                        112.5,
                        36.5
                    ],
                    [
                        112.5,
                        36.5
                    ],
                    [
                        113,
                        37.5
                    ],
                    [
                        113.5,
                        38
                    ],
                    [
                        114.5,
                        38.27777777777778
                    ],
                    [
                        114.9,
                        38.5
                    ],
                    [
                        115.5,
                        39.25
                    ],
                    [
                        115.83333333333333,
                        39.5
                    ],
                    [
                        116.1,
                        40.5
                    ],
                    [
                        115.5,
                        41.1
                    ],
                    [
                        114.5,
                        41
                    ],
                    [
                        113.5,
                        41.166666666666664
                    ],
                    [
                        113,
                        41.5
                    ],
                    [
                        112.5,
                        41.642857142857146
                    ],
                    [
                        111.5,
                        41.94444444444444
                    ],
                    [
                        110.5,
                        42.3
                    ],
                    [
                        110.16666666666667,
                        42.5
                    ],
                    [
                        109.83333333333333,
                        43.5
                    ],
                    [
                        109.5,
                        44.25
                    ],
                    [
                        109.33333333333333,
                        44.5
                    ],
                    [
                        108.5,
                        45.5
                    ],
                    [
                        108.5,
                        45.5
                    ],
                    [
                        108.5,
                        45.5
                    ],
                    [
                        109.5,
                        46.5
                    ],
                    [
                        108.75,
                        47.5
                    ],
                    [
                        108.5,
                        47.642857142857146
                    ],
                    [
                        107.5,
                        48.3
                    ],
                    [
                        107.16666666666667,
                        48.5
                    ],
                    [
                        106.5,
                        49.166666666666664
                    ],
                    [
                        106,
                        49.5
                    ],
                    [
                        105.5,
                        50
                    ],
                    [
                        104.5,
                        49.5
                    ],
                    [
                        104.5,
                        49.5
                    ],
                    [
                        104.5,
                        49.5
                    ],
                    [
                        103.5,
                        49.625
                    ],
                    [
                        102.5,
                        49.611111111111114
                    ],
                    [
                        101.5,
                        49.5
                    ],
                    [
                        101.5,
                        49.5
                    ],
                    [
                        101.5,
                        49.5
                    ],
                    [
                        100.5,
                        49.666666666666664
                    ],
                    [
                        99.5,
                        49.9
                    ],
                    [
                        98.5,
                        49.833333333333336
                    ],
                    [
                        97.5,
                        50.5
                    ],
                    [
                        96.5,
                        50.166666666666664
                    ],
                    [
                        96,
                        50.5
                    ],
                    [
                        95.5,
                        50.625
                    ],
                    [
                        95,
                        50.5
                    ],
                    [
                        94.5,
                        50.3
                    ],
                    [
                        93.5,
                        50.5
                    ],
                    [
                        93.5,
                        50.5
                    ],
                    [
                        92.5,
                        51
                    ],
                    [
                        91.5,
                        50.92857142857143
                    ],
                    [
                        90.5,
                        50.5
                    ],
                    [
                        90.5,
                        49.5
                    ],
                    [
                        90.5,
                        49.5
                    ],
                    [
                        90.5,
                        49.5
                    ],
                    [
                        89.5,
                        50.1
                    ],
                    [
                        88.5,
                        50.357142857142854
                    ],
                    [
                        87.5,
                        50.5
                    ],
                    [
                        87.5,
                        50.5
                    ],
                    [
                        86.5,
                        50.6
                    ],
                    [
                        85.5,
                        50.59090909090909
                    ],
                    [
                        84.5,
                        50.5
                    ],
                    [
                        84.5,
                        50.5
                    ],
                    [
                        84.5,
                        50.5
                    ],
                    [
                        83.5,
                        50.625
                    ],
                    [
                        82.5,
                        50.714285714285715
                    ],
                    [
                        81.5,
                        51.04545454545455
                    ],
                    [
                        80.66666666666667,
                        51.5
                    ],
                    [
                        80.5,
                        51.75
                    ],
                    [
                        79.5,
                        52
                    ],
                    [
                        78.5,
                        52.26923076923077
                    ],
                    [
                        78.26923076923077,
                        52.5
                    ],
                    [
                        77.5,
                        53.40909090909091
                    ],
                    [
                        77.33333333333333,
                        53.5
                    ],
                    [
                        77.5,
                        53.611111111111114
                    ],
                    [
                        78.5,
                        53.68181818181818
                    ],
                    [
                        78.9,
                        53.5
                    ],
                    [
                        79.5,
                        53.07142857142857
                    ],
                    [
                        80.5,
                        53.25
                    ],
                    [
                        80.83333333333333,
                        53.5
                    ],
                    [
                        80.5,
                        54.5
                    ],
                    [
                        80.5,
                        54.5
                    ],
                    [
                        80.5,
                        54.5
                    ],
                    [
                        80.83333333333333,
                        55.5
                    ],
                    [
                        81.5,
                        55.9
                    ],
                    [
                        81.83333333333333,
                        56.5
                    ],
                    [
                        81.88461538461539,
                        57.5
                    ],
                    [
                        82.375,
                        58.5
                    ],
                    [
                        82.5,
                        58.6
                    ],
                    [
                        83.5,
                        59.25
                    ],
                    [
                        84.5,
                        59.3
                    ],
                    [
                        85.5,
                        59.375
                    ],
                    [
                        86.5,
                        59.5
                    ],
                    [
                        86.5,
                        59.5
                    ],
                    [
                        87.5,
                        60.5
                    ],
                    [
                        87.5,
                        61.5
                    ],
                    [
                        87.5,
                        62.5
                    ],
                    [
                        86.5,
                        63
                    ],
                    [
                        85.5,
                        63.3
                    ],
                    [
                        84.5,
                        63.166666666666664
                    ],
                    [
                        83.5,
                        63.5
                    ],
                    [
                        83.5,
                        63.5
                    ],
                    [
                        82.5,
                        64.16666666666667
                    ],
                    [
                        81.5,
                        64.16666666666667
                    ],
                    [
                        81,
                        64.5
                    ],
                    [
                        80.5,
                        65.5
                    ],
                    [
                        80.5,
                        65.5
                    ],
                    [
                        79.5,
                        66.5
                    ],
                    [
                        78.5,
                        66.5
                    ],
                    [
                        77.5,
                        66.5
                    ],
                    [
                        76.5,
                        66.5
                    ],
                    [
                        75.5,
                        66.5
                    ],
                    [
                        75.5,
                        66.5
                    ],
                    [
                        74.5,
                        66.7
                    ],
                    [
                        73.5,
                        67.25
                    ],
                    [
                        72.5,
                        67.25
                    ],
                    [
                        71.5,
                        67.5
                    ],
                    [
                        71.5,
                        67.5
                    ],
                    [
                        70.5,
                        67.75
                    ],
                    [
                        70.16666666666667,
                        67.5
                    ],
                    [
                        69.5,
                        66.5
                    ],
                    [
                        69.5,
                        66.5
                    ],
                    [
                        68.5,
                        66.5
                    ],
                    [
                        68.5,
                        66.5
                    ],
                    [
                        67.5,
                        67
                    ],
                    [
                        66.83333333333333,
                        67.5
                    ],
                    [
                        66.5,
                        67.75
                    ],
                    [
                        66,
                        68.5
                    ],
                    [
                        65.5,
                        69.5
                    ],
                    [
                        65.5,
                        69.5
                    ],
                    [
                        65.5,
                        70.5
                    ],
                    [
                        65.5,
                        70.5
                    ],
                    [
                        65.64285714285714,
                        71.5
                    ],
                    [
                        66,
                        72.5
                    ],
                    [
                        66.5,
                        73
                    ],
                    [
                        67.1,
                        73.5
                    ],
                    [
                        67.5,
                        73.9
                    ],
                    [
                        68.5,
                        74.35714285714286
                    ],
                    [
                        68.75,
                        74.5
                    ],
                    [
                        68.5,
                        75
                    ],
                    [
                        68.25,
                        75.5
                    ],
                    [
                        68.3,
                        76.5
                    ],
                    [
                        68,
                        77.5
                    ],
                    [
                        67.83333333333333,
                        78.5
                    ],
                    [
                        68.3,
                        79.5
                    ],
                    [
                        68.5,
                        79.83333333333333
                    ],
                    [
                        69,
                        80.5
                    ],
                    [
                        69.5,
                        81.5
                    ],
                    [
                        69.5,
                        81.5
                    ],
                    [
                        70.5,
                        81.75
                    ],
                    [
                        71.25,
                        82.5
                    ],
                    [
                        71.5,
                        82.75
                    ],
                    [
                        71.875,
                        83.5
                    ],
                    [
                        72.5,
                        84.5
                    ],
                    [
                        72.5,
                        84.5
                    ],
                    [
                        72.78571428571429,
                        85.5
                    ],
                    [
                        73.5,
                        86.125
                    ],
                    [
                        74.1,
                        86.5
                    ],
                    [
                        74.5,
                        86.9
                    ],
                    [
                        75.5,
                        87.5
                    ],
                    [
                        75.5,
                        87.5
                    ],
                    [
                        76.5,
                        88.25
                    ],
                    [
                        77,
                        88.5
                    ],
                    [
                        77.5,
                        88.75
                    ],
                    [
                        78.5,
                        88.92857142857143
                    ],
                    [
                        79.5,
                        89.25
                    ],
                    [
                        80.5,
                        89.5
                    ],
                    [
                        80.5,
                        89.5
                    ],
                    [
                        81.5,
                        90.07142857142857
                    ],
                    [
                        82.5,
                        90.3
                    ],
                    [
                        82.83333333333333,
                        90.5
                    ],
                    [
                        83.5,
                        91.5
                    ],
                    [
                        83.5,
                        92
                    ],
                    [
                        84.5,
                        92
                    ],
                    [
                        85.5,
                        92
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        144.5,
                        92
                    ],
                    [
                        145.21428571428572,
                        91.5
                    ]
                ],
                [
                    [
                        97.5,
                        54.1
                    ],
                    [
                        96.5,
                        54.5
                    ],
                    [
                        96.1,
                        53.5
                    ],
                    [
                        96.5,
                        52.833333333333336
                    ],
                    [
                        97,
                        52.5
                    ],
                    [
                        97.5,
                        52.25
                    ],
                    [
                        97.7,
                        52.5
                    ],
                    [
                        98,
                        53.5
                    ],
                    [
                        97.5,
                        54.1
                    ]
                ],
                [
                    [
                        108.5,
                        56.625
                    ],
                    [
                        108,
                        56.5
                    ],
                    [
                        108.5,
                        56.166666666666664
                    ],
                    [
                        108.75,
                        56.5
                    ],
                    [
                        108.5,
                        56.625
                    ]
                ],
                [
                    [
                        92.5,
                        60.166666666666664
                    ],
                    [
                        92,
                        59.5
                    ],
                    [
                        91.5,
                        58.5
                    ],
                    [
                        92.5,
                        57.5
                    ],
                    [
                        93.5,
                        57.5
                    ],
                    [
                        94,
                        58.5
                    ],
                    [
                        93.5,
                        59.5
                    ],
                    [
                        93.5,
                        59.5
                    ],
                    [
                        92.5,
                        60.166666666666664
                    ]
                ]
            ],
            [
                [
                    [
                        152.5,
                        91.5
                    ],
                    [
                        152.5,
                        91.5
                    ],
                    [
                        151.5,
                        91.30952380952381
                    ],
                    [
                        150.92857142857142,
                        91.5
                    ],
                    [
                        151.5,
                        92
                    ],
                    [
                        152.5,
                        92
                    ],
                    [
                        152.5,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 90,
        "coordinates": [
            [
                [
                    [
                        160.125,
                        22.5
                    ],
                    [
                        160.5,
                        22.227272727272727
                    ],
                    [
                        160.94444444444446,
                        21.5
                    ],
                    [
                        161.5,
                        21.155172413793103
                    ],
                    [
                        161.91304347826087,
                        20.5
                    ],
                    [
                        161.5,
                        19.924242424242426
                    ],
                    [
                        160.5,
                        19.85483870967742
                    ],
                    [
                        159.5,
                        19.554054054054053
                    ],
                    [
                        158.5,
                        19.533333333333335
                    ],
                    [
                        158.16666666666666,
                        19.5
                    ],
                    [
                        157.5,
                        19.4
                    ],
                    [
                        156.5,
                        19.083333333333332
                    ],
                    [
                        155.72222222222223,
                        18.5
                    ],
                    [
                        155.5,
                        18.166666666666668
                    ],
                    [
                        155.21428571428572,
                        17.5
                    ],
                    [
                        154.5952380952381,
                        16.5
                    ],
                    [
                        154.5,
                        16.318181818181817
                    ],
                    [
                        153.5,
                        15.944444444444443
                    ],
                    [
                        152.875,
                        16.5
                    ],
                    [
                        152.83333333333334,
                        17.5
                    ],
                    [
                        153.4,
                        18.5
                    ],
                    [
                        153.5,
                        18.576923076923077
                    ],
                    [
                        154.5,
                        18.9
                    ],
                    [
                        155.5,
                        19.5
                    ],
                    [
                        155.5,
                        19.5
                    ],
                    [
                        155.72222222222223,
                        20.5
                    ],
                    [
                        156.5,
                        21.2
                    ],
                    [
                        157.5,
                        21
                    ],
                    [
                        157.9,
                        21.5
                    ],
                    [
                        158.33333333333334,
                        22.5
                    ],
                    [
                        158.5,
                        22.785714285714285
                    ],
                    [
                        159.5,
                        23.055555555555557
                    ],
                    [
                        160.125,
                        22.5
                    ]
                ]
            ],
            [
                [
                    [
                        162.25,
                        29.5
                    ],
                    [
                        162.5,
                        29.25
                    ],
                    [
                        163.5,
                        28.653846153846153
                    ],
                    [
                        164.5,
                        28.9
                    ],
                    [
                        165.5,
                        28.5
                    ],
                    [
                        165.5,
                        28.5
                    ],
                    [
                        166.5,
                        27.576923076923077
                    ],
                    [
                        166.54761904761904,
                        27.5
                    ],
                    [
                        166.5,
                        27.423076923076923
                    ],
                    [
                        165.5,
                        26.74
                    ],
                    [
                        164.5,
                        26.9
                    ],
                    [
                        163.5,
                        26.75
                    ],
                    [
                        163.125,
                        26.5
                    ],
                    [
                        162.5,
                        26.205882352941178
                    ],
                    [
                        161.64285714285714,
                        25.5
                    ],
                    [
                        161.5,
                        25.25
                    ],
                    [
                        160.95454545454547,
                        24.5
                    ],
                    [
                        160.5,
                        24
                    ],
                    [
                        159.5,
                        23.863636363636363
                    ],
                    [
                        158.5,
                        24.5
                    ],
                    [
                        158.5,
                        24.5
                    ],
                    [
                        157.5,
                        25
                    ],
                    [
                        156.92857142857142,
                        25.5
                    ],
                    [
                        156.5,
                        26.25
                    ],
                    [
                        156.33333333333334,
                        26.5
                    ],
                    [
                        156.5,
                        27.5
                    ],
                    [
                        156.5,
                        27.5
                    ],
                    [
                        157.5,
                        27.954545454545453
                    ],
                    [
                        158.5,
                        28.5
                    ],
                    [
                        158.5,
                        28.5
                    ],
                    [
                        159.16666666666666,
                        29.5
                    ],
                    [
                        159.5,
                        29.807692307692307
                    ],
                    [
                        160.5,
                        29.944444444444443
                    ],
                    [
                        161.5,
                        29.666666666666668
                    ],
                    [
                        162.25,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        144.5,
                        31.5
                    ],
                    [
                        145.5,
                        30.833333333333332
                    ],
                    [
                        146.5,
                        30.9
                    ],
                    [
                        146.94444444444446,
                        30.5
                    ],
                    [
                        147.5,
                        29.785714285714285
                    ],
                    [
                        147.75,
                        29.5
                    ],
                    [
                        147.5,
                        28.5
                    ],
                    [
                        147.5,
                        28.5
                    ],
                    [
                        147.1,
                        27.5
                    ],
                    [
                        146.5,
                        26.642857142857142
                    ],
                    [
                        145.5,
                        26.55
                    ],
                    [
                        144.5,
                        26.595238095238095
                    ],
                    [
                        144.1,
                        26.5
                    ],
                    [
                        143.5,
                        26.3
                    ],
                    [
                        142.5,
                        26.25
                    ],
                    [
                        141.5,
                        25.875
                    ],
                    [
                        140.5,
                        26.214285714285715
                    ],
                    [
                        139.5,
                        26
                    ],
                    [
                        138.75,
                        26.5
                    ],
                    [
                        139.5,
                        27.25
                    ],
                    [
                        139.75,
                        27.5
                    ],
                    [
                        139.5,
                        28
                    ],
                    [
                        139.35714285714286,
                        28.5
                    ],
                    [
                        138.91666666666666,
                        29.5
                    ],
                    [
                        139.5,
                        30.375
                    ],
                    [
                        139.7,
                        30.5
                    ],
                    [
                        140.5,
                        30.863636363636363
                    ],
                    [
                        141.5,
                        30.863636363636363
                    ],
                    [
                        142.5,
                        30.96153846153846
                    ],
                    [
                        143.5,
                        31.192307692307693
                    ],
                    [
                        144.5,
                        31.5
                    ],
                    [
                        144.5,
                        31.5
                    ],
                    [
                        144.5,
                        31.5
                    ]
                ]
            ],
            [
                [
                    [
                        113,
                        32.5
                    ],
                    [
                        112.5,
                        32
                    ],
                    [
                        112,
                        31.5
                    ],
                    [
                        111.5,
                        31.416666666666668
                    ],
                    [
                        110.5,
                        31.375
                    ],
                    [
                        109.5,
                        30.9
                    ],
                    [
                        109.27777777777777,
                        30.5
                    ],
                    [
                        109.375,
                        29.5
                    ],
                    [
                        108.5,
                        29.166666666666668
                    ],
                    [
                        107.5,
                        28.96153846153846
                    ],
                    [
                        106.95454545454545,
                        28.5
                    ],
                    [
                        106.5,
                        27.875
                    ],
                    [
                        106.16666666666667,
                        27.5
                    ],
                    [
                        105.5,
                        26.954545454545453
                    ],
                    [
                        104.5,
                        26.67391304347826
                    ],
                    [
                        104.26470588235294,
                        26.5
                    ],
                    [
                        103.77272727272727,
                        25.5
                    ],
                    [
                        103.5,
                        25.125
                    ],
                    [
                        103,
                        24.5
                    ],
                    [
                        102.5,
                        24.261904761904763
                    ],
                    [
                        101.5,
                        23.5
                    ],
                    [
                        101.71875,
                        22.5
                    ],
                    [
                        101.9,
                        21.5
                    ],
                    [
                        101.5,
                        20.7
                    ],
                    [
                        100.5,
                        20.7
                    ],
                    [
                        99.5,
                        20.814285714285713
                    ],
                    [
                        98.5,
                        20.954545454545453
                    ],
                    [
                        97.5,
                        21.11904761904762
                    ],
                    [
                        96.5,
                        21.5
                    ],
                    [
                        96.5,
                        21.5
                    ],
                    [
                        95.5,
                        21.875
                    ],
                    [
                        94.5,
                        22.07894736842105
                    ],
                    [
                        93.5,
                        21.833333333333332
                    ],
                    [
                        92.8076923076923,
                        21.5
                    ],
                    [
                        92.5,
                        21.318181818181817
                    ],
                    [
                        91.5,
                        21.285714285714285
                    ],
                    [
                        90.5,
                        20.625
                    ],
                    [
                        89.5,
                        20.53846153846154
                    ],
                    [
                        89.33333333333333,
                        20.5
                    ],
                    [
                        88.5,
                        20.045454545454547
                    ],
                    [
                        88.1,
                        19.5
                    ],
                    [
                        87.5,
                        18.75
                    ],
                    [
                        87.07142857142857,
                        18.5
                    ],
                    [
                        86.5,
                        18.192307692307693
                    ],
                    [
                        85.6,
                        17.5
                    ],
                    [
                        85.72222222222223,
                        16.5
                    ],
                    [
                        85.5,
                        16.214285714285715
                    ],
                    [
                        85.31818181818181,
                        16.5
                    ],
                    [
                        84.5,
                        17.5
                    ],
                    [
                        84.5,
                        17.5
                    ],
                    [
                        84,
                        18.5
                    ],
                    [
                        83.92105263157895,
                        19.5
                    ],
                    [
                        83.8125,
                        20.5
                    ],
                    [
                        84.16666666666667,
                        21.5
                    ],
                    [
                        84,
                        22.5
                    ],
                    [
                        83.72222222222223,
                        23.5
                    ],
                    [
                        83.8529411764706,
                        24.5
                    ],
                    [
                        84.5,
                        25.05
                    ],
                    [
                        85,
                        25.5
                    ],
                    [
                        85.5,
                        26.318181818181817
                    ],
                    [
                        85.66666666666667,
                        26.5
                    ],
                    [
                        86.125,
                        27.5
                    ],
                    [
                        86.5,
                        28.25
                    ],
                    [
                        87.5,
                        28.1
                    ],
                    [
                        88.5,
                        27.875
                    ],
                    [
                        89.5,
                        28.166666666666668
                    ],
                    [
                        90.5,
                        27.75
                    ],
                    [
                        90.61111111111111,
                        27.5
                    ],
                    [
                        91.5,
                        26.966666666666665
                    ],
                    [
                        92.27777777777777,
                        26.5
                    ],
                    [
                        92.5,
                        26.27777777777778
                    ],
                    [
                        93.375,
                        25.5
                    ],
                    [
                        93.5,
                        25.4
                    ],
                    [
                        93.83333333333333,
                        25.5
                    ],
                    [
                        94.5,
                        26.166666666666668
                    ],
                    [
                        95,
                        26.5
                    ],
                    [
                        95.5,
                        26.75
                    ],
                    [
                        96.5,
                        27.3
                    ],
                    [
                        97.5,
                        27.5
                    ],
                    [
                        97.5,
                        27.5
                    ],
                    [
                        98,
                        28.5
                    ],
                    [
                        98.375,
                        29.5
                    ],
                    [
                        98.5,
                        29.576923076923077
                    ],
                    [
                        99.5,
                        29.916666666666668
                    ],
                    [
                        100.5,
                        29.75
                    ],
                    [
                        101.5,
                        29.61764705882353
                    ],
                    [
                        102.5,
                        29.863636363636363
                    ],
                    [
                        103.375,
                        30.5
                    ],
                    [
                        103.5,
                        30.666666666666668
                    ],
                    [
                        104.5,
                        30.9
                    ],
                    [
                        105.5,
                        30.9
                    ],
                    [
                        106.5,
                        30.928571428571427
                    ],
                    [
                        107.5,
                        31.4
                    ],
                    [
                        108,
                        31.5
                    ],
                    [
                        108.5,
                        31.833333333333336
                    ],
                    [
                        109,
                        32.5
                    ],
                    [
                        109.5,
                        33
                    ],
                    [
                        110.5,
                        33.25
                    ],
                    [
                        111.5,
                        33.07142857142857
                    ],
                    [
                        112.5,
                        32.666666666666664
                    ],
                    [
                        113,
                        32.5
                    ]
                ]
            ],
            [
                [
                    [
                        117.7,
                        33.5
                    ],
                    [
                        118.5,
                        33.13636363636363
                    ],
                    [
                        119.5,
                        33
                    ],
                    [
                        120.3,
                        32.5
                    ],
                    [
                        120.5,
                        32.375
                    ],
                    [
                        121.5,
                        32.07142857142857
                    ],
                    [
                        122.16666666666667,
                        31.5
                    ],
                    [
                        122.5,
                        31.318181818181817
                    ],
                    [
                        123.5,
                        30.7
                    ],
                    [
                        123.83333333333333,
                        30.5
                    ],
                    [
                        124.5,
                        29.833333333333332
                    ],
                    [
                        125.16666666666667,
                        29.5
                    ],
                    [
                        125.5,
                        29.4
                    ],
                    [
                        126.5,
                        28.944444444444443
                    ],
                    [
                        127.5,
                        28.875
                    ],
                    [
                        128.5,
                        28.833333333333332
                    ],
                    [
                        129.5,
                        28.833333333333332
                    ],
                    [
                        130.5,
                        28.681818181818183
                    ],
                    [
                        131.5,
                        28.785714285714285
                    ],
                    [
                        132.5,
                        28.625
                    ],
                    [
                        132.64285714285714,
                        28.5
                    ],
                    [
                        132.5,
                        28.25
                    ],
                    [
                        131.5,
                        28.166666666666668
                    ],
                    [
                        130.7,
                        27.5
                    ],
                    [
                        130.5,
                        27.4
                    ],
                    [
                        129.5,
                        27
                    ],
                    [
                        129.125,
                        26.5
                    ],
                    [
                        128.5,
                        25.666666666666668
                    ],
                    [
                        127.5,
                        25.5
                    ],
                    [
                        127.5,
                        25.5
                    ],
                    [
                        127.5,
                        25.5
                    ],
                    [
                        126.5,
                        25.852941176470587
                    ],
                    [
                        125.5,
                        26.108695652173914
                    ],
                    [
                        124.5,
                        26.227272727272727
                    ],
                    [
                        123.5,
                        26.25
                    ],
                    [
                        122.5,
                        26.25
                    ],
                    [
                        121.5,
                        25.97826086956522
                    ],
                    [
                        120.65384615384616,
                        25.5
                    ],
                    [
                        120.5,
                        25.428571428571427
                    ],
                    [
                        119.5,
                        25.20967741935484
                    ],
                    [
                        118.5,
                        25.142857142857142
                    ],
                    [
                        118.27272727272727,
                        25.5
                    ],
                    [
                        118.30952380952381,
                        26.5
                    ],
                    [
                        118.5,
                        27.3
                    ],
                    [
                        118.6,
                        27.5
                    ],
                    [
                        119.21428571428571,
                        28.5
                    ],
                    [
                        118.95454545454545,
                        29.5
                    ],
                    [
                        118.5,
                        30.5
                    ],
                    [
                        118.5,
                        30.5
                    ],
                    [
                        117.5,
                        31.055555555555557
                    ],
                    [
                        116.83333333333333,
                        31.5
                    ],
                    [
                        116.5,
                        32
                    ],
                    [
                        115.5,
                        32.166666666666664
                    ],
                    [
                        114.5,
                        32.5
                    ],
                    [
                        114.5,
                        32.5
                    ],
                    [
                        114.5,
                        32.5
                    ],
                    [
                        115.5,
                        33.5
                    ],
                    [
                        115.5,
                        33.5
                    ],
                    [
                        115.5,
                        33.5
                    ],
                    [
                        116.5,
                        33.166666666666664
                    ],
                    [
                        117,
                        33.5
                    ],
                    [
                        117.5,
                        33.666666666666664
                    ],
                    [
                        117.7,
                        33.5
                    ]
                ]
            ],
            [
                [
                    [
                        147.83333333333334,
                        36.5
                    ],
                    [
                        147.5,
                        36.42307692307692
                    ],
                    [
                        147.45,
                        36.5
                    ],
                    [
                        147.5,
                        36.54545454545455
                    ],
                    [
                        147.83333333333334,
                        36.5
                    ]
                ]
            ],
            [
                [
                    [
                        120.66666666666667,
                        38.5
                    ],
                    [
                        120.73076923076923,
                        37.5
                    ],
                    [
                        120.5,
                        37
                    ],
                    [
                        120.22727272727273,
                        36.5
                    ],
                    [
                        120.5,
                        35.9
                    ],
                    [
                        120.66666666666667,
                        35.5
                    ],
                    [
                        120.5,
                        35.214285714285715
                    ],
                    [
                        119.66666666666667,
                        34.5
                    ],
                    [
                        119.5,
                        34.3
                    ],
                    [
                        119.3,
                        34.5
                    ],
                    [
                        118.5,
                        35
                    ],
                    [
                        117.5,
                        35.5
                    ],
                    [
                        117.5,
                        35.5
                    ],
                    [
                        116.5,
                        36.5
                    ],
                    [
                        116.5,
                        36.5
                    ],
                    [
                        116.5,
                        36.5
                    ],
                    [
                        117.16666666666667,
                        37.5
                    ],
                    [
                        117.5,
                        38.1
                    ],
                    [
                        117.9,
                        38.5
                    ],
                    [
                        118.5,
                        38.8
                    ],
                    [
                        119.5,
                        39.125
                    ],
                    [
                        120.5,
                        38.833333333333336
                    ],
                    [
                        120.66666666666667,
                        38.5
                    ]
                ]
            ],
            [
                [
                    [
                        56.5,
                        42.5
                    ],
                    [
                        57.5,
                        42.166666666666664
                    ],
                    [
                        58.5,
                        42.22727272727273
                    ],
                    [
                        59.5,
                        42.07142857142857
                    ],
                    [
                        60.5,
                        42.1
                    ],
                    [
                        61.5,
                        42.166666666666664
                    ],
                    [
                        61.833333333333336,
                        41.5
                    ],
                    [
                        61.5,
                        41
                    ],
                    [
                        61,
                        40.5
                    ],
                    [
                        61.166666666666664,
                        39.5
                    ],
                    [
                        61.07142857142857,
                        38.5
                    ],
                    [
                        61,
                        37.5
                    ],
                    [
                        61.5,
                        36.9
                    ],
                    [
                        61.9,
                        36.5
                    ],
                    [
                        61.5,
                        36.1
                    ],
                    [
                        61.25,
                        35.5
                    ],
                    [
                        60.5,
                        35.17857142857143
                    ],
                    [
                        59.63636363636363,
                        34.5
                    ],
                    [
                        59.5,
                        34.44117647058823
                    ],
                    [
                        58.5,
                        34.293103448275865
                    ],
                    [
                        57.833333333333336,
                        34.5
                    ],
                    [
                        57.5,
                        34.65
                    ],
                    [
                        56.5,
                        34.6764705882353
                    ],
                    [
                        56.166666666666664,
                        34.5
                    ],
                    [
                        55.5,
                        34.3125
                    ],
                    [
                        54.5,
                        34.47142857142857
                    ],
                    [
                        54.40909090909091,
                        34.5
                    ],
                    [
                        54,
                        35.5
                    ],
                    [
                        54.1,
                        36.5
                    ],
                    [
                        53.5,
                        36.77272727272727
                    ],
                    [
                        52.5,
                        37.5
                    ],
                    [
                        52.5,
                        37.5
                    ],
                    [
                        51.5,
                        38
                    ],
                    [
                        50.5,
                        37.76086956521739
                    ],
                    [
                        49.5,
                        37.84782608695652
                    ],
                    [
                        48.5,
                        38.06521739130435
                    ],
                    [
                        47.5,
                        38.189655172413794
                    ],
                    [
                        46.5,
                        38.473684210526315
                    ],
                    [
                        46.4375,
                        38.5
                    ],
                    [
                        45.72222222222222,
                        39.5
                    ],
                    [
                        46.5,
                        40.5
                    ],
                    [
                        46.5,
                        40.5
                    ],
                    [
                        47.5,
                        40.9
                    ],
                    [
                        48.5,
                        41.166666666666664
                    ],
                    [
                        49.5,
                        41.3
                    ],
                    [
                        50.5,
                        41.5
                    ],
                    [
                        50.5,
                        41.5
                    ],
                    [
                        51.5,
                        41.833333333333336
                    ],
                    [
                        52.5,
                        42.22727272727273
                    ],
                    [
                        53.25,
                        42.5
                    ],
                    [
                        53.5,
                        42.642857142857146
                    ],
                    [
                        54.5,
                        42.666666666666664
                    ],
                    [
                        54.833333333333336,
                        42.5
                    ],
                    [
                        55.5,
                        42.27777777777778
                    ],
                    [
                        56.5,
                        42.5
                    ],
                    [
                        56.5,
                        42.5
                    ],
                    [
                        56.5,
                        42.5
                    ]
                ]
            ],
            [
                [
                    [
                        84.3,
                        52.5
                    ],
                    [
                        83.5,
                        51.7
                    ],
                    [
                        82.83333333333333,
                        52.5
                    ],
                    [
                        83.5,
                        53.07142857142857
                    ],
                    [
                        84.3,
                        52.5
                    ]
                ]
            ],
            [
                [
                    [
                        102.875,
                        53.5
                    ],
                    [
                        102.5,
                        53.22727272727273
                    ],
                    [
                        101.5,
                        52.9
                    ],
                    [
                        100.5,
                        53.5
                    ],
                    [
                        100.5,
                        53.5
                    ],
                    [
                        100.5,
                        53.5
                    ],
                    [
                        101.5,
                        54.357142857142854
                    ],
                    [
                        102.5,
                        53.92857142857143
                    ],
                    [
                        102.875,
                        53.5
                    ]
                ]
            ],
            [
                [
                    [
                        109.5,
                        53.5
                    ],
                    [
                        110.5,
                        52.6
                    ],
                    [
                        110.66666666666667,
                        52.5
                    ],
                    [
                        111.5,
                        51.666666666666664
                    ],
                    [
                        111.64285714285714,
                        51.5
                    ],
                    [
                        112.5,
                        50.642857142857146
                    ],
                    [
                        112.7,
                        50.5
                    ],
                    [
                        113.5,
                        50.19230769230769
                    ],
                    [
                        114.5,
                        50.19230769230769
                    ],
                    [
                        115.5,
                        49.9
                    ],
                    [
                        116.07142857142857,
                        49.5
                    ],
                    [
                        116.5,
                        49.26923076923077
                    ],
                    [
                        117.5,
                        48.75
                    ],
                    [
                        118.16666666666667,
                        48.5
                    ],
                    [
                        118.5,
                        48.375
                    ],
                    [
                        119.03846153846153,
                        47.5
                    ],
                    [
                        119.2,
                        46.5
                    ],
                    [
                        118.9,
                        45.5
                    ],
                    [
                        119.5,
                        45.125
                    ],
                    [
                        120.5,
                        44.642857142857146
                    ],
                    [
                        121.5,
                        44.5
                    ],
                    [
                        121.5,
                        44.5
                    ],
                    [
                        122.5,
                        44.125
                    ],
                    [
                        123.5,
                        44.07142857142857
                    ],
                    [
                        124.5,
                        44.11538461538461
                    ],
                    [
                        125.5,
                        44
                    ],
                    [
                        126.5,
                        43.72222222222222
                    ],
                    [
                        127.16666666666667,
                        43.5
                    ],
                    [
                        127.5,
                        43
                    ],
                    [
                        127.61111111111111,
                        42.5
                    ],
                    [
                        127.5,
                        42.375
                    ],
                    [
                        126.5,
                        41.642857142857146
                    ],
                    [
                        126.38888888888889,
                        41.5
                    ],
                    [
                        125.7,
                        40.5
                    ],
                    [
                        125.5,
                        40.34615384615385
                    ],
                    [
                        124.5,
                        40.34615384615385
                    ],
                    [
                        123.5,
                        40.375
                    ],
                    [
                        122.5,
                        39.9
                    ],
                    [
                        121.75,
                        40.5
                    ],
                    [
                        121.5,
                        40.7
                    ],
                    [
                        120.5,
                        41.166666666666664
                    ],
                    [
                        120.25,
                        41.5
                    ],
                    [
                        119.5,
                        42.25
                    ],
                    [
                        118.5,
                        42.333333333333336
                    ],
                    [
                        117.5,
                        42.166666666666664
                    ],
                    [
                        116.5,
                        41.98
                    ],
                    [
                        115.5,
                        41.90625
                    ],
                    [
                        114.5,
                        41.87931034482759
                    ],
                    [
                        113.5,
                        42.22222222222222
                    ],
                    [
                        112.875,
                        42.5
                    ],
                    [
                        112.5,
                        42.875
                    ],
                    [
                        111.875,
                        43.5
                    ],
                    [
                        111.5,
                        44.5
                    ],
                    [
                        111.5,
                        44.5
                    ],
                    [
                        111.5,
                        44.5
                    ],
                    [
                        111.7,
                        45.5
                    ],
                    [
                        111.66666666666667,
                        46.5
                    ],
                    [
                        111.5,
                        47.5
                    ],
                    [
                        111.5,
                        47.5
                    ],
                    [
                        110.5,
                        48.5
                    ],
                    [
                        110.5,
                        48.5
                    ],
                    [
                        109.5,
                        49.04545454545455
                    ],
                    [
                        108.66666666666667,
                        49.5
                    ],
                    [
                        108.5,
                        49.75
                    ],
                    [
                        107.5,
                        50.388888888888886
                    ],
                    [
                        107.35714285714286,
                        50.5
                    ],
                    [
                        107.5,
                        50.625
                    ],
                    [
                        108.27777777777777,
                        51.5
                    ],
                    [
                        108.5,
                        51.9
                    ],
                    [
                        109.5,
                        52.5
                    ],
                    [
                        109.5,
                        53.5
                    ],
                    [
                        109.5,
                        53.5
                    ],
                    [
                        109.5,
                        53.5
                    ]
                ]
            ],
            [
                [
                    [
                        91.92857142857143,
                        54.5
                    ],
                    [
                        91.5,
                        54.07142857142857
                    ],
                    [
                        90.5,
                        54.3
                    ],
                    [
                        90.16666666666667,
                        54.5
                    ],
                    [
                        90.5,
                        55.166666666666664
                    ],
                    [
                        91.5,
                        55
                    ],
                    [
                        91.92857142857143,
                        54.5
                    ]
                ]
            ],
            [
                [
                    [
                        89.5,
                        58.5
                    ],
                    [
                        90.25,
                        57.5
                    ],
                    [
                        89.5,
                        56.5
                    ],
                    [
                        89.5,
                        56.5
                    ],
                    [
                        89.36666666666666,
                        55.5
                    ],
                    [
                        88.5,
                        54.63333333333333
                    ],
                    [
                        88.16666666666667,
                        54.5
                    ],
                    [
                        87.5,
                        53.7
                    ],
                    [
                        87.35714285714286,
                        53.5
                    ],
                    [
                        86.5,
                        53
                    ],
                    [
                        85.83333333333333,
                        53.5
                    ],
                    [
                        85.5,
                        54.1
                    ],
                    [
                        84.5,
                        53.5
                    ],
                    [
                        84.5,
                        53.5
                    ],
                    [
                        84.5,
                        53.5
                    ],
                    [
                        83.83333333333333,
                        54.5
                    ],
                    [
                        84.1,
                        55.5
                    ],
                    [
                        83.5,
                        56
                    ],
                    [
                        83.25,
                        56.5
                    ],
                    [
                        83.27777777777777,
                        57.5
                    ],
                    [
                        83.5,
                        57.9
                    ],
                    [
                        84.5,
                        57.625
                    ],
                    [
                        85.5,
                        57.77272727272727
                    ],
                    [
                        86.5,
                        57.766666666666666
                    ],
                    [
                        87.5,
                        57.96666666666667
                    ],
                    [
                        88.5,
                        58.05555555555556
                    ],
                    [
                        89.5,
                        58.5
                    ],
                    [
                        89.5,
                        58.5
                    ],
                    [
                        89.5,
                        58.5
                    ]
                ]
            ],
            [
                [
                    [
                        106,
                        58.5
                    ],
                    [
                        105.5,
                        57.9
                    ],
                    [
                        104.5,
                        58.083333333333336
                    ],
                    [
                        103.5,
                        58.2
                    ],
                    [
                        102.5,
                        58.333333333333336
                    ],
                    [
                        102.16666666666667,
                        58.5
                    ],
                    [
                        102.5,
                        58.75
                    ],
                    [
                        103.5,
                        59
                    ],
                    [
                        104.5,
                        59.125
                    ],
                    [
                        105.5,
                        59
                    ],
                    [
                        106,
                        58.5
                    ]
                ]
            ],
            [
                [
                    [
                        178.83333333333334,
                        70.5
                    ],
                    [
                        178.5,
                        69.9
                    ],
                    [
                        177.5,
                        69.5
                    ],
                    [
                        177.5,
                        69.5
                    ],
                    [
                        177.5,
                        69.5
                    ],
                    [
                        177.5,
                        70.5
                    ],
                    [
                        177.5,
                        70.5
                    ],
                    [
                        178.5,
                        71.25
                    ],
                    [
                        178.83333333333334,
                        70.5
                    ]
                ]
            ],
            [
                [
                    [
                        70.5,
                        72.5
                    ],
                    [
                        70.5,
                        72.5
                    ],
                    [
                        70,
                        71.5
                    ],
                    [
                        69.5,
                        71.33333333333333
                    ],
                    [
                        68.5,
                        71.16666666666667
                    ],
                    [
                        68.25,
                        71.5
                    ],
                    [
                        68.5,
                        72.5
                    ],
                    [
                        68.5,
                        72.5
                    ],
                    [
                        69.5,
                        72.5
                    ],
                    [
                        70.5,
                        72.5
                    ],
                    [
                        70.5,
                        72.5
                    ]
                ]
            ],
            [
                [
                    [
                        160.7,
                        88.5
                    ],
                    [
                        161.5,
                        88.11904761904762
                    ],
                    [
                        162.5,
                        87.8157894736842
                    ],
                    [
                        163.5,
                        87.73809523809524
                    ],
                    [
                        164.21428571428572,
                        87.5
                    ],
                    [
                        163.5,
                        86.5
                    ],
                    [
                        163.5,
                        86.5
                    ],
                    [
                        162.5,
                        86.5
                    ],
                    [
                        161.5,
                        86.32758620689656
                    ],
                    [
                        160.5,
                        85.8125
                    ],
                    [
                        159.78571428571428,
                        85.5
                    ],
                    [
                        159.5,
                        85.32608695652173
                    ],
                    [
                        158.5,
                        85.35
                    ],
                    [
                        158.16666666666666,
                        85.5
                    ],
                    [
                        157.5,
                        85.8157894736842
                    ],
                    [
                        156.73529411764707,
                        86.5
                    ],
                    [
                        156.5,
                        87
                    ],
                    [
                        156.32608695652175,
                        87.5
                    ],
                    [
                        156.44736842105263,
                        88.5
                    ],
                    [
                        156.5,
                        88.66666666666667
                    ],
                    [
                        157.5,
                        89.23333333333333
                    ],
                    [
                        158.5,
                        89.375
                    ],
                    [
                        159.5,
                        89.42857142857143
                    ],
                    [
                        160.5,
                        88.68181818181819
                    ],
                    [
                        160.7,
                        88.5
                    ]
                ]
            ],
            [
                [
                    [
                        143.5,
                        91.5
                    ],
                    [
                        143.5,
                        91.5
                    ],
                    [
                        142.5,
                        90.8529411764706
                    ],
                    [
                        141.75,
                        90.5
                    ],
                    [
                        141.5,
                        90.375
                    ],
                    [
                        140.5,
                        89.85
                    ],
                    [
                        139.96153846153845,
                        89.5
                    ],
                    [
                        139.5,
                        89.1842105263158
                    ],
                    [
                        138.5,
                        88.57407407407408
                    ],
                    [
                        138.3181818181818,
                        88.5
                    ],
                    [
                        137.5,
                        87.8076923076923
                    ],
                    [
                        137.28947368421052,
                        87.5
                    ],
                    [
                        137.07142857142858,
                        86.5
                    ],
                    [
                        137.5,
                        86
                    ],
                    [
                        138.5,
                        85.5
                    ],
                    [
                        138.5,
                        85.5
                    ],
                    [
                        139.5,
                        84.7
                    ],
                    [
                        139.64285714285714,
                        84.5
                    ],
                    [
                        139.8846153846154,
                        83.5
                    ],
                    [
                        139.6875,
                        82.5
                    ],
                    [
                        139.5,
                        82.26923076923077
                    ],
                    [
                        138.5,
                        81.54761904761905
                    ],
                    [
                        137.5,
                        81.6875
                    ],
                    [
                        136.5,
                        81.61111111111111
                    ],
                    [
                        136.4,
                        81.5
                    ],
                    [
                        135.5,
                        80.85714285714286
                    ],
                    [
                        135,
                        80.5
                    ],
                    [
                        134.5,
                        79.94444444444444
                    ],
                    [
                        134.05555555555554,
                        79.5
                    ],
                    [
                        133.5,
                        79.08333333333333
                    ],
                    [
                        132.5,
                        78.8076923076923
                    ],
                    [
                        131.92857142857142,
                        78.5
                    ],
                    [
                        131.5,
                        77.9
                    ],
                    [
                        130.5,
                        77.5
                    ],
                    [
                        130.9,
                        76.5
                    ],
                    [
                        131.5,
                        76
                    ],
                    [
                        131.92857142857142,
                        75.5
                    ],
                    [
                        132.5,
                        74.83333333333333
                    ],
                    [
                        133.5,
                        74.86363636363636
                    ],
                    [
                        134.5,
                        74.97368421052632
                    ],
                    [
                        135.5,
                        74.97058823529412
                    ],
                    [
                        136.5,
                        74.66666666666667
                    ],
                    [
                        136.9,
                        74.5
                    ],
                    [
                        137.5,
                        74
                    ],
                    [
                        138,
                        73.5
                    ],
                    [
                        138.5,
                        73.2
                    ],
                    [
                        139.5,
                        73.0625
                    ],
                    [
                        140.5,
                        73.1
                    ],
                    [
                        141.5,
                        73.03846153846153
                    ],
                    [
                        142.5,
                        72.5
                    ],
                    [
                        142.5,
                        72.5
                    ],
                    [
                        142.94444444444446,
                        71.5
                    ],
                    [
                        142.91666666666666,
                        70.5
                    ],
                    [
                        142.5,
                        70.28260869565217
                    ],
                    [
                        141.5,
                        69.8
                    ],
                    [
                        140.95454545454547,
                        69.5
                    ],
                    [
                        140.5,
                        69
                    ],
                    [
                        139.5,
                        68.65384615384616
                    ],
                    [
                        138.5,
                        69.4375
                    ],
                    [
                        138.44117647058823,
                        69.5
                    ],
                    [
                        137.77272727272728,
                        70.5
                    ],
                    [
                        137.5,
                        70.75
                    ],
                    [
                        136.5,
                        71.05555555555556
                    ],
                    [
                        135.5,
                        70.66666666666667
                    ],
                    [
                        135.3,
                        70.5
                    ],
                    [
                        134.5,
                        70.15217391304348
                    ],
                    [
                        133.5,
                        70.20588235294117
                    ],
                    [
                        132.5,
                        70.4375
                    ],
                    [
                        131.5,
                        69.71428571428571
                    ],
                    [
                        131.25,
                        69.5
                    ],
                    [
                        130.5,
                        68.85714285714286
                    ],
                    [
                        129.5,
                        68.60526315789474
                    ],
                    [
                        129.36666666666667,
                        68.5
                    ],
                    [
                        128.5,
                        67.93478260869566
                    ],
                    [
                        127.5,
                        67.71052631578948
                    ],
                    [
                        126.5,
                        67.66666666666667
                    ],
                    [
                        125.5,
                        67.55
                    ],
                    [
                        125.38888888888889,
                        67.5
                    ],
                    [
                        124.91666666666667,
                        66.5
                    ],
                    [
                        125.3,
                        65.5
                    ],
                    [
                        125.5,
                        65.28571428571429
                    ],
                    [
                        126.34615384615384,
                        64.5
                    ],
                    [
                        126.5,
                        64.4
                    ],
                    [
                        127.5,
                        64.11904761904762
                    ],
                    [
                        128.36666666666667,
                        63.5
                    ],
                    [
                        128.5,
                        63.27777777777778
                    ],
                    [
                        128.96666666666667,
                        62.5
                    ],
                    [
                        129.5,
                        62.13636363636363
                    ],
                    [
                        130.5,
                        62.31818181818182
                    ],
                    [
                        131.5,
                        62.15217391304348
                    ],
                    [
                        132.5,
                        61.73076923076923
                    ],
                    [
                        132.8,
                        61.5
                    ],
                    [
                        132.96153846153845,
                        60.5
                    ],
                    [
                        132.5,
                        59.75
                    ],
                    [
                        132.34615384615384,
                        59.5
                    ],
                    [
                        132.3181818181818,
                        58.5
                    ],
                    [
                        132.5,
                        58.1
                    ],
                    [
                        132.75,
                        57.5
                    ],
                    [
                        133.3125,
                        56.5
                    ],
                    [
                        133.16666666666666,
                        55.5
                    ],
                    [
                        132.5,
                        54.7
                    ],
                    [
                        132.16666666666666,
                        54.5
                    ],
                    [
                        131.5,
                        54
                    ],
                    [
                        130.5,
                        53.55882352941177
                    ],
                    [
                        129.5,
                        53.54761904761905
                    ],
                    [
                        128.5,
                        53.541666666666664
                    ],
                    [
                        127.5,
                        53.55263157894737
                    ],
                    [
                        126.5,
                        53.611111111111114
                    ],
                    [
                        125.5,
                        54.1
                    ],
                    [
                        124.5,
                        54.5
                    ],
                    [
                        123.5,
                        54.5
                    ],
                    [
                        123.5,
                        54.5
                    ],
                    [
                        122.5,
                        54.875
                    ],
                    [
                        121.5,
                        55
                    ],
                    [
                        120.5,
                        55.214285714285715
                    ],
                    [
                        119.83333333333333,
                        55.5
                    ],
                    [
                        119.5,
                        55.666666666666664
                    ],
                    [
                        118.5,
                        56.25
                    ],
                    [
                        118,
                        56.5
                    ],
                    [
                        117.5,
                        56.833333333333336
                    ],
                    [
                        116.5,
                        57.25
                    ],
                    [
                        116.3,
                        57.5
                    ],
                    [
                        115.5,
                        58.5
                    ],
                    [
                        115.5,
                        58.5
                    ],
                    [
                        114.5,
                        58.642857142857146
                    ],
                    [
                        113.5,
                        59.125
                    ],
                    [
                        112.5,
                        59.388888888888886
                    ],
                    [
                        111.5,
                        59.388888888888886
                    ],
                    [
                        110.5,
                        59.5
                    ],
                    [
                        109.5,
                        59.388888888888886
                    ],
                    [
                        108.5,
                        59.357142857142854
                    ],
                    [
                        107.5,
                        59.5
                    ],
                    [
                        107.5,
                        59.5
                    ],
                    [
                        106.5,
                        59.7
                    ],
                    [
                        105.5,
                        60.5
                    ],
                    [
                        105.5,
                        60.5
                    ],
                    [
                        104.5,
                        60.785714285714285
                    ],
                    [
                        103.5,
                        61.5
                    ],
                    [
                        102.5,
                        61.5
                    ],
                    [
                        102.5,
                        61.5
                    ],
                    [
                        101.5,
                        61.9
                    ],
                    [
                        100.5,
                        62.25
                    ],
                    [
                        100,
                        62.5
                    ],
                    [
                        99.5,
                        62.75
                    ],
                    [
                        98.5,
                        63.5
                    ],
                    [
                        98.5,
                        63.5
                    ],
                    [
                        97.5,
                        64.5
                    ],
                    [
                        97.5,
                        64.5
                    ],
                    [
                        96.5,
                        64.75
                    ],
                    [
                        95.5,
                        65.1
                    ],
                    [
                        94.5,
                        65.1
                    ],
                    [
                        93.5,
                        64.83333333333333
                    ],
                    [
                        92.5,
                        64.7
                    ],
                    [
                        91.5,
                        64.72222222222223
                    ],
                    [
                        90.5,
                        64.91666666666667
                    ],
                    [
                        89.78571428571429,
                        64.5
                    ],
                    [
                        89.5,
                        64.21428571428571
                    ],
                    [
                        88.5,
                        64.5
                    ],
                    [
                        88.5,
                        64.5
                    ],
                    [
                        87.5,
                        64.875
                    ],
                    [
                        86.5,
                        65.5
                    ],
                    [
                        86.5,
                        65.5
                    ],
                    [
                        85.5,
                        66
                    ],
                    [
                        84.75,
                        66.5
                    ],
                    [
                        84.5,
                        66.64285714285714
                    ],
                    [
                        83.64285714285714,
                        67.5
                    ],
                    [
                        83.5,
                        67.83333333333333
                    ],
                    [
                        83.1,
                        68.5
                    ],
                    [
                        82.66666666666667,
                        69.5
                    ],
                    [
                        82.5,
                        69.75
                    ],
                    [
                        81.5,
                        70.5
                    ],
                    [
                        81.5,
                        70.5
                    ],
                    [
                        80.5,
                        71
                    ],
                    [
                        79.5,
                        71.3
                    ],
                    [
                        78.5,
                        71.3
                    ],
                    [
                        77.5,
                        71.21428571428571
                    ],
                    [
                        76.5,
                        71.21428571428571
                    ],
                    [
                        75.5,
                        71.16666666666667
                    ],
                    [
                        74.5,
                        71.5
                    ],
                    [
                        74.5,
                        71.5
                    ],
                    [
                        73.5,
                        72.25
                    ],
                    [
                        73,
                        72.5
                    ],
                    [
                        72.5,
                        73
                    ],
                    [
                        72.25,
                        73.5
                    ],
                    [
                        72.25,
                        74.5
                    ],
                    [
                        72.1,
                        75.5
                    ],
                    [
                        71.66666666666667,
                        76.5
                    ],
                    [
                        71.5,
                        76.7
                    ],
                    [
                        70.92857142857143,
                        77.5
                    ],
                    [
                        70.5,
                        78.5
                    ],
                    [
                        70.5,
                        78.5
                    ],
                    [
                        70.5,
                        78.5
                    ],
                    [
                        71.21428571428571,
                        79.5
                    ],
                    [
                        71.5,
                        79.83333333333333
                    ],
                    [
                        72,
                        80.5
                    ],
                    [
                        72.33333333333333,
                        81.5
                    ],
                    [
                        72.5,
                        81.78571428571429
                    ],
                    [
                        73.21428571428571,
                        82.5
                    ],
                    [
                        73.5,
                        82.83333333333333
                    ],
                    [
                        74.16666666666667,
                        83.5
                    ],
                    [
                        74.5,
                        83.9
                    ],
                    [
                        75.1,
                        84.5
                    ],
                    [
                        75.5,
                        84.83333333333333
                    ],
                    [
                        76.5,
                        85.21428571428571
                    ],
                    [
                        76.9,
                        85.5
                    ],
                    [
                        77.5,
                        86.25
                    ],
                    [
                        78.5,
                        86.5
                    ],
                    [
                        78.5,
                        86.5
                    ],
                    [
                        79.5,
                        87.125
                    ],
                    [
                        80.5,
                        87.38888888888889
                    ],
                    [
                        80.83333333333333,
                        87.5
                    ],
                    [
                        81.5,
                        87.78571428571429
                    ],
                    [
                        82.5,
                        87.875
                    ],
                    [
                        83.5,
                        88.07142857142857
                    ],
                    [
                        84.5,
                        88.33333333333333
                    ],
                    [
                        84.83333333333333,
                        88.5
                    ],
                    [
                        85.5,
                        88.83333333333333
                    ],
                    [
                        86.3,
                        89.5
                    ],
                    [
                        86.5,
                        90.5
                    ],
                    [
                        86.5,
                        91.5
                    ],
                    [
                        86.5,
                        92
                    ],
                    [
                        87.5,
                        92
                    ],
                    [
                        88.5,
                        92
                    ],
                    [
                        89.5,
                        92
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        91.5,
                        92
                    ],
                    [
                        92.5,
                        92
                    ],
                    [
                        93.5,
                        92
                    ],
                    [
                        94.5,
                        92
                    ],
                    [
                        95.5,
                        92
                    ],
                    [
                        96.5,
                        92
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.5,
                        92
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.5,
                        92
                    ],
                    [
                        143.5,
                        92
                    ],
                    [
                        143.5,
                        91.5
                    ]
                ],
                [
                    [
                        179.5,
                        71.5
                    ],
                    [
                        179.5,
                        71.5
                    ],
                    [
                        179.5,
                        71.5
                    ],
                    [
                        179.5,
                        71.5
                    ],
                    [
                        179.5,
                        71.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 105,
        "coordinates": [
            [
                [
                    [
                        159.8,
                        21.5
                    ],
                    [
                        160.5,
                        20.916666666666668
                    ],
                    [
                        161.5,
                        20.637931034482758
                    ],
                    [
                        161.58695652173913,
                        20.5
                    ],
                    [
                        161.5,
                        20.37878787878788
                    ],
                    [
                        160.5,
                        20.338709677419356
                    ],
                    [
                        159.5,
                        19.95945945945946
                    ],
                    [
                        158.5,
                        20.033333333333335
                    ],
                    [
                        157.8913043478261,
                        20.5
                    ],
                    [
                        158.5,
                        21.2
                    ],
                    [
                        159.16666666666666,
                        21.5
                    ],
                    [
                        159.5,
                        21.73076923076923
                    ],
                    [
                        159.8,
                        21.5
                    ]
                ]
            ],
            [
                [
                    [
                        91.7,
                        25.5
                    ],
                    [
                        92,
                        24.5
                    ],
                    [
                        92.5,
                        24.25
                    ],
                    [
                        93.5,
                        23.9
                    ],
                    [
                        94,
                        23.5
                    ],
                    [
                        93.8,
                        22.5
                    ],
                    [
                        93.5,
                        22.38888888888889
                    ],
                    [
                        92.5,
                        22
                    ],
                    [
                        91.5,
                        21.96153846153846
                    ],
                    [
                        90.5,
                        21.543478260869566
                    ],
                    [
                        90.4090909090909,
                        21.5
                    ],
                    [
                        89.5,
                        21.115384615384617
                    ],
                    [
                        88.5,
                        20.916666666666668
                    ],
                    [
                        87.83333333333333,
                        20.5
                    ],
                    [
                        87.5,
                        20.045454545454547
                    ],
                    [
                        86.83333333333333,
                        19.5
                    ],
                    [
                        86.5,
                        19.285714285714285
                    ],
                    [
                        85.5,
                        18.96153846153846
                    ],
                    [
                        84.86363636363636,
                        19.5
                    ],
                    [
                        84.94444444444444,
                        20.5
                    ],
                    [
                        85.41666666666667,
                        21.5
                    ],
                    [
                        84.83333333333333,
                        22.5
                    ],
                    [
                        84.56666666666666,
                        23.5
                    ],
                    [
                        84.78571428571429,
                        24.5
                    ],
                    [
                        85.5,
                        25.125
                    ],
                    [
                        85.96153846153847,
                        25.5
                    ],
                    [
                        86.5,
                        26.083333333333332
                    ],
                    [
                        87.5,
                        26.071428571428573
                    ],
                    [
                        88.16666666666667,
                        25.5
                    ],
                    [
                        88.5,
                        24.833333333333332
                    ],
                    [
                        89.5,
                        25.4
                    ],
                    [
                        90.5,
                        25.5
                    ],
                    [
                        90.5,
                        25.5
                    ],
                    [
                        91.5,
                        25.7
                    ],
                    [
                        91.7,
                        25.5
                    ]
                ]
            ],
            [
                [
                    [
                        162.64285714285714,
                        27.5
                    ],
                    [
                        162.5,
                        27.40909090909091
                    ],
                    [
                        162.16666666666666,
                        27.5
                    ],
                    [
                        162.5,
                        27.576923076923077
                    ],
                    [
                        162.64285714285714,
                        27.5
                    ]
                ]
            ],
            [
                [
                    [
                        165.72222222222223,
                        27.5
                    ],
                    [
                        165.5,
                        27.34
                    ],
                    [
                        165.1,
                        27.5
                    ],
                    [
                        165.5,
                        27.710526315789473
                    ],
                    [
                        165.72222222222223,
                        27.5
                    ]
                ]
            ],
            [
                [
                    [
                        160,
                        28.5
                    ],
                    [
                        160.5,
                        28.333333333333332
                    ],
                    [
                        161.21428571428572,
                        27.5
                    ],
                    [
                        161.14285714285714,
                        26.5
                    ],
                    [
                        160.57142857142858,
                        25.5
                    ],
                    [
                        160.5,
                        25.40909090909091
                    ],
                    [
                        159.5,
                        24.944444444444443
                    ],
                    [
                        158.66666666666666,
                        25.5
                    ],
                    [
                        158.5,
                        26
                    ],
                    [
                        158.27777777777777,
                        26.5
                    ],
                    [
                        158.5,
                        26.785714285714285
                    ],
                    [
                        158.95454545454547,
                        27.5
                    ],
                    [
                        159.4375,
                        28.5
                    ],
                    [
                        159.5,
                        28.583333333333332
                    ],
                    [
                        160,
                        28.5
                    ]
                ]
            ],
            [
                [
                    [
                        105,
                        29.5
                    ],
                    [
                        105.5,
                        29.166666666666668
                    ],
                    [
                        105.94444444444444,
                        28.5
                    ],
                    [
                        105.5,
                        28.029411764705884
                    ],
                    [
                        104.8076923076923,
                        27.5
                    ],
                    [
                        104.5,
                        27.32608695652174
                    ],
                    [
                        103.5,
                        26.666666666666668
                    ],
                    [
                        103.39473684210526,
                        26.5
                    ],
                    [
                        102.95454545454545,
                        25.5
                    ],
                    [
                        102.5,
                        25
                    ],
                    [
                        101.5,
                        24.5
                    ],
                    [
                        101.5,
                        24.5
                    ],
                    [
                        100.5,
                        24.055555555555557
                    ],
                    [
                        99.5,
                        23.545454545454547
                    ],
                    [
                        99.25,
                        23.5
                    ],
                    [
                        99.5,
                        23.333333333333332
                    ],
                    [
                        100.5,
                        22.666666666666668
                    ],
                    [
                        100.7,
                        22.5
                    ],
                    [
                        101.125,
                        21.5
                    ],
                    [
                        100.5,
                        21.3
                    ],
                    [
                        99.5,
                        21.242857142857144
                    ],
                    [
                        98.5,
                        21.40909090909091
                    ],
                    [
                        98.2,
                        21.5
                    ],
                    [
                        97.78571428571429,
                        22.5
                    ],
                    [
                        97.9,
                        23.5
                    ],
                    [
                        97.5,
                        23.72222222222222
                    ],
                    [
                        97,
                        24.5
                    ],
                    [
                        97.25,
                        25.5
                    ],
                    [
                        97.5,
                        25.928571428571427
                    ],
                    [
                        97.86363636363636,
                        26.5
                    ],
                    [
                        98.5,
                        27.083333333333332
                    ],
                    [
                        99.125,
                        27.5
                    ],
                    [
                        99.5,
                        27.928571428571427
                    ],
                    [
                        100.16666666666667,
                        28.5
                    ],
                    [
                        100.5,
                        28.666666666666668
                    ],
                    [
                        101.5,
                        28.633333333333333
                    ],
                    [
                        102.5,
                        28.653846153846153
                    ],
                    [
                        103.5,
                        29.26923076923077
                    ],
                    [
                        103.92857142857143,
                        29.5
                    ],
                    [
                        104.5,
                        29.735294117647058
                    ],
                    [
                        105,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        122,
                        29.5
                    ],
                    [
                        122.5,
                        29.3
                    ],
                    [
                        123.5,
                        28.833333333333332
                    ],
                    [
                        124.5,
                        28.5
                    ],
                    [
                        124.5,
                        28.5
                    ],
                    [
                        125.5,
                        27.642857142857142
                    ],
                    [
                        126.5,
                        27.5
                    ],
                    [
                        126.5,
                        27.5
                    ],
                    [
                        126.5,
                        27.5
                    ],
                    [
                        125.5,
                        27.357142857142858
                    ],
                    [
                        124.5,
                        27.318181818181817
                    ],
                    [
                        123.5,
                        27.142857142857142
                    ],
                    [
                        122.5,
                        27.029411764705884
                    ],
                    [
                        121.5,
                        26.833333333333332
                    ],
                    [
                        121,
                        26.5
                    ],
                    [
                        120.5,
                        26.3125
                    ],
                    [
                        119.75,
                        26.5
                    ],
                    [
                        120.25,
                        27.5
                    ],
                    [
                        120.5,
                        28
                    ],
                    [
                        120.72222222222223,
                        28.5
                    ],
                    [
                        121,
                        29.5
                    ],
                    [
                        121.5,
                        30
                    ],
                    [
                        122,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        144.92857142857142,
                        29.5
                    ],
                    [
                        145.5,
                        29
                    ],
                    [
                        145.78571428571428,
                        28.5
                    ],
                    [
                        145.80769230769232,
                        27.5
                    ],
                    [
                        145.5,
                        27.3
                    ],
                    [
                        144.5,
                        27.30952380952381
                    ],
                    [
                        143.5,
                        27.3
                    ],
                    [
                        142.5,
                        27.366666666666667
                    ],
                    [
                        142.16666666666666,
                        27.5
                    ],
                    [
                        141.5,
                        28.5
                    ],
                    [
                        141.5,
                        28.5
                    ],
                    [
                        141.3,
                        29.5
                    ],
                    [
                        141.5,
                        29.583333333333332
                    ],
                    [
                        142.5,
                        29.6
                    ],
                    [
                        143.5,
                        29.5
                    ],
                    [
                        144.5,
                        29.928571428571427
                    ],
                    [
                        144.92857142857142,
                        29.5
                    ]
                ]
            ],
            [
                [
                    [
                        58.666666666666664,
                        40.5
                    ],
                    [
                        59.3,
                        39.5
                    ],
                    [
                        58.72222222222222,
                        38.5
                    ],
                    [
                        58.75,
                        37.5
                    ],
                    [
                        58.875,
                        36.5
                    ],
                    [
                        59.166666666666664,
                        35.5
                    ],
                    [
                        58.5,
                        35.31818181818182
                    ],
                    [
                        57.5,
                        35.4
                    ],
                    [
                        56.833333333333336,
                        35.5
                    ],
                    [
                        56.5,
                        35.59090909090909
                    ],
                    [
                        55.5,
                        36.3
                    ],
                    [
                        55.34615384615385,
                        36.5
                    ],
                    [
                        54.5,
                        37.14705882352941
                    ],
                    [
                        53.5,
                        37.45454545454545
                    ],
                    [
                        53.4375,
                        37.5
                    ],
                    [
                        52.785714285714285,
                        38.5
                    ],
                    [
                        52.5,
                        38.75
                    ],
                    [
                        51.5,
                        38.833333333333336
                    ],
                    [
                        50.833333333333336,
                        38.5
                    ],
                    [
                        50.5,
                        38.41304347826087
                    ],
                    [
                        49.5,
                        38.5
                    ],
                    [
                        49.5,
                        38.5
                    ],
                    [
                        48.5,
                        39.125
                    ],
                    [
                        47.75,
                        39.5
                    ],
                    [
                        48.5,
                        39.875
                    ],
                    [
                        49.5,
                        40.125
                    ],
                    [
                        50,
                        40.5
                    ],
                    [
                        50.5,
                        40.666666666666664
                    ],
                    [
                        51.5,
                        40.794117647058826
                    ],
                    [
                        52.5,
                        40.8
                    ],
                    [
                        53.25,
                        40.5
                    ],
                    [
                        53.5,
                        40.25
                    ],
                    [
                        53.625,
                        40.5
                    ],
                    [
                        54.5,
                        41.03846153846154
                    ],
                    [
                        55.5,
                        40.92857142857143
                    ],
                    [
                        56.5,
                        40.5
                    ],
                    [
                        57.5,
                        40.68181818181818
                    ],
                    [
                        58.5,
                        40.625
                    ],
                    [
                        58.666666666666664,
                        40.5
                    ]
                ]
            ],
            [
                [
                    [
                        115.5,
                        48.5
                    ],
                    [
                        116.5,
                        47.666666666666664
                    ],
                    [
                        116.83333333333333,
                        47.5
                    ],
                    [
                        117,
                        46.5
                    ],
                    [
                        116.66666666666667,
                        45.5
                    ],
                    [
                        117.38888888888889,
                        44.5
                    ],
                    [
                        117.5,
                        44
                    ],
                    [
                        117.61111111111111,
                        43.5
                    ],
                    [
                        117.5,
                        43.40909090909091
                    ],
                    [
                        116.5,
                        42.6
                    ],
                    [
                        116.16666666666667,
                        42.5
                    ],
                    [
                        115.5,
                        42.375
                    ],
                    [
                        114.5,
                        42.39655172413793
                    ],
                    [
                        114.26923076923077,
                        42.5
                    ],
                    [
                        113.5,
                        43.214285714285715
                    ],
                    [
                        113.21428571428571,
                        43.5
                    ],
                    [
                        113.5,
                        44.5
                    ],
                    [
                        113.5,
                        44.5
                    ],
                    [
                        114.5,
                        45.5
                    ],
                    [
                        113.94444444444444,
                        46.5
                    ],
                    [
                        113.5,
                        47.3
                    ],
                    [
                        113.4,
                        47.5
                    ],
                    [
                        112.95454545454545,
                        48.5
                    ],
                    [
                        113.5,
                        49
                    ],
                    [
                        114.5,
                        49.14705882352941
                    ],
                    [
                        115.5,
                        48.5
                    ],
                    [
                        115.5,
                        48.5
                    ]
                ]
            ],
            [
                [
                    [
                        88.5625,
                        56.5
                    ],
                    [
                        88.5,
                        56.166666666666664
                    ],
                    [
                        88.27777777777777,
                        55.5
                    ],
                    [
                        87.5,
                        55.111111111111114
                    ],
                    [
                        86.5,
                        54.888888888888886
                    ],
                    [
                        85.65384615384616,
                        55.5
                    ],
                    [
                        85.5,
                        56.5
                    ],
                    [
                        85.5,
                        56.5
                    ],
                    [
                        85.5,
                        56.5
                    ],
                    [
                        86.5,
                        57
                    ],
                    [
                        87.5,
                        57.11904761904762
                    ],
                    [
                        88.5,
                        56.59090909090909
                    ],
                    [
                        88.5625,
                        56.5
                    ]
                ]
            ],
            [
                [
                    [
                        141.91666666666666,
                        71.5
                    ],
                    [
                        141.5,
                        70.66666666666667
                    ],
                    [
                        141.3,
                        70.5
                    ],
                    [
                        140.5,
                        70.21428571428571
                    ],
                    [
                        139.5,
                        70
                    ],
                    [
                        139.13636363636363,
                        70.5
                    ],
                    [
                        138.78571428571428,
                        71.5
                    ],
                    [
                        139.5,
                        71.95454545454545
                    ],
                    [
                        140.5,
                        72.1
                    ],
                    [
                        141.5,
                        71.88461538461539
                    ],
                    [
                        141.91666666666666,
                        71.5
                    ]
                ]
            ],
            [
                [
                    [
                        135.72222222222223,
                        73.5
                    ],
                    [
                        136.1153846153846,
                        72.5
                    ],
                    [
                        135.5,
                        71.88461538461539
                    ],
                    [
                        135.04545454545453,
                        71.5
                    ],
                    [
                        134.5,
                        71.03846153846153
                    ],
                    [
                        133.5,
                        71.21428571428571
                    ],
                    [
                        133.1,
                        71.5
                    ],
                    [
                        133.1153846153846,
                        72.5
                    ],
                    [
                        133.5,
                        73.05555555555556
                    ],
                    [
                        133.80769230769232,
                        73.5
                    ],
                    [
                        134.5,
                        74.1
                    ],
                    [
                        135.5,
                        73.72222222222223
                    ],
                    [
                        135.72222222222223,
                        73.5
                    ]
                ]
            ],
            [
                [
                    [
                        161.16666666666666,
                        87.5
                    ],
                    [
                        160.91176470588235,
                        86.5
                    ],
                    [
                        160.5,
                        86.28125
                    ],
                    [
                        159.5,
                        85.87931034482759
                    ],
                    [
                        158.5,
                        85.92857142857143
                    ],
                    [
                        157.61111111111111,
                        86.5
                    ],
                    [
                        157.5,
                        86.75
                    ],
                    [
                        157.14705882352942,
                        87.5
                    ],
                    [
                        157.5,
                        88.1
                    ],
                    [
                        158.5,
                        88.45238095238095
                    ],
                    [
                        159.5,
                        88.38235294117646
                    ],
                    [
                        160.5,
                        87.73529411764706
                    ],
                    [
                        161.16666666666666,
                        87.5
                    ]
                ]
            ],
            [
                [
                    [
                        142.21428571428572,
                        91.5
                    ],
                    [
                        141.5,
                        91.06521739130434
                    ],
                    [
                        140.5,
                        90.58
                    ],
                    [
                        140.39473684210526,
                        90.5
                    ],
                    [
                        139.5,
                        89.84615384615384
                    ],
                    [
                        139.02631578947367,
                        89.5
                    ],
                    [
                        138.5,
                        89.12962962962963
                    ],
                    [
                        137.5,
                        88.6875
                    ],
                    [
                        136.9,
                        88.5
                    ],
                    [
                        136.5,
                        87.5
                    ],
                    [
                        136.5,
                        87.5
                    ],
                    [
                        136.1315789473684,
                        86.5
                    ],
                    [
                        136.5,
                        85.72222222222223
                    ],
                    [
                        136.6818181818182,
                        85.5
                    ],
                    [
                        137.5,
                        85.0909090909091
                    ],
                    [
                        138.5,
                        84.5
                    ],
                    [
                        138.5,
                        84.5
                    ],
                    [
                        139.2058823529412,
                        83.5
                    ],
                    [
                        138.7941176470588,
                        82.5
                    ],
                    [
                        138.5,
                        82.26190476190476
                    ],
                    [
                        137.78571428571428,
                        82.5
                    ],
                    [
                        137.5,
                        82.625
                    ],
                    [
                        136.5,
                        82.91176470588235
                    ],
                    [
                        135.8,
                        82.5
                    ],
                    [
                        135.5,
                        82.16666666666667
                    ],
                    [
                        134.5,
                        81.58333333333333
                    ],
                    [
                        134.4090909090909,
                        81.5
                    ],
                    [
                        133.5,
                        80.5
                    ],
                    [
                        133.5,
                        80.5
                    ],
                    [
                        132.5,
                        80
                    ],
                    [
                        131.64285714285714,
                        79.5
                    ],
                    [
                        131.5,
                        79.42307692307692
                    ],
                    [
                        130.5,
                        78.97058823529412
                    ],
                    [
                        129.77272727272728,
                        78.5
                    ],
                    [
                        129.5,
                        78.16666666666667
                    ],
                    [
                        128.83333333333334,
                        77.5
                    ],
                    [
                        128.94444444444446,
                        76.5
                    ],
                    [
                        129.5,
                        75.66666666666667
                    ],
                    [
                        129.61111111111111,
                        75.5
                    ],
                    [
                        129.7,
                        74.5
                    ],
                    [
                        129.9,
                        73.5
                    ],
                    [
                        130.25,
                        72.5
                    ],
                    [
                        130.5,
                        72.21428571428571
                    ],
                    [
                        131.05555555555554,
                        71.5
                    ],
                    [
                        131.16666666666666,
                        70.5
                    ],
                    [
                        130.5,
                        69.92857142857143
                    ],
                    [
                        129.75,
                        69.5
                    ],
                    [
                        129.5,
                        69.39473684210526
                    ],
                    [
                        128.5,
                        68.64285714285714
                    ],
                    [
                        127.5,
                        68.5
                    ],
                    [
                        127.5,
                        68.5
                    ],
                    [
                        127.5,
                        68.5
                    ],
                    [
                        126.5,
                        68.85714285714286
                    ],
                    [
                        125.94444444444444,
                        68.5
                    ],
                    [
                        125.5,
                        68.3
                    ],
                    [
                        124.5,
                        67.88888888888889
                    ],
                    [
                        123.96153846153847,
                        67.5
                    ],
                    [
                        123.91176470588235,
                        66.5
                    ],
                    [
                        124.375,
                        65.5
                    ],
                    [
                        124.5,
                        65.2
                    ],
                    [
                        125.13636363636364,
                        64.5
                    ],
                    [
                        125.5,
                        64.1923076923077
                    ],
                    [
                        126.5,
                        63.650000000000006
                    ],
                    [
                        127.1,
                        63.5
                    ],
                    [
                        127.5,
                        63.36666666666667
                    ],
                    [
                        128.11904761904762,
                        62.5
                    ],
                    [
                        128.16666666666666,
                        61.5
                    ],
                    [
                        128.5,
                        61.44444444444444
                    ],
                    [
                        129.5,
                        61.45454545454545
                    ],
                    [
                        129.75,
                        61.5
                    ],
                    [
                        130.5,
                        61.63636363636363
                    ],
                    [
                        131.5,
                        61.5
                    ],
                    [
                        131.5,
                        61.5
                    ],
                    [
                        131.97058823529412,
                        60.5
                    ],
                    [
                        131.5,
                        59.833333333333336
                    ],
                    [
                        131.16666666666666,
                        59.5
                    ],
                    [
                        131,
                        58.5
                    ],
                    [
                        131.5,
                        57.75
                    ],
                    [
                        131.64285714285714,
                        57.5
                    ],
                    [
                        132.33333333333334,
                        56.5
                    ],
                    [
                        132.2,
                        55.5
                    ],
                    [
                        131.5,
                        55.0625
                    ],
                    [
                        130.6,
                        54.5
                    ],
                    [
                        130.5,
                        54.44117647058823
                    ],
                    [
                        129.5,
                        54.26190476190476
                    ],
                    [
                        128.5,
                        54.166666666666664
                    ],
                    [
                        127.5,
                        54.3421052631579
                    ],
                    [
                        127.2,
                        54.5
                    ],
                    [
                        126.5,
                        55
                    ],
                    [
                        125.5,
                        55.36666666666667
                    ],
                    [
                        125,
                        55.5
                    ],
                    [
                        124.5,
                        55.68181818181818
                    ],
                    [
                        123.5,
                        56.22727272727273
                    ],
                    [
                        122.5,
                        56.40909090909091
                    ],
                    [
                        122.3,
                        56.5
                    ],
                    [
                        121.5,
                        56.9
                    ],
                    [
                        120.5,
                        57
                    ],
                    [
                        119.5,
                        57.40909090909091
                    ],
                    [
                        119.33333333333333,
                        57.5
                    ],
                    [
                        119.38888888888889,
                        58.5
                    ],
                    [
                        119.5,
                        58.833333333333336
                    ],
                    [
                        119.83333333333333,
                        59.5
                    ],
                    [
                        119.5,
                        60
                    ],
                    [
                        119.25,
                        60.5
                    ],
                    [
                        119.33333333333333,
                        61.5
                    ],
                    [
                        118.875,
                        62.5
                    ],
                    [
                        118.5,
                        62.92857142857143
                    ],
                    [
                        117.5,
                        63
                    ],
                    [
                        116.5,
                        62.94444444444444
                    ],
                    [
                        115.83333333333333,
                        62.5
                    ],
                    [
                        115.5,
                        61.833333333333336
                    ],
                    [
                        115.16666666666667,
                        61.5
                    ],
                    [
                        114.5,
                        61
                    ],
                    [
                        113.5,
                        60.611111111111114
                    ],
                    [
                        113,
                        60.5
                    ],
                    [
                        112.5,
                        60.43333333333333
                    ],
                    [
                        111.5,
                        60.43333333333333
                    ],
                    [
                        111,
                        60.5
                    ],
                    [
                        110.5,
                        60.53846153846154
                    ],
                    [
                        109.5,
                        60.58571428571429
                    ],
                    [
                        108.5,
                        60.57692307692308
                    ],
                    [
                        107.5,
                        60.85
                    ],
                    [
                        106.5,
                        61.1875
                    ],
                    [
                        105.875,
                        61.5
                    ],
                    [
                        105.5,
                        61.6875
                    ],
                    [
                        104.5,
                        62.26923076923077
                    ],
                    [
                        104.07142857142857,
                        62.5
                    ],
                    [
                        103.5,
                        63
                    ],
                    [
                        103.05555555555556,
                        63.5
                    ],
                    [
                        102.625,
                        64.5
                    ],
                    [
                        102.5,
                        64.66666666666667
                    ],
                    [
                        101.66666666666667,
                        65.5
                    ],
                    [
                        101.5,
                        65.64285714285714
                    ],
                    [
                        100.5,
                        66.5
                    ],
                    [
                        99.5,
                        66.5
                    ],
                    [
                        99.5,
                        66.5
                    ],
                    [
                        98.5,
                        66.64285714285714
                    ],
                    [
                        97.5,
                        66.92857142857143
                    ],
                    [
                        96.5,
                        67.07142857142857
                    ],
                    [
                        95.5,
                        67.25
                    ],
                    [
                        94.5,
                        67.38888888888889
                    ],
                    [
                        93.5,
                        67.125
                    ],
                    [
                        92.5,
                        66.72222222222223
                    ],
                    [
                        91.5,
                        66.54347826086956
                    ],
                    [
                        91.25,
                        66.5
                    ],
                    [
                        90.5,
                        66.22727272727273
                    ],
                    [
                        89.5,
                        66.1
                    ],
                    [
                        88.5,
                        66
                    ],
                    [
                        87.5,
                        66.5
                    ],
                    [
                        87.5,
                        66.5
                    ],
                    [
                        86.5,
                        67.25
                    ],
                    [
                        86.27777777777777,
                        67.5
                    ],
                    [
                        86,
                        68.5
                    ],
                    [
                        85.5,
                        69.25
                    ],
                    [
                        85.25,
                        69.5
                    ],
                    [
                        85.5,
                        69.83333333333333
                    ],
                    [
                        85.75,
                        70.5
                    ],
                    [
                        85.5,
                        71.5
                    ],
                    [
                        85.5,
                        71.5
                    ],
                    [
                        85,
                        72.5
                    ],
                    [
                        84.5,
                        73.5
                    ],
                    [
                        84.5,
                        73.5
                    ],
                    [
                        83.5,
                        74
                    ],
                    [
                        82.5,
                        73.9
                    ],
                    [
                        81.5,
                        73.875
                    ],
                    [
                        80.5,
                        74.05555555555556
                    ],
                    [
                        79.5,
                        74.07142857142857
                    ],
                    [
                        78.5,
                        74.5
                    ],
                    [
                        78.5,
                        74.5
                    ],
                    [
                        77.5,
                        74.64285714285714
                    ],
                    [
                        76.5,
                        74.83333333333333
                    ],
                    [
                        76,
                        75.5
                    ],
                    [
                        75.5,
                        75.94444444444444
                    ],
                    [
                        75,
                        76.5
                    ],
                    [
                        74.5,
                        77.05555555555556
                    ],
                    [
                        73.5,
                        77.5
                    ],
                    [
                        73.5,
                        77.5
                    ],
                    [
                        72.75,
                        78.5
                    ],
                    [
                        73.33333333333333,
                        79.5
                    ],
                    [
                        73.5,
                        79.75
                    ],
                    [
                        73.875,
                        80.5
                    ],
                    [
                        74.5,
                        81.5
                    ],
                    [
                        74.5,
                        81.5
                    ],
                    [
                        75.5,
                        82.35714285714286
                    ],
                    [
                        75.75,
                        82.5
                    ],
                    [
                        76.5,
                        83
                    ],
                    [
                        76.92857142857143,
                        83.5
                    ],
                    [
                        77.5,
                        84
                    ],
                    [
                        78.5,
                        84.5
                    ],
                    [
                        78.5,
                        84.5
                    ],
                    [
                        79.5,
                        85.35714285714286
                    ],
                    [
                        79.75,
                        85.5
                    ],
                    [
                        80.5,
                        85.8
                    ],
                    [
                        81.5,
                        86.125
                    ],
                    [
                        82.5,
                        86.125
                    ],
                    [
                        83.5,
                        85.72222222222223
                    ],
                    [
                        84.5,
                        85.66666666666667
                    ],
                    [
                        85.5,
                        86
                    ],
                    [
                        86.25,
                        86.5
                    ],
                    [
                        86.5,
                        86.66666666666667
                    ],
                    [
                        87.5,
                        87.33333333333333
                    ],
                    [
                        87.75,
                        87.5
                    ],
                    [
                        88.5,
                        88
                    ],
                    [
                        89.1,
                        88.5
                    ],
                    [
                        89.5,
                        89
                    ],
                    [
                        89.83333333333333,
                        89.5
                    ],
                    [
                        90.16666666666667,
                        90.5
                    ],
                    [
                        90.5,
                        91.5
                    ],
                    [
                        90.5,
                        92
                    ],
                    [
                        90.5,
                        91.5
                    ],
                    [
                        91.5,
                        91.125
                    ],
                    [
                        92.5,
                        90.75
                    ],
                    [
                        92.875,
                        90.5
                    ],
                    [
                        93.5,
                        90.11538461538461
                    ],
                    [
                        94.5,
                        89.77272727272727
                    ],
                    [
                        95.5,
                        89.625
                    ],
                    [
                        96.5,
                        90
                    ],
                    [
                        96.83333333333333,
                        90.5
                    ],
                    [
                        96.875,
                        91.5
                    ],
                    [
                        97.5,
                        92
                    ],
                    [
                        98.5,
                        92
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.5,
                        92
                    ],
                    [
                        128.375,
                        91.5
                    ],
                    [
                        128.5,
                        91.31818181818181
                    ],
                    [
                        128.6,
                        91.5
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.5,
                        92
                    ],
                    [
                        142.21428571428572,
                        91.5
                    ]
                ],
                [
                    [
                        126.5,
                        88.72222222222223
                    ],
                    [
                        125.5,
                        88.5
                    ],
                    [
                        126.5,
                        88.35714285714286
                    ],
                    [
                        126.61764705882354,
                        88.5
                    ],
                    [
                        126.5,
                        88.72222222222223
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 120,
        "coordinates": [
            [
                [
                    [
                        159.83333333333334,
                        20.5
                    ],
                    [
                        159.5,
                        20.364864864864863
                    ],
                    [
                        158.66666666666666,
                        20.5
                    ],
                    [
                        159.5,
                        20.794117647058822
                    ],
                    [
                        159.83333333333334,
                        20.5
                    ]
                ]
            ],
            [
                [
                    [
                        90.58333333333333,
                        24.5
                    ],
                    [
                        91.5,
                        23.88888888888889
                    ],
                    [
                        92.2,
                        23.5
                    ],
                    [
                        91.5,
                        22.625
                    ],
                    [
                        91.375,
                        22.5
                    ],
                    [
                        90.5,
                        22.195652173913043
                    ],
                    [
                        89.5,
                        21.8125
                    ],
                    [
                        88.5,
                        21.6
                    ],
                    [
                        88.33333333333333,
                        21.5
                    ],
                    [
                        87.5,
                        21.166666666666668
                    ],
                    [
                        86.875,
                        21.5
                    ],
                    [
                        86.5,
                        21.928571428571427
                    ],
                    [
                        86.05555555555556,
                        22.5
                    ],
                    [
                        85.64285714285714,
                        23.5
                    ],
                    [
                        86.5,
                        24.357142857142858
                    ],
                    [
                        87.5,
                        23.681818181818183
                    ],
                    [
                        88.5,
                        23.8
                    ],
                    [
                        89.5,
                        24.166666666666668
                    ],
                    [
                        90.35714285714286,
                        24.5
                    ],
                    [
                        90.5,
                        24.5625
                    ],
                    [
                        90.58333333333333,
                        24.5
                    ]
                ]
            ],
            [
                [
                    [
                        159.9,
                        26.5
                    ],
                    [
                        159.5,
                        26.055555555555557
                    ],
                    [
                        159.26470588235293,
                        26.5
                    ],
                    [
                        159.5,
                        26.807692307692307
                    ],
                    [
                        159.9,
                        26.5
                    ]
                ]
            ],
            [
                [
                    [
                        102.5,
                        27.5
                    ],
                    [
                        102.60526315789474,
                        26.5
                    ],
                    [
                        102.5,
                        26.214285714285715
                    ],
                    [
                        101.94444444444444,
                        25.5
                    ],
                    [
                        101.5,
                        25.289473684210527
                    ],
                    [
                        100.5,
                        25.136363636363637
                    ],
                    [
                        99.96153846153847,
                        24.5
                    ],
                    [
                        99.5,
                        24.227272727272727
                    ],
                    [
                        98.5,
                        24.3
                    ],
                    [
                        98.22727272727273,
                        24.5
                    ],
                    [
                        98.5,
                        25.25
                    ],
                    [
                        98.7,
                        25.5
                    ],
                    [
                        99.5,
                        26
                    ],
                    [
                        100.3,
                        26.5
                    ],
                    [
                        100.5,
                        26.642857142857142
                    ],
                    [
                        101.5,
                        27.214285714285715
                    ],
                    [
                        102.5,
                        27.5
                    ],
                    [
                        102.5,
                        27.5
                    ],
                    [
                        102.5,
                        27.5
                    ]
                ]
            ],
            [
                [
                    [
                        116.67647058823529,
                        43.5
                    ],
                    [
                        116.5,
                        43.35
                    ],
                    [
                        115.5,
                        43.078947368421055
                    ],
                    [
                        114.5,
                        43.205882352941174
                    ],
                    [
                        114.1875,
                        43.5
                    ],
                    [
                        114.5,
                        44
                    ],
                    [
                        115.5,
                        44.11538461538461
                    ],
                    [
                        116.5,
                        43.8
                    ],
                    [
                        116.67647058823529,
                        43.5
                    ]
                ]
            ],
            [
                [
                    [
                        159.5,
                        87.5
                    ],
                    [
                        159.77272727272728,
                        86.5
                    ],
                    [
                        159.5,
                        86.39655172413794
                    ],
                    [
                        158.5,
                        86.46428571428571
                    ],
                    [
                        158.44444444444446,
                        86.5
                    ],
                    [
                        158.14285714285714,
                        87.5
                    ],
                    [
                        158.5,
                        87.73809523809524
                    ],
                    [
                        159.5,
                        87.5
                    ],
                    [
                        159.5,
                        87.5
                    ]
                ]
            ],
            [
                [
                    [
                        141.1153846153846,
                        91.5
                    ],
                    [
                        140.5,
                        91.18
                    ],
                    [
                        139.60526315789474,
                        90.5
                    ],
                    [
                        139.5,
                        90.42307692307692
                    ],
                    [
                        138.5,
                        89.68518518518519
                    ],
                    [
                        138.1875,
                        89.5
                    ],
                    [
                        137.5,
                        89.15625
                    ],
                    [
                        136.5,
                        88.92307692307692
                    ],
                    [
                        136.10714285714286,
                        88.5
                    ],
                    [
                        135.875,
                        87.5
                    ],
                    [
                        135.5,
                        86.75
                    ],
                    [
                        135.38,
                        86.5
                    ],
                    [
                        135.5,
                        85.5
                    ],
                    [
                        135.5,
                        85.5
                    ],
                    [
                        136.5,
                        84.63333333333334
                    ],
                    [
                        137,
                        84.5
                    ],
                    [
                        136.5,
                        84.21428571428571
                    ],
                    [
                        135.5,
                        84
                    ],
                    [
                        134.83333333333334,
                        83.5
                    ],
                    [
                        134.5,
                        83.16666666666667
                    ],
                    [
                        134.05555555555554,
                        82.5
                    ],
                    [
                        133.5,
                        82
                    ],
                    [
                        132.78571428571428,
                        81.5
                    ],
                    [
                        132.5,
                        81.31818181818181
                    ],
                    [
                        131.5,
                        80.7
                    ],
                    [
                        131.05555555555554,
                        80.5
                    ],
                    [
                        130.5,
                        80.04545454545455
                    ],
                    [
                        129.75,
                        79.5
                    ],
                    [
                        129.5,
                        79.35714285714286
                    ],
                    [
                        128.5,
                        78.875
                    ],
                    [
                        128,
                        78.5
                    ],
                    [
                        127.75,
                        77.5
                    ],
                    [
                        127.88888888888889,
                        76.5
                    ],
                    [
                        128.0625,
                        75.5
                    ],
                    [
                        128.42857142857142,
                        74.5
                    ],
                    [
                        128.5,
                        74.25
                    ],
                    [
                        128.71428571428572,
                        73.5
                    ],
                    [
                        129,
                        72.5
                    ],
                    [
                        129.5,
                        71.75
                    ],
                    [
                        129.73076923076923,
                        71.5
                    ],
                    [
                        129.86363636363637,
                        70.5
                    ],
                    [
                        129.5,
                        70.26470588235294
                    ],
                    [
                        128.5,
                        69.73076923076923
                    ],
                    [
                        127.5,
                        69.71428571428571
                    ],
                    [
                        126.5,
                        69.78571428571429
                    ],
                    [
                        126.03846153846153,
                        69.5
                    ],
                    [
                        125.5,
                        69.11111111111111
                    ],
                    [
                        124.5,
                        68.66
                    ],
                    [
                        124,
                        68.5
                    ],
                    [
                        123.5,
                        68.1923076923077
                    ],
                    [
                        122.6,
                        67.5
                    ],
                    [
                        123.05555555555556,
                        66.5
                    ],
                    [
                        123.5,
                        65.92857142857143
                    ],
                    [
                        123.75,
                        65.5
                    ],
                    [
                        124.02941176470588,
                        64.5
                    ],
                    [
                        124.5,
                        64.02941176470588
                    ],
                    [
                        125.1,
                        63.5
                    ],
                    [
                        125.5,
                        63.2
                    ],
                    [
                        126.5,
                        62.9
                    ],
                    [
                        127.3,
                        62.5
                    ],
                    [
                        126.77777777777777,
                        61.5
                    ],
                    [
                        127.5,
                        60.57142857142857
                    ],
                    [
                        128.5,
                        60.611111111111114
                    ],
                    [
                        129.5,
                        60.77272727272727
                    ],
                    [
                        130.5,
                        60.86842105263158
                    ],
                    [
                        131,
                        60.5
                    ],
                    [
                        130.5,
                        60
                    ],
                    [
                        129.625,
                        59.5
                    ],
                    [
                        129.75,
                        58.5
                    ],
                    [
                        130.5,
                        57.68181818181818
                    ],
                    [
                        130.63333333333333,
                        57.5
                    ],
                    [
                        131.1153846153846,
                        56.5
                    ],
                    [
                        130.8846153846154,
                        55.5
                    ],
                    [
                        130.5,
                        55.23684210526316
                    ],
                    [
                        129.5,
                        54.870370370370374
                    ],
                    [
                        128.5,
                        54.75925925925926
                    ],
                    [
                        127.5,
                        55.07142857142857
                    ],
                    [
                        126.97058823529412,
                        55.5
                    ],
                    [
                        126.5,
                        55.7962962962963
                    ],
                    [
                        125.5,
                        56.3125
                    ],
                    [
                        125.16666666666667,
                        56.5
                    ],
                    [
                        124.5,
                        57.04545454545455
                    ],
                    [
                        123.94444444444444,
                        57.5
                    ],
                    [
                        123.5,
                        57.86363636363637
                    ],
                    [
                        122.5,
                        58.3
                    ],
                    [
                        122.1,
                        58.5
                    ],
                    [
                        121.72222222222223,
                        59.5
                    ],
                    [
                        121.5,
                        60.166666666666664
                    ],
                    [
                        121.375,
                        60.5
                    ],
                    [
                        120.8,
                        61.5
                    ],
                    [
                        120.5,
                        62.5
                    ],
                    [
                        120.5,
                        62.5
                    ],
                    [
                        119.91666666666667,
                        63.5
                    ],
                    [
                        119.5,
                        63.95454545454545
                    ],
                    [
                        118.64285714285714,
                        64.5
                    ],
                    [
                        118.5,
                        64.61111111111111
                    ],
                    [
                        117.5,
                        64.75
                    ],
                    [
                        116.5,
                        64.64285714285714
                    ],
                    [
                        116.1,
                        64.5
                    ],
                    [
                        115.5,
                        64.25
                    ],
                    [
                        114.5,
                        63.80769230769231
                    ],
                    [
                        114.23333333333333,
                        63.5
                    ],
                    [
                        113.94444444444444,
                        62.5
                    ],
                    [
                        113.5,
                        62.13636363636363
                    ],
                    [
                        112.5,
                        61.63333333333333
                    ],
                    [
                        112.25,
                        61.5
                    ],
                    [
                        111.5,
                        61.2
                    ],
                    [
                        110.5,
                        61.11538461538461
                    ],
                    [
                        109.5,
                        61.01428571428571
                    ],
                    [
                        108.5,
                        61.15384615384615
                    ],
                    [
                        107.68181818181819,
                        61.5
                    ],
                    [
                        107.5,
                        61.595238095238095
                    ],
                    [
                        106.5,
                        62.026315789473685
                    ],
                    [
                        105.68181818181819,
                        62.5
                    ],
                    [
                        105.5,
                        62.611111111111114
                    ],
                    [
                        104.5,
                        63.25
                    ],
                    [
                        104.23333333333333,
                        63.5
                    ],
                    [
                        103.97058823529412,
                        64.5
                    ],
                    [
                        103.58333333333333,
                        65.5
                    ],
                    [
                        103.5,
                        65.61111111111111
                    ],
                    [
                        102.77272727272727,
                        66.5
                    ],
                    [
                        102.5,
                        66.8
                    ],
                    [
                        101.5,
                        67.31818181818181
                    ],
                    [
                        101.31818181818181,
                        67.5
                    ],
                    [
                        101.5,
                        68.16666666666667
                    ],
                    [
                        101.625,
                        68.5
                    ],
                    [
                        101.92857142857143,
                        69.5
                    ],
                    [
                        101.67647058823529,
                        70.5
                    ],
                    [
                        101.5,
                        71
                    ],
                    [
                        101.25,
                        70.5
                    ],
                    [
                        100.83333333333333,
                        69.5
                    ],
                    [
                        100.5,
                        69.07142857142857
                    ],
                    [
                        99.5,
                        68.5909090909091
                    ],
                    [
                        98.5,
                        68.72222222222223
                    ],
                    [
                        97.5,
                        68.66666666666667
                    ],
                    [
                        96.5,
                        68.9
                    ],
                    [
                        95.5,
                        68.6
                    ],
                    [
                        94.5,
                        68.57692307692308
                    ],
                    [
                        94,
                        68.5
                    ],
                    [
                        93.5,
                        68.42307692307692
                    ],
                    [
                        92.5,
                        67.97058823529412
                    ],
                    [
                        91.96666666666667,
                        67.5
                    ],
                    [
                        91.5,
                        67.19565217391305
                    ],
                    [
                        90.5,
                        66.92857142857143
                    ],
                    [
                        89.5,
                        66.92307692307692
                    ],
                    [
                        88.5,
                        67.1
                    ],
                    [
                        87.95454545454545,
                        67.5
                    ],
                    [
                        87.5,
                        68.33333333333333
                    ],
                    [
                        87.42307692307692,
                        68.5
                    ],
                    [
                        87.26923076923077,
                        69.5
                    ],
                    [
                        87.25,
                        70.5
                    ],
                    [
                        87.22727272727273,
                        71.5
                    ],
                    [
                        87.38888888888889,
                        72.5
                    ],
                    [
                        87.375,
                        73.5
                    ],
                    [
                        86.92857142857143,
                        74.5
                    ],
                    [
                        86.5,
                        75.25
                    ],
                    [
                        85.5,
                        75.5
                    ],
                    [
                        85.5,
                        75.5
                    ],
                    [
                        84.5,
                        75.92857142857143
                    ],
                    [
                        83.5,
                        76.33333333333333
                    ],
                    [
                        82.5,
                        76
                    ],
                    [
                        81.5,
                        75.9
                    ],
                    [
                        80.5,
                        76.5
                    ],
                    [
                        80.5,
                        76.5
                    ],
                    [
                        79.5,
                        76.83333333333333
                    ],
                    [
                        78.92857142857143,
                        77.5
                    ],
                    [
                        78.5,
                        78.1
                    ],
                    [
                        77.75,
                        77.5
                    ],
                    [
                        77.5,
                        77.25
                    ],
                    [
                        76.5,
                        77
                    ],
                    [
                        75.9,
                        77.5
                    ],
                    [
                        75.5,
                        77.9
                    ],
                    [
                        75.16666666666667,
                        78.5
                    ],
                    [
                        75.5,
                        79.25
                    ],
                    [
                        75.6,
                        79.5
                    ],
                    [
                        75.75,
                        80.5
                    ],
                    [
                        76.5,
                        81.35714285714286
                    ],
                    [
                        76.66666666666667,
                        81.5
                    ],
                    [
                        77.5,
                        82
                    ],
                    [
                        78.125,
                        82.5
                    ],
                    [
                        78.5,
                        82.875
                    ],
                    [
                        79.5,
                        83.5
                    ],
                    [
                        79.5,
                        83.5
                    ],
                    [
                        80.5,
                        83.5
                    ],
                    [
                        81.5,
                        83.5
                    ],
                    [
                        82.5,
                        83.875
                    ],
                    [
                        83.5,
                        83.75
                    ],
                    [
                        84.5,
                        83.75
                    ],
                    [
                        85.5,
                        83.5
                    ],
                    [
                        86.5,
                        83.83333333333333
                    ],
                    [
                        87.5,
                        84.5
                    ],
                    [
                        87.5,
                        84.5
                    ],
                    [
                        88.5,
                        85.5
                    ],
                    [
                        88.5,
                        85.5
                    ],
                    [
                        89.5,
                        86.125
                    ],
                    [
                        90.1,
                        86.5
                    ],
                    [
                        90.5,
                        86.9
                    ],
                    [
                        91.1,
                        87.5
                    ],
                    [
                        91.33333333333333,
                        88.5
                    ],
                    [
                        91.5,
                        88.7
                    ],
                    [
                        92.5,
                        88.83333333333333
                    ],
                    [
                        93,
                        88.5
                    ],
                    [
                        93.5,
                        88.375
                    ],
                    [
                        94.5,
                        88.2
                    ],
                    [
                        95.5,
                        87.94444444444444
                    ],
                    [
                        96.5,
                        87.77272727272727
                    ],
                    [
                        97.5,
                        87.68181818181819
                    ],
                    [
                        98.5,
                        87.7
                    ],
                    [
                        99.5,
                        88.16666666666667
                    ],
                    [
                        100.16666666666667,
                        88.5
                    ],
                    [
                        100.5,
                        88.66666666666667
                    ],
                    [
                        101.5,
                        89.1
                    ],
                    [
                        102.16666666666667,
                        89.5
                    ],
                    [
                        101.5,
                        89.65384615384616
                    ],
                    [
                        100.5,
                        90
                    ],
                    [
                        99.78571428571429,
                        90.5
                    ],
                    [
                        99.5,
                        90.9
                    ],
                    [
                        99.07142857142857,
                        91.5
                    ],
                    [
                        99.5,
                        92
                    ],
                    [
                        100.5,
                        92
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        127.45652173913044,
                        91.5
                    ],
                    [
                        126.97619047619048,
                        90.5
                    ],
                    [
                        126.5,
                        89.94444444444444
                    ],
                    [
                        125.5,
                        89.55
                    ],
                    [
                        125.42857142857143,
                        89.5
                    ],
                    [
                        124.5,
                        88.93478260869566
                    ],
                    [
                        123.66666666666667,
                        88.5
                    ],
                    [
                        124.5,
                        87.66666666666667
                    ],
                    [
                        125.5,
                        87.5
                    ],
                    [
                        125.5,
                        87.5
                    ],
                    [
                        126.5,
                        87.36363636363636
                    ],
                    [
                        126.625,
                        87.5
                    ],
                    [
                        127.5,
                        88.5
                    ],
                    [
                        127.5,
                        88.5
                    ],
                    [
                        127.94999999999999,
                        89.5
                    ],
                    [
                        128.5,
                        90.1470588235294
                    ],
                    [
                        128.78571428571428,
                        90.5
                    ],
                    [
                        129.35,
                        91.5
                    ],
                    [
                        129.5,
                        92
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.5,
                        92
                    ],
                    [
                        135.5,
                        92
                    ],
                    [
                        136.5,
                        92
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140.5,
                        92
                    ],
                    [
                        141.1153846153846,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 135,
        "coordinates": [
            [
                [
                    [
                        140,
                        91.5
                    ],
                    [
                        139.5,
                        91.15
                    ],
                    [
                        138.85,
                        90.5
                    ],
                    [
                        138.5,
                        90.24074074074075
                    ],
                    [
                        137.5,
                        89.73529411764706
                    ],
                    [
                        136.5,
                        89.5
                    ],
                    [
                        136.5,
                        89.5
                    ],
                    [
                        135.57142857142858,
                        88.5
                    ],
                    [
                        135.5,
                        88.25
                    ],
                    [
                        135.22727272727272,
                        87.5
                    ],
                    [
                        134.78,
                        86.5
                    ],
                    [
                        134.5625,
                        85.5
                    ],
                    [
                        134.5,
                        85.3
                    ],
                    [
                        134.21428571428572,
                        84.5
                    ],
                    [
                        133.5,
                        83.5
                    ],
                    [
                        133.5,
                        83.5
                    ],
                    [
                        132.5909090909091,
                        82.5
                    ],
                    [
                        132.5,
                        82.42857142857143
                    ],
                    [
                        131.57142857142858,
                        81.5
                    ],
                    [
                        131.5,
                        81.45
                    ],
                    [
                        130.5,
                        80.95454545454545
                    ],
                    [
                        129.875,
                        80.5
                    ],
                    [
                        129.5,
                        80.1842105263158
                    ],
                    [
                        128.5,
                        79.77777777777777
                    ],
                    [
                        127.875,
                        79.5
                    ],
                    [
                        127.5,
                        79.25
                    ],
                    [
                        127.05,
                        78.5
                    ],
                    [
                        126.88888888888889,
                        77.5
                    ],
                    [
                        127.13636363636364,
                        76.5
                    ],
                    [
                        127.1842105263158,
                        75.5
                    ],
                    [
                        127.38235294117646,
                        74.5
                    ],
                    [
                        127.5,
                        74.16666666666667
                    ],
                    [
                        127.75,
                        73.5
                    ],
                    [
                        128.14705882352942,
                        72.5
                    ],
                    [
                        128.5,
                        71.5
                    ],
                    [
                        128.5,
                        71.5
                    ],
                    [
                        128.5,
                        71.5
                    ],
                    [
                        127.5,
                        70.78571428571429
                    ],
                    [
                        126.5,
                        70.5
                    ],
                    [
                        126.5,
                        70.5
                    ],
                    [
                        125.5,
                        69.86363636363636
                    ],
                    [
                        124.92857142857143,
                        69.5
                    ],
                    [
                        124.5,
                        69.26
                    ],
                    [
                        123.5,
                        69.05
                    ],
                    [
                        122.5,
                        68.63333333333334
                    ],
                    [
                        122.375,
                        68.5
                    ],
                    [
                        121.8913043478261,
                        67.5
                    ],
                    [
                        122.22222222222223,
                        66.5
                    ],
                    [
                        122.5,
                        66
                    ],
                    [
                        122.85714285714286,
                        65.5
                    ],
                    [
                        123.1470588235294,
                        64.5
                    ],
                    [
                        123.5,
                        64.125
                    ],
                    [
                        124.125,
                        63.5
                    ],
                    [
                        124.5,
                        63.07142857142857
                    ],
                    [
                        125.38888888888889,
                        62.5
                    ],
                    [
                        125.5,
                        62.388888888888886
                    ],
                    [
                        125.94444444444444,
                        61.5
                    ],
                    [
                        125.91666666666667,
                        60.5
                    ],
                    [
                        126.5,
                        60.088235294117645
                    ],
                    [
                        127.5,
                        59.76315789473684
                    ],
                    [
                        127.85714285714286,
                        59.5
                    ],
                    [
                        128.5,
                        58.6
                    ],
                    [
                        128.57692307692307,
                        58.5
                    ],
                    [
                        129.5,
                        57.57692307692308
                    ],
                    [
                        129.57142857142858,
                        57.5
                    ],
                    [
                        130.03333333333333,
                        56.5
                    ],
                    [
                        129.66666666666666,
                        55.5
                    ],
                    [
                        129.5,
                        55.425925925925924
                    ],
                    [
                        128.5,
                        55.31481481481482
                    ],
                    [
                        128.04545454545453,
                        55.5
                    ],
                    [
                        127.5,
                        55.76086956521739
                    ],
                    [
                        126.5,
                        56.351851851851855
                    ],
                    [
                        126.25,
                        56.5
                    ],
                    [
                        125.5,
                        57.25
                    ],
                    [
                        125.21428571428571,
                        57.5
                    ],
                    [
                        124.5,
                        58.5
                    ],
                    [
                        124.5,
                        58.5
                    ],
                    [
                        123.64285714285714,
                        59.5
                    ],
                    [
                        123.5,
                        59.7
                    ],
                    [
                        123,
                        60.5
                    ],
                    [
                        122.5,
                        61
                    ],
                    [
                        122.16666666666667,
                        61.5
                    ],
                    [
                        121.5,
                        62.166666666666664
                    ],
                    [
                        121.28947368421052,
                        62.5
                    ],
                    [
                        120.92105263157895,
                        63.5
                    ],
                    [
                        120.64285714285714,
                        64.5
                    ],
                    [
                        120.5,
                        64.64285714285714
                    ],
                    [
                        119.83333333333333,
                        65.5
                    ],
                    [
                        119.5,
                        65.625
                    ],
                    [
                        118.5,
                        65.88888888888889
                    ],
                    [
                        117.5,
                        65.8157894736842
                    ],
                    [
                        116.5,
                        65.63636363636364
                    ],
                    [
                        116.07142857142857,
                        65.5
                    ],
                    [
                        115.5,
                        65.25
                    ],
                    [
                        114.5,
                        64.65384615384616
                    ],
                    [
                        114.1,
                        64.5
                    ],
                    [
                        113.5,
                        63.80769230769231
                    ],
                    [
                        113.21428571428571,
                        63.5
                    ],
                    [
                        112.5,
                        62.666666666666664
                    ],
                    [
                        112.38235294117646,
                        62.5
                    ],
                    [
                        111.5,
                        61.875
                    ],
                    [
                        110.5,
                        61.76315789473684
                    ],
                    [
                        109.78571428571429,
                        61.5
                    ],
                    [
                        109.5,
                        61.44285714285714
                    ],
                    [
                        109.25,
                        61.5
                    ],
                    [
                        108.5,
                        61.785714285714285
                    ],
                    [
                        107.5,
                        62.30952380952381
                    ],
                    [
                        107.1,
                        62.5
                    ],
                    [
                        106.5,
                        62.875
                    ],
                    [
                        105.5,
                        63.44444444444444
                    ],
                    [
                        105.41666666666667,
                        63.5
                    ],
                    [
                        104.77272727272727,
                        64.5
                    ],
                    [
                        104.625,
                        65.5
                    ],
                    [
                        104.5,
                        65.83333333333333
                    ],
                    [
                        103.96666666666667,
                        66.5
                    ],
                    [
                        103.5,
                        66.91176470588235
                    ],
                    [
                        102.94444444444444,
                        67.5
                    ],
                    [
                        102.77586206896552,
                        68.5
                    ],
                    [
                        102.76923076923077,
                        69.5
                    ],
                    [
                        102.55,
                        70.5
                    ],
                    [
                        102.5,
                        70.56666666666666
                    ],
                    [
                        101.96153846153847,
                        71.5
                    ],
                    [
                        101.8225806451613,
                        72.5
                    ],
                    [
                        101.7,
                        73.5
                    ],
                    [
                        102.5,
                        74.11538461538461
                    ],
                    [
                        103.05555555555556,
                        74.5
                    ],
                    [
                        103.5,
                        74.9
                    ],
                    [
                        104.5,
                        75.29411764705883
                    ],
                    [
                        105.5,
                        75.47297297297297
                    ],
                    [
                        105.6,
                        75.5
                    ],
                    [
                        105.5,
                        75.61111111111111
                    ],
                    [
                        104.5,
                        76.5
                    ],
                    [
                        104.5,
                        76.5
                    ],
                    [
                        103.5,
                        76.83333333333333
                    ],
                    [
                        103.38,
                        76.5
                    ],
                    [
                        102.64285714285714,
                        75.5
                    ],
                    [
                        102.5,
                        75.33333333333333
                    ],
                    [
                        101.5,
                        74.68181818181819
                    ],
                    [
                        101.28947368421052,
                        74.5
                    ],
                    [
                        101.21428571428571,
                        73.5
                    ],
                    [
                        100.5,
                        72.5
                    ],
                    [
                        100.5,
                        72.5
                    ],
                    [
                        100.04545454545455,
                        71.5
                    ],
                    [
                        99.5,
                        70.5
                    ],
                    [
                        99.5,
                        70.5
                    ],
                    [
                        99.5,
                        70.5
                    ],
                    [
                        98.5,
                        70.64285714285714
                    ],
                    [
                        98.16666666666667,
                        70.5
                    ],
                    [
                        97.5,
                        70.33333333333333
                    ],
                    [
                        96.5,
                        70.25
                    ],
                    [
                        95.5,
                        69.96153846153847
                    ],
                    [
                        94.5,
                        69.71428571428571
                    ],
                    [
                        94,
                        69.5
                    ],
                    [
                        93.5,
                        69.32352941176471
                    ],
                    [
                        92.5,
                        68.8529411764706
                    ],
                    [
                        92.1,
                        68.5
                    ],
                    [
                        91.5,
                        67.97058823529412
                    ],
                    [
                        90.61111111111111,
                        67.5
                    ],
                    [
                        90.5,
                        67.46428571428571
                    ],
                    [
                        89.5,
                        67.5
                    ],
                    [
                        89.5,
                        67.5
                    ],
                    [
                        88.9,
                        68.5
                    ],
                    [
                        89.125,
                        69.5
                    ],
                    [
                        88.85714285714286,
                        70.5
                    ],
                    [
                        88.79411764705883,
                        71.5
                    ],
                    [
                        88.83333333333333,
                        72.5
                    ],
                    [
                        88.72222222222223,
                        73.5
                    ],
                    [
                        88.83333333333333,
                        74.5
                    ],
                    [
                        88.5,
                        75.1
                    ],
                    [
                        88.27777777777777,
                        75.5
                    ],
                    [
                        87.75,
                        76.5
                    ],
                    [
                        87.5,
                        77.16666666666667
                    ],
                    [
                        87.33333333333333,
                        77.5
                    ],
                    [
                        86.75,
                        78.5
                    ],
                    [
                        86.5,
                        79
                    ],
                    [
                        85.5,
                        79.25
                    ],
                    [
                        84.5,
                        79.3
                    ],
                    [
                        84,
                        79.5
                    ],
                    [
                        83.5,
                        80.5
                    ],
                    [
                        83.5,
                        80.5
                    ],
                    [
                        83.5,
                        80.5
                    ],
                    [
                        84.5,
                        81
                    ],
                    [
                        85.5,
                        80.75
                    ],
                    [
                        86.5,
                        81
                    ],
                    [
                        86.83333333333333,
                        81.5
                    ],
                    [
                        87.5,
                        82.16666666666667
                    ],
                    [
                        88,
                        82.5
                    ],
                    [
                        88.5,
                        82.66666666666667
                    ],
                    [
                        89.5,
                        83.5
                    ],
                    [
                        89.5,
                        83.5
                    ],
                    [
                        90.5,
                        84.375
                    ],
                    [
                        90.66666666666667,
                        84.5
                    ],
                    [
                        91.5,
                        85.33333333333333
                    ],
                    [
                        91.7,
                        85.5
                    ],
                    [
                        92.5,
                        85.94444444444444
                    ],
                    [
                        93.5,
                        85.9
                    ],
                    [
                        94.5,
                        85.75
                    ],
                    [
                        95.5,
                        85.9
                    ],
                    [
                        96.5,
                        85.9
                    ],
                    [
                        97.5,
                        85.92857142857143
                    ],
                    [
                        98.5,
                        86.21428571428571
                    ],
                    [
                        99.5,
                        86.5
                    ],
                    [
                        99.5,
                        86.5
                    ],
                    [
                        100.5,
                        86.625
                    ],
                    [
                        101.5,
                        86.92857142857143
                    ],
                    [
                        102.5,
                        87.5
                    ],
                    [
                        102.5,
                        87.5
                    ],
                    [
                        103.5,
                        88.03333333333333
                    ],
                    [
                        104.2,
                        88.5
                    ],
                    [
                        104.5,
                        89.25
                    ],
                    [
                        104.75,
                        89.5
                    ],
                    [
                        104.5,
                        89.58333333333333
                    ],
                    [
                        103.5,
                        90.14285714285714
                    ],
                    [
                        102.5,
                        90.375
                    ],
                    [
                        102.16666666666667,
                        90.5
                    ],
                    [
                        101.5,
                        91.16666666666667
                    ],
                    [
                        101.1,
                        91.5
                    ],
                    [
                        101.5,
                        92
                    ],
                    [
                        102.5,
                        92
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.5,
                        92
                    ],
                    [
                        126.80434782608695,
                        91.5
                    ],
                    [
                        126.5,
                        90.91666666666667
                    ],
                    [
                        125.94444444444444,
                        90.5
                    ],
                    [
                        125.5,
                        90.3
                    ],
                    [
                        124.5,
                        89.65384615384616
                    ],
                    [
                        124.31818181818181,
                        89.5
                    ],
                    [
                        123.5,
                        89.0909090909091
                    ],
                    [
                        122.8157894736842,
                        88.5
                    ],
                    [
                        122.5,
                        87.5
                    ],
                    [
                        122.5,
                        87.5
                    ],
                    [
                        121.5,
                        86.5
                    ],
                    [
                        122.5,
                        85.9
                    ],
                    [
                        123.5,
                        86.5
                    ],
                    [
                        123.5,
                        86.5
                    ],
                    [
                        124.5,
                        86.88095238095238
                    ],
                    [
                        125.5,
                        86.75
                    ],
                    [
                        126.5,
                        86.68181818181819
                    ],
                    [
                        127.25,
                        87.5
                    ],
                    [
                        127.5,
                        87.78571428571429
                    ],
                    [
                        128.05555555555554,
                        88.5
                    ],
                    [
                        128.5,
                        89.25
                    ],
                    [
                        128.78571428571428,
                        89.5
                    ],
                    [
                        129.5,
                        90.5
                    ],
                    [
                        129.5,
                        90.5
                    ],
                    [
                        130.3,
                        91.5
                    ],
                    [
                        130.5,
                        92
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.5,
                        92
                    ],
                    [
                        134.34615384615384,
                        91.5
                    ],
                    [
                        134.5,
                        91.38235294117646
                    ],
                    [
                        135.5,
                        90.66666666666667
                    ],
                    [
                        136.5,
                        90.83333333333333
                    ],
                    [
                        137,
                        91.5
                    ],
                    [
                        137.5,
                        92
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        139.5,
                        92
                    ],
                    [
                        140,
                        91.5
                    ]
                ],
                [
                    [
                        105.5,
                        79.5
                    ],
                    [
                        104.5,
                        79.05555555555556
                    ],
                    [
                        104.26190476190476,
                        78.5
                    ],
                    [
                        104.5,
                        77.5
                    ],
                    [
                        105.5,
                        78.33333333333333
                    ],
                    [
                        105.71428571428571,
                        78.5
                    ],
                    [
                        105.5,
                        79.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 150,
        "coordinates": [
            [
                [
                    [
                        127.83333333333334,
                        58.5
                    ],
                    [
                        128.5,
                        57.833333333333336
                    ],
                    [
                        128.83333333333334,
                        57.5
                    ],
                    [
                        129.11111111111111,
                        56.5
                    ],
                    [
                        128.5,
                        55.976190476190474
                    ],
                    [
                        127.5,
                        56.41304347826087
                    ],
                    [
                        127.34615384615384,
                        56.5
                    ],
                    [
                        126.5,
                        57.078947368421055
                    ],
                    [
                        126.07894736842105,
                        57.5
                    ],
                    [
                        125.92857142857143,
                        58.5
                    ],
                    [
                        126.5,
                        59.11538461538461
                    ],
                    [
                        127.5,
                        58.911764705882355
                    ],
                    [
                        127.83333333333334,
                        58.5
                    ]
                ]
            ],
            [
                [
                    [
                        123.1875,
                        63.5
                    ],
                    [
                        123.5,
                        63.142857142857146
                    ],
                    [
                        124.0625,
                        62.5
                    ],
                    [
                        123.5,
                        61.6
                    ],
                    [
                        122.5,
                        62.023809523809526
                    ],
                    [
                        122.02380952380952,
                        62.5
                    ],
                    [
                        121.76666666666667,
                        63.5
                    ],
                    [
                        122.5,
                        64.23333333333333
                    ],
                    [
                        123.1875,
                        63.5
                    ]
                ]
            ],
            [
                [
                    [
                        101.5,
                        84.5
                    ],
                    [
                        102.5,
                        84.27777777777777
                    ],
                    [
                        103.5,
                        83.83333333333333
                    ],
                    [
                        103.83333333333333,
                        83.5
                    ],
                    [
                        104.5,
                        82.83333333333333
                    ],
                    [
                        104.75,
                        82.5
                    ],
                    [
                        105.38888888888889,
                        81.5
                    ],
                    [
                        105.04545454545455,
                        80.5
                    ],
                    [
                        104.5,
                        80.1470588235294
                    ],
                    [
                        103.65384615384616,
                        79.5
                    ],
                    [
                        103.54761904761905,
                        78.5
                    ],
                    [
                        103.5,
                        78.4
                    ],
                    [
                        102.9375,
                        77.5
                    ],
                    [
                        102.78,
                        76.5
                    ],
                    [
                        102.5,
                        76.15
                    ],
                    [
                        101.6875,
                        75.5
                    ],
                    [
                        101.5,
                        75.36363636363636
                    ],
                    [
                        100.5,
                        74.5
                    ],
                    [
                        100.5,
                        74.5
                    ],
                    [
                        99.5,
                        73.5
                    ],
                    [
                        99.5,
                        73.5
                    ],
                    [
                        98.5,
                        72.7
                    ],
                    [
                        98.25,
                        72.5
                    ],
                    [
                        97.5,
                        72.125
                    ],
                    [
                        96.66666666666667,
                        71.5
                    ],
                    [
                        96.5,
                        71.42307692307692
                    ],
                    [
                        95.5,
                        71.16666666666667
                    ],
                    [
                        94.5,
                        70.83333333333333
                    ],
                    [
                        93.83333333333333,
                        70.5
                    ],
                    [
                        93.5,
                        70.35714285714286
                    ],
                    [
                        92.5,
                        69.7
                    ],
                    [
                        92,
                        69.5
                    ],
                    [
                        91.5,
                        69.1
                    ],
                    [
                        90.5,
                        69.25
                    ],
                    [
                        90.42307692307692,
                        69.5
                    ],
                    [
                        89.8,
                        70.5
                    ],
                    [
                        89.63636363636364,
                        71.5
                    ],
                    [
                        89.9375,
                        72.5
                    ],
                    [
                        90.07142857142857,
                        73.5
                    ],
                    [
                        90.1923076923077,
                        74.5
                    ],
                    [
                        90.16666666666667,
                        75.5
                    ],
                    [
                        89.8,
                        76.5
                    ],
                    [
                        89.5,
                        77.5
                    ],
                    [
                        89.5,
                        77.5
                    ],
                    [
                        88.94444444444444,
                        78.5
                    ],
                    [
                        89.1,
                        79.5
                    ],
                    [
                        89.5,
                        79.83333333333333
                    ],
                    [
                        90.07142857142857,
                        80.5
                    ],
                    [
                        90.5,
                        81.1
                    ],
                    [
                        90.75,
                        81.5
                    ],
                    [
                        91.5,
                        82.5
                    ],
                    [
                        91.5,
                        82.5
                    ],
                    [
                        92,
                        83.5
                    ],
                    [
                        92.5,
                        83.75
                    ],
                    [
                        93.5,
                        84.1
                    ],
                    [
                        94.5,
                        84.42857142857143
                    ],
                    [
                        95.5,
                        84.5
                    ],
                    [
                        95.5,
                        84.5
                    ],
                    [
                        95.5,
                        84.5
                    ],
                    [
                        96.5,
                        84.375
                    ],
                    [
                        97.5,
                        84.26190476190476
                    ],
                    [
                        98.5,
                        84.20588235294117
                    ],
                    [
                        99.33333333333333,
                        84.5
                    ],
                    [
                        99.5,
                        84.61111111111111
                    ],
                    [
                        100.5,
                        84.625
                    ],
                    [
                        101.5,
                        84.5
                    ],
                    [
                        101.5,
                        84.5
                    ]
                ]
            ],
            [
                [
                    [
                        133.16666666666666,
                        91.5
                    ],
                    [
                        133.5,
                        91.27777777777777
                    ],
                    [
                        134.5,
                        90.5
                    ],
                    [
                        134.5,
                        90.5
                    ],
                    [
                        135.08823529411765,
                        89.5
                    ],
                    [
                        134.88095238095238,
                        88.5
                    ],
                    [
                        134.54545454545453,
                        87.5
                    ],
                    [
                        134.5,
                        87.38888888888889
                    ],
                    [
                        133.96666666666667,
                        86.5
                    ],
                    [
                        133.56666666666666,
                        85.5
                    ],
                    [
                        133.5,
                        85.33333333333333
                    ],
                    [
                        133.1153846153846,
                        84.5
                    ],
                    [
                        132.5625,
                        83.5
                    ],
                    [
                        132.5,
                        83.43333333333334
                    ],
                    [
                        131.56666666666666,
                        82.5
                    ],
                    [
                        131.5,
                        82.43333333333334
                    ],
                    [
                        130.5,
                        81.7
                    ],
                    [
                        130.3,
                        81.5
                    ],
                    [
                        129.5,
                        80.92857142857143
                    ],
                    [
                        128.5,
                        80.58
                    ],
                    [
                        128.25,
                        80.5
                    ],
                    [
                        127.5,
                        80.16666666666667
                    ],
                    [
                        126.5,
                        79.5
                    ],
                    [
                        126.5,
                        79.5
                    ],
                    [
                        126.21428571428571,
                        78.5
                    ],
                    [
                        125.96666666666667,
                        77.5
                    ],
                    [
                        126.44444444444444,
                        76.5
                    ],
                    [
                        126.38235294117646,
                        75.5
                    ],
                    [
                        126.5,
                        74.5
                    ],
                    [
                        126.5,
                        74.5
                    ],
                    [
                        126.8125,
                        73.5
                    ],
                    [
                        127.21428571428571,
                        72.5
                    ],
                    [
                        126.5,
                        71.5909090909091
                    ],
                    [
                        126.42307692307692,
                        71.5
                    ],
                    [
                        125.5,
                        70.57692307692308
                    ],
                    [
                        125.41666666666667,
                        70.5
                    ],
                    [
                        124.5,
                        69.95
                    ],
                    [
                        123.5,
                        69.71428571428571
                    ],
                    [
                        122.5,
                        69.5625
                    ],
                    [
                        122.39473684210526,
                        69.5
                    ],
                    [
                        121.5,
                        68.55555555555556
                    ],
                    [
                        121.45238095238095,
                        68.5
                    ],
                    [
                        121.23913043478261,
                        67.5
                    ],
                    [
                        121.33333333333333,
                        66.5
                    ],
                    [
                        120.5,
                        65.97368421052632
                    ],
                    [
                        119.5,
                        66.25
                    ],
                    [
                        118.9,
                        66.5
                    ],
                    [
                        118.5,
                        66.63333333333334
                    ],
                    [
                        117.5,
                        66.58
                    ],
                    [
                        117.16666666666667,
                        66.5
                    ],
                    [
                        116.5,
                        66.31818181818181
                    ],
                    [
                        115.5,
                        65.97826086956522
                    ],
                    [
                        115.12068965517241,
                        65.5
                    ],
                    [
                        114.5,
                        65.03846153846153
                    ],
                    [
                        113.5,
                        64.66216216216216
                    ],
                    [
                        113.07142857142857,
                        64.5
                    ],
                    [
                        112.5,
                        63.88461538461539
                    ],
                    [
                        112.16666666666667,
                        63.5
                    ],
                    [
                        111.5,
                        62.5
                    ],
                    [
                        111.5,
                        62.5
                    ],
                    [
                        111.5,
                        62.5
                    ],
                    [
                        110.5,
                        62.583333333333336
                    ],
                    [
                        109.8125,
                        63.5
                    ],
                    [
                        109.5,
                        63.638888888888886
                    ],
                    [
                        109.25,
                        63.5
                    ],
                    [
                        108.5,
                        62.5
                    ],
                    [
                        108.5,
                        62.5
                    ],
                    [
                        108.5,
                        62.5
                    ],
                    [
                        107.5,
                        62.92307692307692
                    ],
                    [
                        106.75,
                        63.5
                    ],
                    [
                        106.5,
                        63.66666666666667
                    ],
                    [
                        105.5,
                        64.43333333333334
                    ],
                    [
                        105.45454545454545,
                        64.5
                    ],
                    [
                        105.09375,
                        65.5
                    ],
                    [
                        104.75,
                        66.5
                    ],
                    [
                        104.5,
                        66.86842105263158
                    ],
                    [
                        103.79411764705883,
                        67.5
                    ],
                    [
                        103.5,
                        67.95454545454545
                    ],
                    [
                        103.29310344827586,
                        68.5
                    ],
                    [
                        103.34615384615384,
                        69.5
                    ],
                    [
                        103.3,
                        70.5
                    ],
                    [
                        102.55263157894737,
                        71.5
                    ],
                    [
                        102.5,
                        71.64285714285714
                    ],
                    [
                        102.30645161290323,
                        72.5
                    ],
                    [
                        102.45,
                        73.5
                    ],
                    [
                        102.5,
                        73.53846153846153
                    ],
                    [
                        103.5,
                        74.29411764705883
                    ],
                    [
                        103.86842105263158,
                        74.5
                    ],
                    [
                        104.5,
                        74.8529411764706
                    ],
                    [
                        105.5,
                        75.06756756756756
                    ],
                    [
                        106.5,
                        75.29310344827586
                    ],
                    [
                        107.5,
                        75.46666666666667
                    ],
                    [
                        108.5,
                        75.5
                    ],
                    [
                        108.5,
                        75.5
                    ],
                    [
                        109.5,
                        76.1
                    ],
                    [
                        110.16666666666667,
                        76.5
                    ],
                    [
                        109.5,
                        76.64285714285714
                    ],
                    [
                        108.5,
                        76.6875
                    ],
                    [
                        107.5,
                        77.03333333333333
                    ],
                    [
                        106.5,
                        77.03846153846153
                    ],
                    [
                        105.5,
                        77.5
                    ],
                    [
                        105.5,
                        77.5
                    ],
                    [
                        105.5,
                        77.5
                    ],
                    [
                        106.5,
                        78.1
                    ],
                    [
                        106.83333333333333,
                        78.5
                    ],
                    [
                        107.0625,
                        79.5
                    ],
                    [
                        107.5,
                        80.375
                    ],
                    [
                        107.61111111111111,
                        80.5
                    ],
                    [
                        108,
                        81.5
                    ],
                    [
                        108.5,
                        82.5
                    ],
                    [
                        108.25,
                        83.5
                    ],
                    [
                        107.5,
                        83.875
                    ],
                    [
                        106.5,
                        84.125
                    ],
                    [
                        105.5,
                        84.16666666666667
                    ],
                    [
                        104.5,
                        84.5
                    ],
                    [
                        104.5,
                        84.5
                    ],
                    [
                        103.625,
                        85.5
                    ],
                    [
                        103.5,
                        85.64285714285714
                    ],
                    [
                        103.03846153846153,
                        86.5
                    ],
                    [
                        103.5,
                        86.96153846153847
                    ],
                    [
                        103.81818181818181,
                        87.5
                    ],
                    [
                        104.5,
                        88.05555555555556
                    ],
                    [
                        105.20588235294117,
                        88.5
                    ],
                    [
                        105.5,
                        88.79411764705883
                    ],
                    [
                        106.5,
                        89.25
                    ],
                    [
                        107.5,
                        89.5
                    ],
                    [
                        106.5,
                        90.35714285714286
                    ],
                    [
                        105.5,
                        90.3
                    ],
                    [
                        105.07142857142857,
                        90.5
                    ],
                    [
                        104.5,
                        90.67391304347827
                    ],
                    [
                        103.5,
                        91.05555555555556
                    ],
                    [
                        102.77272727272727,
                        91.5
                    ],
                    [
                        103.5,
                        92
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        106.5,
                        92
                    ],
                    [
                        107.5,
                        92
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.5,
                        92
                    ],
                    [
                        126.1,
                        91.5
                    ],
                    [
                        125.5,
                        90.97826086956522
                    ],
                    [
                        124.5,
                        90.64285714285714
                    ],
                    [
                        124.23333333333333,
                        90.5
                    ],
                    [
                        123.5,
                        89.8529411764706
                    ],
                    [
                        122.83333333333333,
                        89.5
                    ],
                    [
                        122.5,
                        89.25
                    ],
                    [
                        122.05,
                        88.5
                    ],
                    [
                        121.5,
                        87.58333333333333
                    ],
                    [
                        121.375,
                        87.5
                    ],
                    [
                        120.5,
                        86.91666666666667
                    ],
                    [
                        119.66666666666667,
                        86.5
                    ],
                    [
                        119.5,
                        86.16666666666667
                    ],
                    [
                        119.31818181818181,
                        85.5
                    ],
                    [
                        119.5,
                        85.25
                    ],
                    [
                        120.25,
                        84.5
                    ],
                    [
                        120.5,
                        84.33333333333333
                    ],
                    [
                        121.5,
                        83.95454545454545
                    ],
                    [
                        122.5,
                        84.5
                    ],
                    [
                        122.5,
                        84.5
                    ],
                    [
                        123.34615384615384,
                        85.5
                    ],
                    [
                        123.5,
                        85.61764705882354
                    ],
                    [
                        124.5,
                        86.08823529411765
                    ],
                    [
                        125.5,
                        85.94444444444444
                    ],
                    [
                        126.5,
                        85.97619047619048
                    ],
                    [
                        127.28571428571429,
                        86.5
                    ],
                    [
                        127.5,
                        86.75
                    ],
                    [
                        127.9090909090909,
                        87.5
                    ],
                    [
                        128.5,
                        88.3125
                    ],
                    [
                        128.625,
                        88.5
                    ],
                    [
                        129.5,
                        89.3076923076923
                    ],
                    [
                        129.77777777777777,
                        89.5
                    ],
                    [
                        130.25,
                        90.5
                    ],
                    [
                        130.5,
                        90.79411764705883
                    ],
                    [
                        131.3,
                        91.5
                    ],
                    [
                        131.5,
                        92
                    ],
                    [
                        132.5,
                        92
                    ],
                    [
                        133.16666666666666,
                        91.5
                    ]
                ]
            ],
            [
                [
                    [
                        138.7,
                        91.5
                    ],
                    [
                        138.5,
                        91.3
                    ],
                    [
                        138.27777777777777,
                        91.5
                    ],
                    [
                        138.5,
                        92
                    ],
                    [
                        138.7,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 165,
        "coordinates": [
            [
                [
                    [
                        127.61111111111111,
                        57.5
                    ],
                    [
                        127.5,
                        57.42857142857143
                    ],
                    [
                        127.375,
                        57.5
                    ],
                    [
                        127.5,
                        57.611111111111114
                    ],
                    [
                        127.61111111111111,
                        57.5
                    ]
                ]
            ],
            [
                [
                    [
                        97.75,
                        83.5
                    ],
                    [
                        98.5,
                        83.38
                    ],
                    [
                        99.5,
                        83.41666666666667
                    ],
                    [
                        100.5,
                        83.45238095238095
                    ],
                    [
                        101.5,
                        83.35714285714286
                    ],
                    [
                        102.5,
                        82.83333333333333
                    ],
                    [
                        102.86363636363636,
                        82.5
                    ],
                    [
                        103.5,
                        81.5
                    ],
                    [
                        103.5,
                        81.5
                    ],
                    [
                        103.5,
                        81.5
                    ],
                    [
                        103.16666666666667,
                        80.5
                    ],
                    [
                        102.6875,
                        79.5
                    ],
                    [
                        102.5,
                        79
                    ],
                    [
                        102.26923076923077,
                        78.5
                    ],
                    [
                        101.5,
                        77.73076923076923
                    ],
                    [
                        101,
                        77.5
                    ],
                    [
                        100.5,
                        76.9
                    ],
                    [
                        100.1,
                        76.5
                    ],
                    [
                        99.5,
                        76.07142857142857
                    ],
                    [
                        98.7,
                        75.5
                    ],
                    [
                        98.5,
                        75.35714285714286
                    ],
                    [
                        97.95454545454545,
                        74.5
                    ],
                    [
                        97.5,
                        73.66666666666667
                    ],
                    [
                        97.38888888888889,
                        73.5
                    ],
                    [
                        96.5,
                        72.88461538461539
                    ],
                    [
                        95.875,
                        72.5
                    ],
                    [
                        95.5,
                        72.28571428571429
                    ],
                    [
                        94.5,
                        71.88888888888889
                    ],
                    [
                        93.5,
                        71.5952380952381
                    ],
                    [
                        93.35714285714286,
                        71.5
                    ],
                    [
                        92.57142857142857,
                        70.5
                    ],
                    [
                        92.5,
                        70.45
                    ],
                    [
                        91.5,
                        70.07894736842105
                    ],
                    [
                        90.61111111111111,
                        70.5
                    ],
                    [
                        90.5,
                        70.7
                    ],
                    [
                        90.31818181818181,
                        71.5
                    ],
                    [
                        90.5,
                        71.9
                    ],
                    [
                        90.8,
                        72.5
                    ],
                    [
                        91.14285714285714,
                        73.5
                    ],
                    [
                        91.07894736842105,
                        74.5
                    ],
                    [
                        91.3,
                        75.5
                    ],
                    [
                        91.03333333333333,
                        76.5
                    ],
                    [
                        90.73529411764706,
                        77.5
                    ],
                    [
                        90.66666666666667,
                        78.5
                    ],
                    [
                        90.92857142857143,
                        79.5
                    ],
                    [
                        91.3,
                        80.5
                    ],
                    [
                        91.5,
                        80.75
                    ],
                    [
                        92.25,
                        81.5
                    ],
                    [
                        92.5,
                        81.8
                    ],
                    [
                        93.13636363636364,
                        82.5
                    ],
                    [
                        93.5,
                        82.8076923076923
                    ],
                    [
                        94.5,
                        83.42
                    ],
                    [
                        95.16666666666667,
                        83.5
                    ],
                    [
                        95.5,
                        83.5625
                    ],
                    [
                        96,
                        83.5
                    ],
                    [
                        96.5,
                        83.46875
                    ],
                    [
                        97,
                        83.5
                    ],
                    [
                        97.5,
                        83.54761904761905
                    ],
                    [
                        97.75,
                        83.5
                    ]
                ]
            ],
            [
                [
                    [
                        133.42857142857142,
                        90.5
                    ],
                    [
                        133.5,
                        90.45454545454545
                    ],
                    [
                        134.30769230769232,
                        89.5
                    ],
                    [
                        134.23076923076923,
                        88.5
                    ],
                    [
                        133.72222222222223,
                        87.5
                    ],
                    [
                        133.5,
                        87.16666666666667
                    ],
                    [
                        132.5,
                        86.75
                    ],
                    [
                        131.5,
                        86.57692307692308
                    ],
                    [
                        130.5,
                        86.5
                    ],
                    [
                        130.5,
                        86.5
                    ],
                    [
                        130.5,
                        86.5
                    ],
                    [
                        129.5,
                        86.61764705882354
                    ],
                    [
                        128.61764705882354,
                        87.5
                    ],
                    [
                        129.25,
                        88.5
                    ],
                    [
                        129.5,
                        88.73076923076923
                    ],
                    [
                        130.5,
                        89.4
                    ],
                    [
                        130.61111111111111,
                        89.5
                    ],
                    [
                        131.125,
                        90.5
                    ],
                    [
                        131.5,
                        90.83333333333333
                    ],
                    [
                        132.5,
                        91.15
                    ],
                    [
                        133.42857142857142,
                        90.5
                    ]
                ]
            ],
            [
                [
                    [
                        105.5,
                        91.5
                    ],
                    [
                        105.5,
                        91.5
                    ],
                    [
                        104.5,
                        91.32608695652173
                    ],
                    [
                        104.13636363636364,
                        91.5
                    ],
                    [
                        104.5,
                        92
                    ],
                    [
                        105.5,
                        92
                    ],
                    [
                        105.5,
                        91.5
                    ]
                ]
            ],
            [
                [
                    [
                        125.25,
                        91.5
                    ],
                    [
                        124.5,
                        91.17857142857143
                    ],
                    [
                        123.5,
                        90.66666666666667
                    ],
                    [
                        123.28947368421052,
                        90.5
                    ],
                    [
                        122.5,
                        89.94444444444444
                    ],
                    [
                        121.5,
                        89.54347826086956
                    ],
                    [
                        121.3,
                        89.5
                    ],
                    [
                        120.92857142857143,
                        88.5
                    ],
                    [
                        120.5,
                        88.22727272727273
                    ],
                    [
                        119.61111111111111,
                        87.5
                    ],
                    [
                        119.5,
                        87.43333333333334
                    ],
                    [
                        118.625,
                        86.5
                    ],
                    [
                        118.5,
                        86.25
                    ],
                    [
                        117.64285714285714,
                        85.5
                    ],
                    [
                        117.5,
                        85
                    ],
                    [
                        117.375,
                        84.5
                    ],
                    [
                        117.5,
                        84.41666666666667
                    ],
                    [
                        118.5,
                        84.04545454545455
                    ],
                    [
                        119.5,
                        83.75
                    ],
                    [
                        119.875,
                        83.5
                    ],
                    [
                        120.5,
                        83.08333333333333
                    ],
                    [
                        121.5,
                        82.78571428571429
                    ],
                    [
                        122.5,
                        82.9
                    ],
                    [
                        123.25,
                        83.5
                    ],
                    [
                        123.5,
                        84
                    ],
                    [
                        123.68181818181819,
                        84.5
                    ],
                    [
                        124.5,
                        85.14285714285714
                    ],
                    [
                        125.5,
                        85.11111111111111
                    ],
                    [
                        126.5,
                        85.20588235294117
                    ],
                    [
                        127.125,
                        85.5
                    ],
                    [
                        127.5,
                        85.7
                    ],
                    [
                        128.5,
                        85.64285714285714
                    ],
                    [
                        128.83333333333334,
                        85.5
                    ],
                    [
                        129.5,
                        85.16666666666667
                    ],
                    [
                        130.5,
                        84.83333333333333
                    ],
                    [
                        131.5,
                        84.9
                    ],
                    [
                        131.72222222222223,
                        84.5
                    ],
                    [
                        131.5,
                        84.1
                    ],
                    [
                        131,
                        83.5
                    ],
                    [
                        130.5,
                        83
                    ],
                    [
                        130.22727272727272,
                        82.5
                    ],
                    [
                        129.5,
                        81.77272727272727
                    ],
                    [
                        129.22727272727272,
                        81.5
                    ],
                    [
                        128.5,
                        81.18
                    ],
                    [
                        127.5,
                        80.875
                    ],
                    [
                        126.5,
                        80.73529411764706
                    ],
                    [
                        126,
                        80.5
                    ],
                    [
                        125.66666666666667,
                        79.5
                    ],
                    [
                        125.5,
                        79.125
                    ],
                    [
                        125.23684210526316,
                        78.5
                    ],
                    [
                        125.02941176470588,
                        77.5
                    ],
                    [
                        125.5,
                        76.7
                    ],
                    [
                        125.61111111111111,
                        76.5
                    ],
                    [
                        125.5,
                        75.5
                    ],
                    [
                        125.5,
                        75.5
                    ],
                    [
                        125.42857142857143,
                        74.5
                    ],
                    [
                        125.45,
                        73.5
                    ],
                    [
                        125.5,
                        73.3
                    ],
                    [
                        125.94444444444444,
                        72.5
                    ],
                    [
                        125.5,
                        71.92857142857143
                    ],
                    [
                        125.33333333333333,
                        71.5
                    ],
                    [
                        124.5,
                        70.71052631578948
                    ],
                    [
                        124.13636363636364,
                        70.5
                    ],
                    [
                        123.5,
                        70.25
                    ],
                    [
                        122.5,
                        70.03125
                    ],
                    [
                        121.60526315789474,
                        69.5
                    ],
                    [
                        121.5,
                        69.38888888888889
                    ],
                    [
                        120.73809523809524,
                        68.5
                    ],
                    [
                        120.58695652173913,
                        67.5
                    ],
                    [
                        120.5,
                        67.21428571428571
                    ],
                    [
                        119.5,
                        66.92857142857143
                    ],
                    [
                        118.5,
                        67.13333333333334
                    ],
                    [
                        117.5,
                        67.18
                    ],
                    [
                        116.5,
                        67.02380952380952
                    ],
                    [
                        115.5,
                        66.6304347826087
                    ],
                    [
                        115.40322580645162,
                        66.5
                    ],
                    [
                        114.60344827586206,
                        65.5
                    ],
                    [
                        114.5,
                        65.42307692307692
                    ],
                    [
                        113.5,
                        65.06756756756756
                    ],
                    [
                        112.5,
                        64.79166666666667
                    ],
                    [
                        111.86363636363636,
                        64.5
                    ],
                    [
                        111.5,
                        64.05555555555556
                    ],
                    [
                        110.5,
                        63.66
                    ],
                    [
                        109.5,
                        64.05555555555556
                    ],
                    [
                        108.5,
                        63.5
                    ],
                    [
                        108.5,
                        63.5
                    ],
                    [
                        107.5,
                        63.5
                    ],
                    [
                        107.5,
                        63.5
                    ],
                    [
                        106.5,
                        64.16666666666667
                    ],
                    [
                        106.08333333333333,
                        64.5
                    ],
                    [
                        105.55555555555556,
                        65.5
                    ],
                    [
                        105.5,
                        65.75
                    ],
                    [
                        105.28571428571429,
                        66.5
                    ],
                    [
                        104.625,
                        67.5
                    ],
                    [
                        104.5,
                        67.58571428571429
                    ],
                    [
                        103.71951219512195,
                        68.5
                    ],
                    [
                        103.78947368421052,
                        69.5
                    ],
                    [
                        103.94,
                        70.5
                    ],
                    [
                        103.5,
                        71.28571428571429
                    ],
                    [
                        103.34210526315789,
                        71.5
                    ],
                    [
                        102.82142857142857,
                        72.5
                    ],
                    [
                        103.03846153846153,
                        73.5
                    ],
                    [
                        103.5,
                        73.8529411764706
                    ],
                    [
                        104.5,
                        74.39655172413794
                    ],
                    [
                        104.83333333333333,
                        74.5
                    ],
                    [
                        105.5,
                        74.66216216216216
                    ],
                    [
                        106.5,
                        74.77586206896552
                    ],
                    [
                        107.5,
                        74.96666666666667
                    ],
                    [
                        108.5,
                        74.875
                    ],
                    [
                        109.5,
                        74.79411764705883
                    ],
                    [
                        110.5,
                        75.04545454545455
                    ],
                    [
                        111.5,
                        75.125
                    ],
                    [
                        112.5,
                        75.15217391304348
                    ],
                    [
                        113.22727272727273,
                        75.5
                    ],
                    [
                        113.3125,
                        76.5
                    ],
                    [
                        113.41666666666667,
                        77.5
                    ],
                    [
                        113.07142857142857,
                        78.5
                    ],
                    [
                        112.5,
                        78.94444444444444
                    ],
                    [
                        111.5,
                        79.16666666666667
                    ],
                    [
                        110.5,
                        79.5
                    ],
                    [
                        110.5,
                        79.5
                    ],
                    [
                        109.83333333333333,
                        80.5
                    ],
                    [
                        109.5,
                        81
                    ],
                    [
                        109.31818181818181,
                        81.5
                    ],
                    [
                        109.5,
                        81.68181818181819
                    ],
                    [
                        110.1923076923077,
                        82.5
                    ],
                    [
                        110.5,
                        83.07142857142857
                    ],
                    [
                        111.5,
                        83.5
                    ],
                    [
                        110.5,
                        84
                    ],
                    [
                        110.07142857142857,
                        84.5
                    ],
                    [
                        109.5,
                        85.07142857142857
                    ],
                    [
                        108.5,
                        85.4
                    ],
                    [
                        108.16666666666667,
                        85.5
                    ],
                    [
                        107.5,
                        85.57407407407408
                    ],
                    [
                        106.5,
                        85.5
                    ],
                    [
                        106.5,
                        85.5
                    ],
                    [
                        106.5,
                        85.5
                    ],
                    [
                        105.5,
                        85.64814814814815
                    ],
                    [
                        104.5,
                        86.03333333333333
                    ],
                    [
                        104.0625,
                        86.5
                    ],
                    [
                        104.5,
                        87.5
                    ],
                    [
                        104.5,
                        87.5
                    ],
                    [
                        105.5,
                        88.2560975609756
                    ],
                    [
                        106.26923076923077,
                        88.5
                    ],
                    [
                        106.5,
                        88.625
                    ],
                    [
                        107.5,
                        88.61764705882354
                    ],
                    [
                        107.9,
                        88.5
                    ],
                    [
                        108.5,
                        88.32352941176471
                    ],
                    [
                        109.5,
                        88.125
                    ],
                    [
                        110.1,
                        88.5
                    ],
                    [
                        109.5,
                        89
                    ],
                    [
                        109.22727272727273,
                        89.5
                    ],
                    [
                        108.5,
                        89.86363636363636
                    ],
                    [
                        107.96153846153847,
                        90.5
                    ],
                    [
                        107.53703703703704,
                        91.5
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        124.5,
                        92
                    ],
                    [
                        125.25,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 180,
        "coordinates": [
            [
                [
                    [
                        92.125,
                        71.5
                    ],
                    [
                        91.5,
                        71.08333333333333
                    ],
                    [
                        91.1875,
                        71.5
                    ],
                    [
                        91.5,
                        72.33333333333333
                    ],
                    [
                        92.125,
                        71.5
                    ]
                ]
            ],
            [
                [
                    [
                        101.71428571428571,
                        82.5
                    ],
                    [
                        101.625,
                        81.5
                    ],
                    [
                        101.5,
                        80.5
                    ],
                    [
                        101.75,
                        79.5
                    ],
                    [
                        101.5,
                        79.05555555555556
                    ],
                    [
                        100.78571428571429,
                        78.5
                    ],
                    [
                        100.5,
                        78.35714285714286
                    ],
                    [
                        99.5,
                        77.68181818181819
                    ],
                    [
                        99.25,
                        77.5
                    ],
                    [
                        98.5,
                        76.9
                    ],
                    [
                        98.1,
                        76.5
                    ],
                    [
                        97.5,
                        75.95454545454545
                    ],
                    [
                        97.08333333333333,
                        75.5
                    ],
                    [
                        96.5,
                        74.5
                    ],
                    [
                        96.5,
                        74.5
                    ],
                    [
                        95.86363636363636,
                        73.5
                    ],
                    [
                        95.5,
                        73.25
                    ],
                    [
                        94.5,
                        72.65384615384616
                    ],
                    [
                        94,
                        72.5
                    ],
                    [
                        93.5,
                        72.30952380952381
                    ],
                    [
                        92.5,
                        71.8
                    ],
                    [
                        91.625,
                        72.5
                    ],
                    [
                        91.9,
                        73.5
                    ],
                    [
                        91.75,
                        74.5
                    ],
                    [
                        92.04545454545455,
                        75.5
                    ],
                    [
                        92,
                        76.5
                    ],
                    [
                        91.6,
                        77.5
                    ],
                    [
                        91.76315789473684,
                        78.5
                    ],
                    [
                        91.86842105263158,
                        79.5
                    ],
                    [
                        92.20588235294117,
                        80.5
                    ],
                    [
                        92.5,
                        80.79411764705883
                    ],
                    [
                        93.5,
                        81.5
                    ],
                    [
                        93.5,
                        81.5
                    ],
                    [
                        94.07894736842105,
                        82.5
                    ],
                    [
                        94.5,
                        82.82
                    ],
                    [
                        95.5,
                        83.11111111111111
                    ],
                    [
                        96.5,
                        83
                    ],
                    [
                        97.5,
                        82.8913043478261
                    ],
                    [
                        98.5,
                        82.78
                    ],
                    [
                        99.5,
                        82.79166666666667
                    ],
                    [
                        100.5,
                        82.73809523809524
                    ],
                    [
                        101.5,
                        82.64285714285714
                    ],
                    [
                        101.71428571428571,
                        82.5
                    ]
                ]
            ],
            [
                [
                    [
                        129.16666666666666,
                        83.5
                    ],
                    [
                        129.03333333333333,
                        82.5
                    ],
                    [
                        128.5,
                        81.96666666666667
                    ],
                    [
                        127.5,
                        81.5
                    ],
                    [
                        127.5,
                        81.5
                    ],
                    [
                        127.5,
                        81.5
                    ],
                    [
                        126.5,
                        81.7
                    ],
                    [
                        125.5,
                        82
                    ],
                    [
                        125.16666666666667,
                        81.5
                    ],
                    [
                        124.8125,
                        80.5
                    ],
                    [
                        124.9,
                        79.5
                    ],
                    [
                        124.5,
                        78.61111111111111
                    ],
                    [
                        124.44736842105263,
                        78.5
                    ],
                    [
                        124.2,
                        77.5
                    ],
                    [
                        124.5,
                        76.95454545454545
                    ],
                    [
                        124.77777777777777,
                        76.5
                    ],
                    [
                        124.5,
                        75.5
                    ],
                    [
                        124.5,
                        75.5
                    ],
                    [
                        124.4,
                        74.5
                    ],
                    [
                        124.5,
                        74.16666666666667
                    ],
                    [
                        124.7,
                        73.5
                    ],
                    [
                        124.76666666666667,
                        72.5
                    ],
                    [
                        124.5,
                        71.5
                    ],
                    [
                        124.5,
                        71.5
                    ],
                    [
                        123.5,
                        70.76666666666667
                    ],
                    [
                        122.5,
                        70.5
                    ],
                    [
                        122.5,
                        70.5
                    ],
                    [
                        121.5,
                        69.94827586206897
                    ],
                    [
                        120.95833333333333,
                        69.5
                    ],
                    [
                        120.5,
                        68.97619047619048
                    ],
                    [
                        119.83333333333333,
                        68.5
                    ],
                    [
                        119.5,
                        67.875
                    ],
                    [
                        118.5,
                        67.67391304347827
                    ],
                    [
                        117.5,
                        67.7258064516129
                    ],
                    [
                        116.5,
                        67.67857142857143
                    ],
                    [
                        116,
                        67.5
                    ],
                    [
                        115.5,
                        67.28260869565217
                    ],
                    [
                        114.91935483870968,
                        66.5
                    ],
                    [
                        114.5,
                        65.98
                    ],
                    [
                        113.57692307692308,
                        65.5
                    ],
                    [
                        113.5,
                        65.47297297297297
                    ],
                    [
                        112.5,
                        65.41666666666667
                    ],
                    [
                        111.5,
                        65.11111111111111
                    ],
                    [
                        110.8529411764706,
                        64.5
                    ],
                    [
                        110.5,
                        64.26
                    ],
                    [
                        109.5,
                        64.47222222222223
                    ],
                    [
                        108.5,
                        64.28947368421052
                    ],
                    [
                        107.5,
                        64.25
                    ],
                    [
                        107,
                        64.5
                    ],
                    [
                        106.5,
                        64.70833333333333
                    ],
                    [
                        105.97222222222223,
                        65.5
                    ],
                    [
                        105.68367346938776,
                        66.5
                    ],
                    [
                        105.5,
                        67.1
                    ],
                    [
                        105.25,
                        67.5
                    ],
                    [
                        104.5,
                        68.01428571428572
                    ],
                    [
                        104.08536585365853,
                        68.5
                    ],
                    [
                        104.1842105263158,
                        69.5
                    ],
                    [
                        104.5,
                        70.42307692307692
                    ],
                    [
                        104.52777777777777,
                        70.5
                    ],
                    [
                        104.5,
                        70.66666666666667
                    ],
                    [
                        104.20588235294117,
                        71.5
                    ],
                    [
                        103.5,
                        72.25
                    ],
                    [
                        103.35714285714286,
                        72.5
                    ],
                    [
                        103.5,
                        73.07142857142857
                    ],
                    [
                        103.71428571428571,
                        73.5
                    ],
                    [
                        104.5,
                        73.87931034482759
                    ],
                    [
                        105.5,
                        74.14
                    ],
                    [
                        106.5,
                        74.25
                    ],
                    [
                        107.5,
                        74.46
                    ],
                    [
                        108.5,
                        74.23913043478261
                    ],
                    [
                        109.5,
                        73.78571428571429
                    ],
                    [
                        110.16666666666667,
                        73.5
                    ],
                    [
                        110.5,
                        73.3
                    ],
                    [
                        110.66666666666667,
                        73.5
                    ],
                    [
                        111.5,
                        74.16666666666667
                    ],
                    [
                        112.5,
                        74.5
                    ],
                    [
                        112.5,
                        74.5
                    ],
                    [
                        113.5,
                        74.86842105263158
                    ],
                    [
                        114.5,
                        75.13636363636364
                    ],
                    [
                        114.9,
                        75.5
                    ],
                    [
                        114.73076923076923,
                        76.5
                    ],
                    [
                        114.65384615384616,
                        77.5
                    ],
                    [
                        114.5,
                        77.83333333333333
                    ],
                    [
                        114.25,
                        78.5
                    ],
                    [
                        113.73076923076923,
                        79.5
                    ],
                    [
                        113.5,
                        79.66666666666667
                    ],
                    [
                        112.5,
                        80.21428571428571
                    ],
                    [
                        112.05555555555556,
                        80.5
                    ],
                    [
                        111.94444444444444,
                        81.5
                    ],
                    [
                        112.5,
                        82
                    ],
                    [
                        113.5,
                        82.33333333333333
                    ],
                    [
                        113.75,
                        82.5
                    ],
                    [
                        114.5,
                        83.1
                    ],
                    [
                        115.5,
                        83.38888888888889
                    ],
                    [
                        116.5,
                        83.38235294117646
                    ],
                    [
                        117.5,
                        83.3
                    ],
                    [
                        118.5,
                        83
                    ],
                    [
                        119.4,
                        82.5
                    ],
                    [
                        119.5,
                        82.42307692307692
                    ],
                    [
                        120.42307692307692,
                        81.5
                    ],
                    [
                        120.5,
                        81.44117647058823
                    ],
                    [
                        120.83333333333333,
                        81.5
                    ],
                    [
                        121.5,
                        81.65384615384616
                    ],
                    [
                        122.5,
                        81.92105263157895
                    ],
                    [
                        123.5,
                        81.96153846153847
                    ],
                    [
                        124.27777777777777,
                        82.5
                    ],
                    [
                        124.5,
                        83
                    ],
                    [
                        124.78571428571429,
                        83.5
                    ],
                    [
                        125.5,
                        84.05555555555556
                    ],
                    [
                        126.5,
                        84.28571428571429
                    ],
                    [
                        127.5,
                        84.1875
                    ],
                    [
                        128.5,
                        84.07142857142857
                    ],
                    [
                        129.16666666666666,
                        83.5
                    ]
                ]
            ],
            [
                [
                    [
                        115.66666666666667,
                        85.5
                    ],
                    [
                        115.5,
                        84.5
                    ],
                    [
                        115.5,
                        84.5
                    ],
                    [
                        114.5,
                        84.5
                    ],
                    [
                        114.5,
                        84.5
                    ],
                    [
                        113.5,
                        85.5
                    ],
                    [
                        113.5,
                        85.5
                    ],
                    [
                        113.5,
                        85.5
                    ],
                    [
                        114.5,
                        85.5
                    ],
                    [
                        115.5,
                        86
                    ],
                    [
                        115.66666666666667,
                        85.5
                    ]
                ]
            ],
            [
                [
                    [
                        108.4,
                        87.5
                    ],
                    [
                        108.5,
                        86.5
                    ],
                    [
                        108.5,
                        86.5
                    ],
                    [
                        108.5,
                        86.5
                    ],
                    [
                        107.5,
                        86.12962962962963
                    ],
                    [
                        106.5,
                        85.94117647058823
                    ],
                    [
                        105.5,
                        86.20370370370371
                    ],
                    [
                        105,
                        86.5
                    ],
                    [
                        104.98387096774194,
                        87.5
                    ],
                    [
                        105.5,
                        87.89024390243902
                    ],
                    [
                        106.5,
                        88.13636363636364
                    ],
                    [
                        107.5,
                        87.9090909090909
                    ],
                    [
                        108.4,
                        87.5
                    ]
                ]
            ],
            [
                [
                    [
                        133.73076923076923,
                        89.5
                    ],
                    [
                        133.65384615384616,
                        88.5
                    ],
                    [
                        133.5,
                        88.23333333333333
                    ],
                    [
                        132.5,
                        87.6875
                    ],
                    [
                        131.5,
                        87.8
                    ],
                    [
                        130.5,
                        87.5
                    ],
                    [
                        130.5,
                        87.5
                    ],
                    [
                        129.5,
                        87.5
                    ],
                    [
                        129.5,
                        87.5
                    ],
                    [
                        129.5,
                        87.5
                    ],
                    [
                        130.25,
                        88.5
                    ],
                    [
                        130.5,
                        88.65
                    ],
                    [
                        131.44444444444446,
                        89.5
                    ],
                    [
                        131.5,
                        89.6
                    ],
                    [
                        132.5,
                        90.36666666666666
                    ],
                    [
                        133.5,
                        89.77272727272727
                    ],
                    [
                        133.73076923076923,
                        89.5
                    ]
                ]
            ],
            [
                [
                    [
                        123.95454545454545,
                        91.5
                    ],
                    [
                        123.5,
                        91.29166666666667
                    ],
                    [
                        122.5,
                        90.5
                    ],
                    [
                        122.5,
                        90.5
                    ],
                    [
                        121.5,
                        90.19565217391305
                    ],
                    [
                        120.5,
                        90.05
                    ],
                    [
                        119.5,
                        89.58333333333333
                    ],
                    [
                        119.35714285714286,
                        89.5
                    ],
                    [
                        118.75,
                        88.5
                    ],
                    [
                        118.5,
                        88.31818181818181
                    ],
                    [
                        117.5,
                        87.94444444444444
                    ],
                    [
                        116.5,
                        87.72222222222223
                    ],
                    [
                        115.5,
                        87.68181818181819
                    ],
                    [
                        114.5,
                        87.5
                    ],
                    [
                        114.5,
                        87.5
                    ],
                    [
                        113.5,
                        87.5
                    ],
                    [
                        113.5,
                        87.5
                    ],
                    [
                        112.5,
                        88
                    ],
                    [
                        112.125,
                        88.5
                    ],
                    [
                        111.5,
                        88.85714285714286
                    ],
                    [
                        110.5,
                        89.3125
                    ],
                    [
                        110.3,
                        89.5
                    ],
                    [
                        109.5,
                        89.77272727272727
                    ],
                    [
                        108.53030303030303,
                        90.5
                    ],
                    [
                        108.5,
                        90.58333333333333
                    ],
                    [
                        108.0925925925926,
                        91.5
                    ],
                    [
                        108.5,
                        92
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        121.5,
                        92
                    ],
                    [
                        122.5,
                        92
                    ],
                    [
                        123.5,
                        92
                    ],
                    [
                        123.95454545454545,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 195,
        "coordinates": [
            [
                [
                    [
                        96.64285714285714,
                        82.5
                    ],
                    [
                        97.5,
                        82.29310344827586
                    ],
                    [
                        98.5,
                        82.16666666666667
                    ],
                    [
                        99.5,
                        82.05555555555556
                    ],
                    [
                        100.5,
                        81.5
                    ],
                    [
                        100.5,
                        81.5
                    ],
                    [
                        100.5,
                        81.5
                    ],
                    [
                        100.42857142857143,
                        80.5
                    ],
                    [
                        100.13636363636364,
                        79.5
                    ],
                    [
                        99.5,
                        78.96153846153847
                    ],
                    [
                        98.5,
                        78.5625
                    ],
                    [
                        98.4090909090909,
                        78.5
                    ],
                    [
                        97.68181818181819,
                        77.5
                    ],
                    [
                        97.5,
                        77.31818181818181
                    ],
                    [
                        96.75,
                        76.5
                    ],
                    [
                        96.5,
                        76.22727272727273
                    ],
                    [
                        95.83333333333333,
                        75.5
                    ],
                    [
                        95.5,
                        74.7
                    ],
                    [
                        95.45,
                        74.5
                    ],
                    [
                        94.88888888888889,
                        73.5
                    ],
                    [
                        94.5,
                        73.23076923076923
                    ],
                    [
                        93.5,
                        72.87931034482759
                    ],
                    [
                        92.5,
                        73.5
                    ],
                    [
                        92.5,
                        73.5
                    ],
                    [
                        92.28571428571429,
                        74.5
                    ],
                    [
                        92.5,
                        75.04545454545455
                    ],
                    [
                        92.75,
                        75.5
                    ],
                    [
                        92.81818181818181,
                        76.5
                    ],
                    [
                        92.5,
                        77.2
                    ],
                    [
                        92.35,
                        77.5
                    ],
                    [
                        92.5,
                        78.25
                    ],
                    [
                        92.54347826086956,
                        78.5
                    ],
                    [
                        92.6875,
                        79.5
                    ],
                    [
                        93.5,
                        80.5
                    ],
                    [
                        93.5,
                        80.5
                    ],
                    [
                        94.33333333333333,
                        81.5
                    ],
                    [
                        94.5,
                        81.8
                    ],
                    [
                        95,
                        82.5
                    ],
                    [
                        95.5,
                        82.69444444444444
                    ],
                    [
                        96.5,
                        82.53125
                    ],
                    [
                        96.64285714285714,
                        82.5
                    ]
                ]
            ],
            [
                [
                    [
                        117.64285714285714,
                        82.5
                    ],
                    [
                        118.5,
                        82.16666666666667
                    ],
                    [
                        119.3,
                        81.5
                    ],
                    [
                        119.5,
                        81.3125
                    ],
                    [
                        120.5,
                        80.55882352941177
                    ],
                    [
                        121.5,
                        80.77777777777777
                    ],
                    [
                        122.5,
                        81.08823529411765
                    ],
                    [
                        123.5,
                        80.6
                    ],
                    [
                        123.5909090909091,
                        80.5
                    ],
                    [
                        124.11111111111111,
                        79.5
                    ],
                    [
                        123.65789473684211,
                        78.5
                    ],
                    [
                        123.5,
                        77.75
                    ],
                    [
                        123.41666666666667,
                        77.5
                    ],
                    [
                        123.5,
                        77.375
                    ],
                    [
                        123.91176470588235,
                        76.5
                    ],
                    [
                        123.5625,
                        75.5
                    ],
                    [
                        123.65,
                        74.5
                    ],
                    [
                        123.8125,
                        73.5
                    ],
                    [
                        123.95,
                        72.5
                    ],
                    [
                        123.81818181818181,
                        71.5
                    ],
                    [
                        123.5,
                        71.26666666666667
                    ],
                    [
                        122.5,
                        70.98387096774194
                    ],
                    [
                        121.5625,
                        70.5
                    ],
                    [
                        121.5,
                        70.46551724137932
                    ],
                    [
                        120.5,
                        69.65384615384616
                    ],
                    [
                        120.27777777777777,
                        69.5
                    ],
                    [
                        119.5,
                        68.91666666666667
                    ],
                    [
                        118.78571428571429,
                        68.5
                    ],
                    [
                        118.5,
                        68.32608695652173
                    ],
                    [
                        117.5,
                        68.20967741935483
                    ],
                    [
                        116.5,
                        68.21428571428571
                    ],
                    [
                        115.5,
                        68.08823529411765
                    ],
                    [
                        114.97368421052632,
                        67.5
                    ],
                    [
                        114.5,
                        66.68181818181819
                    ],
                    [
                        114.36666666666666,
                        66.5
                    ],
                    [
                        113.5,
                        66.01851851851852
                    ],
                    [
                        112.5,
                        66.04166666666667
                    ],
                    [
                        111.5,
                        65.83333333333333
                    ],
                    [
                        111.07894736842105,
                        65.5
                    ],
                    [
                        110.5,
                        64.95
                    ],
                    [
                        109.5,
                        64.91176470588235
                    ],
                    [
                        108.5,
                        64.80555555555556
                    ],
                    [
                        107.5,
                        64.8125
                    ],
                    [
                        106.5,
                        65.33333333333333
                    ],
                    [
                        106.38888888888889,
                        65.5
                    ],
                    [
                        105.98979591836735,
                        66.5
                    ],
                    [
                        105.71428571428571,
                        67.5
                    ],
                    [
                        105.5,
                        67.725
                    ],
                    [
                        104.5,
                        68.44285714285714
                    ],
                    [
                        104.45121951219512,
                        68.5
                    ],
                    [
                        104.5,
                        68.9
                    ],
                    [
                        104.57317073170732,
                        69.5
                    ],
                    [
                        104.94444444444444,
                        70.5
                    ],
                    [
                        104.87037037037037,
                        71.5
                    ],
                    [
                        104.56666666666666,
                        72.5
                    ],
                    [
                        105.3,
                        73.5
                    ],
                    [
                        105.5,
                        73.54
                    ],
                    [
                        106.5,
                        73.71428571428571
                    ],
                    [
                        107.5,
                        73.86
                    ],
                    [
                        108.5,
                        73.58695652173913
                    ],
                    [
                        108.65384615384616,
                        73.5
                    ],
                    [
                        109.5,
                        72.5
                    ],
                    [
                        109.5,
                        72.5
                    ],
                    [
                        110.5,
                        71.96153846153847
                    ],
                    [
                        111.5,
                        72.5
                    ],
                    [
                        111.5,
                        72.5
                    ],
                    [
                        112.125,
                        73.5
                    ],
                    [
                        112.5,
                        73.66666666666667
                    ],
                    [
                        113.5,
                        74.3048780487805
                    ],
                    [
                        114.5,
                        74.28947368421052
                    ],
                    [
                        115.5,
                        74.375
                    ],
                    [
                        115.92857142857143,
                        74.5
                    ],
                    [
                        116.31818181818181,
                        75.5
                    ],
                    [
                        115.83333333333333,
                        76.5
                    ],
                    [
                        115.7,
                        77.5
                    ],
                    [
                        115.5,
                        77.83333333333333
                    ],
                    [
                        115.07894736842105,
                        78.5
                    ],
                    [
                        114.76315789473684,
                        79.5
                    ],
                    [
                        114.5,
                        80
                    ],
                    [
                        113.5,
                        80.5
                    ],
                    [
                        113.5,
                        80.5
                    ],
                    [
                        113.5,
                        80.5
                    ],
                    [
                        114.5,
                        80.95454545454545
                    ],
                    [
                        114.92857142857143,
                        81.5
                    ],
                    [
                        115.5,
                        82.03333333333333
                    ],
                    [
                        116.5,
                        82.5
                    ],
                    [
                        116.5,
                        82.5
                    ],
                    [
                        117.5,
                        82.55
                    ],
                    [
                        117.64285714285714,
                        82.5
                    ]
                ]
            ],
            [
                [
                    [
                        107,
                        87.5
                    ],
                    [
                        106.94444444444444,
                        86.5
                    ],
                    [
                        106.5,
                        86.38235294117646
                    ],
                    [
                        106.13636363636364,
                        86.5
                    ],
                    [
                        105.5,
                        87.375
                    ],
                    [
                        105.46774193548387,
                        87.5
                    ],
                    [
                        105.5,
                        87.52439024390245
                    ],
                    [
                        106.5,
                        87.68181818181819
                    ],
                    [
                        107,
                        87.5
                    ]
                ]
            ],
            [
                [
                    [
                        120.7,
                        91.5
                    ],
                    [
                        120.5,
                        91.35714285714286
                    ],
                    [
                        119.5,
                        90.94444444444444
                    ],
                    [
                        118.7,
                        90.5
                    ],
                    [
                        118.5,
                        90.4
                    ],
                    [
                        117.5,
                        89.86363636363636
                    ],
                    [
                        116.92857142857143,
                        89.5
                    ],
                    [
                        116.5,
                        89.22727272727273
                    ],
                    [
                        115.5,
                        88.92857142857143
                    ],
                    [
                        114.5,
                        89.02941176470588
                    ],
                    [
                        113.5,
                        89.05
                    ],
                    [
                        112.5,
                        89.35714285714286
                    ],
                    [
                        112.25,
                        89.5
                    ],
                    [
                        111.5,
                        89.62765957446808
                    ],
                    [
                        110.5,
                        89.74489795918367
                    ],
                    [
                        109.5,
                        90.11363636363636
                    ],
                    [
                        108.98484848484848,
                        90.5
                    ],
                    [
                        108.6,
                        91.5
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.5,
                        92
                    ],
                    [
                        118.5,
                        92
                    ],
                    [
                        119.5,
                        92
                    ],
                    [
                        120.5,
                        92
                    ],
                    [
                        120.7,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 210,
        "coordinates": [
            [
                [
                    [
                        98.66666666666667,
                        81.5
                    ],
                    [
                        99.34615384615384,
                        80.5
                    ],
                    [
                        98.5,
                        79.5
                    ],
                    [
                        98.5,
                        79.5
                    ],
                    [
                        97.5,
                        79
                    ],
                    [
                        97.14285714285714,
                        78.5
                    ],
                    [
                        96.5,
                        77.6
                    ],
                    [
                        96.42307692307692,
                        77.5
                    ],
                    [
                        95.5,
                        76.64285714285714
                    ],
                    [
                        95.27777777777777,
                        76.5
                    ],
                    [
                        94.76666666666667,
                        75.5
                    ],
                    [
                        94.7,
                        74.5
                    ],
                    [
                        94.5,
                        74.16666666666667
                    ],
                    [
                        93.77272727272727,
                        73.5
                    ],
                    [
                        93.5,
                        73.39655172413794
                    ],
                    [
                        93.33333333333333,
                        73.5
                    ],
                    [
                        93.02941176470588,
                        74.5
                    ],
                    [
                        93.5,
                        75.5
                    ],
                    [
                        93.5,
                        76.5
                    ],
                    [
                        93.3,
                        77.5
                    ],
                    [
                        93.19565217391305,
                        78.5
                    ],
                    [
                        93.5,
                        79.27777777777777
                    ],
                    [
                        93.66666666666667,
                        79.5
                    ],
                    [
                        94.5,
                        80.16666666666667
                    ],
                    [
                        94.95454545454545,
                        80.5
                    ],
                    [
                        95.25,
                        81.5
                    ],
                    [
                        95.5,
                        81.83333333333333
                    ],
                    [
                        96.5,
                        81.96153846153847
                    ],
                    [
                        97.5,
                        81.77586206896552
                    ],
                    [
                        98.5,
                        81.54166666666667
                    ],
                    [
                        98.66666666666667,
                        81.5
                    ]
                ]
            ],
            [
                [
                    [
                        118.07142857142857,
                        81.5
                    ],
                    [
                        118.5,
                        81.28571428571429
                    ],
                    [
                        119.34615384615384,
                        80.5
                    ],
                    [
                        119.5,
                        80.375
                    ],
                    [
                        120.5,
                        79.56666666666666
                    ],
                    [
                        121.5,
                        79.875
                    ],
                    [
                        122.5,
                        80.11538461538461
                    ],
                    [
                        123.16666666666667,
                        79.5
                    ],
                    [
                        122.5,
                        78.7
                    ],
                    [
                        122.35714285714286,
                        78.5
                    ],
                    [
                        122.3,
                        77.5
                    ],
                    [
                        122.5,
                        77.1
                    ],
                    [
                        122.92857142857143,
                        76.5
                    ],
                    [
                        122.83333333333333,
                        75.5
                    ],
                    [
                        122.75,
                        74.5
                    ],
                    [
                        123.06521739130434,
                        73.5
                    ],
                    [
                        123.26,
                        72.5
                    ],
                    [
                        122.61111111111111,
                        71.5
                    ],
                    [
                        122.5,
                        71.46774193548387
                    ],
                    [
                        121.5,
                        71.03846153846153
                    ],
                    [
                        120.83333333333333,
                        70.5
                    ],
                    [
                        120.5,
                        70.23076923076923
                    ],
                    [
                        119.5,
                        69.54761904761905
                    ],
                    [
                        119.42857142857143,
                        69.5
                    ],
                    [
                        118.5,
                        68.95833333333333
                    ],
                    [
                        117.5,
                        68.74
                    ],
                    [
                        116.5,
                        68.80434782608695
                    ],
                    [
                        115.5,
                        68.83333333333333
                    ],
                    [
                        114.88461538461539,
                        68.5
                    ],
                    [
                        114.5,
                        68.04545454545455
                    ],
                    [
                        114.03846153846153,
                        67.5
                    ],
                    [
                        113.5,
                        66.72222222222223
                    ],
                    [
                        112.5,
                        66.66666666666667
                    ],
                    [
                        111.7,
                        66.5
                    ],
                    [
                        111.5,
                        66.45833333333333
                    ],
                    [
                        110.5,
                        65.75
                    ],
                    [
                        110.05555555555556,
                        65.5
                    ],
                    [
                        109.5,
                        65.3529411764706
                    ],
                    [
                        108.5,
                        65.22222222222223
                    ],
                    [
                        107.5,
                        65.28125
                    ],
                    [
                        107.11111111111111,
                        65.5
                    ],
                    [
                        106.5,
                        66.02380952380952
                    ],
                    [
                        106.29591836734694,
                        66.5
                    ],
                    [
                        106.07142857142857,
                        67.5
                    ],
                    [
                        105.5,
                        68.1
                    ],
                    [
                        104.94827586206897,
                        68.5
                    ],
                    [
                        104.9390243902439,
                        69.5
                    ],
                    [
                        105.36111111111111,
                        70.5
                    ],
                    [
                        105.42592592592592,
                        71.5
                    ],
                    [
                        105.5,
                        72.16666666666667
                    ],
                    [
                        105.56666666666666,
                        72.5
                    ],
                    [
                        106.5,
                        73.1086956521739
                    ],
                    [
                        107.5,
                        73.28571428571429
                    ],
                    [
                        108.5,
                        72.77777777777777
                    ],
                    [
                        108.75,
                        72.5
                    ],
                    [
                        109.46153846153847,
                        71.5
                    ],
                    [
                        109.5,
                        71.46
                    ],
                    [
                        110.5,
                        71.1086956521739
                    ],
                    [
                        111.5,
                        70.9375
                    ],
                    [
                        112,
                        71.5
                    ],
                    [
                        112.1,
                        72.5
                    ],
                    [
                        112.5,
                        72.95454545454545
                    ],
                    [
                        112.9,
                        73.5
                    ],
                    [
                        113.5,
                        73.9390243902439
                    ],
                    [
                        114.5,
                        73.89473684210526
                    ],
                    [
                        115.5,
                        73.75
                    ],
                    [
                        116.5,
                        73.58333333333333
                    ],
                    [
                        117.5,
                        74.1
                    ],
                    [
                        117.7,
                        74.5
                    ],
                    [
                        117.5909090909091,
                        75.5
                    ],
                    [
                        117.5,
                        75.625
                    ],
                    [
                        116.91666666666667,
                        76.5
                    ],
                    [
                        116.5,
                        77.33333333333333
                    ],
                    [
                        116.45,
                        77.5
                    ],
                    [
                        115.91176470588235,
                        78.5
                    ],
                    [
                        115.57692307692308,
                        79.5
                    ],
                    [
                        115.5,
                        80.5
                    ],
                    [
                        115.5,
                        80.5
                    ],
                    [
                        115.5,
                        80.5
                    ],
                    [
                        116.2,
                        81.5
                    ],
                    [
                        116.5,
                        81.66666666666667
                    ],
                    [
                        117.5,
                        81.72222222222223
                    ],
                    [
                        118.07142857142857,
                        81.5
                    ]
                ]
            ],
            [
                [
                    [
                        117.1,
                        91.5
                    ],
                    [
                        116.5,
                        90.9
                    ],
                    [
                        116.36666666666666,
                        90.5
                    ],
                    [
                        115.5,
                        89.85
                    ],
                    [
                        114.5,
                        89.81818181818181
                    ],
                    [
                        113.5,
                        89.66666666666667
                    ],
                    [
                        112.5,
                        89.83333333333333
                    ],
                    [
                        111.5,
                        89.94680851063829
                    ],
                    [
                        110.5,
                        90.05102040816327
                    ],
                    [
                        109.5,
                        90.45454545454545
                    ],
                    [
                        109.43939393939394,
                        90.5
                    ],
                    [
                        108.975,
                        91.5
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        116.5,
                        92
                    ],
                    [
                        117.1,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 225,
        "coordinates": [
            [
                [
                    [
                        95.95454545454545,
                        78.5
                    ],
                    [
                        95.5,
                        77.875
                    ],
                    [
                        94.5,
                        77.77272727272727
                    ],
                    [
                        94,
                        78.5
                    ],
                    [
                        94.5,
                        79.11538461538461
                    ],
                    [
                        95.5,
                        79.33333333333333
                    ],
                    [
                        95.95454545454545,
                        78.5
                    ]
                ]
            ],
            [
                [
                    [
                        98.13636363636364,
                        80.5
                    ],
                    [
                        97.5,
                        80.08823529411765
                    ],
                    [
                        96.5,
                        80
                    ],
                    [
                        96.1,
                        80.5
                    ],
                    [
                        96.5,
                        81.16666666666667
                    ],
                    [
                        97.5,
                        81
                    ],
                    [
                        98.13636363636364,
                        80.5
                    ]
                ]
            ],
            [
                [
                    [
                        117.92857142857143,
                        80.5
                    ],
                    [
                        118.5,
                        80.25
                    ],
                    [
                        119.42307692307692,
                        79.5
                    ],
                    [
                        119.5,
                        79.43333333333334
                    ],
                    [
                        120.5,
                        78.67647058823529
                    ],
                    [
                        121,
                        78.5
                    ],
                    [
                        121.5,
                        77.75
                    ],
                    [
                        121.55,
                        77.5
                    ],
                    [
                        122.02631578947368,
                        76.5
                    ],
                    [
                        122.05555555555556,
                        75.5
                    ],
                    [
                        122.12068965517241,
                        74.5
                    ],
                    [
                        122.44117647058823,
                        73.5
                    ],
                    [
                        122.5,
                        73.16666666666667
                    ],
                    [
                        122.66,
                        72.5
                    ],
                    [
                        122.5,
                        72.27777777777777
                    ],
                    [
                        121.5,
                        71.61538461538461
                    ],
                    [
                        121.25,
                        71.5
                    ],
                    [
                        120.5,
                        70.97058823529412
                    ],
                    [
                        119.88461538461539,
                        70.5
                    ],
                    [
                        119.5,
                        70.26190476190476
                    ],
                    [
                        118.5,
                        69.61764705882354
                    ],
                    [
                        118.16666666666667,
                        69.5
                    ],
                    [
                        117.5,
                        69.34
                    ],
                    [
                        116.5,
                        69.45652173913044
                    ],
                    [
                        115.5,
                        69.45833333333333
                    ],
                    [
                        114.5,
                        68.9
                    ],
                    [
                        113.5,
                        69.1875
                    ],
                    [
                        112.58333333333333,
                        68.5
                    ],
                    [
                        112.88461538461539,
                        67.5
                    ],
                    [
                        112.5,
                        67.29166666666667
                    ],
                    [
                        111.5,
                        67.01851851851852
                    ],
                    [
                        110.5,
                        66.62
                    ],
                    [
                        110.25,
                        66.5
                    ],
                    [
                        109.5,
                        66.02631578947368
                    ],
                    [
                        108.5,
                        65.65151515151516
                    ],
                    [
                        107.5,
                        65.75806451612904
                    ],
                    [
                        106.67857142857143,
                        66.5
                    ],
                    [
                        106.5,
                        67.125
                    ],
                    [
                        106.42857142857143,
                        67.5
                    ],
                    [
                        105.5,
                        68.475
                    ],
                    [
                        105.46551724137932,
                        68.5
                    ],
                    [
                        105.3048780487805,
                        69.5
                    ],
                    [
                        105.5,
                        69.94444444444444
                    ],
                    [
                        105.73809523809524,
                        70.5
                    ],
                    [
                        105.88235294117646,
                        71.5
                    ],
                    [
                        106.5,
                        72.45454545454545
                    ],
                    [
                        106.625,
                        72.5
                    ],
                    [
                        107.5,
                        72.75
                    ],
                    [
                        107.91176470588235,
                        72.5
                    ],
                    [
                        108.5,
                        72
                    ],
                    [
                        108.88461538461539,
                        71.5
                    ],
                    [
                        109.5,
                        70.86
                    ],
                    [
                        110.4,
                        70.5
                    ],
                    [
                        110.5,
                        70.45652173913044
                    ],
                    [
                        111.5,
                        69.83333333333333
                    ],
                    [
                        112.5,
                        70.16666666666667
                    ],
                    [
                        112.57692307692308,
                        70.5
                    ],
                    [
                        112.73076923076923,
                        71.5
                    ],
                    [
                        112.61111111111111,
                        72.5
                    ],
                    [
                        113.4,
                        73.5
                    ],
                    [
                        113.5,
                        73.57317073170732
                    ],
                    [
                        114.5,
                        73.5
                    ],
                    [
                        114.5,
                        73.5
                    ],
                    [
                        115.5,
                        73.1896551724138
                    ],
                    [
                        116.5,
                        72.76315789473684
                    ],
                    [
                        117.5,
                        72.5
                    ],
                    [
                        118.5,
                        72.8
                    ],
                    [
                        118.9375,
                        73.5
                    ],
                    [
                        118.79166666666667,
                        74.5
                    ],
                    [
                        118.77777777777777,
                        75.5
                    ],
                    [
                        118.5,
                        76.21428571428571
                    ],
                    [
                        118.3,
                        76.5
                    ],
                    [
                        117.5,
                        77.38888888888889
                    ],
                    [
                        117.43333333333334,
                        77.5
                    ],
                    [
                        116.8125,
                        78.5
                    ],
                    [
                        116.77272727272727,
                        79.5
                    ],
                    [
                        117,
                        80.5
                    ],
                    [
                        117.5,
                        80.71428571428571
                    ],
                    [
                        117.92857142857143,
                        80.5
                    ]
                ]
            ],
            [
                [
                    [
                        115.7,
                        91.5
                    ],
                    [
                        115.5,
                        90.9
                    ],
                    [
                        114.5,
                        90.5
                    ],
                    [
                        114.5,
                        90.5
                    ],
                    [
                        113.5,
                        90.08333333333333
                    ],
                    [
                        112.5,
                        90.21794871794872
                    ],
                    [
                        111.5,
                        90.26595744680851
                    ],
                    [
                        110.5,
                        90.35714285714286
                    ],
                    [
                        110.15,
                        90.5
                    ],
                    [
                        109.5,
                        91.1842105263158
                    ],
                    [
                        109.35,
                        91.5
                    ],
                    [
                        109.5,
                        92
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        115.5,
                        92
                    ],
                    [
                        115.7,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 240,
        "coordinates": [
            [
                [
                    [
                        108.3076923076923,
                        71.5
                    ],
                    [
                        108.5,
                        71.29166666666667
                    ],
                    [
                        109.26,
                        70.5
                    ],
                    [
                        109.5,
                        70.31818181818181
                    ],
                    [
                        110.5,
                        69.80434782608695
                    ],
                    [
                        110.88888888888889,
                        69.5
                    ],
                    [
                        111.45833333333333,
                        68.5
                    ],
                    [
                        111.27777777777777,
                        67.5
                    ],
                    [
                        110.5,
                        67.22
                    ],
                    [
                        109.5,
                        66.9
                    ],
                    [
                        109.1842105263158,
                        66.5
                    ],
                    [
                        108.5,
                        66.10606060606061
                    ],
                    [
                        107.5,
                        66.24193548387096
                    ],
                    [
                        107.21428571428571,
                        66.5
                    ],
                    [
                        106.82432432432432,
                        67.5
                    ],
                    [
                        106.5,
                        67.96153846153847
                    ],
                    [
                        106,
                        68.5
                    ],
                    [
                        105.7,
                        69.5
                    ],
                    [
                        106.0952380952381,
                        70.5
                    ],
                    [
                        106.32352941176471,
                        71.5
                    ],
                    [
                        106.5,
                        71.77272727272727
                    ],
                    [
                        107.5,
                        72.22413793103448
                    ],
                    [
                        108.3076923076923,
                        71.5
                    ]
                ]
            ],
            [
                [
                    [
                        115.83333333333333,
                        72.5
                    ],
                    [
                        116.5,
                        71.5
                    ],
                    [
                        116.5,
                        71.5
                    ],
                    [
                        117.5,
                        70.94444444444444
                    ],
                    [
                        118.5,
                        70.5
                    ],
                    [
                        118.5,
                        70.5
                    ],
                    [
                        118.5,
                        70.5
                    ],
                    [
                        117.5,
                        70.23333333333333
                    ],
                    [
                        116.5,
                        70.43333333333334
                    ],
                    [
                        115.5,
                        70.2
                    ],
                    [
                        114.5,
                        69.5
                    ],
                    [
                        114.5,
                        69.5
                    ],
                    [
                        114.5,
                        69.5
                    ],
                    [
                        113.67647058823529,
                        70.5
                    ],
                    [
                        113.5,
                        70.875
                    ],
                    [
                        113.3076923076923,
                        71.5
                    ],
                    [
                        112.94444444444444,
                        72.5
                    ],
                    [
                        113.5,
                        73.17567567567568
                    ],
                    [
                        114.5,
                        73.14285714285714
                    ],
                    [
                        115.5,
                        72.67241379310344
                    ],
                    [
                        115.83333333333333,
                        72.5
                    ]
                ]
            ],
            [
                [
                    [
                        119.375,
                        78.5
                    ],
                    [
                        119.5,
                        78.4375
                    ],
                    [
                        120.5,
                        77.75
                    ],
                    [
                        120.72222222222223,
                        77.5
                    ],
                    [
                        121.29166666666667,
                        76.5
                    ],
                    [
                        121.16666666666667,
                        75.5
                    ],
                    [
                        121.5,
                        74.875
                    ],
                    [
                        121.60344827586206,
                        74.5
                    ],
                    [
                        122,
                        73.5
                    ],
                    [
                        121.92105263157895,
                        72.5
                    ],
                    [
                        121.5,
                        72.1923076923077
                    ],
                    [
                        120.5,
                        71.8529411764706
                    ],
                    [
                        119.8529411764706,
                        72.5
                    ],
                    [
                        119.8157894736842,
                        73.5
                    ],
                    [
                        119.5,
                        74.25
                    ],
                    [
                        119.41666666666667,
                        74.5
                    ],
                    [
                        119.5,
                        75
                    ],
                    [
                        119.66666666666667,
                        75.5
                    ],
                    [
                        119.5,
                        75.61764705882354
                    ],
                    [
                        118.96428571428571,
                        76.5
                    ],
                    [
                        118.5,
                        77.36666666666666
                    ],
                    [
                        118.375,
                        77.5
                    ],
                    [
                        117.86363636363636,
                        78.5
                    ],
                    [
                        118.5,
                        79.2
                    ],
                    [
                        119.375,
                        78.5
                    ]
                ]
            ],
            [
                [
                    [
                        114.86842105263158,
                        91.5
                    ],
                    [
                        114.5,
                        91.18181818181819
                    ],
                    [
                        113.5,
                        90.5
                    ],
                    [
                        113.5,
                        90.5
                    ],
                    [
                        113.5,
                        90.5
                    ],
                    [
                        112.5,
                        90.65384615384616
                    ],
                    [
                        111.5,
                        90.61428571428571
                    ],
                    [
                        110.5,
                        90.77586206896552
                    ],
                    [
                        109.8,
                        91.5
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.5,
                        92
                    ],
                    [
                        114.86842105263158,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 255,
        "coordinates": [
            [
                [
                    [
                        107.73076923076923,
                        71.5
                    ],
                    [
                        108.5,
                        70.66666666666667
                    ],
                    [
                        108.66,
                        70.5
                    ],
                    [
                        109.5,
                        69.86363636363636
                    ],
                    [
                        110.1,
                        69.5
                    ],
                    [
                        110.5,
                        69
                    ],
                    [
                        110.83333333333333,
                        68.5
                    ],
                    [
                        110.5,
                        68
                    ],
                    [
                        109.5,
                        67.68181818181819
                    ],
                    [
                        109.125,
                        67.5
                    ],
                    [
                        108.5,
                        66.66666666666667
                    ],
                    [
                        107.5,
                        66.91176470588235
                    ],
                    [
                        107.22972972972973,
                        67.5
                    ],
                    [
                        106.55882352941177,
                        68.5
                    ],
                    [
                        106.5,
                        68.57142857142857
                    ],
                    [
                        106.12857142857143,
                        69.5
                    ],
                    [
                        106.45238095238095,
                        70.5
                    ],
                    [
                        106.5,
                        70.68181818181819
                    ],
                    [
                        107.1,
                        71.5
                    ],
                    [
                        107.5,
                        71.70689655172414
                    ],
                    [
                        107.73076923076923,
                        71.5
                    ]
                ]
            ],
            [
                [
                    [
                        115.04545454545455,
                        72.5
                    ],
                    [
                        115.16666666666667,
                        71.5
                    ],
                    [
                        114.5,
                        70.61111111111111
                    ],
                    [
                        114.05555555555556,
                        71.5
                    ],
                    [
                        113.5,
                        72
                    ],
                    [
                        113.27777777777777,
                        72.5
                    ],
                    [
                        113.5,
                        72.77027027027027
                    ],
                    [
                        114.5,
                        72.78571428571429
                    ],
                    [
                        115.04545454545455,
                        72.5
                    ]
                ]
            ],
            [
                [
                    [
                        121.55882352941177,
                        73.5
                    ],
                    [
                        121.5,
                        73.27777777777777
                    ],
                    [
                        121,
                        73.5
                    ],
                    [
                        121.5,
                        73.64285714285714
                    ],
                    [
                        121.55882352941177,
                        73.5
                    ]
                ]
            ],
            [
                [
                    [
                        120.75,
                        74.5
                    ],
                    [
                        120.5,
                        73.83333333333333
                    ],
                    [
                        120.26470588235294,
                        74.5
                    ],
                    [
                        120.5,
                        74.94444444444444
                    ],
                    [
                        120.75,
                        74.5
                    ]
                ]
            ],
            [
                [
                    [
                        119.5,
                        77.5
                    ],
                    [
                        120.5,
                        76.76666666666667
                    ],
                    [
                        120.66666666666667,
                        76.5
                    ],
                    [
                        120.5,
                        76.05555555555556
                    ],
                    [
                        119.5,
                        76.5
                    ],
                    [
                        119.5,
                        76.5
                    ],
                    [
                        119.5,
                        77.5
                    ],
                    [
                        119.5,
                        77.5
                    ],
                    [
                        119.5,
                        77.5
                    ]
                ]
            ],
            [
                [
                    [
                        114.05555555555556,
                        91.5
                    ],
                    [
                        113.5,
                        91.1
                    ],
                    [
                        112.5,
                        91.23076923076923
                    ],
                    [
                        111.5,
                        91.04285714285714
                    ],
                    [
                        110.5,
                        91.29310344827586
                    ],
                    [
                        110.3,
                        91.5
                    ],
                    [
                        110.5,
                        92
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        112.5,
                        92
                    ],
                    [
                        113.5,
                        92
                    ],
                    [
                        114.05555555555556,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 270,
        "coordinates": [
            [
                [
                    [
                        107.76666666666667,
                        70.5
                    ],
                    [
                        108.5,
                        69.76666666666667
                    ],
                    [
                        109.07142857142857,
                        69.5
                    ],
                    [
                        109.5,
                        69.3
                    ],
                    [
                        110.13157894736842,
                        68.5
                    ],
                    [
                        109.5,
                        68.13636363636364
                    ],
                    [
                        108.5,
                        67.88461538461539
                    ],
                    [
                        107.5,
                        68.33333333333333
                    ],
                    [
                        107.44117647058823,
                        68.5
                    ],
                    [
                        106.72222222222223,
                        69.5
                    ],
                    [
                        107.26470588235294,
                        70.5
                    ],
                    [
                        107.5,
                        70.8076923076923
                    ],
                    [
                        107.76666666666667,
                        70.5
                    ]
                ]
            ],
            [
                [
                    [
                        111.61111111111111,
                        91.5
                    ],
                    [
                        111.5,
                        91.47142857142858
                    ],
                    [
                        111.4,
                        91.5
                    ],
                    [
                        111.5,
                        92
                    ],
                    [
                        111.61111111111111,
                        91.5
                    ]
                ]
            ]
        ]
    },
    {
        "type": "MultiPolygon",
        "value": 285,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 300,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 315,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 330,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 345,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 360,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 375,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 390,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 405,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 420,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 435,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 450,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 465,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 480,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 495,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 510,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 525,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 540,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 555,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 570,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 585,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 600,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 615,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 630,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 645,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 660,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 675,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 690,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 705,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 720,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 735,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 750,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 765,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 780,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 795,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 810,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 825,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 840,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 855,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 870,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 885,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 900,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 915,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 930,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 945,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 960,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 975,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 990,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1005,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1020,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1035,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1050,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1065,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1080,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1095,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1110,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1125,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1140,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1155,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1170,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1185,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1200,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1215,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1230,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1245,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1260,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1275,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1290,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1305,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1320,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1335,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1350,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1365,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1380,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1395,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1410,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1425,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1440,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1455,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1470,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1485,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1500,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1515,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1530,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1545,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1560,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1575,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1590,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1605,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1620,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1635,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1650,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1665,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1680,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1695,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1710,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1725,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1740,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1755,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1770,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1785,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1800,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1815,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1830,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1845,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1860,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1875,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1890,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1905,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1920,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1935,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1950,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1965,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1980,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 1995,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2010,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2025,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2040,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2055,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2070,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2085,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2100,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2115,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2130,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2145,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2160,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2175,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2190,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2205,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2220,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2235,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2250,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2265,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2280,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2295,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2310,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2325,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2340,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2355,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2370,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2385,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2400,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2415,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2430,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2445,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2460,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2475,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2490,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2505,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2520,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2535,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2550,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2565,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2580,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2595,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2610,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2625,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2640,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2655,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2670,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2685,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2700,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2715,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2730,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2745,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2760,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2775,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2790,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2805,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2820,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2835,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2850,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2865,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2880,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2895,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2910,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2925,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2940,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2955,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2970,
        "coordinates": []
    },
    {
        "type": "MultiPolygon",
        "value": 2985,
        "coordinates": []
    }
];
